export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AnyType: { input: any; output: any; }
  /** A date string with format 'Y-m-d', e.g. '2011-05-23'. */
  Date: { input: any; output: any; }
  /** A datetime string with format 'Y-m-d H:i:s', e.g. '2018-01-01 13:00:00'. */
  DateTime: { input: any; output: any; }
  DateTimeTz: { input: any; output: any; }
  DateTimeUtc: { input: any; output: any; }
  /** Arbitrary precision decimal type, primarily for monetary values */
  Decimal: { input: any; output: any; }
  /** JSON custom scalar type */
  JSON: { input: any; output: any; }
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  LocalDate: { input: any; output: any; }
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: { input: any; output: any; }
  /** Can be either a string, array of strings, or null */
  StringOrStringArray: { input: any; output: any; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: any; output: any; }
  /** A field whose value is a UTC Offset: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
  UtcOffset: { input: any; output: any; }
  /** A time string at a particular timezone, such as 10:15:30+01:00 */
  ZonedTime: { input: any; output: any; }
  join__DirectiveArguments: { input: any; output: any; }
  join__FieldSet: { input: any; output: any; }
  link__Import: { input: any; output: any; }
};

export type AcceptBookingInviteInput = {
  booking_invite_id: Scalars['Int']['input'];
};

export type AcceptGenericBookingInviteInput = {
  booking_id: Scalars['Int']['input'];
  inviter_referral_code: Scalars['String']['input'];
};

export type ActivateFeaturedPromoCodeInput = {
  featureText?: InputMaybe<Scalars['String']['input']>;
  promoCodeId: Scalars['ID']['input'];
};

export type ActivatePassInput = {
  passId: Scalars['ID']['input'];
};

/** active or expired flag for guestPasses */
export const ActiveOrExpired = {
  ACTIVE: 'ACTIVE',
  BOTH: 'BOTH',
  EXPIRED: 'EXPIRED'
} as const;

export type ActiveOrExpired = typeof ActiveOrExpired[keyof typeof ActiveOrExpired];
export type AddGuestAsFavoriteInput = {
  guestId: Scalars['ID']['input'];
};

export type AddPaymentSourceInput = {
  token: Scalars['String']['input'];
};

export type AddWaitlistSubscriptionInput = {
  email: Scalars['String']['input'];
  fullAddress: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  listingType: WaitlistListingType;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  useCaseId?: InputMaybe<Scalars['Int']['input']>;
};

export type ApproveEditReservationInput = {
  apple_google_pay?: InputMaybe<Scalars['Boolean']['input']>;
  booking_id: Scalars['Int']['input'];
  payment_source_id?: InputMaybe<Scalars['Int']['input']>;
};

/** Auto-renewal states for premium subscriptions */
export const AutoRenewState = {
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED'
} as const;

export type AutoRenewState = typeof AutoRenewState[keyof typeof AutoRenewState];
export const AutomatedMessageEventType = {
  AFTER_BOOKING_END_1H: 'AFTER_BOOKING_END_1H',
  AFTER_BOOKING_END_2H: 'AFTER_BOOKING_END_2H',
  AFTER_BOOKING_END_3H: 'AFTER_BOOKING_END_3H',
  AFTER_BOOKING_END_12H: 'AFTER_BOOKING_END_12H',
  AFTER_BOOKING_END_24H: 'AFTER_BOOKING_END_24H',
  AFTER_BOOKING_END_30M: 'AFTER_BOOKING_END_30M',
  BEFORE_BOOKING_END_15M: 'BEFORE_BOOKING_END_15M',
  BEFORE_BOOKING_END_30M: 'BEFORE_BOOKING_END_30M',
  BEFORE_RESERVATION_2H: 'BEFORE_RESERVATION_2H',
  BEFORE_RESERVATION_24H: 'BEFORE_RESERVATION_24H',
  BOOKING_COMPLETION: 'BOOKING_COMPLETION',
  BOOKING_CONFIRMATION: 'BOOKING_CONFIRMATION',
  CHECK_IN: 'CHECK_IN',
  CHECK_OUT: 'CHECK_OUT'
} as const;

export type AutomatedMessageEventType = typeof AutomatedMessageEventType[keyof typeof AutomatedMessageEventType];
export type AvailableTimeInput = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type BlockUserInput = {
  block_user_id: Scalars['Int']['input'];
};

export type BookPoolInput = {
  adult_guests?: InputMaybe<Scalars['Int']['input']>;
  apple_google_pay?: InputMaybe<Scalars['Boolean']['input']>;
  awc?: InputMaybe<Scalars['String']['input']>;
  booking_id?: InputMaybe<Scalars['Int']['input']>;
  booking_reason_id?: InputMaybe<Scalars['Int']['input']>;
  children_guests?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  end_datetime_utc?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  guest_pass_id?: InputMaybe<Scalars['Int']['input']>;
  host_message?: InputMaybe<Scalars['String']['input']>;
  infant_guests?: InputMaybe<Scalars['Int']['input']>;
  low_fee_link_hash?: InputMaybe<Scalars['String']['input']>;
  payment_source_id?: InputMaybe<Scalars['Int']['input']>;
  pet_guests?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  pool_id: Scalars['Int']['input'];
  promo_code?: InputMaybe<Scalars['String']['input']>;
  reason_for_booking?: InputMaybe<Scalars['String']['input']>;
  search_address?: InputMaybe<Scalars['String']['input']>;
  start_datetime_utc?: InputMaybe<Scalars['DateTime']['input']>;
  survey_response?: InputMaybe<Scalars['AnyType']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  upsell_pass_id?: InputMaybe<Scalars['Int']['input']>;
  useAward?: InputMaybe<Scalars['Boolean']['input']>;
  use_premium_amenities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type BookServiceInput = {
  bookingId: Scalars['Int']['input'];
  paymentSourceId?: InputMaybe<Scalars['Int']['input']>;
};

export type BookWithConciergeInput = {
  adults: Scalars['Int']['input'];
  children?: InputMaybe<Scalars['Int']['input']>;
  infants?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  pets?: InputMaybe<Scalars['Int']['input']>;
};

export const BookabilityCategory = {
  AVAILABILITY: 'AVAILABILITY',
  BOOKING_SUCCESS: 'BOOKING_SUCCESS',
  BRANDING: 'BRANDING',
  LISTING_QUALITY: 'LISTING_QUALITY',
  PRICING: 'PRICING'
} as const;

export type BookabilityCategory = typeof BookabilityCategory[keyof typeof BookabilityCategory];
export const BookabilityScoreStatus = {
  AT_RISK: 'AT_RISK',
  EXCELLENT: 'EXCELLENT',
  GOOD: 'GOOD',
  GREAT: 'GREAT',
  NEEDS_WORK: 'NEEDS_WORK'
} as const;

export type BookabilityScoreStatus = typeof BookabilityScoreStatus[keyof typeof BookabilityScoreStatus];
export type BookingChatDetails = {
  adult_guests?: InputMaybe<Scalars['Int']['input']>;
  children_guests?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  infant_guests?: InputMaybe<Scalars['Int']['input']>;
  pet_guests?: InputMaybe<Scalars['Int']['input']>;
  pool_id: Scalars['Int']['input'];
  reason_for_booking?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type BookingForChatInput = {
  user_id: Scalars['Int']['input'];
};

/** Guest pass auto renew state */
export const BookingGuestPassAutoRenewState = {
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED',
  RENEWED: 'RENEWED'
} as const;

export type BookingGuestPassAutoRenewState = typeof BookingGuestPassAutoRenewState[keyof typeof BookingGuestPassAutoRenewState];
/** Guest pass state */
export const BookingGuestPassState = {
  ACTIVATION_FAILED: 'ACTIVATION_FAILED',
  CANCELED: 'CANCELED',
  PAID: 'PAID',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  PENDING: 'PENDING',
  RENEWAL_FAILED: 'RENEWAL_FAILED',
  RENEWED: 'RENEWED'
} as const;

export type BookingGuestPassState = typeof BookingGuestPassState[keyof typeof BookingGuestPassState];
export type BookingInquiryInput = {
  adult_guests: Scalars['Int']['input'];
  children_guests: Scalars['Int']['input'];
  end_datetime: Scalars['DateTimeUtc']['input'];
  infant_guests: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  pet_guests: Scalars['Int']['input'];
  pool_id: Scalars['Int']['input'];
  start_datetime: Scalars['DateTimeUtc']['input'];
};

export type BookingInviteInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

export const BookingInvitesExperiment = {
  Control: 'Control',
  Test1: 'Test1',
  Test2: 'Test2',
  Test3: 'Test3'
} as const;

export type BookingInvitesExperiment = typeof BookingInvitesExperiment[keyof typeof BookingInvitesExperiment];
export const BookingSpecialOfferStatus = {
  Accepted: 'Accepted',
  Canceled: 'Canceled',
  Declined: 'Declined',
  Expired: 'Expired',
  Pending: 'Pending'
} as const;

export type BookingSpecialOfferStatus = typeof BookingSpecialOfferStatus[keyof typeof BookingSpecialOfferStatus];
export const BookingStatusEnum = {
  Approved: 'Approved',
  Cancelled: 'Cancelled',
  CancelledByAdmin: 'CancelledByAdmin',
  Completed: 'Completed',
  Confirmed: 'Confirmed',
  Declined: 'Declined',
  EmptyBooking: 'EmptyBooking',
  Expired: 'Expired',
  ExpiredInquiry: 'ExpiredInquiry',
  PaymentFailed: 'PaymentFailed',
  PaymentProcessing: 'PaymentProcessing',
  Pending: 'Pending',
  PreApprove: 'PreApprove',
  RejectedAbuseDecision: 'RejectedAbuseDecision'
} as const;

export type BookingStatusEnum = typeof BookingStatusEnum[keyof typeof BookingStatusEnum];
export const CalendarProvider = {
  APPLE: 'APPLE',
  EXCHANGE: 'EXCHANGE',
  GOOGLE: 'GOOGLE',
  ICAL: 'ICAL',
  OFFICE365: 'OFFICE365',
  SWIMPLY: 'SWIMPLY'
} as const;

export type CalendarProvider = typeof CalendarProvider[keyof typeof CalendarProvider];
export const CalendarSyncBufferProvider = {
  CRONOFY: 'CRONOFY',
  ICAL: 'ICAL'
} as const;

export type CalendarSyncBufferProvider = typeof CalendarSyncBufferProvider[keyof typeof CalendarSyncBufferProvider];
export type CancelBookingSpecialOfferInput = {
  booking_id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};

export type CancelEditReservationRequestInput = {
  booking_id: Scalars['Int']['input'];
};

export type CancelPassInput = {
  cancelNote?: InputMaybe<Scalars['String']['input']>;
  cancelReason: Scalars['String']['input'];
  guestPassId: Scalars['ID']['input'];
  onBehalfOf?: InputMaybe<OnBehalfOf>;
  paymentSourceId?: InputMaybe<Scalars['ID']['input']>;
};

export type CardDetailsInput = {
  booking_id?: InputMaybe<Scalars['ID']['input']>;
  edit_multi?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export const CartStatus = {
  Booked: 'Booked',
  Closed: 'Closed',
  Pending: 'Pending',
  Processing: 'Processing',
  Reminded: 'Reminded',
  SkippedReminder: 'SkippedReminder'
} as const;

export type CartStatus = typeof CartStatus[keyof typeof CartStatus];
export type ChangePoolStatusInput = {
  pause_reason?: InputMaybe<Scalars['String']['input']>;
  pause_reason_message?: InputMaybe<Scalars['String']['input']>;
  pool_id: Scalars['ID']['input'];
  status: Scalars['Int']['input'];
};

export type ChangePremiumPaymentInput = {
  paymentSourceId: Scalars['Int']['input'];
};

export type ChargeInput = {
  apple_google_pay?: InputMaybe<Scalars['Boolean']['input']>;
  booking_id: Scalars['ID']['input'];
  payment_source_id?: InputMaybe<Scalars['Int']['input']>;
  promo_code?: InputMaybe<Scalars['String']['input']>;
};

export type ChatConversationInput = {
  excluded_id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  reciever_id: Scalars['Int']['input'];
  search_string?: InputMaybe<Scalars['String']['input']>;
};

export type ChatListInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search_string?: InputMaybe<Scalars['String']['input']>;
};

export type CheckAvailableBookingInput = {
  adult_guests?: InputMaybe<Scalars['Int']['input']>;
  booking_id?: InputMaybe<Scalars['Int']['input']>;
  children_guests?: InputMaybe<Scalars['Int']['input']>;
  date: Scalars['Date']['input'];
  from: Scalars['String']['input'];
  infant_guests?: InputMaybe<Scalars['Int']['input']>;
  pet_guests?: InputMaybe<Scalars['Int']['input']>;
  pool_id: Scalars['Int']['input'];
  to: Scalars['String']['input'];
};

export type CheckInBookingInput = {
  booking_id: Scalars['Int']['input'];
};

export type CheckServiceAvailabilityInput = {
  bookingId: Scalars['Int']['input'];
};

export type CompleteListingPostOnboardingStepInput = {
  listingId: Scalars['ID']['input'];
  postOnboardingStepName: PostOnboardingStepName;
};

export type CompleteOnboardingScreenInput = {
  listingId: Scalars['ID']['input'];
  onboardingScreenName: OnboardingScreenName;
  /** Flag to use the V2 onboarding flow (bypassing DB) */
  onboardingV2?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom flag in case we have some backwards compatibility */
  requestAvailabilityScreen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom flag for verification screen in case we have some backwards compatibility */
  requestVerificationScreen?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompleteTutorialInput = {
  tutorial_status: Scalars['Boolean']['input'];
};

export type ConversationInput = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  participantUserId: Scalars['ID']['input'];
};

export type ConversationListInput = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export const ConversationListItemBookingStatus = {
  Canceled: 'Canceled',
  Completed: 'Completed',
  Confirmed: 'Confirmed',
  Declined: 'Declined',
  Expired: 'Expired',
  ExpiredInquiry: 'ExpiredInquiry',
  Inquiry: 'Inquiry',
  PaymentProcessing: 'PaymentProcessing',
  Pending: 'Pending',
  PendingEdit: 'PendingEdit',
  PreApprovedInquiry: 'PreApprovedInquiry',
  RecentlyCompleted: 'RecentlyCompleted',
  SpecialOffer: 'SpecialOffer'
} as const;

export type ConversationListItemBookingStatus = typeof ConversationListItemBookingStatus[keyof typeof ConversationListItemBookingStatus];
export type CoordinatesInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type Coords = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type CreateBookingInviteInput = {
  booking_id: Scalars['Int']['input'];
  invites: Array<BookingInviteInput>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBookingSpecialOfferInput = {
  adult_guests: Scalars['Int']['input'];
  booking_id?: InputMaybe<Scalars['ID']['input']>;
  child_guests: Scalars['Int']['input'];
  end_datetime_utc: Scalars['DateTimeUtc']['input'];
  guest_user_id: Scalars['ID']['input'];
  infant_guests: Scalars['Int']['input'];
  listing_id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  pet_guests: Scalars['Int']['input'];
  premium_amenity_ids: Array<Scalars['ID']['input']>;
  special_offer_price: Scalars['Float']['input'];
  start_datetime_utc: Scalars['DateTimeUtc']['input'];
};

export type CreateListingInput = {
  custom_listing_type?: InputMaybe<Scalars['String']['input']>;
  listing_type: ListingType;
};

export type CreateListingPromocodeInput = {
  discountPercent: Scalars['Int']['input'];
  expirationDate: Scalars['DateTime']['input'];
  isFeaturedPromo?: InputMaybe<Scalars['Boolean']['input']>;
  listingId: Scalars['ID']['input'];
  maxRedemptions: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  promocodeType?: InputMaybe<Scalars['String']['input']>;
  redemptionRuleLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateProfileInput = {
  country_phone_code?: InputMaybe<Scalars['String']['input']>;
  date_birthday?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  isModify: Scalars['Boolean']['input'];
  lastname?: InputMaybe<Scalars['String']['input']>;
  mobile_number?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  postal_code_source?: InputMaybe<PostalCodeSource>;
  role?: InputMaybe<RoleEnum>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUnavailabilityEventInput = {
  from: Scalars['DateTime']['input'];
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  listingId: Scalars['ID']['input'];
  reason: UnavailabilityReason;
  to: Scalars['DateTime']['input'];
};

export const CreditEarningsType = {
  PREMIUM: 'PREMIUM'
} as const;

export type CreditEarningsType = typeof CreditEarningsType[keyof typeof CreditEarningsType];
export const CtaTarget = {
  BookNow: 'BookNow',
  EditInvite: 'EditInvite',
  FindPool: 'FindPool',
  InviteFriends: 'InviteFriends',
  LeaveReview: 'LeaveReview',
  SeeBBQPools: 'SeeBBQPools',
  ShowPools: 'ShowPools'
} as const;

export type CtaTarget = typeof CtaTarget[keyof typeof CtaTarget];
export type CurrentLocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type DailyPriceTierInput = {
  daily_price: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
};

export type DailyPricingInput = {
  daily_price: Scalars['Float']['input'];
  is_onboarding: Scalars['Boolean']['input'];
  listing_id: Scalars['Int']['input'];
};

export type DailyTieredPricingInput = {
  daily_price_tiers: Array<DailyPriceTierInput>;
  is_onboarding: Scalars['Boolean']['input'];
  listing_id: Scalars['Int']['input'];
};

/** Day type options for V3 passes */
export const DayType = {
  HOLIDAYS: 'HOLIDAYS',
  WEEKDAYS: 'WEEKDAYS',
  WEEKENDS: 'WEEKENDS'
} as const;

export type DayType = typeof DayType[keyof typeof DayType];
export const Days = {
  FRIDAY: 'FRIDAY',
  MONDAY: 'MONDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY',
  THURSDAY: 'THURSDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY'
} as const;

export type Days = typeof Days[keyof typeof Days];
export type DeactivateFeaturedPromoCodeInput = {
  promoCodeId: Scalars['ID']['input'];
};

export type DeactivatePassInput = {
  deactivationReason: Scalars['String']['input'];
  passId: Scalars['ID']['input'];
};

export type DeclineBookingSpecialOfferInput = {
  booking_id: Scalars['ID']['input'];
};

export type DeclineEditReservationTypeInput = {
  booking_id: Scalars['Int']['input'];
  cancel_chat_message?: InputMaybe<Scalars['String']['input']>;
  decline_reason?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultPricesInput = {
  hourly_price: Scalars['Float']['input'];
  pool_id: Scalars['Int']['input'];
  price_per_guest?: InputMaybe<Scalars['Float']['input']>;
  price_per_guest_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  price_per_guest_min_capacity?: InputMaybe<Scalars['Int']['input']>;
};

export type DeleteAccessPhotoInput = {
  access_photo_id: Scalars['Int']['input'];
  pool_id: Scalars['Int']['input'];
};

export type DeleteFavoriteCollectionsInput = {
  ids: Array<Scalars['Int']['input']>;
};

export type DeletePoolImageInput = {
  key: Scalars['String']['input'];
  pool_id: Scalars['ID']['input'];
  pool_image_id: Scalars['ID']['input'];
};

export type DipDiscount = {
  bookings_number?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discount_type?: InputMaybe<DipType>;
};

export const DipType = {
  BRONZE: 'BRONZE',
  DIAMOND: 'DIAMOND',
  GOLD: 'GOLD',
  SILVER: 'SILVER'
} as const;

export type DipType = typeof DipType[keyof typeof DipType];
export type DiscountFirstBookingSData = {
  discount: Scalars['Boolean']['input'];
  pool_id: Scalars['Int']['input'];
};

export const DiscountType = {
  FEATURED_PROMO: 'FEATURED_PROMO',
  FIRST_BOOKING: 'FIRST_BOOKING',
  FULL_REFUND: 'FULL_REFUND',
  HOST_RESCHEDULE: 'HOST_RESCHEDULE',
  MEMBERSHIP_UPSELL: 'MEMBERSHIP_UPSELL',
  PROMO_CODE: 'PROMO_CODE',
  Pass: 'Pass',
  SINGLE_DAY: 'SINGLE_DAY',
  WEEKDAY: 'WEEKDAY'
} as const;

export type DiscountType = typeof DiscountType[keyof typeof DiscountType];
export type DiscoveryInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  space_type_slug?: InputMaybe<Scalars['String']['input']>;
};

export const DoNextIfBookingEditDeclined = {
  cancel: 'cancel',
  nothing: 'nothing'
} as const;

export type DoNextIfBookingEditDeclined = typeof DoNextIfBookingEditDeclined[keyof typeof DoNextIfBookingEditDeclined];
export type DynamicSearchFilter = {
  filter_key: Scalars['String']['input'];
  values: Array<InputMaybe<Scalars['String']['input']>>;
};

export type DynamicSearchInput = {
  adults: Scalars['Int']['input'];
  children?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  display_full_prices?: InputMaybe<Scalars['Boolean']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  favorite_collection_id?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<DynamicSearchFilter>>;
  first: Scalars['Int']['input'];
  flexibleDuration?: InputMaybe<Scalars['Float']['input']>;
  flexibleEndDate?: InputMaybe<Scalars['String']['input']>;
  flexibleStartDate?: InputMaybe<Scalars['String']['input']>;
  flexibleStartRangeHours?: InputMaybe<Scalars['Float']['input']>;
  histogramStub?: InputMaybe<HistogramStubType>;
  infants?: InputMaybe<Scalars['Int']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  optInSearchV2?: InputMaybe<Scalars['Boolean']['input']>;
  override_distance_factor?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  pets?: InputMaybe<Scalars['Int']['input']>;
  space_type_slug?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
  use_case_slug?: InputMaybe<Scalars['String']['input']>;
  use_case_slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  weekend?: InputMaybe<Scalars['String']['input']>;
};

export type EarningsInsightsInput = {
  period: EarningsInsightsPeriod;
  pool_id?: InputMaybe<Scalars['Int']['input']>;
};

export const EarningsInsightsPeriod = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  WEEKLY: 'WEEKLY',
  YEARLY: 'YEARLY'
} as const;

export type EarningsInsightsPeriod = typeof EarningsInsightsPeriod[keyof typeof EarningsInsightsPeriod];
export type EarningsSummaryInput = {
  pool_id?: InputMaybe<Scalars['Int']['input']>;
};

export type EditBookingInput = {
  adult_guests?: InputMaybe<Scalars['Int']['input']>;
  booking_id: Scalars['Int']['input'];
  child_guests?: InputMaybe<Scalars['Int']['input']>;
  end_datetime?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  host_discount?: InputMaybe<Scalars['Int']['input']>;
  infant_guests?: InputMaybe<Scalars['Int']['input']>;
  is_apple_google_pay?: InputMaybe<Scalars['Boolean']['input']>;
  is_from_refund_flow?: InputMaybe<Scalars['Boolean']['input']>;
  payment_source_id?: InputMaybe<Scalars['Int']['input']>;
  pet_guests?: InputMaybe<Scalars['Int']['input']>;
  pool_premium_amenity_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  refund_flow_message?: InputMaybe<Scalars['String']['input']>;
  reschedule_message?: InputMaybe<Scalars['String']['input']>;
  special_offer_price?: InputMaybe<Scalars['Float']['input']>;
  start_datetime?: InputMaybe<Scalars['DateTimeUtc']['input']>;
};

export type EditBookingPoolInput = {
  adult_guests?: InputMaybe<Scalars['Int']['input']>;
  apple_google_pay?: InputMaybe<Scalars['Boolean']['input']>;
  booking_id: Scalars['Int']['input'];
  children_guests?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  discount_offered_by_host?: InputMaybe<Scalars['Int']['input']>;
  do_next_if_declined?: InputMaybe<DoNextIfBookingEditDeclined>;
  from?: InputMaybe<Scalars['String']['input']>;
  infant_guests?: InputMaybe<Scalars['Int']['input']>;
  payment_source_id?: InputMaybe<Scalars['Int']['input']>;
  pet_guests?: InputMaybe<Scalars['Int']['input']>;
  requested_pool_premium_amenities?: InputMaybe<Array<Scalars['Int']['input']>>;
  reschedule_reason_message?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type EmailVerificationInput = {
  token: Scalars['String']['input'];
};

export type EmailsInput = {
  email: Scalars['String']['input'];
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export const EntryMethod = {
  FrontDoor: 'FrontDoor',
  Other: 'Other',
  SideGate: 'SideGate'
} as const;

export type EntryMethod = typeof EntryMethod[keyof typeof EntryMethod];
export type EstimateEarningsExtendedInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  maxGuests?: InputMaybe<Scalars['Int']['input']>;
  poolId?: InputMaybe<Scalars['ID']['input']>;
};

export type EstimateEarningsInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export const FavCollectionInviteType = {
  COLLABORATE: 'COLLABORATE',
  VIEW: 'VIEW'
} as const;

export type FavCollectionInviteType = typeof FavCollectionInviteType[keyof typeof FavCollectionInviteType];
export const FavoriteFrom = {
  PLP: 'PLP',
  SEARCH: 'SEARCH'
} as const;

export type FavoriteFrom = typeof FavoriteFrom[keyof typeof FavoriteFrom];
export const FavoritedFromTypes = {
  plp: 'plp',
  search: 'search'
} as const;

export type FavoritedFromTypes = typeof FavoritedFromTypes[keyof typeof FavoritedFromTypes];
export type FlatRatePricingInput = {
  from_onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hourly_price: Scalars['Float']['input'];
  pool_id: Scalars['Int']['input'];
  price_per_guest?: InputMaybe<Scalars['Float']['input']>;
  price_per_guest_threshold?: InputMaybe<Scalars['Int']['input']>;
};

export type ForgotPasswordInput = {
  email: Scalars['String']['input'];
};

export const FreeBusy = {
  BUSY: 'BUSY',
  FREE: 'FREE'
} as const;

export type FreeBusy = typeof FreeBusy[keyof typeof FreeBusy];
export type FullRefundInput = {
  booking_id: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
};

export type GeoCodeInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<CoordinatesInput>;
};

export type GetAutomatedMessageContentInput = {
  eventName: AutomatedMessageEventType;
  listingId: Scalars['Int']['input'];
};

export type GetAutomatedMessageEventsInput = {
  listingId: Scalars['Int']['input'];
};

export type GetBasePriceInput = {
  listingId: Scalars['ID']['input'];
  tierId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetCalendarLinkInput = {
  listingId: Scalars['String']['input'];
};

export type GetDailyBookingAvailabilityInput = {
  bookingId: Scalars['ID']['input'];
  day: Scalars['LocalDate']['input'];
};

export type GetDailyListingAvailabilityInput = {
  day?: InputMaybe<Scalars['Date']['input']>;
  ignoreBookingId?: InputMaybe<Scalars['String']['input']>;
  listingId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['UtcOffset']['input']>;
};

export type GetDailyListingAvailabilitySummaryInput = {
  from: Scalars['Date']['input'];
  ignoreBookingId?: InputMaybe<Scalars['String']['input']>;
  listingId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['UtcOffset']['input']>;
  to: Scalars['Date']['input'];
};

export type GetDefaultMaxGuestCountTiersInput = {
  listingId: Scalars['ID']['input'];
};

export type GetGuestPassPricingInput = {
  adultGuests: Scalars['Int']['input'];
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  childGuests: Scalars['Int']['input'];
  flatPremiumAmenityIds?: Array<Scalars['Int']['input']>;
  from: Scalars['DateTime']['input'];
  guestPassId: Scalars['ID']['input'];
  hourlyPremiumAmenityIds?: Array<Scalars['Int']['input']>;
  infantGuests: Scalars['Int']['input'];
  isEditingBooking?: InputMaybe<Scalars['Boolean']['input']>;
  petGuests: Scalars['Int']['input'];
  to: Scalars['DateTime']['input'];
};

export type GetGuestPassPurchaseHistoryInput = {
  guestPassId: Scalars['ID']['input'];
};

export type GetHostPassInput = {
  listingId: Scalars['Int']['input'];
  passType: PassType;
};

export type GetHostPassesInput = {
  listingId: Scalars['Int']['input'];
};

export type GetListingBrandingInput = {
  listingId: Scalars['ID']['input'];
};

export type GetListingMessageTemplateInput = {
  eventName?: InputMaybe<AutomatedMessageEventType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  listingId: Scalars['Int']['input'];
};

export type GetListingMessageTemplatesForChatInput = {
  resolveVarsForChatWithUserId: Scalars['ID']['input'];
};

export type GetListingMessageTemplatesInput = {
  listingId: Scalars['Int']['input'];
};

export type GetListingOnboardingScreenInput = {
  listingId: Scalars['ID']['input'];
  onboardingScreenName: OnboardingScreenName;
};

export type GetListingOnboardingScreensInput = {
  listingId?: InputMaybe<Scalars['ID']['input']>;
  /** Flag to use the V2 onboarding flow (bypassing DB) */
  onboardingV2?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom flag in case we have some backwards compatibility */
  requestAvailabilityScreen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom flag for verification screen in case we have some backwards compatibility */
  requestVerificationScreen?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetListingPassesV2Input = {
  active: Scalars['Boolean']['input'];
  includeV3Passes?: InputMaybe<Scalars['Boolean']['input']>;
  listingId: Scalars['Int']['input'];
  totalGuests: Scalars['Int']['input'];
  totalHours?: InputMaybe<Scalars['Float']['input']>;
};

export type GetListingPhotoScoresInput = {
  listingId: Scalars['ID']['input'];
};

export type GetListingPostOnboardingStepsInput = {
  listingId: Scalars['ID']['input'];
};

export type GetListingPromocodesInput = {
  listingId: Scalars['ID']['input'];
};

export type GetListingPromotionsInput = {
  listingId: Scalars['ID']['input'];
};

export type GetListingScheduleInput = {
  days?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  listingId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['UtcOffset']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetListingTypePropertiesInput = {
  category: ListingTypePropertiesCategory;
  isOnboarding?: Scalars['Boolean']['input'];
  listingId?: InputMaybe<Scalars['ID']['input']>;
  listingType?: InputMaybe<ListingTypeNameEnum>;
};

export type GetPassHoldersInput = {
  activeOrExpired: ActiveOrExpired;
  listingId: Scalars['Int']['input'];
  passType: PassType;
};

export type GetPriceBreakdownInput = {
  adult_guests?: InputMaybe<Scalars['Int']['input']>;
  apply_credits?: InputMaybe<Scalars['Boolean']['input']>;
  booking_id?: InputMaybe<Scalars['Int']['input']>;
  children_guests?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  discount_offered_by_host?: InputMaybe<Scalars['Int']['input']>;
  for_guest_or_host?: InputMaybe<GuestOrHost>;
  from?: InputMaybe<Scalars['String']['input']>;
  infant_guests?: InputMaybe<Scalars['Int']['input']>;
  itemize_items?: InputMaybe<Scalars['Boolean']['input']>;
  multidips?: InputMaybe<Array<InputMaybe<MultiDipInput>>>;
  pet_guests?: InputMaybe<Scalars['Int']['input']>;
  pool_id?: InputMaybe<Scalars['Int']['input']>;
  promocode_id?: InputMaybe<Scalars['Int']['input']>;
  requested_pool_premium_amenities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  to?: InputMaybe<Scalars['String']['input']>;
  with_booking_update_request?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetPromocodeInput = {
  listingId?: InputMaybe<Scalars['ID']['input']>;
  platform?: InputMaybe<PromocodePlatform>;
  promocodeName: Scalars['String']['input'];
};

export type GetPublicPoolsInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  poolsTake: Scalars['Float']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type GetReservationsInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  tab?: InputMaybe<UserReservationTabs>;
  type?: InputMaybe<UserReservationTypes>;
};

export type GetScreenPropertiesInput = {
  screen: Screen;
};

export type GetUserExperimentsInput = {
  experiment_name?: InputMaybe<Scalars['String']['input']>;
};

export type GuestBookingsInput = {
  count: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  sort: GuestBookingsInputSort;
  status: GuestBookingsInputStatus;
};

export const GuestBookingsInputSort = {
  BookingStartAsc: 'BookingStartAsc',
  BookingStartDesc: 'BookingStartDesc',
  CreatedAtAsc: 'CreatedAtAsc',
  CreatedAtDesc: 'CreatedAtDesc'
} as const;

export type GuestBookingsInputSort = typeof GuestBookingsInputSort[keyof typeof GuestBookingsInputSort];
export const GuestBookingsInputStatus = {
  Past: 'Past',
  Today: 'Today',
  Upcoming: 'Upcoming',
  UpcomingFuture: 'UpcomingFuture'
} as const;

export type GuestBookingsInputStatus = typeof GuestBookingsInputStatus[keyof typeof GuestBookingsInputStatus];
export const GuestCancelRefundType = {
  Cash: 'Cash',
  Credits: 'Credits'
} as const;

export type GuestCancelRefundType = typeof GuestCancelRefundType[keyof typeof GuestCancelRefundType];
export const GuestCompensation = {
  Credits110: 'Credits110',
  FullRefund: 'FullRefund',
  NotSelected: 'NotSelected'
} as const;

export type GuestCompensation = typeof GuestCompensation[keyof typeof GuestCompensation];
export type GuestInput = {
  userId: Scalars['ID']['input'];
};

export const GuestOrHost = {
  BOTH: 'BOTH',
  GUEST: 'GUEST',
  HOST: 'HOST'
} as const;

export type GuestOrHost = typeof GuestOrHost[keyof typeof GuestOrHost];
/** Guest pass auto renew state */
export const GuestPassAutoRenewState = {
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED',
  RENEWED: 'RENEWED'
} as const;

export type GuestPassAutoRenewState = typeof GuestPassAutoRenewState[keyof typeof GuestPassAutoRenewState];
export type GuestPassChargeInfoInput = {
  guestPassId: Scalars['ID']['input'];
};

export const GuestPassPricingAvailableTimeStatus = {
  FULLY_COVERED: 'FULLY_COVERED',
  FULLY_OUTSIDE: 'FULLY_OUTSIDE',
  PARTIALLY_OUTSIDE: 'PARTIALLY_OUTSIDE'
} as const;

export type GuestPassPricingAvailableTimeStatus = typeof GuestPassPricingAvailableTimeStatus[keyof typeof GuestPassPricingAvailableTimeStatus];
/** Guest pass state */
export const GuestPassState = {
  ACTIVATION_FAILED: 'ACTIVATION_FAILED',
  CANCELED: 'CANCELED',
  PAID: 'PAID',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  PENDING: 'PENDING',
  RENEWAL_FAILED: 'RENEWAL_FAILED',
  RENEWED: 'RENEWED'
} as const;

export type GuestPassState = typeof GuestPassState[keyof typeof GuestPassState];
export type GuestsInput = {
  children_allowed: Scalars['Boolean']['input'];
  infant_allowed: Scalars['Boolean']['input'];
  max_number_guest: Scalars['Int']['input'];
  pet_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  pets_rule?: InputMaybe<PetsRules>;
  pool_id: Scalars['Int']['input'];
};

export const HeardAboutUsChannel = {
  AI_SEARCH: 'AI_SEARCH',
  ATTENDED_BOOKING: 'ATTENDED_BOOKING',
  BILLBOARD: 'BILLBOARD',
  DIRECT_MAIL: 'DIRECT_MAIL',
  FACEBOOK: 'FACEBOOK',
  FACEBOOK_OR_INSTAGRAM_AD: 'FACEBOOK_OR_INSTAGRAM_AD',
  FRIEND_OR_FAMILY: 'FRIEND_OR_FAMILY',
  FROM_A_FRIEND: 'FROM_A_FRIEND',
  GOOGLE_SEARCH: 'GOOGLE_SEARCH',
  INSTAGRAM: 'INSTAGRAM',
  MAILED_FLYER: 'MAILED_FLYER',
  NEWS_ARTICLE: 'NEWS_ARTICLE',
  OTHER: 'OTHER',
  SHARK_TANK: 'SHARK_TANK',
  SOCIAL_MEDIA_FOLLOW: 'SOCIAL_MEDIA_FOLLOW',
  SWIMPLY_HOST: 'SWIMPLY_HOST',
  TIKTOK: 'TIKTOK',
  YOUTUBE: 'YOUTUBE'
} as const;

export type HeardAboutUsChannel = typeof HeardAboutUsChannel[keyof typeof HeardAboutUsChannel];
export const HistogramStubType = {
  SPARSE: 'SPARSE',
  TIGHT: 'TIGHT',
  WIDE: 'WIDE'
} as const;

export type HistogramStubType = typeof HistogramStubType[keyof typeof HistogramStubType];
export type HostBookingsInput = {
  count: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  sort: HostBookingsInputSort;
  status: HostBookingsInputStatus;
};

export const HostBookingsInputSort = {
  BookingStartAsc: 'BookingStartAsc',
  BookingStartDesc: 'BookingStartDesc',
  CreatedAtAsc: 'CreatedAtAsc',
  CreatedAtDesc: 'CreatedAtDesc'
} as const;

export type HostBookingsInputSort = typeof HostBookingsInputSort[keyof typeof HostBookingsInputSort];
export const HostBookingsInputStatus = {
  Past: 'Past',
  Upcoming: 'Upcoming'
} as const;

export type HostBookingsInputStatus = typeof HostBookingsInputStatus[keyof typeof HostBookingsInputStatus];
export type HostClaimInput = {
  amount_minor: Scalars['Int']['input'];
  booking_id: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

export const HostInteractionSettings = {
  MayGreet: 'MayGreet',
  WillGreet: 'WillGreet',
  WillNotGreet: 'WillNotGreet'
} as const;

export type HostInteractionSettings = typeof HostInteractionSettings[keyof typeof HostInteractionSettings];
export type HostReviewInput = {
  booking_id: Scalars['Int']['input'];
  comment: Scalars['String']['input'];
  rating: Scalars['Float']['input'];
  user_id: Scalars['Int']['input'];
};

export type HostServiceInput = {
  advance_notice?: InputMaybe<Scalars['Int']['input']>;
  amenity_id?: InputMaybe<Scalars['Int']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_service_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  pool_id: Scalars['Int']['input'];
  price_amount?: InputMaybe<Scalars['Float']['input']>;
  price_type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HostSignupInterest = {
  email: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  zipcode: Scalars['String']['input'];
};

/** Identity verification statuses */
export const IdVerificationStatus = {
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  UNDER_AGE: 'UNDER_AGE',
  UNVERIFIED: 'UNVERIFIED',
  VERIFIED: 'VERIFIED'
} as const;

export type IdVerificationStatus = typeof IdVerificationStatus[keyof typeof IdVerificationStatus];
export const InterestedInSpaceType = {
  BASKETBALL: 'BASKETBALL',
  DISCOVER: 'DISCOVER',
  EVENT_VENUE: 'EVENT_VENUE',
  HOME: 'HOME',
  IGLOO: 'IGLOO',
  OTHER: 'OTHER',
  PET_PARK: 'PET_PARK',
  PHOTOGRAPHY: 'PHOTOGRAPHY',
  PICKLEBALL: 'PICKLEBALL',
  POOL: 'POOL',
  TENNIS: 'TENNIS'
} as const;

export type InterestedInSpaceType = typeof InterestedInSpaceType[keyof typeof InterestedInSpaceType];
export const InvitationTheme = {
  Blue: 'Blue',
  Green: 'Green',
  Orange: 'Orange',
  Pink: 'Pink',
  White: 'White',
  Yellow: 'Yellow'
} as const;

export type InvitationTheme = typeof InvitationTheme[keyof typeof InvitationTheme];
export type InviteInput = {
  referral: Scalars['String']['input'];
  to: Array<Scalars['String']['input']>;
};

export type InviteUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  referral_type: ReferralInviteTypes;
};

export type IsNewPromoCodeAvailableInput = {
  promo_code: Scalars['String']['input'];
};

export type LatestInquiryInput = {
  user_id: Scalars['Int']['input'];
};

export const ListingAbandonedCartSettingsPromoCodeAmountOffType = {
  Flat: 'Flat',
  Percent: 'Percent'
} as const;

export type ListingAbandonedCartSettingsPromoCodeAmountOffType = typeof ListingAbandonedCartSettingsPromoCodeAmountOffType[keyof typeof ListingAbandonedCartSettingsPromoCodeAmountOffType];
export const ListingAvailabilityOverrideStatus = {
  INSTANT_BOOK: 'INSTANT_BOOK',
  PARTIALLY_UNAVAILABLE: 'PARTIALLY_UNAVAILABLE',
  REQUEST_BOOK: 'REQUEST_BOOK',
  UNAVAILABLE: 'UNAVAILABLE'
} as const;

export type ListingAvailabilityOverrideStatus = typeof ListingAvailabilityOverrideStatus[keyof typeof ListingAvailabilityOverrideStatus];
export const ListingAvailabilityStatus = {
  OPEN: 'OPEN',
  PARTIAL: 'PARTIAL',
  UNAVAILABLE: 'UNAVAILABLE'
} as const;

export type ListingAvailabilityStatus = typeof ListingAvailabilityStatus[keyof typeof ListingAvailabilityStatus];
export type ListingBookabilityScoreInput = {
  listingId: Scalars['ID']['input'];
};

export const ListingBookingRequestType = {
  INSTANT_BOOK: 'INSTANT_BOOK',
  MIXED: 'MIXED',
  REQUEST_BOOK: 'REQUEST_BOOK'
} as const;

export type ListingBookingRequestType = typeof ListingBookingRequestType[keyof typeof ListingBookingRequestType];
export const ListingBookingStatus = {
  APPROVED: 'APPROVED',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  CONFIRMED: 'CONFIRMED',
  DECLINED: 'DECLINED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  PAYMENT_PROCESSING: 'PAYMENT_PROCESSING',
  PENDING: 'PENDING'
} as const;

export type ListingBookingStatus = typeof ListingBookingStatus[keyof typeof ListingBookingStatus];
export type ListingCompletenessInput = {
  listingId: Scalars['ID']['input'];
};

export type ListingCountryInput = {
  countryName: Scalars['String']['input'];
};

export type ListingPriceTiersInput = {
  pool_id: Scalars['Int']['input'];
};

export type ListingPromotionInput = {
  discountPercentage: Scalars['Int']['input'];
  isEnabled: Scalars['Boolean']['input'];
  promotionType: PromotionType;
};

export type ListingSearchInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type ListingSeasonalAvailabilityInput = {
  listingId: Scalars['Int']['input'];
};

export type ListingStateInput = {
  countryName: Scalars['String']['input'];
  stateName: Scalars['String']['input'];
};

export const ListingStatus = {
  ACTIVE: 'ACTIVE',
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
  COMMERCIAL_LIVE: 'COMMERCIAL_LIVE',
  COMMERCIAL_WAITLISTED: 'COMMERCIAL_WAITLISTED',
  DEACTIVATED: 'DEACTIVATED',
  PAUSED: 'PAUSED',
  REJECTED: 'REJECTED',
  UNLISTED: 'UNLISTED',
  WAITLISTED: 'WAITLISTED'
} as const;

export type ListingStatus = typeof ListingStatus[keyof typeof ListingStatus];
export const ListingStatusInput = {
  ACTIVE: 'ACTIVE',
  UNLISTED: 'UNLISTED'
} as const;

export type ListingStatusInput = typeof ListingStatusInput[keyof typeof ListingStatusInput];
export const ListingType = {
  artStudio: 'artStudio',
  basketballCourt: 'basketballCourt',
  disney: 'disney',
  dockedBoat: 'dockedBoat',
  experiences: 'experiences',
  experiencesAllDogsWelcome: 'experiencesAllDogsWelcome',
  experiencesFamiliesOnly: 'experiencesFamiliesOnly',
  experiencesGirlsAndGays18Plus: 'experiencesGirlsAndGays18Plus',
  experiencesGoldenRetrieversOnly: 'experiencesGoldenRetrieversOnly',
  experiencesMomsAndChildren: 'experiencesMomsAndChildren',
  experiencesSmallDogsOnly: 'experiencesSmallDogsOnly',
  home: 'home',
  homeGym: 'homeGym',
  igloo: 'igloo',
  joyspace: 'joyspace',
  kitchen: 'kitchen',
  largeBackyard: 'largeBackyard',
  musicStudio: 'musicStudio',
  other: 'other',
  pcBackyard: 'pcBackyard',
  pending: 'pending',
  pickleball: 'pickleball',
  pool: 'pool',
  privateLake: 'privateLake',
  roofDeck: 'roofDeck',
  simply: 'simply',
  tennisCourt: 'tennisCourt'
} as const;

export type ListingType = typeof ListingType[keyof typeof ListingType];
export const ListingTypeCategoryIcon = {
  barbell: 'barbell',
  guitar: 'guitar',
  homes: 'homes',
  pool: 'pool',
  tennis: 'tennis',
  yards: 'yards'
} as const;

export type ListingTypeCategoryIcon = typeof ListingTypeCategoryIcon[keyof typeof ListingTypeCategoryIcon];
export const ListingTypeCategoryListingTypeIcon = {
  barbell: 'barbell',
  basketball: 'basketball',
  camera: 'camera',
  coldPlunge: 'coldPlunge',
  guitar: 'guitar',
  hotAndCold: 'hotAndCold',
  jacuzzi: 'jacuzzi',
  paintBrush: 'paintBrush',
  partyPopper: 'partyPopper',
  paw: 'paw',
  pickleball: 'pickleball',
  sauna: 'sauna',
  tennis: 'tennis',
  tv: 'tv'
} as const;

export type ListingTypeCategoryListingTypeIcon = typeof ListingTypeCategoryListingTypeIcon[keyof typeof ListingTypeCategoryListingTypeIcon];
export type ListingTypeInput = {
  custom_listing_type?: InputMaybe<Scalars['String']['input']>;
  listing_type: ListingType;
  pool_id: Scalars['Int']['input'];
};

export const ListingTypeNameEnum = {
  artStudio: 'artStudio',
  basketballCourt: 'basketballCourt',
  disney: 'disney',
  dockedBoat: 'dockedBoat',
  experiences: 'experiences',
  experiencesAllDogsWelcome: 'experiencesAllDogsWelcome',
  experiencesFamiliesOnly: 'experiencesFamiliesOnly',
  experiencesGirlsAndGays18Plus: 'experiencesGirlsAndGays18Plus',
  experiencesGoldenRetrieversOnly: 'experiencesGoldenRetrieversOnly',
  experiencesMomsAndChildren: 'experiencesMomsAndChildren',
  experiencesSmallDogsOnly: 'experiencesSmallDogsOnly',
  home: 'home',
  homeGym: 'homeGym',
  igloo: 'igloo',
  joyspace: 'joyspace',
  kitchen: 'kitchen',
  largeBackyard: 'largeBackyard',
  musicStudio: 'musicStudio',
  other: 'other',
  pcBackyard: 'pcBackyard',
  pending: 'pending',
  pickleball: 'pickleball',
  pool: 'pool',
  privateLake: 'privateLake',
  roofDeck: 'roofDeck',
  simply: 'simply',
  tennisCourt: 'tennisCourt'
} as const;

export type ListingTypeNameEnum = typeof ListingTypeNameEnum[keyof typeof ListingTypeNameEnum];
export const ListingTypePropertiesCategory = {
  Features: 'Features',
  Parking: 'Parking',
  Privacy: 'Privacy',
  Restroom: 'Restroom',
  SpaceDetails: 'SpaceDetails',
  V2Allowed: 'V2Allowed',
  V2Availability: 'V2Availability',
  V2BookingPreferences: 'V2BookingPreferences',
  V2CancellationPolicy: 'V2CancellationPolicy',
  V2Features: 'V2Features',
  V2GuestParking: 'V2GuestParking',
  V2GuestRules: 'V2GuestRules',
  V2ListingCourtType: 'V2ListingCourtType',
  V2ListingPoolType: 'V2ListingPoolType',
  V2Privacy: 'V2Privacy',
  V2Restroom: 'V2Restroom',
  V2SpaceDetails: 'V2SpaceDetails'
} as const;

export type ListingTypePropertiesCategory = typeof ListingTypePropertiesCategory[keyof typeof ListingTypePropertiesCategory];
export const ListingTypePropertiesDataType = {
  Boolean: 'Boolean',
  Float: 'Float',
  Int: 'Int',
  String: 'String',
  StringArray: 'StringArray'
} as const;

export type ListingTypePropertiesDataType = typeof ListingTypePropertiesDataType[keyof typeof ListingTypePropertiesDataType];
export const ListingTypePropertiesDisplayType = {
  CardSelector: 'CardSelector',
  Dropdown: 'Dropdown',
  DropdownRelationship: 'DropdownRelationship',
  GridSelector: 'GridSelector',
  HorizontalRadioSelector: 'HorizontalRadioSelector',
  MultiHorizontalRadioSelector: 'MultiHorizontalRadioSelector',
  MultiRadioSelector: 'MultiRadioSelector',
  MultiToggle: 'MultiToggle',
  NumericInput: 'NumericInput',
  NumericSlider: 'NumericSlider',
  PopupTextArea: 'PopupTextArea',
  QuantitySelector: 'QuantitySelector',
  RadioSelector: 'RadioSelector',
  RestroomSelector: 'RestroomSelector',
  TagSelector: 'TagSelector',
  TextAreaInput: 'TextAreaInput',
  ToggleDropdown: 'ToggleDropdown',
  ToggleSelector: 'ToggleSelector'
} as const;

export type ListingTypePropertiesDisplayType = typeof ListingTypePropertiesDisplayType[keyof typeof ListingTypePropertiesDisplayType];
export const ListingTypePropertyIcon = {
  aboveGround: 'aboveGround',
  adaCompliant: 'adaCompliant',
  apartmentLoft: 'apartmentLoft',
  asphalt: 'asphalt',
  backyard: 'backyard',
  ballMachine: 'ballMachine',
  balls: 'balls',
  barRestaurant: 'barRestaurant',
  basement: 'basement',
  basketballCourt: 'basketballCourt',
  calendar: 'calendar',
  cave: 'cave',
  cement: 'cement',
  changingArea: 'changingArea',
  chlorine: 'chlorine',
  clay: 'clay',
  coldPlunge: 'coldPlunge',
  conferenceSpace: 'conferenceSpace',
  customHostService: 'customHostService',
  daisyAi: 'daisyAi',
  danceFloor: 'danceFloor',
  default: 'default',
  diningArea: 'diningArea',
  divingBoard: 'divingBoard',
  eventVenue: 'eventVenue',
  firePit: 'firePit',
  fivePlusSpace: 'fivePlusSpace',
  fixedNet: 'fixedNet',
  fourSpace: 'fourSpace',
  framedPool: 'framedPool',
  fullCourt: 'fullCourt',
  fullSizedPool: 'fullSizedPool',
  gameRoom: 'gameRoom',
  garage: 'garage',
  grass: 'grass',
  greatSunlight: 'greatSunlight',
  grill: 'grill',
  grotto: 'grotto',
  halfCourt: 'halfCourt',
  hammocks: 'hammocks',
  hardcourt: 'hardcourt',
  hardwood: 'hardwood',
  heated: 'heated',
  heatedPool: 'heatedPool',
  homeGym: 'homeGym',
  hoop: 'hoop',
  hotTub: 'hotTub',
  house: 'house',
  inGround: 'inGround',
  instructor: 'instructor',
  kiddiePool: 'kiddiePool',
  kitchen: 'kitchen',
  largeYard: 'largeYard',
  letterCircleP: 'letterCircleP',
  lighting: 'lighting',
  livingRoom: 'livingRoom',
  mansion: 'mansion',
  mediaRoom: 'mediaRoom',
  meetingSpace: 'meetingSpace',
  nightLighting: 'nightLighting',
  noRestroom: 'noRestroom',
  nonRegulation: 'nonRegulation',
  oasis: 'oasis',
  oneSpace: 'oneSpace',
  openBook: 'openBook',
  otherHomeType: 'otherHomeType',
  outdoorBar: 'outdoorBar',
  outdoorShower: 'outdoorShower',
  oven: 'oven',
  patio: 'patio',
  pickleball: 'pickleball',
  pickleballCourt: 'pickleballCourt',
  playground: 'playground',
  plunge: 'plunge',
  plungePool: 'plungePool',
  plus: 'plus',
  plusSign: 'plusSign',
  pool: 'pool',
  poolHoop: 'poolHoop',
  poolSizeDeepEnd: 'poolSizeDeepEnd',
  poolSizeLength: 'poolSizeLength',
  poolSizeShallowEnd: 'poolSizeShallowEnd',
  poolSizeWidth: 'poolSizeWidth',
  poolToys: 'poolToys',
  portableRestroom: 'portableRestroom',
  prepRoom: 'prepRoom',
  racquets: 'racquets',
  refridgerator: 'refridgerator',
  regulation: 'regulation',
  roadHorizon: 'roadHorizon',
  roofDeck: 'roofDeck',
  roofTop: 'roofTop',
  saltwater: 'saltwater',
  sauna: 'sauna',
  scenicViews: 'scenicViews',
  securityCamera: 'securityCamera',
  shadedArea: 'shadedArea',
  shallowArea: 'shallowArea',
  sittingArea: 'sittingArea',
  sparkle: 'sparkle',
  speakers: 'speakers',
  studio: 'studio',
  swimmingLanes: 'swimmingLanes',
  tanningEdge: 'tanningEdge',
  temporaryNet: 'temporaryNet',
  tennis: 'tennis',
  thermometer: 'thermometer',
  threeSpace: 'threeSpace',
  toilet: 'toilet',
  towels: 'towels',
  tv: 'tv',
  tvs: 'tvs',
  twoSpace: 'twoSpace',
  umbrella: 'umbrella',
  volleyballCourt: 'volleyballCourt',
  warehouse: 'warehouse',
  water: 'water',
  waterSlide: 'waterSlide',
  waterfall: 'waterfall',
  waterslide: 'waterslide',
  wifi: 'wifi',
  workspace: 'workspace'
} as const;

export type ListingTypePropertyIcon = typeof ListingTypePropertyIcon[keyof typeof ListingTypePropertyIcon];
export type ListingTypePropertyIdAndValue = {
  listingTypePropertyId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type ListingWakeupChecklistInput = {
  listingIds: Array<Scalars['ID']['input']>;
};

export const LoadingState = {
  COMPLETED: 'COMPLETED',
  NOT_PROCESSING: 'NOT_PROCESSING',
  PROCESSING: 'PROCESSING'
} as const;

export type LoadingState = typeof LoadingState[keyof typeof LoadingState];
export type LoginInput = {
  country_phone_code?: InputMaybe<Scalars['String']['input']>;
  mobile_number?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  verification_code?: InputMaybe<Scalars['String']['input']>;
};

export type LookupEmailInput = {
  email: Scalars['String']['input'];
};

export type LookupMobileNumberInput = {
  country_phone_code: Scalars['String']['input'];
  mobile_number: Scalars['String']['input'];
};

export const ManageCategory = {
  Calendar: 'Calendar',
  GuestCheckIn: 'GuestCheckIn',
  ListingPage: 'ListingPage',
  Policies: 'Policies',
  Pricing: 'Pricing',
  Todos: 'Todos'
} as const;

export type ManageCategory = typeof ManageCategory[keyof typeof ManageCategory];
export const ManageGuestsFilter = {
  All: 'All',
  Favorites: 'Favorites',
  OneTimeGuests: 'OneTimeGuests',
  PassHolders: 'PassHolders',
  RepeatGuests: 'RepeatGuests'
} as const;

export type ManageGuestsFilter = typeof ManageGuestsFilter[keyof typeof ManageGuestsFilter];
export type ManageGuestsInput = {
  count: Scalars['Int']['input'];
  filter: ManageGuestsFilter;
  skip: Scalars['Int']['input'];
  sort: ManageGuestsSort;
};

export const ManageGuestsSort = {
  LeastSpent: 'LeastSpent',
  MostBookings: 'MostBookings',
  MostRecentVisit: 'MostRecentVisit',
  MostSpent: 'MostSpent'
} as const;

export type ManageGuestsSort = typeof ManageGuestsSort[keyof typeof ManageGuestsSort];
export const ManageItemIcon = {
  Amenities: 'Amenities',
  Award: 'Award',
  Book: 'Book',
  BookBookmarkTwoTone: 'BookBookmarkTwoTone',
  CalendarCheck: 'CalendarCheck',
  CalendarHeart: 'CalendarHeart',
  CalendarXTwoTone: 'CalendarXTwoTone',
  CallBellTwoTone: 'CallBellTwoTone',
  CarTwoTone: 'CarTwoTone',
  ChatTeardropDotsTwoTone: 'ChatTeardropDotsTwoTone',
  CheckedBriefcase: 'CheckedBriefcase',
  ClockTwoTone: 'ClockTwoTone',
  CourtBasketballTwoTone: 'CourtBasketballTwoTone',
  Crown: 'Crown',
  CurrencyTwoTone: 'CurrencyTwoTone',
  DoorOpenTwoTone: 'DoorOpenTwoTone',
  DownloadSimpleTwoTone: 'DownloadSimpleTwoTone',
  Feather: 'Feather',
  FeatherTwoTone: 'FeatherTwoTone',
  FlowerLotus: 'FlowerLotus',
  HandShakeTwoTone: 'HandShakeTwoTone',
  IdCardTwoTone: 'IdCardTwoTone',
  ImagesTwoTone: 'ImagesTwoTone',
  Key: 'Key',
  Lock: 'Lock',
  NotebookTwoTone: 'NotebookTwoTone',
  PiggyBankTwoTone: 'PiggyBankTwoTone',
  PresentationTwoTone: 'PresentationTwoTone',
  SealCheck: 'SealCheck',
  Shield: 'Shield',
  Star: 'Star',
  SwimmingPool: 'SwimmingPool',
  SwimmingPoolTwoTone: 'SwimmingPoolTwoTone',
  TagTwoTone: 'TagTwoTone',
  ToggleRightTwoTone: 'ToggleRightTwoTone',
  ToiletTwoTone: 'ToiletTwoTone',
  TreeEvergreenTwoTone: 'TreeEvergreenTwoTone',
  UserCheckTwoTone: 'UserCheckTwoTone',
  Users: 'Users',
  VideoConferenceTwoTone: 'VideoConferenceTwoTone',
  VideoTwoTone: 'VideoTwoTone',
  Wrench: 'Wrench',
  XCircle: 'XCircle',
  Zap: 'Zap'
} as const;

export type ManageItemIcon = typeof ManageItemIcon[keyof typeof ManageItemIcon];
export type ManageListingInput = {
  listingId: Scalars['ID']['input'];
};

export type ManageLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MarkUnreadInput = {
  participantUserId: Scalars['ID']['input'];
};

export type MarketingTipsInput = {
  listing_id?: InputMaybe<Scalars['Int']['input']>;
};

export const Measurement = {
  area: 'area',
  currency: 'currency',
  numeric: 'numeric',
  size: 'size'
} as const;

export type Measurement = typeof Measurement[keyof typeof Measurement];
export type MessageInput = {
  booking_chat?: InputMaybe<BookingChatDetails>;
  message: Scalars['String']['input'];
  reciever_id: Scalars['Int']['input'];
  time_zone?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
};

export const MessageType = {
  Automated: 'Automated',
  AutomatedMessage: 'AutomatedMessage',
  BookingCanceled: 'BookingCanceled',
  BookingCompleted: 'BookingCompleted',
  BookingConfirmed: 'BookingConfirmed',
  BookingEditRequestApproved: 'BookingEditRequestApproved',
  BookingEditRequestAutoApproved: 'BookingEditRequestAutoApproved',
  BookingEditRequestCreated: 'BookingEditRequestCreated',
  BookingEditRequestDeclined: 'BookingEditRequestDeclined',
  BookingEditRequestExpired: 'BookingEditRequestExpired',
  BookingEditRequestWithdrawn: 'BookingEditRequestWithdrawn',
  BookingInquiryCreated: 'BookingInquiryCreated',
  BookingPreApproved: 'BookingPreApproved',
  BookingRequestCreated: 'BookingRequestCreated',
  BookingRequestDeclined: 'BookingRequestDeclined',
  BookingRequestExpired: 'BookingRequestExpired',
  CircumventionWarning: 'CircumventionWarning',
  FansAutomatedMessage: 'FansAutomatedMessage',
  FansMessage: 'FansMessage',
  FraudWarning: 'FraudWarning',
  FullRefundMessage: 'FullRefundMessage',
  Message: 'Message',
  MissedCall: 'MissedCall',
  PartialRefundMessage: 'PartialRefundMessage',
  PassCanceled: 'PassCanceled',
  PassPurchased: 'PassPurchased',
  RequestRefundMessage: 'RequestRefundMessage',
  SpecialOfferCanceled: 'SpecialOfferCanceled',
  SpecialOfferCreated: 'SpecialOfferCreated',
  SpecialOfferDeclined: 'SpecialOfferDeclined',
  SpecialOfferExpired: 'SpecialOfferExpired'
} as const;

export type MessageType = typeof MessageType[keyof typeof MessageType];
export type MoneyInput = {
  amount: Scalars['Int']['input'];
  currencyCode: Scalars['String']['input'];
};

export type MultiDipInput = {
  adult_guests?: InputMaybe<Scalars['Int']['input']>;
  children_guests?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  infant_guests?: InputMaybe<Scalars['Int']['input']>;
  pet_guests?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type NewPasswordWithCodeInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export const NotificationChannel = {
  EMAIL: 'EMAIL',
  PUSH: 'PUSH',
  TEXT: 'TEXT',
  TEXT_MARKETING: 'TEXT_MARKETING',
  TEXT_TRANSACTIONAL: 'TEXT_TRANSACTIONAL'
} as const;

export type NotificationChannel = typeof NotificationChannel[keyof typeof NotificationChannel];
export type NotificationInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  last_date?: InputMaybe<Scalars['String']['input']>;
  receiver?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  update_read?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationReadInput = {
  notification_ids: Array<InputMaybe<Scalars['Int']['input']>>;
};

export const NotificationVisual = {
  DaisyScore: 'DaisyScore',
  Duck: 'Duck',
  SoccerBall: 'SoccerBall'
} as const;

export type NotificationVisual = typeof NotificationVisual[keyof typeof NotificationVisual];
export type NumberParkingSpacesInput = {
  number_of_parking_spaces: Scalars['Int']['input'];
  parking_context?: InputMaybe<Scalars['String']['input']>;
  pool_id: Scalars['Int']['input'];
};

export type Oauth2Input = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  apple_email_allow?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  date_birthday?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  id_token?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  provider: Provider;
  referral_token?: InputMaybe<Scalars['String']['input']>;
  request: RequestType;
  set_birthday_later?: InputMaybe<Scalars['Boolean']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type OauthInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** Who the pass is on behalf of */
export const OnBehalfOf = {
  GUEST: 'GUEST',
  HOST: 'HOST'
} as const;

export type OnBehalfOf = typeof OnBehalfOf[keyof typeof OnBehalfOf];
export const OnboardingScreenName = {
  Availability: 'Availability',
  Details: 'Details',
  GuestCount: 'GuestCount',
  ListingType: 'ListingType',
  Location: 'Location',
  Photos: 'Photos',
  Price: 'Price',
  StartDate: 'StartDate',
  Title: 'Title',
  V2_AddPhotos: 'V2_AddPhotos',
  V2_AllowedActivities: 'V2_AllowedActivities',
  V2_AvailabilitySettings: 'V2_AvailabilitySettings',
  V2_BasePrice: 'V2_BasePrice',
  V2_Basics: 'V2_Basics',
  V2_BasicsIntro: 'V2_BasicsIntro',
  V2_BookingPreferences: 'V2_BookingPreferences',
  V2_BookingSetupIntro: 'V2_BookingSetupIntro',
  V2_CancellationPolicy: 'V2_CancellationPolicy',
  V2_DaisyBranding: 'V2_DaisyBranding',
  V2_DaisyPricing: 'V2_DaisyPricing',
  V2_FullPriceList: 'V2_FullPriceList',
  V2_GuestArrival: 'V2_GuestArrival',
  V2_GuestCapacity: 'V2_GuestCapacity',
  V2_GuestDemographics: 'V2_GuestDemographics',
  V2_InstantBookingOptIn: 'V2_InstantBookingOptIn',
  V2_ListingDescription: 'V2_ListingDescription',
  V2_ListingSubType: 'V2_ListingSubType',
  V2_ListingTitle: 'V2_ListingTitle',
  V2_LocationInput: 'V2_LocationInput',
  V2_OffPeakPricing: 'V2_OffPeakPricing',
  V2_PrivacyLevel: 'V2_PrivacyLevel',
  V2_ReadyToGoLive: 'V2_ReadyToGoLive',
  V2_RestroomAccess: 'V2_RestroomAccess',
  V2_SpaceShowcaseIntro: 'V2_SpaceShowcaseIntro',
  V2_SpecialFeatures: 'V2_SpecialFeatures',
  V2_YouAreLive: 'V2_YouAreLive',
  Verification: 'Verification'
} as const;

export type OnboardingScreenName = typeof OnboardingScreenName[keyof typeof OnboardingScreenName];
export type OptInInput = {
  is_promo_opted_in: Scalars['Boolean']['input'];
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export const OrderByRelationAggregateFunction = {
  /** Amount of items. */
  COUNT: 'COUNT'
} as const;

export type OrderByRelationAggregateFunction = typeof OrderByRelationAggregateFunction[keyof typeof OrderByRelationAggregateFunction];
/** Aggregate functions when ordering by a relation that may specify a column. */
export const OrderByRelationWithColumnAggregateFunction = {
  /** Average. */
  AVG: 'AVG',
  /** Amount of items. */
  COUNT: 'COUNT',
  /** Maximum. */
  MAX: 'MAX',
  /** Minimum. */
  MIN: 'MIN',
  /** Sum. */
  SUM: 'SUM'
} as const;

export type OrderByRelationWithColumnAggregateFunction = typeof OrderByRelationWithColumnAggregateFunction[keyof typeof OrderByRelationWithColumnAggregateFunction];
export type OwnersCamerasInput = {
  be_home_other_message?: InputMaybe<Scalars['String']['input']>;
  is_security_cameras?: InputMaybe<Scalars['Boolean']['input']>;
  pool_id: Scalars['Int']['input'];
  reservation_be_home?: InputMaybe<ReservationOwnersBeHome>;
};

export type PartnershipInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bannerToInsert?: InputMaybe<Scalars['String']['input']>;
  colorTheme?: InputMaybe<Scalars['String']['input']>;
  guestRestrictions?: InputMaybe<Scalars['String']['input']>;
  hasExplicitAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  hasWaitListBooking?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isPriced: Scalars['Boolean']['input'];
  listingHeroIcon?: InputMaybe<Scalars['String']['input']>;
  listingTypeId: Scalars['Float']['input'];
  mobileBannerToInsert?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pdpHighlightMsgBody?: InputMaybe<Scalars['String']['input']>;
  pdpHighlightMsgTitle?: InputMaybe<Scalars['String']['input']>;
  sponsoredBy?: InputMaybe<Scalars['String']['input']>;
  submitCaption?: InputMaybe<Scalars['String']['input']>;
  survey?: InputMaybe<Scalars['JSON']['input']>;
};

/** Allowed discount types */
export const PassDiscountType = {
  FIXED: 'FIXED',
  PERCENTAGE: 'PERCENTAGE'
} as const;

export type PassDiscountType = typeof PassDiscountType[keyof typeof PassDiscountType];
/** Pass expiration type options for V3 passes */
export const PassExpirationType = {
  END_OF_SEASON: 'END_OF_SEASON',
  INDEFINITELY: 'INDEFINITELY'
} as const;

export type PassExpirationType = typeof PassExpirationType[keyof typeof PassExpirationType];
export type PassInput = {
  availableTimes?: InputMaybe<Array<AvailableTimeInput>>;
  blackoutDays?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  discountType?: InputMaybe<PassDiscountType>;
  eligibleDays?: InputMaybe<Array<Days>>;
  enabledForHolidays?: InputMaybe<Scalars['Boolean']['input']>;
  enabledForWeekends?: InputMaybe<Scalars['Boolean']['input']>;
  listingId: Scalars['Int']['input'];
  maxActiveBookings?: InputMaybe<Scalars['Int']['input']>;
  maxActivePasses?: InputMaybe<Scalars['Int']['input']>;
  maxDailyBookings?: InputMaybe<Scalars['Int']['input']>;
  maxDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxGuests?: InputMaybe<Scalars['Int']['input']>;
  passAmenities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  price?: InputMaybe<MoneyInput>;
  tiers?: InputMaybe<Array<TierInput>>;
  type: PassType;
};

export const PassPricingStatus = {
  FullyCovered: 'FullyCovered',
  NotCovered: 'NotCovered',
  PartiallyCovered: 'PartiallyCovered'
} as const;

export type PassPricingStatus = typeof PassPricingStatus[keyof typeof PassPricingStatus];
/** Allowed pass states */
export const PassState = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  INACTIVE: 'INACTIVE'
} as const;

export type PassState = typeof PassState[keyof typeof PassState];
/** Allowed pass types */
export const PassType = {
  ALL_ACCESS: 'ALL_ACCESS',
  BASKETBALL_PRO: 'BASKETBALL_PRO',
  BASKETBALL_STANDARD: 'BASKETBALL_STANDARD',
  BASKETBALL_VIP: 'BASKETBALL_VIP',
  EARLY_BIRD: 'EARLY_BIRD',
  EARLY_BIRD_V2: 'EARLY_BIRD_V2',
  FAMILY_AND_FRIENDS: 'FAMILY_AND_FRIENDS',
  FIXED_HOURS: 'FIXED_HOURS',
  PICKLEBALL_PRO: 'PICKLEBALL_PRO',
  PICKLEBALL_STANDARD: 'PICKLEBALL_STANDARD',
  PICKLEBALL_VIP: 'PICKLEBALL_VIP',
  STANDARD_ACCESS: 'STANDARD_ACCESS',
  TENNIS_PRO: 'TENNIS_PRO',
  TENNIS_STANDARD: 'TENNIS_STANDARD',
  TENNIS_VIP: 'TENNIS_VIP',
  VIP_ACCESS: 'VIP_ACCESS',
  WEEKDAY: 'WEEKDAY'
} as const;

export type PassType = typeof PassType[keyof typeof PassType];
export const PassesType = {
  ANYTIME: 'ANYTIME',
  BASKETBALL_PRO: 'BASKETBALL_PRO',
  BASKETBALL_STANDARD: 'BASKETBALL_STANDARD',
  BASKETBALL_VIP: 'BASKETBALL_VIP',
  EARLY_BIRD: 'EARLY_BIRD',
  EARLY_BIRD_V2: 'EARLY_BIRD_V2',
  FAMILY_AND_FRIENDS: 'FAMILY_AND_FRIENDS',
  FIXED_HOURS: 'FIXED_HOURS',
  PICKLEBALL_PRO: 'PICKLEBALL_PRO',
  PICKLEBALL_STANDARD: 'PICKLEBALL_STANDARD',
  PICKLEBALL_VIP: 'PICKLEBALL_VIP',
  STANDARD_ACCESS: 'STANDARD_ACCESS',
  TENNIS_PRO: 'TENNIS_PRO',
  TENNIS_STANDARD: 'TENNIS_STANDARD',
  TENNIS_VIP: 'TENNIS_VIP',
  VIP_ACCESS: 'VIP_ACCESS',
  WEEKDAY: 'WEEKDAY'
} as const;

export type PassesType = typeof PassesType[keyof typeof PassesType];
export const PaymentMethod = {
  card: 'card',
  credits: 'credits',
  klarna: 'klarna'
} as const;

export type PaymentMethod = typeof PaymentMethod[keyof typeof PaymentMethod];
export type PerGuestPricingInput = {
  from_onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hourly_price: Scalars['Float']['input'];
  pool_id: Scalars['Int']['input'];
  price_per_guest?: InputMaybe<Scalars['Float']['input']>;
  price_per_guest_threshold?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformanceOverviewInput = {
  period: PerformanceOverviewPeriod;
  pool_id?: InputMaybe<Scalars['Int']['input']>;
};

export const PerformanceOverviewPeriod = {
  ALL_TIME: 'ALL_TIME',
  DAYS_365: 'DAYS_365',
  MONTH: 'MONTH',
  WEEK: 'WEEK',
  YEAR: 'YEAR'
} as const;

export type PerformanceOverviewPeriod = typeof PerformanceOverviewPeriod[keyof typeof PerformanceOverviewPeriod];
export const PerformanceRating = {
  FAIR: 'FAIR',
  GREAT: 'GREAT',
  POOR: 'POOR'
} as const;

export type PerformanceRating = typeof PerformanceRating[keyof typeof PerformanceRating];
export type PerformanceScoresInput = {
  pool_id?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformanceTipsInput = {
  listing_id: Scalars['Int']['input'];
};

export const PetsRules = {
  InSpace: 'InSpace',
  NotAllowed: 'NotAllowed',
  NotInSpace: 'NotInSpace'
} as const;

export type PetsRules = typeof PetsRules[keyof typeof PetsRules];
export const PhotoResponseStatus = {
  BAD: 'BAD',
  GOOD: 'GOOD',
  NEEDS_IMPROVEMENT: 'NEEDS_IMPROVEMENT'
} as const;

export type PhotoResponseStatus = typeof PhotoResponseStatus[keyof typeof PhotoResponseStatus];
export type PoolAmenitiesAdditionalInput = {
  additional_amenities?: InputMaybe<Scalars['String']['input']>;
  pool_id: Scalars['ID']['input'];
  restroom_access: Scalars['Boolean']['input'];
  restroom_description?: InputMaybe<Scalars['String']['input']>;
};

export type PoolAmenitiesListInput = {
  amenities_list?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pool_id: Scalars['ID']['input'];
};

export type PoolAvailabilityInput = {
  advance_notice?: InputMaybe<Scalars['Int']['input']>;
  availability_window?: InputMaybe<Scalars['Int']['input']>;
  available_from?: InputMaybe<Scalars['String']['input']>;
  available_to?: InputMaybe<Scalars['String']['input']>;
  default_instant_booking?: InputMaybe<Scalars['Boolean']['input']>;
  instant_booking_min_hours_in_advance?: InputMaybe<Scalars['Int']['input']>;
  instant_booking_require_verified?: InputMaybe<Scalars['Boolean']['input']>;
  instant_group_size?: InputMaybe<Scalars['Int']['input']>;
  min_booking_length?: InputMaybe<Scalars['Int']['input']>;
  min_buffer_time?: InputMaybe<Scalars['Int']['input']>;
  months_open?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pool_id: Scalars['ID']['input'];
};

export type PoolCancellationPolicyInput = {
  pool_cancellation_id: Scalars['ID']['input'];
  pool_id: Scalars['ID']['input'];
};

export type PoolDaysInput = {
  available?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pool_id?: InputMaybe<Scalars['Int']['input']>;
  unavailable?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PoolDimensionsInput = {
  deep_end?: InputMaybe<Scalars['AnyType']['input']>;
  pool_id: Scalars['ID']['input'];
  pool_length?: InputMaybe<Scalars['AnyType']['input']>;
  pool_width?: InputMaybe<Scalars['AnyType']['input']>;
  shallow_end?: InputMaybe<Scalars['AnyType']['input']>;
};

export type PoolDipDiscountInput = {
  discounts?: InputMaybe<Array<InputMaybe<DipDiscount>>>;
  pool_id: Scalars['Int']['input'];
};

export type PoolDiscountDaysInput = {
  discount_days: Scalars['String']['input'];
  pool_id: Scalars['ID']['input'];
};

export type PoolFurniture = {
  furniture_id?: InputMaybe<Scalars['Int']['input']>;
  item_amount?: InputMaybe<Scalars['Int']['input']>;
  persons_number?: InputMaybe<Scalars['Int']['input']>;
};

export type PoolFurnitureInput = {
  furniture?: InputMaybe<Array<InputMaybe<PoolFurniture>>>;
  other_furniture?: InputMaybe<Scalars['String']['input']>;
  pool_id: Scalars['Int']['input'];
};

export type PoolImageInput = {
  cover_image?: InputMaybe<Scalars['String']['input']>;
  other_images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pool_id: Scalars['ID']['input'];
};

export type PoolLocationInput = {
  advance_notice?: InputMaybe<Scalars['Int']['input']>;
  availability_window?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  custom_listing_type?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  full_address: Scalars['String']['input'];
  listing_type?: InputMaybe<ListingType>;
  name?: InputMaybe<Scalars['String']['input']>;
  pool_id?: InputMaybe<Scalars['ID']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  special_access_instruction?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  zip_code: Scalars['String']['input'];
};

export type PoolPricingAndGuestInput = {
  children_allowed: Scalars['Boolean']['input'];
  discount_days?: InputMaybe<Scalars['String']['input']>;
  hourly_price: Scalars['Float']['input'];
  infant_allowed: Scalars['Boolean']['input'];
  max_number_guest: Scalars['Int']['input'];
  pet_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  pets_rule?: InputMaybe<PetsRules>;
  pool_id: Scalars['ID']['input'];
  price_per_guest?: InputMaybe<Scalars['Float']['input']>;
  price_per_guest_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  price_per_guest_min_capacity?: InputMaybe<Scalars['Int']['input']>;
};

export type PoolPrivacyInput = {
  pool_id: Scalars['ID']['input'];
  pool_privacy_id: Scalars['ID']['input'];
};

export type PoolRuleInput = {
  additional_rules?: InputMaybe<Scalars['String']['input']>;
  pets_rule?: InputMaybe<PetsRules>;
  pool_id: Scalars['ID']['input'];
  pool_rules_id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type PoolSecurityDepositInput = {
  amount_minor?: InputMaybe<Scalars['Int']['input']>;
  min_guests?: InputMaybe<Scalars['Int']['input']>;
  pool_id: Scalars['ID']['input'];
};

export type PoolTimesInput = {
  available_date?: InputMaybe<Scalars['Date']['input']>;
  available_time?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  days?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  pool_id: Scalars['ID']['input'];
  repeat_availablitlity: Scalars['Boolean']['input'];
};

export type PoolTypeInput = {
  pool_id: Scalars['Int']['input'];
  pool_type: Scalars['String']['input'];
  water_system: WaterSystems;
};

export const PostOnboardingStepIcon = {
  BigCheckMark: 'BigCheckMark',
  Calendar: 'Calendar',
  Car: 'Car',
  CheckList: 'CheckList',
  CheckedBriefcase: 'CheckedBriefcase',
  CheckedUser: 'CheckedUser',
  ClosedEye: 'ClosedEye',
  EditPencil: 'EditPencil',
  House: 'House',
  Manual: 'Manual',
  Membership: 'Membership',
  PhotoUpload: 'PhotoUpload',
  Star: 'Star',
  StarterKit: 'StarterKit',
  Videos: 'Videos'
} as const;

export type PostOnboardingStepIcon = typeof PostOnboardingStepIcon[keyof typeof PostOnboardingStepIcon];
export const PostOnboardingStepName = {
  Access: 'Access',
  Amenities: 'Amenities',
  Availability: 'Availability',
  Calendar: 'Calendar',
  Description: 'Description',
  GuestRules: 'GuestRules',
  Membership: 'Membership',
  Parking: 'Parking',
  Payments: 'Payments',
  Photos: 'Photos',
  Privacy: 'Privacy',
  Rules: 'Rules',
  SpaceFeatures: 'SpaceFeatures',
  StarterKit: 'StarterKit',
  Videos: 'Videos'
} as const;

export type PostOnboardingStepName = typeof PostOnboardingStepName[keyof typeof PostOnboardingStepName];
export const PostalCodeSource = {
  GEOLOCATION: 'GEOLOCATION',
  USER_INPUT: 'USER_INPUT'
} as const;

export type PostalCodeSource = typeof PostalCodeSource[keyof typeof PostalCodeSource];
export type PreBookingChecksInput = {
  adult_guests: Scalars['Int']['input'];
  child_guests: Scalars['Int']['input'];
  end_datetime: Scalars['DateTimeTz']['input'];
  infant_guests: Scalars['Int']['input'];
  pet_guests: Scalars['Int']['input'];
  pool_id: Scalars['Int']['input'];
  start_datetime: Scalars['DateTimeTz']['input'];
};

export type PremiumAmenityInput = {
  advance_notice?: InputMaybe<Scalars['Int']['input']>;
  amenity_id?: InputMaybe<Scalars['Int']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_service_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  main_category?: InputMaybe<Scalars['String']['input']>;
  pool_id: Scalars['Int']['input'];
  price_amount?: InputMaybe<Scalars['Float']['input']>;
  price_type?: InputMaybe<Scalars['String']['input']>;
  square_footage?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
};

export type PremiumInfoInput = {
  /** Optional booking context for calculating upsell savings (same as pricingSummary) */
  booking?: InputMaybe<PricingSummaryInput>;
};

export type PremiumInput = {
  appleGooglePay: Scalars['Boolean']['input'];
  /** Expected price in cents for validation */
  expectedPriceCents?: InputMaybe<Scalars['Float']['input']>;
  paymentSourceId?: InputMaybe<Scalars['ID']['input']>;
  premiumV2?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseSource?: InputMaybe<PurchaseSource>;
  type: PremiumType;
};

export type PremiumInputNoType = {
  appleGooglePay: Scalars['Boolean']['input'];
  paymentSourceId?: InputMaybe<Scalars['ID']['input']>;
};

export const PremiumState = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  NONE: 'NONE'
} as const;

export type PremiumState = typeof PremiumState[keyof typeof PremiumState];
/** Allowed premium statuses */
export const PremiumStatus = {
  ACTIVE: 'ACTIVE',
  CANCELED: 'CANCELED',
  DOWNGRADED: 'DOWNGRADED',
  EXPIRED: 'EXPIRED',
  PAUSED: 'PAUSED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  PENDING: 'PENDING',
  RENEWAL_ATTEMPT_FAILED: 'RENEWAL_ATTEMPT_FAILED',
  RENEWAL_FAILED: 'RENEWAL_FAILED',
  TRIAL: 'TRIAL',
  UPGRADED: 'UPGRADED'
} as const;

export type PremiumStatus = typeof PremiumStatus[keyof typeof PremiumStatus];
/** Allowed premium types */
export const PremiumType = {
  IGLOO: 'IGLOO',
  REGULAR: 'REGULAR',
  SUMMER: 'SUMMER'
} as const;

export type PremiumType = typeof PremiumType[keyof typeof PremiumType];
export type PriceTierInput = {
  hourly_price: Scalars['Float']['input'];
  price_tier_id: Scalars['Int']['input'];
};

export type PriceTiersValues = {
  id: Scalars['Int']['input'];
  price: Scalars['Float']['input'];
};

export const PriceTypeEnum = {
  Flat: 'Flat',
  PerGuest: 'PerGuest',
  PerHour: 'PerHour'
} as const;

export type PriceTypeEnum = typeof PriceTypeEnum[keyof typeof PriceTypeEnum];
export type PricingDetailsInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  end_datetime?: InputMaybe<Scalars['DateTimeTz']['input']>;
  pool_id: Scalars['Int']['input'];
  skip_service_fees?: InputMaybe<Scalars['Boolean']['input']>;
  start_datetime?: InputMaybe<Scalars['DateTimeTz']['input']>;
};

export const PricingScheme = {
  DAILY: 'DAILY',
  DAILY_TIERED: 'DAILY_TIERED',
  PER_GUEST: 'PER_GUEST',
  TIERED: 'TIERED'
} as const;

export type PricingScheme = typeof PricingScheme[keyof typeof PricingScheme];
export type PricingSummaryInput = {
  adult_guests?: InputMaybe<Scalars['Int']['input']>;
  booking_id?: InputMaybe<Scalars['Int']['input']>;
  child_guests?: InputMaybe<Scalars['Int']['input']>;
  display_fees?: InputMaybe<Scalars['Boolean']['input']>;
  display_for_host?: InputMaybe<Scalars['Boolean']['input']>;
  duration_in_minutes_override?: InputMaybe<Scalars['Int']['input']>;
  end_datetime?: InputMaybe<Scalars['DateTimeTz']['input']>;
  guest_pass_id?: InputMaybe<Scalars['Int']['input']>;
  host_discount?: InputMaybe<Scalars['Float']['input']>;
  include_display_sections: Scalars['Boolean']['input'];
  include_lifeguard_in_calculations?: InputMaybe<Scalars['Boolean']['input']>;
  include_monitor_in_calculations?: InputMaybe<Scalars['Boolean']['input']>;
  include_pending_change?: InputMaybe<Scalars['Boolean']['input']>;
  infant_guests?: InputMaybe<Scalars['Int']['input']>;
  is_editing_booking?: InputMaybe<Scalars['Boolean']['input']>;
  pet_guests?: InputMaybe<Scalars['Int']['input']>;
  pool_id?: InputMaybe<Scalars['Int']['input']>;
  pool_premium_amenity_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  promo_code_id?: InputMaybe<Scalars['Int']['input']>;
  special_offer_price?: InputMaybe<Scalars['Float']['input']>;
  start_datetime?: InputMaybe<Scalars['DateTimeTz']['input']>;
  upsell_pass_id?: InputMaybe<Scalars['Int']['input']>;
  use_credits?: InputMaybe<Scalars['Boolean']['input']>;
  use_klarna?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricingSummaryPublicInput = {
  adult_guests?: InputMaybe<Scalars['Int']['input']>;
  child_guests?: InputMaybe<Scalars['Int']['input']>;
  display_fees: Scalars['Boolean']['input'];
  display_for_host: Scalars['Boolean']['input'];
  end_datetime?: InputMaybe<Scalars['DateTimeTz']['input']>;
  guest_pass_id?: InputMaybe<Scalars['Int']['input']>;
  host_discount?: InputMaybe<Scalars['Float']['input']>;
  include_display_sections: Scalars['Boolean']['input'];
  include_lifeguard_in_calculations?: InputMaybe<Scalars['Boolean']['input']>;
  include_monitor_in_calculations?: InputMaybe<Scalars['Boolean']['input']>;
  infant_guests?: InputMaybe<Scalars['Int']['input']>;
  pet_guests?: InputMaybe<Scalars['Int']['input']>;
  pool_id?: InputMaybe<Scalars['Int']['input']>;
  pool_premium_amenity_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  promo_code_id?: InputMaybe<Scalars['Int']['input']>;
  start_datetime?: InputMaybe<Scalars['DateTimeTz']['input']>;
  upsell_pass_id?: InputMaybe<Scalars['Int']['input']>;
};

export const ProDefaultTab = {
  Pro: 'Pro',
  Promote: 'Promote'
} as const;

export type ProDefaultTab = typeof ProDefaultTab[keyof typeof ProDefaultTab];
export type ProInput = {
  listingId: Scalars['ID']['input'];
};

export const ProMarketingShareTarget = {
  Email: 'Email',
  Facebook: 'Facebook',
  Instagram: 'Instagram',
  QrCode: 'QrCode',
  ShareTo: 'ShareTo',
  Stories: 'Stories',
  Text: 'Text'
} as const;

export type ProMarketingShareTarget = typeof ProMarketingShareTarget[keyof typeof ProMarketingShareTarget];
export const ProToolTarget = {
  AbandonCartPromo: 'AbandonCartPromo',
  CreateAnnouncement: 'CreateAnnouncement',
  CreatePackage: 'CreatePackage',
  CreatePromoCode: 'CreatePromoCode',
  CustomUrl: 'CustomUrl',
  DownloadIGTemplates: 'DownloadIGTemplates',
  DownloadPostCard: 'DownloadPostCard',
  HostExperience: 'HostExperience',
  HostSwimLessons: 'HostSwimLessons',
  LaunchMembership: 'LaunchMembership',
  ManageGuests: 'ManageGuests',
  PostDeal: 'PostDeal'
} as const;

export type ProToolTarget = typeof ProToolTarget[keyof typeof ProToolTarget];
export const PromocodePlatform = {
  APP: 'APP',
  WEB: 'WEB'
} as const;

export type PromocodePlatform = typeof PromocodePlatform[keyof typeof PromocodePlatform];
export const PromotionType = {
  DROP_OFF: 'DROP_OFF',
  LONG_BOOKING: 'LONG_BOOKING',
  OFF_PEAK: 'OFF_PEAK',
  SAME_DAY: 'SAME_DAY',
  WEEKDAY: 'WEEKDAY'
} as const;

export type PromotionType = typeof PromotionType[keyof typeof PromotionType];
export const Provider = {
  APPLE: 'APPLE',
  FACEBOOK: 'FACEBOOK',
  GOOGLE: 'GOOGLE'
} as const;

export type Provider = typeof Provider[keyof typeof Provider];
export type PurchasePassInput = {
  appleGooglePay: Scalars['Boolean']['input'];
  bookingGuests?: InputMaybe<Scalars['Int']['input']>;
  bookingUpsellId?: InputMaybe<Scalars['ID']['input']>;
  hoursUsed?: InputMaybe<Scalars['Int']['input']>;
  isAutoRenew?: Scalars['Boolean']['input'];
  listingId?: InputMaybe<Scalars['ID']['input']>;
  passId: Scalars['ID']['input'];
  paymentSourceId?: InputMaybe<Scalars['ID']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
  useCredits: Scalars['Boolean']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** Where the user initiated the premium purchase */
export const PurchaseSource = {
  BOOKING_UPSELL: 'BOOKING_UPSELL',
  HOME_BANNER: 'HOME_BANNER',
  OTHER: 'OTHER',
  POPUP: 'POPUP',
  PROFILE: 'PROFILE'
} as const;

export type PurchaseSource = typeof PurchaseSource[keyof typeof PurchaseSource];
export const RatePlatform = {
  android: 'android',
  ios: 'ios'
} as const;

export type RatePlatform = typeof RatePlatform[keyof typeof RatePlatform];
export type ReadMessagesInput = {
  participantUserId: Scalars['ID']['input'];
};

export type ReadPassFormV3Input = {
  listingId: Scalars['Int']['input'];
  type?: InputMaybe<PassType>;
};

export type RecordActivityInput = {
  resource_id: Scalars['Int']['input'];
  type: UserActivityTypeInput;
};

export const ReferalMilestoneActionsTypes = {
  completed_guest_booking: 'completed_guest_booking',
  host_earnings: 'host_earnings',
  signed_up: 'signed_up'
} as const;

export type ReferalMilestoneActionsTypes = typeof ReferalMilestoneActionsTypes[keyof typeof ReferalMilestoneActionsTypes];
export const ReferalMilestoneApplyToTypes = {
  ALL: 'ALL',
  GUEST: 'GUEST',
  HOST: 'HOST'
} as const;

export type ReferalMilestoneApplyToTypes = typeof ReferalMilestoneApplyToTypes[keyof typeof ReferalMilestoneApplyToTypes];
export const ReferalMilestonePayoutTypes = {
  CASH: 'CASH',
  CREDIT: 'CREDIT'
} as const;

export type ReferalMilestonePayoutTypes = typeof ReferalMilestonePayoutTypes[keyof typeof ReferalMilestonePayoutTypes];
export const ReferalMilestoneWhoGetsPaidTypes = {
  REFERRED: 'REFERRED',
  REFERRER: 'REFERRER'
} as const;

export type ReferalMilestoneWhoGetsPaidTypes = typeof ReferalMilestoneWhoGetsPaidTypes[keyof typeof ReferalMilestoneWhoGetsPaidTypes];
export const ReferralAction = {
  completed_guest_booking: 'completed_guest_booking',
  first_pool_booked: 'first_pool_booked',
  host_earnings: 'host_earnings',
  signed_up: 'signed_up'
} as const;

export type ReferralAction = typeof ReferralAction[keyof typeof ReferralAction];
export type ReferralInput = {
  user_id: Scalars['Int']['input'];
};

export type ReferralInviteInput = {
  referral_url: Scalars['String']['input'];
  to?: InputMaybe<Array<InviteUserInput>>;
};

export const ReferralInviteTypes = {
  GUEST: 'GUEST',
  HOST: 'HOST'
} as const;

export type ReferralInviteTypes = typeof ReferralInviteTypes[keyof typeof ReferralInviteTypes];
export const ReferralInviterType = {
  PARTNER: 'PARTNER',
  USER: 'USER'
} as const;

export type ReferralInviterType = typeof ReferralInviterType[keyof typeof ReferralInviterType];
export type ReferralMilestonesByReferralTokenInput = {
  referral_token?: InputMaybe<Scalars['String']['input']>;
};

export const ReferralPayoutTypes = {
  CASH: 'CASH',
  CREDIT: 'CREDIT'
} as const;

export type ReferralPayoutTypes = typeof ReferralPayoutTypes[keyof typeof ReferralPayoutTypes];
export const ReferrerOrReferred = {
  REFERRED: 'REFERRED',
  REFERRER: 'REFERRER'
} as const;

export type ReferrerOrReferred = typeof ReferrerOrReferred[keyof typeof ReferrerOrReferred];
export type RefreshTokenInput = {
  refresh_token?: InputMaybe<Scalars['String']['input']>;
};

export const RefundType = {
  guest_cancel_cash: 'guest_cancel_cash',
  guest_cancel_credits: 'guest_cancel_credits',
  host_cancel_cash: 'host_cancel_cash',
  host_cancel_credits: 'host_cancel_credits',
  host_request_decline: 'host_request_decline',
  host_request_expire: 'host_request_expire'
} as const;

export type RefundType = typeof RefundType[keyof typeof RefundType];
export type RegisterInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
};

export const RegisterStatuses = {
  MUST_VERIFY_EMAIL: 'MUST_VERIFY_EMAIL',
  SUCCESS: 'SUCCESS'
} as const;

export type RegisterStatuses = typeof RegisterStatuses[keyof typeof RegisterStatuses];
export type RemoveBookingInvitesInput = {
  booking_id: Scalars['Int']['input'];
  booking_invite_ids: Array<Scalars['Int']['input']>;
};

export type RemoveGuestFromFavoritesInput = {
  guestId: Scalars['ID']['input'];
};

export type RemoveListingReviewHostResponseInput = {
  listing_review_id: Scalars['Int']['input'];
};

export type RemovePaymentSourceInput = {
  id: Scalars['Int']['input'];
};

export type RequestRefundInput = {
  booking_id: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export const RequestResponse = {
  accept: 'accept',
  decline: 'decline'
} as const;

export type RequestResponse = typeof RequestResponse[keyof typeof RequestResponse];
export const RequestType = {
  auth: 'auth',
  url: 'url'
} as const;

export type RequestType = typeof RequestType[keyof typeof RequestType];
export type ResendEmailVerificationInput = {
  email: Scalars['String']['input'];
};

export type ReservationInput = {
  booking_id: Scalars['Int']['input'];
  cancel_chat_message?: InputMaybe<Scalars['String']['input']>;
  cancel_reason?: InputMaybe<Scalars['String']['input']>;
  cancel_reason_message?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  decline_reason?: InputMaybe<Scalars['String']['input']>;
  execute?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  guest_cancel_refund_type?: InputMaybe<GuestCancelRefundType>;
  payment_source_id?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export const ReservationOwnersBeHome = {
  BeHome: 'BeHome',
  NotBeHome: 'NotBeHome',
  Other: 'Other'
} as const;

export type ReservationOwnersBeHome = typeof ReservationOwnersBeHome[keyof typeof ReservationOwnersBeHome];
export type ReserveServiceInput = {
  bookingId: Scalars['Int']['input'];
};

export type RespondToListingReviewInput = {
  listing_review_id: Scalars['Int']['input'];
  message: Scalars['String']['input'];
};

export type RestroomAccessInput = {
  pool_id: Scalars['Int']['input'];
  restroom_access_type: RestroomAccessTypes;
};

export const RestroomAccessType = {
  NoRestroom: 'NoRestroom',
  PortableRestroom: 'PortableRestroom',
  PrivateRestroom: 'PrivateRestroom',
  ResidenceRestroom: 'ResidenceRestroom'
} as const;

export type RestroomAccessType = typeof RestroomAccessType[keyof typeof RestroomAccessType];
export const RestroomAccessTypes = {
  none: 'none',
  portable: 'portable',
  private: 'private',
  residence: 'residence'
} as const;

export type RestroomAccessTypes = typeof RestroomAccessTypes[keyof typeof RestroomAccessTypes];
export type ReviewInput = {
  booking_id: Scalars['Int']['input'];
  comment: Scalars['String']['input'];
  rating: Scalars['Float']['input'];
};

export const RoleEnum = {
  Host: 'Host',
  Swimmer: 'Swimmer'
} as const;

export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
export const RuleIcon = {
  ALCOHOL: 'ALCOHOL',
  COMMERCIAL_USE: 'COMMERCIAL_USE',
  DIVING: 'DIVING',
  FOOD: 'FOOD',
  GLASS: 'GLASS',
  LOUD_MUSIC: 'LOUD_MUSIC',
  NUDITY: 'NUDITY',
  PARTIES: 'PARTIES',
  PETS: 'PETS',
  SMOKING: 'SMOKING',
  THIRD_PARTY_VENDORS: 'THIRD_PARTY_VENDORS'
} as const;

export type RuleIcon = typeof RuleIcon[keyof typeof RuleIcon];
export type RuleInput = {
  id: Scalars['Int']['input'];
  is_allowed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveAutomatedMessageContentInput = {
  eventName: AutomatedMessageEventType;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  listingId: Scalars['Int']['input'];
  messageContent?: InputMaybe<Scalars['String']['input']>;
  messageTitle?: InputMaybe<Scalars['String']['input']>;
};

export type SaveBookingInvitationInput = {
  booking_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<InvitationTheme>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SaveFavoriteCollectionInput = {
  favorited_from?: InputMaybe<FavoritedFromTypes>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pools?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SaveFavoritePoolInput = {
  favorite: Scalars['Boolean']['input'];
  favorited_from?: InputMaybe<FavoritedFromTypes>;
  pool_id: Scalars['Int']['input'];
};

export type SaveGuestNoteInput = {
  note: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type SaveListingAvailabilityOverrideInput = {
  days: Array<Scalars['DateTime']['input']>;
  /** Whether or not to ignore bookings that overlap with unavailabilities */
  ignoreOverlappingBookings?: Scalars['Boolean']['input'];
  listingId: Scalars['ID']['input'];
  /** Listing status for the availability event */
  listingStatus?: InputMaybe<ListingAvailabilityOverrideStatus>;
  /** Any price modifiers in percent (positive or negative) */
  priceModifier?: InputMaybe<Scalars['Int']['input']>;
  /** Offset to include when returning schedule response */
  responseOffset?: InputMaybe<Scalars['UtcOffset']['input']>;
  /** List of unavailability times to apply to each date */
  unavailableTimes?: InputMaybe<Array<UnavailabilityTime>>;
};

export type SaveListingInsuranceCoverageInput = {
  is_covered_by_insurance: Scalars['Boolean']['input'];
  listing_id: Scalars['ID']['input'];
};

export type SaveListingMessageTemplateInput = {
  clearTrigger?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventName?: InputMaybe<AutomatedMessageEventType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  listingId: Scalars['Int']['input'];
  messageContent?: InputMaybe<Scalars['String']['input']>;
  messageTitle?: InputMaybe<Scalars['String']['input']>;
};

export type SavePassV3Input = {
  dayTypes: Array<DayType>;
  discount: Scalars['Int']['input'];
  expirationType?: PassExpirationType;
  hoursPerMonth: Scalars['Int']['input'];
  listingId: Scalars['Int']['input'];
  maxGuests?: InputMaybe<Scalars['Int']['input']>;
  state: PassState;
  timeType: TimeType;
  type: PassType;
};

export type SavePoolToFavoriteCollectionsInput = {
  collection_ids: Array<Scalars['Int']['input']>;
  favorited_from?: InputMaybe<FavoritedFromTypes>;
  pool_id: Scalars['Int']['input'];
};

export type SavePriceTiersInput = {
  from_onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  pool_id: Scalars['Int']['input'];
  price_tiers: Array<PriceTiersValues>;
};

export const Screen = {
  AdvancedPricing: 'AdvancedPricing',
  AutomatedMessages: 'AutomatedMessages',
  ConciergeBanner: 'ConciergeBanner',
  GuestAccess: 'GuestAccess',
  GuestCheckIn: 'GuestCheckIn',
  GuestParking: 'GuestParking',
  GuestSettings: 'GuestSettings',
  HostServices: 'HostServices',
  Pricing: 'Pricing',
  TitleAndDescription: 'TitleAndDescription',
  VideoTour: 'VideoTour',
  WelcomeKit: 'WelcomeKit'
} as const;

export type Screen = typeof Screen[keyof typeof Screen];
export const SearchFilterIcon = {
  ADA_FRIENDLY: 'ADA_FRIENDLY',
  ALCOHOL: 'ALCOHOL',
  APARTMENT: 'APARTMENT',
  ASPHALT: 'ASPHALT',
  BACKYARD: 'BACKYARD',
  BALLS: 'BALLS',
  BALL_MACHINE: 'BALL_MACHINE',
  BAR: 'BAR',
  BASEMENT: 'BASEMENT',
  BUDGET: 'BUDGET',
  CASUAL_PLAY: 'CASUAL_PLAY',
  CAVE: 'CAVE',
  CELEBRATIONS: 'CELEBRATIONS',
  CEMENT: 'CEMENT',
  CHILDREN_INFANTS: 'CHILDREN_INFANTS',
  CHLORINE: 'CHLORINE',
  CIGARETTE: 'CIGARETTE',
  CLAY: 'CLAY',
  COLD_PLUNGE: 'COLD_PLUNGE',
  COMPETITIVE_PLAY: 'COMPETITIVE_PLAY',
  CONFERENCE: 'CONFERENCE',
  COOKING: 'COOKING',
  CORPORATE_EVENTS: 'CORPORATE_EVENTS',
  DEAL: 'DEAL',
  DINING_AREA: 'DINING_AREA',
  DINNERS: 'DINNERS',
  DISCOVER: 'DISCOVER',
  DISNEY: 'DISNEY',
  DIVING_BOARD: 'DIVING_BOARD',
  EVENT_VENUE: 'EVENT_VENUE',
  FAMILY_GATHERINGS: 'FAMILY_GATHERINGS',
  FIRE_PIT: 'FIRE_PIT',
  FIXED_NET: 'FIXED_NET',
  FRIEND_HANGOUTS: 'FRIEND_HANGOUTS',
  GAME_ROOM: 'GAME_ROOM',
  GARAGE: 'GARAGE',
  GRASS: 'GRASS',
  GREAT_SUNLIGHT: 'GREAT_SUNLIGHT',
  GRILL: 'GRILL',
  GROTTO: 'GROTTO',
  GYM: 'GYM',
  HARD: 'HARD',
  HARDWOOD: 'HARDWOOD',
  HEATED: 'HEATED',
  HOME: 'HOME',
  HOOPS: 'HOOPS',
  HOT_TUB: 'HOT_TUB',
  IGLOO: 'IGLOO',
  INDOOR: 'INDOOR',
  INSTANT_BOOK: 'INSTANT_BOOK',
  INSTRUCTOR: 'INSTRUCTOR',
  KIDDIE_POOL: 'KIDDIE_POOL',
  KITCHEN: 'KITCHEN',
  LESSONS: 'LESSONS',
  LIVING_ROOM: 'LIVING_ROOM',
  LOFT: 'LOFT',
  LOUNGE_CHAIRS: 'LOUNGE_CHAIRS',
  MANSION: 'MANSION',
  MEDIA_ROOM: 'MEDIA_ROOM',
  MEETING_SPACE: 'MEETING_SPACE',
  MOVIE: 'MOVIE',
  MULTICOURT: 'MULTICOURT',
  NIGHT_LIGHTING: 'NIGHT_LIGHTING',
  OUTDOOR: 'OUTDOOR',
  PARKING: 'PARKING',
  PARTY: 'PARTY',
  PASS: 'PASS',
  PATIO: 'PATIO',
  PC: 'PC',
  PERSON: 'PERSON',
  PETS: 'PETS',
  PET_PARK: 'PET_PARK',
  PHOTO_SHOOT: 'PHOTO_SHOOT',
  PICKLEBALL: 'PICKLEBALL',
  PLAYGROUND: 'PLAYGROUND',
  PLUNGE: 'PLUNGE',
  POOL: 'POOL',
  POOL_HOOP: 'POOL_HOOP',
  POOL_TOYS: 'POOL_TOYS',
  PROFESSIONAL_TRAINING: 'PROFESSIONAL_TRAINING',
  RACQUETS: 'RACQUETS',
  RESTAURANT: 'RESTAURANT',
  RESTROOM: 'RESTROOM',
  ROOFTOP: 'ROOFTOP',
  SALTWATER: 'SALTWATER',
  SAUNA: 'SAUNA',
  SHADED_AREA: 'SHADED_AREA',
  SHALLOW_AREA: 'SHALLOW_AREA',
  SHOWER: 'SHOWER',
  SIMPLY: 'SIMPLY',
  SITTING_AREA: 'SITTING_AREA',
  SPEAKERS: 'SPEAKERS',
  SPORTS: 'SPORTS',
  STOREFRONT: 'STOREFRONT',
  STOVE_OVEN: 'STOVE_OVEN',
  STUDIO: 'STUDIO',
  SWIMMING_LANES: 'SWIMMING_LANES',
  TANNING_EDGE: 'TANNING_EDGE',
  TEMPORARY_NET: 'TEMPORARY_NET',
  TENNIS: 'TENNIS',
  TOWELS: 'TOWELS',
  TVS: 'TVS',
  USE_CASE_ALL: 'USE_CASE_ALL',
  USE_CASE_LUXE: 'USE_CASE_LUXE',
  USE_CASE_NEW: 'USE_CASE_NEW',
  USE_CASE_PRIVACY_PLUS: 'USE_CASE_PRIVACY_PLUS',
  USE_CASE_SALT_WATER: 'USE_CASE_SALT_WATER',
  USE_CASE_SHALLOW_POOLS: 'USE_CASE_SHALLOW_POOLS',
  USE_CASE_TODAY: 'USE_CASE_TODAY',
  VIDEO_SHOOT: 'VIDEO_SHOOT',
  VIP: 'VIP',
  VOLLEYBALL: 'VOLLEYBALL',
  WAREHOUSE: 'WAREHOUSE',
  WATER: 'WATER',
  WATERFALL: 'WATERFALL',
  WATER_SLIDE: 'WATER_SLIDE',
  WEDDING: 'WEDDING',
  WIFI: 'WIFI',
  WORKSPACE: 'WORKSPACE'
} as const;

export type SearchFilterIcon = typeof SearchFilterIcon[keyof typeof SearchFilterIcon];
export const SearchFilterType = {
  CARD_SELECT_VERTICAL: 'CARD_SELECT_VERTICAL',
  CHECKBOX: 'CHECKBOX',
  HISTOGRAM_RANGE_SLIDER: 'HISTOGRAM_RANGE_SLIDER',
  KEYWORD_PILLS: 'KEYWORD_PILLS',
  MAP: 'MAP',
  MULTISELECT_CARDS: 'MULTISELECT_CARDS',
  MULTISELECT_PILLS: 'MULTISELECT_PILLS',
  MULTISELECT_VERTICAL: 'MULTISELECT_VERTICAL',
  RADIO_ICON: 'RADIO_ICON',
  RADIO_PILLS: 'RADIO_PILLS',
  RANGE_SLIDER: 'RANGE_SLIDER',
  SELECT_VERTICAL: 'SELECT_VERTICAL',
  SLIDER: 'SLIDER',
  SLIDER_OPTIONS: 'SLIDER_OPTIONS',
  TOGGLE: 'TOGGLE'
} as const;

export type SearchFilterType = typeof SearchFilterType[keyof typeof SearchFilterType];
export const SecurityDepositEnum = {
  open: 'open',
  refunded: 'refunded',
  resolved: 'resolved',
  under_review: 'under_review'
} as const;

export type SecurityDepositEnum = typeof SecurityDepositEnum[keyof typeof SecurityDepositEnum];
export type SelectHostCancellationCompensationInput = {
  bookingHostCancellationId: Scalars['Int']['input'];
  compensation: SelectableGuestCompensation;
};

export const SelectableGuestCompensation = {
  Credits110: 'Credits110',
  FullRefund: 'FullRefund'
} as const;

export type SelectableGuestCompensation = typeof SelectableGuestCompensation[keyof typeof SelectableGuestCompensation];
export type SendBookingInvitesInput = {
  booking_id: Scalars['Int']['input'];
  emails: Array<Scalars['String']['input']>;
};

export const SendGroupMessageGroupType = {
  abandoned_carts: 'abandoned_carts',
  guest_leads: 'guest_leads',
  one_time_guests: 'one_time_guests',
  repeat_guests: 'repeat_guests'
} as const;

export type SendGroupMessageGroupType = typeof SendGroupMessageGroupType[keyof typeof SendGroupMessageGroupType];
export type SendGroupMessageInput = {
  duration_limit?: InputMaybe<Scalars['Int']['input']>;
  group_types: Array<InputMaybe<SendGroupMessageGroupType>>;
  max_redemptions?: InputMaybe<Scalars['Int']['input']>;
  message: Scalars['String']['input'];
  percent_off?: InputMaybe<Scalars['Int']['input']>;
  pool_id: Scalars['ID']['input'];
  promo_code?: InputMaybe<Scalars['String']['input']>;
  promo_code_id?: InputMaybe<Scalars['ID']['input']>;
  redeem_by?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SendMessageInput = {
  message: Scalars['String']['input'];
  participantUserId: Scalars['ID']['input'];
};

export type SendVerificationCodeToMobileInput = {
  country_phone_code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  mobile_number?: InputMaybe<Scalars['String']['input']>;
  verification_code_type: VerificationCodeType;
};

export type SetBasePriceInput = {
  listingId: Scalars['ID']['input'];
  targetPriceMajor: Scalars['Float']['input'];
  tierId?: InputMaybe<Scalars['Int']['input']>;
};

export type SetDefaultPaymentSourceInput = {
  id: Scalars['Int']['input'];
};

export type SetGeneralListingAvailabilityInput = {
  /** How much advance notice a host needs for a booking (in hours) */
  advanceBookingNotice?: InputMaybe<Scalars['Int']['input']>;
  /** Days of the week the listing is available */
  availableDays?: InputMaybe<Array<Days>>;
  /** Daily time from which the listing is available (in 24hr format) */
  availableFrom?: InputMaybe<Scalars['String']['input']>;
  /** Daily time to which the listing is available (in 24hr format) */
  availableTo?: InputMaybe<Scalars['String']['input']>;
  /** Booking buffer time needed in minutes */
  bookingBufferMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Cancel any existing pause for this listing */
  cancelPause?: InputMaybe<Scalars['Boolean']['input']>;
  /** How far in advance a guest can book a listing (in months from now) */
  futureBookingLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum hours in advance required for instant booking (null = no restriction) */
  instantBookingMinHoursInAdvance?: InputMaybe<Scalars['Int']['input']>;
  /** Require verified user for instant booking */
  instantBookingRequireVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isInstantBook?: InputMaybe<Scalars['Boolean']['input']>;
  listingId: Scalars['ID']['input'];
  maxInstantGuestCount?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum booking length (in hours) */
  minimumBookingLength?: InputMaybe<Scalars['Decimal']['input']>;
  /** Date to which the listing will be paused */
  pauseEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date from which the listing is paused */
  pauseStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** End date of the seasonal open window */
  seasonEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Start date of the seasonal open window */
  seasonStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Listing status */
  status?: InputMaybe<ListingStatusInput>;
  /** Reason for the latest status change */
  statusReason?: InputMaybe<Scalars['String']['input']>;
};

export type SetImageInput = {
  imageId: Scalars['ID']['input'];
  index: Scalars['Int']['input'];
  isCover?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetImageOrderDto = {
  listingId: Scalars['ID']['input'];
  order: Array<SetImageInput>;
};

export type SetListingPromotionsInput = {
  listingId: Scalars['ID']['input'];
  promotions: Array<ListingPromotionInput>;
};

export type SetStartDateInput = {
  listingId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
};

export const ShareAccessTiming = {
  FortyEightHoursBefore: 'FortyEightHoursBefore',
  Immediately: 'Immediately',
  TwentyFourHoursBefore: 'TwentyFourHoursBefore'
} as const;

export type ShareAccessTiming = typeof ShareAccessTiming[keyof typeof ShareAccessTiming];
export type SharedFavoriteCollectionInput = {
  id: Scalars['Int']['input'];
};

export type SignUpInput = {
  country_phone_code?: InputMaybe<Scalars['String']['input']>;
  date_birthday?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  is_promo_opted_in?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  mobile_number?: InputMaybe<Scalars['String']['input']>;
  opt_in_notification_channels?: InputMaybe<Array<NotificationChannel>>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  referral_code?: InputMaybe<Scalars['String']['input']>;
  referral_token?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<RoleEnum>;
  verification_code?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type SkipBookingReviewInput = {
  booking_id: Scalars['Int']['input'];
};

export type SocialLoginInput = {
  provider: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type SortOption = {
  field?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<SortOrder>;
};

/** Directions for ordering a list of records. */
export const SortOrder = {
  /** Sort records in ascending order. */
  ASC: 'ASC',
  /** Sort records in descending order. */
  DESC: 'DESC'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
export type SpaceSizeInput = {
  pool_id: Scalars['Int']['input'];
  space_size: SpaceSizes;
};

export const SpaceSizes = {
  large: 'large',
  medium: 'medium',
  small: 'small'
} as const;

export type SpaceSizes = typeof SpaceSizes[keyof typeof SpaceSizes];
export type SpecialAccessInput = {
  access_photos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entry_method?: InputMaybe<EntryMethod>;
  host_interaction_setting?: InputMaybe<HostInteractionSettings>;
  is_security_cameras?: InputMaybe<Scalars['Boolean']['input']>;
  pool_id: Scalars['Int']['input'];
  share_access_timing?: InputMaybe<ShareAccessTiming>;
  skip_instructions_validation?: InputMaybe<Scalars['Boolean']['input']>;
  special_access_instruction?: InputMaybe<Scalars['String']['input']>;
};

export type SsoAuthInput = {
  provider: Provider;
  referral_token?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type StartCartInput = {
  listingId: Scalars['ID']['input'];
};

export type StripeDashboardInput = {
  is_during_onboarding: Scalars['Boolean']['input'];
  listing_id: Scalars['ID']['input'];
};

export const SwimplyContactOptionType = {
  CHAT: 'CHAT',
  REQUEST_CALLBACK: 'REQUEST_CALLBACK',
  SCHEDULE_MEETING: 'SCHEDULE_MEETING'
} as const;

export type SwimplyContactOptionType = typeof SwimplyContactOptionType[keyof typeof SwimplyContactOptionType];
export const TargetScreen = {
  Access: 'Access',
  Amenities: 'Amenities',
  AutomatedMessages: 'AutomatedMessages',
  Availability: 'Availability',
  BookingRestrictions: 'BookingRestrictions',
  BrandingAndSignage: 'BrandingAndSignage',
  Calendar: 'Calendar',
  CancellationPolicy: 'CancellationPolicy',
  CustomUrl: 'CustomUrl',
  Description: 'Description',
  Earnings: 'Earnings',
  GuestCheckIn: 'GuestCheckIn',
  GuestCheckInFlow: 'GuestCheckInFlow',
  GuestRules: 'GuestRules',
  GuestSettings: 'GuestSettings',
  HostGuide: 'HostGuide',
  HostServices: 'HostServices',
  InstantBookSettings: 'InstantBookSettings',
  MarketingPromotions: 'MarketingPromotions',
  Membership: 'Membership',
  Notifications: 'Notifications',
  Parking: 'Parking',
  Payments: 'Payments',
  Photos: 'Photos',
  PoolDetails: 'PoolDetails',
  PopupSpringRelease: 'PopupSpringRelease',
  PopupWorldCup: 'PopupWorldCup',
  Pricing: 'Pricing',
  Privacy: 'Privacy',
  Promotions: 'Promotions',
  Restroom: 'Restroom',
  Rules: 'Rules',
  SecurityDeposits: 'SecurityDeposits',
  SpaceFeatures: 'SpaceFeatures',
  StarterKit: 'StarterKit',
  Title: 'Title',
  UserProfile: 'UserProfile',
  Videos: 'Videos'
} as const;

export type TargetScreen = typeof TargetScreen[keyof typeof TargetScreen];
export type TierInput = {
  enabled: Scalars['Boolean']['input'];
  hours: Scalars['Int']['input'];
  percentageSavings: Scalars['Int']['input'];
  price?: InputMaybe<MoneyInput>;
};

export type TieredPricingInput = {
  from_onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  pool_id: Scalars['Int']['input'];
  tiers: Array<PriceTierInput>;
};

/** Time type options for V3 passes */
export const TimeType = {
  ALL_DAY: 'ALL_DAY',
  MORNINGS: 'MORNINGS'
} as const;

export type TimeType = typeof TimeType[keyof typeof TimeType];
export const TransactionSortField = {
  CREATED_AT: 'CREATED_AT',
  DATE: 'DATE'
} as const;

export type TransactionSortField = typeof TransactionSortField[keyof typeof TransactionSortField];
export type TransactionsInput = {
  end_date?: InputMaybe<Scalars['Date']['input']>;
  sort_field?: InputMaybe<TransactionSortField>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
};

/** Specify if you want to include or exclude trashed results from a query. */
export const Trashed = {
  /** Only return trashed results. */
  ONLY: 'ONLY',
  /** Return both trashed and non-trashed results. */
  WITH: 'WITH',
  /** Only return non-trashed results. */
  WITHOUT: 'WITHOUT'
} as const;

export type Trashed = typeof Trashed[keyof typeof Trashed];
export const TypeMessage = {
  Automated: 'Automated',
  AutomatedMessage: 'AutomatedMessage',
  BookingCanceled: 'BookingCanceled',
  BookingCompleted: 'BookingCompleted',
  BookingConfirmed: 'BookingConfirmed',
  BookingEditRequestApproved: 'BookingEditRequestApproved',
  BookingEditRequestAutoApproved: 'BookingEditRequestAutoApproved',
  BookingEditRequestCreated: 'BookingEditRequestCreated',
  BookingEditRequestDeclined: 'BookingEditRequestDeclined',
  BookingEditRequestExpired: 'BookingEditRequestExpired',
  BookingEditRequestWithdrawn: 'BookingEditRequestWithdrawn',
  BookingInquiryCreated: 'BookingInquiryCreated',
  BookingPreApproved: 'BookingPreApproved',
  BookingRequestCreated: 'BookingRequestCreated',
  BookingRequestDeclined: 'BookingRequestDeclined',
  BookingRequestExpired: 'BookingRequestExpired',
  CircumventionWarning: 'CircumventionWarning',
  FansAutomatedMessage: 'FansAutomatedMessage',
  FansMessage: 'FansMessage',
  FraudWarning: 'FraudWarning',
  FullRefundMessage: 'FullRefundMessage',
  Message: 'Message',
  MissedCall: 'MissedCall',
  PartialRefundMessage: 'PartialRefundMessage',
  PassCanceled: 'PassCanceled',
  PassPurchased: 'PassPurchased',
  RequestRefundMessage: 'RequestRefundMessage',
  SpecialOfferCanceled: 'SpecialOfferCanceled',
  SpecialOfferCreated: 'SpecialOfferCreated',
  SpecialOfferDeclined: 'SpecialOfferDeclined',
  SpecialOfferExpired: 'SpecialOfferExpired'
} as const;

export type TypeMessage = typeof TypeMessage[keyof typeof TypeMessage];
export const TypeSystemMessage = {
  Action: 'Action',
  Negative: 'Negative',
  Positive: 'Positive'
} as const;

export type TypeSystemMessage = typeof TypeSystemMessage[keyof typeof TypeSystemMessage];
export const UnavailabilityReason = {
  CLOSED: 'CLOSED',
  SCHEDULE_CONFLICT: 'SCHEDULE_CONFLICT',
  VACATION: 'VACATION'
} as const;

export type UnavailabilityReason = typeof UnavailabilityReason[keyof typeof UnavailabilityReason];
export const UnavailabilitySource = {
  AVAILABLE_DAYS: 'AVAILABLE_DAYS',
  CALENDAR: 'CALENDAR',
  FUTURE_BOOKING_LIMIT: 'FUTURE_BOOKING_LIMIT',
  OVERRIDE: 'OVERRIDE',
  PAUSED: 'PAUSED'
} as const;

export type UnavailabilitySource = typeof UnavailabilitySource[keyof typeof UnavailabilitySource];
export type UnavailabilityTime = {
  unavailableFrom: Scalars['ZonedTime']['input'];
  unavailableTo: Scalars['ZonedTime']['input'];
};

export const UnlistCtaActionType = {
  CONTINUE_UNLIST: 'CONTINUE_UNLIST',
  DISMISS: 'DISMISS',
  ENABLE_STEALTH_MODE: 'ENABLE_STEALTH_MODE',
  ENABLE_VERIFIED_ONLY: 'ENABLE_VERIFIED_ONLY',
  OPEN_CALENDAR: 'OPEN_CALENDAR',
  OPEN_URL: 'OPEN_URL',
  REQUEST_CALL: 'REQUEST_CALL',
  SHOW_STEALTH_PROMPT: 'SHOW_STEALTH_PROMPT'
} as const;

export type UnlistCtaActionType = typeof UnlistCtaActionType[keyof typeof UnlistCtaActionType];
export const UnlistFlowType = {
  CALENDAR: 'CALENDAR',
  CALL: 'CALL',
  CALL_CONFIRMATION: 'CALL_CONFIRMATION',
  DEFAULT: 'DEFAULT',
  OFFSEASON: 'OFFSEASON',
  STEALTH: 'STEALTH',
  STEALTH_PROMPT: 'STEALTH_PROMPT',
  VERIFIED_GUEST: 'VERIFIED_GUEST'
} as const;

export type UnlistFlowType = typeof UnlistFlowType[keyof typeof UnlistFlowType];
export const UnlistReason = {
  AIRBNB_VRBO_HOME: 'AIRBNB_VRBO_HOME',
  BAD_EXPERIENCE_GUEST: 'BAD_EXPERIENCE_GUEST',
  BAD_EXPERIENCE_SWIMPLY: 'BAD_EXPERIENCE_SWIMPLY',
  GOING_OFF_SEASON: 'GOING_OFF_SEASON',
  GOING_OUT_OF_TOWN: 'GOING_OUT_OF_TOWN',
  HOSTING_TOO_MUCH_WORK: 'HOSTING_TOO_MUCH_WORK',
  LIABILITY_CONCERN: 'LIABILITY_CONCERN',
  NEED_QUICK_BREAK: 'NEED_QUICK_BREAK',
  NEIGHBOR_HOA_COMPLAINTS: 'NEIGHBOR_HOA_COMPLAINTS',
  NOT_EARNING_ENOUGH: 'NOT_EARNING_ENOUGH',
  NOT_GETTING_BOOKINGS: 'NOT_GETTING_BOOKINGS',
  NO_LONGER_LIVE_HERE: 'NO_LONGER_LIVE_HERE',
  NO_LONGER_PHYSICALLY_ABLE: 'NO_LONGER_PHYSICALLY_ABLE',
  OTHER: 'OTHER',
  POOL_MAINTENANCE: 'POOL_MAINTENANCE',
  PRIVACY_ISSUE: 'PRIVACY_ISSUE',
  REGULATORY_LEGAL_ISSUE: 'REGULATORY_LEGAL_ISSUE',
  TOO_MANY_RESERVATIONS: 'TOO_MANY_RESERVATIONS'
} as const;

export type UnlistReason = typeof UnlistReason[keyof typeof UnlistReason];
export type UpdateGuestPassAutoRenewInput = {
  guestPassId: Scalars['ID']['input'];
  isAutoRenew: Scalars['Boolean']['input'];
  passId?: InputMaybe<Scalars['ID']['input']>;
  paymentSourceId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateGuestPassV2PaymentInput = {
  guestPassId: Scalars['ID']['input'];
  paymentSourceId: Scalars['ID']['input'];
};

export type UpdateListingAbandonedCartSettingsInput = {
  isActive: Scalars['Boolean']['input'];
  listingId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  promoCodeAmountOff: Scalars['Int']['input'];
  promoCodeAmountOffType: ListingAbandonedCartSettingsPromoCodeAmountOffType;
  promoCodeDaysExpiresIn: Scalars['Int']['input'];
};

export type UpdateListingPropertiesInput = {
  category: ListingTypePropertiesCategory;
  isOnboarding?: Scalars['Boolean']['input'];
  listingId: Scalars['ID']['input'];
  values: Array<ListingTypePropertyIdAndValue>;
};

export type UpdateListingWakeupChecklistInput = {
  items: Array<WakeupChecklistItemInput>;
  listingId: Scalars['ID']['input'];
};

export type UpdateNotificationSettingsInput = {
  channels: Array<NotificationChannel>;
  is_opted_in: Scalars['Boolean']['input'];
};

export type UpdatePartnershipInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bannerToInsert?: InputMaybe<Scalars['String']['input']>;
  colorTheme?: InputMaybe<Scalars['String']['input']>;
  guestRestrictions?: InputMaybe<Scalars['String']['input']>;
  hasExplicitAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  hasWaitListBooking?: InputMaybe<Scalars['Boolean']['input']>;
  isPriced?: InputMaybe<Scalars['Boolean']['input']>;
  listingHeroIcon?: InputMaybe<Scalars['String']['input']>;
  listingTypeId?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pdpHighlightMsgBody?: InputMaybe<Scalars['String']['input']>;
  pdpHighlightMsgTitle?: InputMaybe<Scalars['String']['input']>;
  submitCaption?: InputMaybe<Scalars['String']['input']>;
  survey?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdatePassword = {
  old_password: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
};

export type UploadBookingInvitationImageInput = {
  booking_id: Scalars['Int']['input'];
  /** A base64 data URI, e.g. "data:image/png;base64,iVBORw0..." */
  image: Scalars['String']['input'];
};

export const UserActivityTypeInput = {
  LISTING_VIEW: 'LISTING_VIEW'
} as const;

export type UserActivityTypeInput = typeof UserActivityTypeInput[keyof typeof UserActivityTypeInput];
export type UserPopupInput = {
  email: Scalars['String']['input'];
  full_address?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export const UserPremiumType = {
  IGLOO: 'IGLOO',
  NONE: 'NONE',
  REGULAR: 'REGULAR',
  SUMMER: 'SUMMER'
} as const;

export type UserPremiumType = typeof UserPremiumType[keyof typeof UserPremiumType];
export const UserReservationTabs = {
  hosting: 'hosting',
  swimming: 'swimming'
} as const;

export type UserReservationTabs = typeof UserReservationTabs[keyof typeof UserReservationTabs];
export const UserReservationTypes = {
  past: 'past',
  pending: 'pending',
  upcoming: 'upcoming'
} as const;

export type UserReservationTypes = typeof UserReservationTypes[keyof typeof UserReservationTypes];
export const UserVerificationImageStatus = {
  Approved: 'Approved',
  Rejected: 'Rejected',
  Unverified: 'Unverified'
} as const;

export type UserVerificationImageStatus = typeof UserVerificationImageStatus[keyof typeof UserVerificationImageStatus];
export type UserVerificationInput = {
  passport_drive_url?: InputMaybe<Scalars['String']['input']>;
  pool_proof_url?: InputMaybe<Scalars['String']['input']>;
  step: Scalars['Int']['input'];
  user_id: Scalars['Int']['input'];
};

export const VerificationCodeType = {
  LOGIN: 'LOGIN',
  VERIFY_MOBILE: 'VERIFY_MOBILE'
} as const;

export type VerificationCodeType = typeof VerificationCodeType[keyof typeof VerificationCodeType];
export type VerifyEmailInput = {
  token: Scalars['String']['input'];
};

export type VerifyMobileNumberInput = {
  mobile_number?: InputMaybe<Scalars['String']['input']>;
  verification_code: Scalars['String']['input'];
};

export type VerifyPasswordInput = {
  password: Scalars['String']['input'];
};

export const WaitlistListingType = {
  BACKYARD: 'BACKYARD',
  BASKETBALL_COURT: 'BASKETBALL_COURT',
  DISNEY: 'DISNEY',
  DOCKED_BOAT: 'DOCKED_BOAT',
  EXPERIENCES: 'EXPERIENCES',
  HOME: 'HOME',
  HOME_GYM: 'HOME_GYM',
  IGLOO: 'IGLOO',
  MUSIC_STUDIO: 'MUSIC_STUDIO',
  PC_BACKYARD: 'PC_BACKYARD',
  PENDING: 'PENDING',
  PICKLEBALL_COURT: 'PICKLEBALL_COURT',
  POOL: 'POOL',
  ROOF_DECK: 'ROOF_DECK',
  SIMPLY: 'SIMPLY',
  TENNIS_COURT: 'TENNIS_COURT'
} as const;

export type WaitlistListingType = typeof WaitlistListingType[keyof typeof WaitlistListingType];
export const WakeupChecklistItemIcon = {
  Bell: 'Bell',
  Calendar: 'Calendar',
  Cards: 'Cards',
  Gear: 'Gear',
  Sliders: 'Sliders'
} as const;

export type WakeupChecklistItemIcon = typeof WakeupChecklistItemIcon[keyof typeof WakeupChecklistItemIcon];
export type WakeupChecklistItemInput = {
  isCompleted: Scalars['Boolean']['input'];
  name: WakeupChecklistItemName;
};

export const WakeupChecklistItemName = {
  ReviewAdvancedAvailabilitySettings: 'ReviewAdvancedAvailabilitySettings',
  ReviewCalendar: 'ReviewCalendar',
  ReviewGeneralAvailabilitySettings: 'ReviewGeneralAvailabilitySettings',
  ReviewNotificationSetting: 'ReviewNotificationSetting',
  ReviewStickers: 'ReviewStickers'
} as const;

export type WakeupChecklistItemName = typeof WakeupChecklistItemName[keyof typeof WakeupChecklistItemName];
export const WaterSystems = {
  chlorine: 'chlorine',
  saltwater: 'saltwater'
} as const;

export type WaterSystems = typeof WaterSystems[keyof typeof WaterSystems];
export type AccurateInput = {
  code?: InputMaybe<CountryCode>;
};

export type AppRatedIntut = {
  platform: RatePlatform;
  status: Scalars['Boolean']['input'];
};

export type ChatDetailsPgnInput = {
  excluded_id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  reciever_id: Scalars['Int']['input'];
  search_string?: InputMaybe<Scalars['String']['input']>;
};

export const CountryCode = {
  AU: 'AU',
  CA: 'CA',
  US: 'US'
} as const;

export type CountryCode = typeof CountryCode[keyof typeof CountryCode];
export const Join__Graph = {
  LARAVEL: 'LARAVEL',
  NEST: 'NEST'
} as const;

export type Join__Graph = typeof Join__Graph[keyof typeof Join__Graph];
export const Link__Purpose = {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  EXECUTION: 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  SECURITY: 'SECURITY'
} as const;

export type Link__Purpose = typeof Link__Purpose[keyof typeof Link__Purpose];
export type PromoCodeInput = {
  fromPage?: InputMaybe<Scalars['String']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  promocode: Scalars['String']['input'];
};

export type SavePoolInfoInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pool_id: Scalars['ID']['input'];
};

export type GetOnboardingListingTypeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnboardingListingTypeQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null } | null };

export type GetPoolMaxGuestsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPoolMaxGuestsQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, max_guests?: number | null, pets_rule?: PetsRules | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, guests_pets_allowed?: boolean | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, rule_settings: Array<{ __typename: 'RuleSetting', id: number, slug: string, name: string, icon: RuleIcon, active: boolean, description?: string | null, is_allowed?: boolean | null } | null> } | null };

export type GetOnboardingHowSwimplyWorksQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnboardingHowSwimplyWorksQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, default_instant_booking: boolean, instant_group_size?: number | null, max_guests?: number | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null } | null };

export type GetOnboardingListingPhotosQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnboardingListingPhotosQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null } | null };

export type GetListingTypeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetListingTypeQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null } | null };

export type GetOnboardingListingStartDateQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnboardingListingStartDateQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, city?: string | null, state?: string | null, zip_code?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null } | null };

export type GetOnboardingListingTitleQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnboardingListingTitleQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, title: string, description?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null } | null };

export type GetListingTypeForBasicsPreviewQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetListingTypeForBasicsPreviewQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null } | null };

export type BookingPublicFragment = { __typename: 'BookingPublic', id: string, status: number, adult_guests: number, start_datetime_utc: any, end_datetime_utc: any, accepted_booking_invites_count: number, pool: { __typename: 'PoolPublic', id: string, time_zone?: string | null, city?: string | null, state?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean }> } };

export type BookingInviteReservationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type BookingInviteReservationQuery = { __typename: 'Query', getBookingPublic?: { __typename: 'BookingPublic', id: string, status: number, adult_guests: number, start_datetime_utc: any, end_datetime_utc: any, accepted_booking_invites_count: number, pool: { __typename: 'PoolPublic', id: string, time_zone?: string | null, city?: string | null, state?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean }> } } | null };

export type GetBookingInviteQueryVariables = Exact<{
  booking_invite_id: Scalars['Int']['input'];
}>;


export type GetBookingInviteQuery = { __typename: 'Query', getBookingInvite?: { __typename: 'BookingInvite', id?: number | null, booking?: { __typename: 'BookingPublic', id: string, status: number, adult_guests: number, start_datetime_utc: any, end_datetime_utc: any, accepted_booking_invites_count: number, pool: { __typename: 'PoolPublic', id: string, time_zone?: string | null, city?: string | null, state?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean }> } } | null } | null };

export type BookingInvitationOgQueryVariables = Exact<{
  booking_id: Scalars['Int']['input'];
}>;


export type BookingInvitationOgQuery = { __typename: 'Query', bookingInvitation: { __typename: 'BookingInvitation', title: string, image?: string | null, isDefaults: boolean, alpha_guest: { __typename: 'BookingInvitationAlphaGuest', first_name?: string | null } } };

export type ReferralMilestonesByReferralTokenServerQueryVariables = Exact<{
  data: ReferralMilestonesByReferralTokenInput;
}>;


export type ReferralMilestonesByReferralTokenServerQuery = { __typename: 'Query', referralMilestonesByReferralToken: Array<{ __typename: 'ReferralMilestone', id: string, title: string, action: ReferalMilestoneActionsTypes, amount: number, who_gets_paid: ReferalMilestoneWhoGetsPaidTypes, payout_amount: number, payout_type: ReferalMilestonePayoutTypes, is_active: boolean, apply_to: ReferalMilestoneApplyToTypes, apply_to_referrer: ReferalMilestoneApplyToTypes }> };

export type SeoUseCaseFragment = { __typename: 'SeoUseCase', slug: string, name: string, eventText: string, spaceText: string, titleText: string, pluralText: string, spaceTypeSlug?: string | null, useCaseSlug?: string | null, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null };

export type SeoSpaceTypeFragment = { __typename: 'SeoSpaceType', slug: string, name: string, categoryName: string, spaceTypeSlug?: string | null, useCaseSlug?: string | null, spaceText: string, pluralText: string, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null };

export type SeoEntityFilterFragment = { __typename: 'SeoEntityFilter', slug: string, name: string, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null };

export type SeoPageQueryVariables = Exact<{
  citySlug: Scalars['String']['input'];
  seoEntitySlug: Scalars['String']['input'];
  filterSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type SeoPageQuery = { __typename: 'Query', seoPage?: { __typename: 'SeoPageResult', isPassesPage: boolean, city: { __typename: 'SeoCity', slug: string, city: string, state: string, country: string, fullState?: string | null }, spaceType?: { __typename: 'SeoSpaceType', slug: string, name: string, categoryName: string, spaceTypeSlug?: string | null, useCaseSlug?: string | null, spaceText: string, pluralText: string, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null } | null, useCase?: { __typename: 'SeoUseCase', slug: string, name: string, eventText: string, spaceText: string, titleText: string, pluralText: string, spaceTypeSlug?: string | null, useCaseSlug?: string | null, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null } | null, listings: Array<{ __typename: 'SearchPool', id: string, cover_image_url?: string | null, title: string, description?: string | null, rating?: number | null, country_code?: string | null, listing_type: ListingType, city: string, state: string, distance?: number | null, is_quality: boolean, max_guests?: number | null, stealth_mode: boolean, reviewsCount: number, pricing: { __typename: 'SearchPoolPricing', price: number, pricing_scheme: PricingScheme, featured_promo_code_percent: number, grand_opening_discount_percent: number } }>, reviews: Array<{ __typename: 'SeoReview', id: number, content: string, rating: number, listingTitle: string, reviewer: { __typename: 'UserPublic', firstName?: string | null, imageUrl?: string | null } } | null>, additionalLocationLinks: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null>, additionalSpaceTypeLinks: Array<{ __typename: 'SeoLinkSection', title: string, links: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null> } | null>, additionalUseCaseLinks: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null>, customContentBlocks?: Array<{ __typename: 'SeoCustomContentBlock', id: number, block_number: number, title: string, body: string, author_img_url?: string | null, author_name?: string | null, updated_at?: any | null }> | null, relatedFilters: Array<{ __typename: 'SeoEntityFilter', slug: string, name: string, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null }>, entityFilter?: { __typename: 'SeoEntityFilter', slug: string, name: string, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null } | null } | null };

export type BackyardsPageQueryVariables = Exact<{
  citySlug: Scalars['String']['input'];
  seoEntitySlug: Scalars['String']['input'];
}>;


export type BackyardsPageQuery = { __typename: 'Query', seoPage?: { __typename: 'SeoPageResult', isPassesPage: boolean, city: { __typename: 'SeoCity', slug: string, city: string, state: string, country: string, fullState?: string | null }, spaceType?: { __typename: 'SeoSpaceType', slug: string, name: string, categoryName: string, spaceTypeSlug?: string | null, useCaseSlug?: string | null, spaceText: string, pluralText: string, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null } | null, useCase?: { __typename: 'SeoUseCase', slug: string, name: string, eventText: string, spaceText: string, titleText: string, pluralText: string, spaceTypeSlug?: string | null, useCaseSlug?: string | null, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null } | null, listings: Array<{ __typename: 'SearchPool', id: string, cover_image_url?: string | null, title: string, description?: string | null, rating?: number | null, country_code?: string | null, listing_type: ListingType, city: string, state: string, distance?: number | null, is_quality: boolean, max_guests?: number | null, stealth_mode: boolean, reviewsCount: number, pricing: { __typename: 'SearchPoolPricing', price: number, pricing_scheme: PricingScheme, featured_promo_code_percent: number, grand_opening_discount_percent: number } }>, reviews: Array<{ __typename: 'SeoReview', id: number, content: string, rating: number, listingTitle: string, reviewer: { __typename: 'UserPublic', firstName?: string | null, imageUrl?: string | null } } | null>, additionalLocationLinks: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null>, additionalSpaceTypeLinks: Array<{ __typename: 'SeoLinkSection', title: string, links: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null> } | null>, additionalUseCaseLinks: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null>, customContentBlocks?: Array<{ __typename: 'SeoCustomContentBlock', id: number, block_number: number, title: string, body: string, author_img_url?: string | null, author_name?: string | null, updated_at?: any | null }> | null } | null };

export type BirthdayPartyPageQueryVariables = Exact<{
  citySlug: Scalars['String']['input'];
  seoEntitySlug: Scalars['String']['input'];
}>;


export type BirthdayPartyPageQuery = { __typename: 'Query', seoPage?: { __typename: 'SeoPageResult', isPassesPage: boolean, city: { __typename: 'SeoCity', slug: string, city: string, state: string, country: string, fullState?: string | null }, spaceType?: { __typename: 'SeoSpaceType', slug: string, name: string, categoryName: string, spaceTypeSlug?: string | null, useCaseSlug?: string | null, spaceText: string, pluralText: string, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null } | null, useCase?: { __typename: 'SeoUseCase', slug: string, name: string, eventText: string, spaceText: string, titleText: string, pluralText: string, spaceTypeSlug?: string | null, useCaseSlug?: string | null, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null } | null, listings: Array<{ __typename: 'SearchPool', id: string, cover_image_url?: string | null, title: string, description?: string | null, rating?: number | null, country_code?: string | null, listing_type: ListingType, city: string, state: string, distance?: number | null, is_quality: boolean, max_guests?: number | null, stealth_mode: boolean, reviewsCount: number, pricing: { __typename: 'SearchPoolPricing', price: number, pricing_scheme: PricingScheme, featured_promo_code_percent: number, grand_opening_discount_percent: number } }>, reviews: Array<{ __typename: 'SeoReview', id: number, content: string, rating: number, listingTitle: string, reviewer: { __typename: 'UserPublic', firstName?: string | null, imageUrl?: string | null } } | null>, additionalLocationLinks: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null>, additionalSpaceTypeLinks: Array<{ __typename: 'SeoLinkSection', title: string, links: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null> } | null>, additionalUseCaseLinks: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null> } | null };

export type PoolPassesPageQueryVariables = Exact<{
  citySlug: Scalars['String']['input'];
  seoEntitySlug: Scalars['String']['input'];
}>;


export type PoolPassesPageQuery = { __typename: 'Query', seoPage?: { __typename: 'SeoPageResult', isPassesPage: boolean, city: { __typename: 'SeoCity', slug: string, city: string, state: string, country: string, fullState?: string | null }, spaceType?: { __typename: 'SeoSpaceType', slug: string, name: string, categoryName: string, spaceTypeSlug?: string | null, useCaseSlug?: string | null, spaceText: string, pluralText: string, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null } | null, useCase?: { __typename: 'SeoUseCase', slug: string, name: string, eventText: string, spaceText: string, titleText: string, pluralText: string, spaceTypeSlug?: string | null, useCaseSlug?: string | null, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null } | null, listings: Array<{ __typename: 'SearchPool', id: string, cover_image_url?: string | null, title: string, description?: string | null, rating?: number | null, country_code?: string | null, listing_type: ListingType, city: string, state: string, distance?: number | null, is_quality: boolean, max_guests?: number | null, stealth_mode: boolean, reviewsCount: number, pricing: { __typename: 'SearchPoolPricing', price: number, pricing_scheme: PricingScheme, featured_promo_code_percent: number, grand_opening_discount_percent: number } }>, reviews: Array<{ __typename: 'SeoReview', id: number, content: string, rating: number, listingTitle: string, reviewer: { __typename: 'UserPublic', firstName?: string | null, imageUrl?: string | null } } | null>, additionalLocationLinks: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null>, additionalSpaceTypeLinks: Array<{ __typename: 'SeoLinkSection', title: string, links: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null> } | null>, additionalUseCaseLinks: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null>, customContentBlocks?: Array<{ __typename: 'SeoCustomContentBlock', id: number, block_number: number, title: string, body: string, author_img_url?: string | null, author_name?: string | null, updated_at?: any | null }> | null } | null };

export type KidsBirthdayPartyPageQueryVariables = Exact<{
  citySlug: Scalars['String']['input'];
  seoEntitySlug: Scalars['String']['input'];
}>;


export type KidsBirthdayPartyPageQuery = { __typename: 'Query', seoPage?: { __typename: 'SeoPageResult', isPassesPage: boolean, city: { __typename: 'SeoCity', slug: string, city: string, state: string, country: string, fullState?: string | null }, spaceType?: { __typename: 'SeoSpaceType', slug: string, name: string, categoryName: string, spaceTypeSlug?: string | null, useCaseSlug?: string | null, spaceText: string, pluralText: string, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null } | null, useCase?: { __typename: 'SeoUseCase', slug: string, name: string, eventText: string, spaceText: string, titleText: string, pluralText: string, spaceTypeSlug?: string | null, useCaseSlug?: string | null, searchFilters?: Array<{ __typename: 'SeoSearchFilter', filter_key: string, values: Array<string | null> } | null> | null } | null, listings: Array<{ __typename: 'SearchPool', id: string, cover_image_url?: string | null, title: string, description?: string | null, rating?: number | null, country_code?: string | null, listing_type: ListingType, city: string, state: string, distance?: number | null, is_quality: boolean, max_guests?: number | null, stealth_mode: boolean, reviewsCount: number, pricing: { __typename: 'SearchPoolPricing', price: number, pricing_scheme: PricingScheme, featured_promo_code_percent: number, grand_opening_discount_percent: number } }>, reviews: Array<{ __typename: 'SeoReview', id: number, content: string, rating: number, listingTitle: string, reviewer: { __typename: 'UserPublic', firstName?: string | null, imageUrl?: string | null } } | null>, additionalLocationLinks: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null>, additionalSpaceTypeLinks: Array<{ __typename: 'SeoLinkSection', title: string, links: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null> } | null>, additionalUseCaseLinks: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null> } | null };

export type SeoLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type SeoLinksQuery = { __typename: 'Query', seoLinks: Array<{ __typename: 'SeoLink', label: string, city_slug: string, seo_entity_slug: string } | null> };

export type ConnectInstagramAccountMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
  accessCode: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
}>;


export type ConnectInstagramAccountMutation = { __typename: 'Mutation', connectInstagramAccount: boolean };

export type GetInstagramAccountDeletionQueryVariables = Exact<{
  confirmationCode: Scalars['String']['input'];
}>;


export type GetInstagramAccountDeletionQuery = { __typename: 'Query', getInstagramAccountDeletion?: { __typename: 'DeleteInstagramConnectionResult', confirmation_code: string, deleted_at: any } | null };

export type MembershipsOverviewSearchQueryVariables = Exact<{
  data: DynamicSearchInput;
}>;


export type MembershipsOverviewSearchQuery = { __typename: 'Query', dynamicSearch: { __typename: 'DynamicSearchResponse', data: Array<{ __typename: 'SearchPool', id: string, cover_image_url?: string | null, title: string, description?: string | null, rating?: number | null, country_code?: string | null, listing_type: ListingType, city: string, state: string, distance?: number | null, is_quality: boolean, max_guests?: number | null, stealth_mode: boolean, reviewsCount: number, pricing: { __typename: 'SearchPoolPricing', price: number, pricing_scheme: PricingScheme, featured_promo_code_percent: number, grand_opening_discount_percent: number } } | null> } };

export type ExperiencesPopupDataQueryVariables = Exact<{
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ExperiencesPopupDataQuery = { __typename: 'Query', experiencesPopupData?: { __typename: 'ExperiencesPopupData', title: string, subtitle: string, cta: { __typename: 'ExperiencesPopupCta', title: string, search_input: { __typename: 'DynamicSearchParams', first: number, page: number, latitude: number, longitude: number, adults: number, space_type_slug?: string | null, use_case_slug?: string | null, use_case_slugs?: Array<string> | null, children?: number | null, infants?: number | null, pets?: number | null, filters?: Array<{ __typename: 'DynamicSearchFilterOutput', filter_key: string, values: Array<string | null> }> | null } }, listings: Array<{ __typename: 'SearchPool', id: string, title: string, cover_image_url?: string | null, image_urls?: Array<string | null> | null, stealth_mode: boolean, country_code?: string | null, images?: Array<{ __typename: 'PoolImage', url: string }> | null, experiences?: { __typename: 'SearchPoolExperiences', per_guest_pricing?: number | null, guest_restrictions?: string | null } | null, pricing: { __typename: 'SearchPoolPricing', price: number, discounted_price: number } }> } | null };

export type PreBookingChecksQueryVariables = Exact<{
  data: PreBookingChecksInput;
}>;


export type PreBookingChecksQuery = { __typename: 'Query', preBookingChecks: { __typename: 'PreBookingChecksResult', is_instant: boolean } };

export type SelectedDayDetailQueryVariables = Exact<{
  input: GetListingScheduleInput;
}>;


export type SelectedDayDetailQuery = { __typename: 'Query', detailedScheduleForListing:
    | { __typename: 'GetDetailScheduleForListingResponse', bookingStatus: ListingBookingRequestType }
    | { __typename: 'InvalidDateRangeError' }
    | { __typename: 'ListingNotFoundError' }
   };

export type BookingChoicesFragment = { __typename: 'BookingReason', id: string, label: string, icon: string, displayOrder: number };

export type BookingChoicesQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type BookingChoicesQuery = { __typename: 'Query', listingDetails:
    | { __typename: 'GetListingDetailsResponse', listing:
        | { __typename: 'BasketballCourtListing', listingType: { __typename: 'ListingTypeEntity', bookingReasonChoices: Array<{ __typename: 'BookingReason', id: string, label: string, icon: string, displayOrder: number }> } }
        | { __typename: 'HomeListing', listingType: { __typename: 'ListingTypeEntity', bookingReasonChoices: Array<{ __typename: 'BookingReason', id: string, label: string, icon: string, displayOrder: number }> } }
        | { __typename: 'Listing', listingType: { __typename: 'ListingTypeEntity', bookingReasonChoices: Array<{ __typename: 'BookingReason', id: string, label: string, icon: string, displayOrder: number }> } }
        | { __typename: 'PickleballCourtListing', listingType: { __typename: 'ListingTypeEntity', bookingReasonChoices: Array<{ __typename: 'BookingReason', id: string, label: string, icon: string, displayOrder: number }> } }
        | { __typename: 'PoolListing', listingType: { __typename: 'ListingTypeEntity', bookingReasonChoices: Array<{ __typename: 'BookingReason', id: string, label: string, icon: string, displayOrder: number }> } }
        | { __typename: 'TennisCourtListing', listingType: { __typename: 'ListingTypeEntity', bookingReasonChoices: Array<{ __typename: 'BookingReason', id: string, label: string, icon: string, displayOrder: number }> } }
       }
    | { __typename: 'ListingNotFoundError' }
   };

export type StartCartMutationVariables = Exact<{
  input: StartCartInput;
}>;


export type StartCartMutation = { __typename: 'Mutation', startCart: { __typename: 'StartCartResponse', cart: { __typename: 'Cart', id: string } } };

export type ListingAmenitiesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  bookingStartTime?: InputMaybe<Scalars['DateTimeUtc']['input']>;
}>;


export type ListingAmenitiesQuery = { __typename: 'Query', listing?: { __typename: 'PoolPublic', amenities?: Array<{ __typename: 'PoolPremiumAmenity', priceAmount?: number | null } | null> | null } | null };

export type MembershipSelectionPricingSummaryQueryVariables = Exact<{
  data: PricingSummaryInput;
}>;


export type MembershipSelectionPricingSummaryQuery = { __typename: 'Query', pricingSummary: { __typename: 'PricingSummary', subtotal: number, host_earnings: number, guest_price: number, display_full_price: boolean, klarnaEligible: boolean, klarnaCancellationFee: number, base_pricing: { __typename: 'BasePricing', amount: number, duration_hours: number, min_guests_for_price: number, max_guests_for_price: number, hourly_rate?: number | null }, base_price_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, amount?: number | null }>, additional_guest_pricing?: { __typename: 'AdditionalGuestPricing', amount: number, additional_guest_count: number, per_guest_rate: number, duration_hours: number } | null, amenity_pricing?: { __typename: 'AmenityPricing', amount: number, amenity_count: number } | null, reservation_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, discount_type: DiscountType, amount?: number | null }>, credit_pricing?: { __typename: 'CreditPricing', amount: number, remaining_balance?: number | null } | null, credit_earnings?: { __typename: 'CreditEarnings', amount: number, earned_credit_type: CreditEarningsType } | null, service_fee_pricing: { __typename: 'ServiceFeePricing', amount?: number | null, service_fee_percentage: number }, host_fee_pricing: { __typename: 'HostFeePricing', amount: number, host_fee_percentage: number }, display_sections?: Array<{ __typename: 'DisplaySection', lines: Array<{ __typename: 'DisplayLine', title: string, subtitle?: any | null, amount: string, is_discount: boolean, is_total: boolean, is_subtotal: boolean, is_premium?: boolean | null, is_membership?: boolean | null }> }> | null, securityDeposit?: { __typename: 'SecurityDepositPricing', amount: number, totalGuests: number } | null, premium_savings?: { __typename: 'PremiumSavings', premium_savings: number, premium_not_saving?: number | null } | null, upsell_discount?: { __typename: 'UpsellDiscount', discount: number, amount: number, hoursUsed: number, hoursLeft: number } | null, pass_discount?: { __typename: 'PassDiscount', discount: number, amount?: number | null, discount_type: DiscountType, can_redeem?: boolean | null, hoursUsed: number, hoursLeft: number } | null } };

export type NonMembershipSelectionPricingSummaryQueryVariables = Exact<{
  data: PricingSummaryInput;
}>;


export type NonMembershipSelectionPricingSummaryQuery = { __typename: 'Query', pricingSummary: { __typename: 'PricingSummary', subtotal: number, host_earnings: number, guest_price: number, display_full_price: boolean, klarnaEligible: boolean, klarnaCancellationFee: number, base_pricing: { __typename: 'BasePricing', amount: number, duration_hours: number, min_guests_for_price: number, max_guests_for_price: number, hourly_rate?: number | null }, base_price_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, amount?: number | null }>, additional_guest_pricing?: { __typename: 'AdditionalGuestPricing', amount: number, additional_guest_count: number, per_guest_rate: number, duration_hours: number } | null, amenity_pricing?: { __typename: 'AmenityPricing', amount: number, amenity_count: number } | null, reservation_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, discount_type: DiscountType, amount?: number | null }>, credit_pricing?: { __typename: 'CreditPricing', amount: number, remaining_balance?: number | null } | null, credit_earnings?: { __typename: 'CreditEarnings', amount: number, earned_credit_type: CreditEarningsType } | null, service_fee_pricing: { __typename: 'ServiceFeePricing', amount?: number | null, service_fee_percentage: number }, host_fee_pricing: { __typename: 'HostFeePricing', amount: number, host_fee_percentage: number }, display_sections?: Array<{ __typename: 'DisplaySection', lines: Array<{ __typename: 'DisplayLine', title: string, subtitle?: any | null, amount: string, is_discount: boolean, is_total: boolean, is_subtotal: boolean, is_premium?: boolean | null, is_membership?: boolean | null }> }> | null, securityDeposit?: { __typename: 'SecurityDepositPricing', amount: number, totalGuests: number } | null, premium_savings?: { __typename: 'PremiumSavings', premium_savings: number, premium_not_saving?: number | null } | null, upsell_discount?: { __typename: 'UpsellDiscount', discount: number, amount: number, hoursUsed: number, hoursLeft: number } | null, pass_discount?: { __typename: 'PassDiscount', discount: number, amount?: number | null, discount_type: DiscountType, can_redeem?: boolean | null, hoursUsed: number, hoursLeft: number } | null } };

export type CheckoutSetupBookingQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CheckoutSetupBookingQuery = { __typename: 'Query', reservationDetails?: { __typename: 'Booking', id: string, status: number, status_name: BookingStatusEnum, start_datetime_utc: any, end_datetime_utc: any, swimmer_review?: boolean | null, host_review?: boolean | null, adultGuests?: number | null, childrenGuests?: number | null, infantGuests?: number | null, petGuests?: number | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string, booking_id: string, status: BookingSpecialOfferStatus, start_datetime_utc: any, end_datetime_utc: any, special_offer_price: number, note: string, created_at: any, expiration_datetime_utc?: any | null, adultGuests: number, childrenGuests: number, infantGuests: number, petGuests: number, premiumAmenities: Array<{ __typename: 'BookingSpecialOfferPremiumAmenity', poolPremiumAmenity: { __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } }> } | null, listing: { __typename: 'PoolPrivate', stealth_mode: boolean, id: string, title: string, time_zone?: string | null, city?: string | null, status: number, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, available_from?: string | null, available_to?: string | null, default_instant_booking: boolean, min_booking_length?: number | null, timeZone?: string | null, countryCode?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean, pool_id: number, id?: string | null }>, createdBy?: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, isProHost: boolean, createdAt: any } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null }, booking_update_request?: { __typename: 'BookingUpdatedRequest', id?: number | null } | null, amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, userPublic: { __typename: 'UserPublic', id: string, firstname?: string | null, rating?: number | null, img_url?: string | null, created_at: any, reviewsCount: number } } | null };

export type GoPuffInfoQueryVariables = Exact<{
  booking_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GoPuffInfoQuery = { __typename: 'Query', goPuffInfo: { __typename: 'GoPuffInfo', showBookingAd?: boolean | null, url: string } };

export type CancelMembershipMutationVariables = Exact<{
  input: CancelPassInput;
}>;


export type CancelMembershipMutation = { __typename: 'Mutation', cancelPass:
    | { __typename: 'CancelPassError', message: string }
    | { __typename: 'MutationResult' }
   };

export type PassholderFragment = { __typename: 'PassHolder', firstName: string, lastName: string, imgUrl: string, memberSince: any, userId: number, guestPass: { __typename: 'GuestPass', state: GuestPassState, isActive: boolean, id: string, start: any, end: any, hoursLeft?: number | null, priceNoFees?: number | null, price?: number | null, autoRenewState: GuestPassAutoRenewState, bookingStats: { __typename: 'BookingStats', completedBookings: number, completedHours: number, guestCanCancel: boolean, hostCanCancel: boolean, upcomingBookings: number }, pass?: { __typename: 'Pass', id: string, hoursPerMonth?: number | null } | null } };

export type GetActiveMembersQueryVariables = Exact<{
  input: GetPassHoldersInput;
}>;


export type GetActiveMembersQuery = { __typename: 'Query', passHolders: Array<{ __typename: 'PassHolder', firstName: string, lastName: string, imgUrl: string, memberSince: any, userId: number, guestPass: { __typename: 'GuestPass', state: GuestPassState, isActive: boolean, id: string, start: any, end: any, hoursLeft?: number | null, priceNoFees?: number | null, price?: number | null, autoRenewState: GuestPassAutoRenewState, bookingStats: { __typename: 'BookingStats', completedBookings: number, completedHours: number, guestCanCancel: boolean, hostCanCancel: boolean, upcomingBookings: number }, pass?: { __typename: 'Pass', id: string, hoursPerMonth?: number | null } | null } }> };

export type GetExpiredMembersQueryVariables = Exact<{
  input: GetPassHoldersInput;
}>;


export type GetExpiredMembersQuery = { __typename: 'Query', passHolders: Array<{ __typename: 'PassHolder', firstName: string, lastName: string, imgUrl: string, memberSince: any, userId: number, guestPass: { __typename: 'GuestPass', state: GuestPassState, isActive: boolean, id: string, start: any, end: any, hoursLeft?: number | null, priceNoFees?: number | null, price?: number | null, autoRenewState: GuestPassAutoRenewState, bookingStats: { __typename: 'BookingStats', completedBookings: number, completedHours: number, guestCanCancel: boolean, hostCanCancel: boolean, upcomingBookings: number }, pass?: { __typename: 'Pass', id: string, hoursPerMonth?: number | null } | null } }> };

export type GuestPassCancelInfoQueryVariables = Exact<{
  input: GuestPassChargeInfoInput;
}>;


export type GuestPassCancelInfoQuery = { __typename: 'Query', guestPassChargeInfoV2:
    | { __typename: 'GuestPassChargeInfo', activationChargeAmount?: number | null, activationChargeDate?: any | null, cancelCharges?: number | null, cancelEligible: boolean, cancelHoursForfeited?: number | null }
    | { __typename: 'GuestPassChargeInfoError' }
   };

export type PendingMembershipSelectionPricingSummaryQueryVariables = Exact<{
  data: PricingSummaryInput;
}>;


export type PendingMembershipSelectionPricingSummaryQuery = { __typename: 'Query', pricingSummary: { __typename: 'PricingSummary', subtotal: number, host_earnings: number, guest_price: number, display_full_price: boolean, klarnaEligible: boolean, klarnaCancellationFee: number, base_pricing: { __typename: 'BasePricing', amount: number, duration_hours: number, min_guests_for_price: number, max_guests_for_price: number, hourly_rate?: number | null }, base_price_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, amount?: number | null }>, additional_guest_pricing?: { __typename: 'AdditionalGuestPricing', amount: number, additional_guest_count: number, per_guest_rate: number, duration_hours: number } | null, amenity_pricing?: { __typename: 'AmenityPricing', amount: number, amenity_count: number } | null, reservation_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, discount_type: DiscountType, amount?: number | null }>, credit_pricing?: { __typename: 'CreditPricing', amount: number, remaining_balance?: number | null } | null, credit_earnings?: { __typename: 'CreditEarnings', amount: number, earned_credit_type: CreditEarningsType } | null, service_fee_pricing: { __typename: 'ServiceFeePricing', amount?: number | null, service_fee_percentage: number }, host_fee_pricing: { __typename: 'HostFeePricing', amount: number, host_fee_percentage: number }, display_sections?: Array<{ __typename: 'DisplaySection', lines: Array<{ __typename: 'DisplayLine', title: string, subtitle?: any | null, amount: string, is_discount: boolean, is_total: boolean, is_subtotal: boolean, is_premium?: boolean | null, is_membership?: boolean | null }> }> | null, securityDeposit?: { __typename: 'SecurityDepositPricing', amount: number, totalGuests: number } | null, premium_savings?: { __typename: 'PremiumSavings', premium_savings: number, premium_not_saving?: number | null } | null, upsell_discount?: { __typename: 'UpsellDiscount', discount: number, amount: number, hoursUsed: number, hoursLeft: number } | null, pass_discount?: { __typename: 'PassDiscount', discount: number, amount?: number | null, discount_type: DiscountType, can_redeem?: boolean | null, hoursUsed: number, hoursLeft: number } | null } };

export type ListingPassesForGuestQueryVariables = Exact<{
  listingPassesInput: GetListingPassesV2Input;
  listingId: Scalars['Int']['input'];
}>;


export type ListingPassesForGuestQuery = { __typename: 'Query', listingPassesV2: Array<{ __typename: 'ListingPass', id: number, hoursPerMonth: number, discount: number, enabledForHolidays: boolean, enabledForWeekends: boolean, monthlyPriceWithFees: number, monthlyPriceNoFees: number, discountedMonthlyPriceNoFees: number, discountedMonthlyPriceWithFees: number, title?: string | null, type: PassType, timeType?: TimeType | null, maxGuestCount: number, passExpiration?: any | null }>, listingPassesForGuestV2:
    | { __typename: 'ListingNotFoundError' }
    | { __typename: 'ListingPassesForGuestOutput', guestPass?: { __typename: 'GuestPass', id: string, isActive: boolean, hoursLeft?: number | null, maxGuestCount?: number | null, end: any, state: GuestPassState, pass?: { __typename: 'Pass', listingId: number, type: PassType, enabledForWeekends?: boolean | null, enabledForHolidays?: boolean | null, name: string } | null } | null, guestPassCard?: { __typename: 'GuestPassCard', description: string, footer: string, title: string } | null }
   };

export type HostGuideQueryVariables = Exact<{ [key: string]: never; }>;


export type HostGuideQuery = { __typename: 'Query', hostGuide: { __typename: 'HostGuide', idempotencyKey: string } };

export type PhotoScoreFragment = { __typename: 'PhotoScore', id?: string | null, url?: string | null, scoreLabel?: string | null, scoreDescription?: string | null, scoreStatus?: PhotoResponseStatus | null, state: LoadingState };

export type GetHostListingPhotosQueryVariables = Exact<{
  listingId: Scalars['Int']['input'];
}>;


export type GetHostListingPhotosQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, images: Array<{ __typename: 'PoolImage', id?: string | null, url: string, cover: boolean }> } | null };

export type GetHostListingPhotoScoresQueryVariables = Exact<{
  input: GetListingPhotoScoresInput;
}>;


export type GetHostListingPhotoScoresQuery = { __typename: 'Query', listingPhotoScores:
    | { __typename: 'GetListingPhotoScoresResponse', coverPhoto: { __typename: 'PhotoScore', id?: string | null, url?: string | null, scoreLabel?: string | null, scoreDescription?: string | null, scoreStatus?: PhotoResponseStatus | null, state: LoadingState }, photos: Array<{ __typename: 'PhotoScore', id?: string | null, url?: string | null, scoreLabel?: string | null, scoreDescription?: string | null, scoreStatus?: PhotoResponseStatus | null, state: LoadingState }> }
    | { __typename: 'ListingNotFoundError', message: string }
   };

export type SetImageOrderMutationVariables = Exact<{
  input: SetImageOrderDto;
}>;


export type SetImageOrderMutation = { __typename: 'Mutation', setImageOrder:
    | { __typename: 'ImageNotFoundError', message: string }
    | { __typename: 'SetImageOrderResponse', images: Array<{ __typename: 'ListingDescriptionImage', id: string, index: number, isCover: boolean }> }
   };

export type FailReservationPaymentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FailReservationPaymentMutation = { __typename: 'Mutation', failReservationPayment?: { __typename: 'FailReservationPaymentResult', succeeded: boolean, message?: string | null } | null };

export type BookingSuccessQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  input: CheckServiceAvailabilityInput;
}>;


export type BookingSuccessQuery = { __typename: 'Query', reservationDetails?: { __typename: 'Booking', id: string, status: number, is_instant_book?: boolean | null, reservation_price_total: number, adult_guests?: number | null, start_datetime_utc: any, end_datetime_utc: any, checked_in_at?: any | null, booking_invite_url: string, expiration_limit: number, hasExperiences?: boolean | null, bookingInvitesExperiment: BookingInvitesExperiment, bookingInvitesExpCapAmount: number, bookingInvitesExpPerGuestAmount: number, poolPrivate: { __typename: 'PoolPrivate', id: string, stealth_mode: boolean, title: string, time_zone?: string | null, country_code?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean }>, user?: { __typename: 'UserPublic', id: string } | null }, userPublic: { __typename: 'UserPublic', id: string }, booking_invites?: Array<{ __typename: 'BookingInvite', id?: number | null } | null> | null } | null, checkLifeguardAvailability: { __typename: 'CheckServiceAvailabilityResult', available?: boolean | null } };

export type VerifyGuestMutationVariables = Exact<{ [key: string]: never; }>;


export type VerifyGuestMutation = { __typename: 'Mutation', verifyGuest:
    | { __typename: 'UserNotFoundError', message: string }
    | { __typename: 'VerifyGuestResponse', clientSecret?: string | null }
   };

export type GetVerificationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVerificationStatusQuery = { __typename: 'Query', getVerificationStatus: IdVerificationStatus };

export type ReviewPendingRequestBookingQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ReviewPendingRequestBookingQuery = { __typename: 'Query', reservationDetails?: { __typename: 'Booking', created_at: any, survey_response?: any | null, checked_in_at?: any | null, id: string, status: number, end_datetime_utc: any, start_datetime_utc: any, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, premium_id?: number | null, guest_pass_id?: number | null, upsold_pass_id?: number | null, guestPassName?: string | null, reservation_price_total: number, swimmer_review?: boolean | null, host_review?: boolean | null, cancelled_by?: number | null, guest_last_name: string, discount_offered_by_host?: number | null, poolPrivate: { __typename: 'PoolPrivate', stealth_mode: boolean, id: string, city?: string | null, state?: string | null, title: string, time_zone?: string | null, country_code?: string | null, default_instant_booking: boolean, instant_group_size?: number | null, max_guests?: number | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, images: Array<{ __typename: 'PoolImage', cover: boolean, url: string }>, user?: { __typename: 'UserPublic', formatted_name?: string | null, firstname?: string | null, id: string, img_url?: string | null, created_at: any, description?: string | null, is_verified: boolean, is_pro_host: boolean } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, cancellation_policy?: { __typename: 'CancellationPolicy', hours: string } | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null }, bookingReasonChoice?: { __typename: 'BookingReasonChoice', label: string } | null, booking_update_request?: { __typename: 'BookingUpdatedRequest', reschedule_reason_message?: string | null, id?: number | null, discount_offered_by_host?: number | null, requester: { __typename: 'UserPublic', id: string } } | null, paymentBreakdown: Array<{ __typename: 'PaymentBreakdownDisplayItem', displayLine: string, icon: string, paymentMethod: PaymentMethod, amount: number }>, monitor?: { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null } | null, lifeguard?: { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null } | null, guestPass?: { __typename: 'BookingGuestPass', id: string, passHoursPerMonth?: number | null, end: any, price?: number | null, hoursLeft: number, maxGuestCount?: number | null, priceNoFess?: number | null } | null, userPublic: { __typename: 'UserPublic', id: string, img_url?: string | null, rating?: number | null, formatted_name?: string | null, firstname?: string | null, created_at: any, description?: string | null, is_verified: boolean, reviewsCount: number }, last_change_request?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, edited_fields?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string } | null, current_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, booking_host_cancellation?: { __typename: 'BookingHostCancellation', guest_compensation?: GuestCompensation | null } | null } | null };

export type CurrentPricingSummaryQueryVariables = Exact<{
  data: PricingSummaryInput;
}>;


export type CurrentPricingSummaryQuery = { __typename: 'Query', pricingSummary: { __typename: 'PricingSummary', subtotal: number, host_earnings: number, guest_price: number, display_full_price: boolean, klarnaEligible: boolean, klarnaCancellationFee: number, base_pricing: { __typename: 'BasePricing', amount: number, duration_hours: number, min_guests_for_price: number, max_guests_for_price: number, hourly_rate?: number | null }, base_price_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, amount?: number | null }>, additional_guest_pricing?: { __typename: 'AdditionalGuestPricing', amount: number, additional_guest_count: number, per_guest_rate: number, duration_hours: number } | null, amenity_pricing?: { __typename: 'AmenityPricing', amount: number, amenity_count: number } | null, reservation_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, discount_type: DiscountType, amount?: number | null }>, credit_pricing?: { __typename: 'CreditPricing', amount: number, remaining_balance?: number | null } | null, credit_earnings?: { __typename: 'CreditEarnings', amount: number, earned_credit_type: CreditEarningsType } | null, service_fee_pricing: { __typename: 'ServiceFeePricing', amount?: number | null, service_fee_percentage: number }, host_fee_pricing: { __typename: 'HostFeePricing', amount: number, host_fee_percentage: number }, display_sections?: Array<{ __typename: 'DisplaySection', lines: Array<{ __typename: 'DisplayLine', title: string, subtitle?: any | null, amount: string, is_discount: boolean, is_total: boolean, is_subtotal: boolean, is_premium?: boolean | null, is_membership?: boolean | null }> }> | null, securityDeposit?: { __typename: 'SecurityDepositPricing', amount: number, totalGuests: number } | null, premium_savings?: { __typename: 'PremiumSavings', premium_savings: number, premium_not_saving?: number | null } | null, upsell_discount?: { __typename: 'UpsellDiscount', discount: number, amount: number, hoursUsed: number, hoursLeft: number } | null, pass_discount?: { __typename: 'PassDiscount', discount: number, amount?: number | null, discount_type: DiscountType, can_redeem?: boolean | null, hoursUsed: number, hoursLeft: number } | null } };

export type PendingPricingSummaryQueryVariables = Exact<{
  data: PricingSummaryInput;
}>;


export type PendingPricingSummaryQuery = { __typename: 'Query', pricingSummary: { __typename: 'PricingSummary', subtotal: number, host_earnings: number, guest_price: number, display_full_price: boolean, klarnaEligible: boolean, klarnaCancellationFee: number, base_pricing: { __typename: 'BasePricing', amount: number, duration_hours: number, min_guests_for_price: number, max_guests_for_price: number, hourly_rate?: number | null }, base_price_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, amount?: number | null }>, additional_guest_pricing?: { __typename: 'AdditionalGuestPricing', amount: number, additional_guest_count: number, per_guest_rate: number, duration_hours: number } | null, amenity_pricing?: { __typename: 'AmenityPricing', amount: number, amenity_count: number } | null, reservation_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, discount_type: DiscountType, amount?: number | null }>, credit_pricing?: { __typename: 'CreditPricing', amount: number, remaining_balance?: number | null } | null, credit_earnings?: { __typename: 'CreditEarnings', amount: number, earned_credit_type: CreditEarningsType } | null, service_fee_pricing: { __typename: 'ServiceFeePricing', amount?: number | null, service_fee_percentage: number }, host_fee_pricing: { __typename: 'HostFeePricing', amount: number, host_fee_percentage: number }, display_sections?: Array<{ __typename: 'DisplaySection', lines: Array<{ __typename: 'DisplayLine', title: string, subtitle?: any | null, amount: string, is_discount: boolean, is_total: boolean, is_subtotal: boolean, is_premium?: boolean | null, is_membership?: boolean | null }> }> | null, securityDeposit?: { __typename: 'SecurityDepositPricing', amount: number, totalGuests: number } | null, premium_savings?: { __typename: 'PremiumSavings', premium_savings: number, premium_not_saving?: number | null } | null, upsell_discount?: { __typename: 'UpsellDiscount', discount: number, amount: number, hoursUsed: number, hoursLeft: number } | null, pass_discount?: { __typename: 'PassDiscount', discount: number, amount?: number | null, discount_type: DiscountType, can_redeem?: boolean | null, hoursUsed: number, hoursLeft: number } | null } };

export type BookingForCancellingQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type BookingForCancellingQuery = { __typename: 'Query', booking?: { __typename: 'Booking', id: string, date: any, from: string, adults?: number | null, children?: number | null, infants?: number | null, pets?: number | null, hostWillEarn?: number | null, guest: { __typename: 'UserPublic', id: string, photoUrl?: string | null, firstName?: string | null }, listing: { __typename: 'PoolPrivate', timeZone?: string | null, countryCode?: string | null, user?: { __typename: 'UserPublic', id: string, firstName?: string | null } | null } } | null };

export type CancelPricingSummaryQueryVariables = Exact<{
  data: PricingSummaryInput;
}>;


export type CancelPricingSummaryQuery = { __typename: 'Query', pricingSummary: { __typename: 'PricingSummary', subtotal: number, host_earnings: number, guest_price: number, display_full_price: boolean, klarnaEligible: boolean, klarnaCancellationFee: number, base_pricing: { __typename: 'BasePricing', amount: number, duration_hours: number, min_guests_for_price: number, max_guests_for_price: number, hourly_rate?: number | null }, base_price_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, amount?: number | null }>, additional_guest_pricing?: { __typename: 'AdditionalGuestPricing', amount: number, additional_guest_count: number, per_guest_rate: number, duration_hours: number } | null, amenity_pricing?: { __typename: 'AmenityPricing', amount: number, amenity_count: number } | null, reservation_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, discount_type: DiscountType, amount?: number | null }>, credit_pricing?: { __typename: 'CreditPricing', amount: number, remaining_balance?: number | null } | null, credit_earnings?: { __typename: 'CreditEarnings', amount: number, earned_credit_type: CreditEarningsType } | null, service_fee_pricing: { __typename: 'ServiceFeePricing', amount?: number | null, service_fee_percentage: number }, host_fee_pricing: { __typename: 'HostFeePricing', amount: number, host_fee_percentage: number }, display_sections?: Array<{ __typename: 'DisplaySection', lines: Array<{ __typename: 'DisplayLine', title: string, subtitle?: any | null, amount: string, is_discount: boolean, is_total: boolean, is_subtotal: boolean, is_premium?: boolean | null, is_membership?: boolean | null }> }> | null, securityDeposit?: { __typename: 'SecurityDepositPricing', amount: number, totalGuests: number } | null, premium_savings?: { __typename: 'PremiumSavings', premium_savings: number, premium_not_saving?: number | null } | null, upsell_discount?: { __typename: 'UpsellDiscount', discount: number, amount: number, hoursUsed: number, hoursLeft: number } | null, pass_discount?: { __typename: 'PassDiscount', discount: number, amount?: number | null, discount_type: DiscountType, can_redeem?: boolean | null, hoursUsed: number, hoursLeft: number } | null } };

export type EditBookingRequiresApprovalQueryVariables = Exact<{
  data: EditBookingInput;
}>;


export type EditBookingRequiresApprovalQuery = { __typename: 'Query', editBookingRequiresApproval: boolean };

export type AddListingToFavCollectionsMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
  collectionIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  from: FavoriteFrom;
}>;


export type AddListingToFavCollectionsMutation = { __typename: 'Mutation', addListingToFavCollections: Array<{ __typename: 'FavCollection', id: number, name: string, listingCount: number, coverImageUrl?: string | null, listingIds: Array<number | null> } | null> };

export type RemoveListingFromFavCollectionsMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
  collectionIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type RemoveListingFromFavCollectionsMutation = { __typename: 'Mutation', removeListingFromFavCollections: Array<{ __typename: 'FavCollection', id: number, name: string, listingCount: number, coverImageUrl?: string | null, listingIds: Array<number | null> } | null> };

export type SetListingAvailabilityMutationVariables = Exact<{
  input: SetGeneralListingAvailabilityInput;
}>;


export type SetListingAvailabilityMutation = { __typename: 'Mutation', setGeneralListingAvailability:
    | { __typename: 'InvalidDailyAvailabilityError', message: string }
    | { __typename: 'ListingNotFoundError', message: string }
    | { __typename: 'ListingOwnershipError', message: string }
    | { __typename: 'ListingStatusLockedError', message: string }
    | { __typename: 'SetGeneralListingAvailabilityResponse', listing: { __typename: 'Listing', status: ListingStatus } }
   };

export type SetStealthModeMutationVariables = Exact<{
  listingId: Scalars['ID']['input'];
  stealthMode: Scalars['Boolean']['input'];
  stealthReason?: InputMaybe<Scalars['String']['input']>;
  stealthReasonMessage?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetStealthModeMutation = { __typename: 'Mutation', setListingStealthMode:
    | { __typename: 'ListingNotFoundError', message: string }
    | { __typename: 'ListingOwnershipError', message: string }
    | { __typename: 'MutationResult', succeeded: boolean }
   };

export type PricingDetailsQueryVariables = Exact<{
  data: PricingDetailsInput;
  smartPricingDate?: InputMaybe<Scalars['Date']['input']>;
  smartPricingStartDatetime?: InputMaybe<Scalars['DateTimeTz']['input']>;
  smartPricingEndDatetime?: InputMaybe<Scalars['DateTimeTz']['input']>;
  skipSmartPricingByDate: Scalars['Boolean']['input'];
  skipSmartPricingByDatetime: Scalars['Boolean']['input'];
}>;


export type PricingDetailsQuery = { __typename: 'Query', pricingDetails: { __typename: 'PricingDetails', pricing_scheme: PricingScheme, smart_pricing_by_date?: { __typename: 'SmartPricing', off_peak_pricing?: { __typename: 'OffPeakPricing', title: string, description: string, icon: string } | null, long_booking_pricing?: { __typename: 'LongBookingPricing', title: string, description: string, icon: string } | null, same_day_pricing?: { __typename: 'SameDayPricing', title: string, description: string, icon: string } | null } | null, smart_pricing_by_datetime?: { __typename: 'SmartPricing', long_booking_pricing?: { __typename: 'LongBookingPricing', title: string, description: string, icon: string } | null, same_day_pricing?: { __typename: 'SameDayPricing', title: string, description: string, icon: string } | null } | null, discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, amount?: number | null, urgency_text?: string | null, discount_type: DiscountType, can_redeem?: boolean | null }>, pricing: Array<{ __typename: 'Pricing', title: string, subtitle?: any | null, dailyPrice?: number | null, fullDailyPrice?: number | null, hourlyPrice?: number | null, fullHourlyPrice?: number | null, modifiedPrice: number, fullModifiedPrice?: number | null, minGuests: number, maxGuests: number }> } };

export type CreateConnectAccountMutationVariables = Exact<{
  data?: InputMaybe<StripeDashboardInput>;
}>;


export type CreateConnectAccountMutation = { __typename: 'Mutation', createConnectAccount?: { __typename: 'StripeDashboard', url?: string | null } | null };

export type RemoveGuestsMutationVariables = Exact<{
  data: RemoveBookingInvitesInput;
}>;


export type RemoveGuestsMutation = { __typename: 'Mutation', removeBookingInvites: { __typename: 'RemoveBookingInvitesResult', booking: { __typename: 'Booking', id: string } } };

export type NotificationCtaFragment = { __typename: 'Cta', text: string, target: CtaTarget, icon?: string | null, full?: boolean | null, destination?:
    | { __typename: 'BookingDestination', id: string, isHost: boolean }
    | { __typename: 'ListingDestination', id: string, isHost: boolean }
    | { __typename: 'SearchDestination', search: { __typename: 'CtaSearchParams', favorite_collection_id?: number | null, first: number, page: number, adults: number, children?: number | null, infants?: number | null, pets?: number | null, space_type_slug?: string | null, use_case_slug?: string | null, use_case_slugs?: Array<string> | null, filters?: Array<{ __typename: 'DynamicSearchFilterOutput', filter_key: string, values: Array<string | null> }> | null } }
   | null };

export type UserNotificationFieldsFragment = { __typename: 'UserNotification', id: string, title: string, description?: string | null, quote?: string | null, isRead: boolean, timestamp: string, bodyImage?: string | null, avatar?: { __typename: 'UserNotificationAvatar', image?: string | null, icon?: string | null, emoji?: string | null, background?: string | null, badge?: { __typename: 'UserNotificationBadge', icon?: string | null, emoji?: string | null, background?: string | null } | null } | null, card?: { __typename: 'UserNotificationCard', coverImage: string, primaryCopy: string, secondaryCopy?: Array<string> | null, listingStatus?: string | null, primaryPriceCopy?: string | null, secondaryPriceCopy?: string | null, copyCentered?: boolean | null, upperBanner?: { __typename: 'UserNotificationBanner', copy: string, backgroundColor?: string | null, color?: string | null } | null, lowerBanner?: { __typename: 'UserNotificationBanner', copy: string, backgroundColor?: string | null, color?: string | null } | null, cta: { __typename: 'Cta', text: string, target: CtaTarget, icon?: string | null, full?: boolean | null, destination?:
        | { __typename: 'BookingDestination', id: string, isHost: boolean }
        | { __typename: 'ListingDestination', id: string, isHost: boolean }
        | { __typename: 'SearchDestination', search: { __typename: 'CtaSearchParams', favorite_collection_id?: number | null, first: number, page: number, adults: number, children?: number | null, infants?: number | null, pets?: number | null, space_type_slug?: string | null, use_case_slug?: string | null, use_case_slugs?: Array<string> | null, filters?: Array<{ __typename: 'DynamicSearchFilterOutput', filter_key: string, values: Array<string | null> }> | null } }
       | null } } | null, cta?: { __typename: 'Cta', text: string, target: CtaTarget, icon?: string | null, full?: boolean | null, destination?:
      | { __typename: 'BookingDestination', id: string, isHost: boolean }
      | { __typename: 'ListingDestination', id: string, isHost: boolean }
      | { __typename: 'SearchDestination', search: { __typename: 'CtaSearchParams', favorite_collection_id?: number | null, first: number, page: number, adults: number, children?: number | null, infants?: number | null, pets?: number | null, space_type_slug?: string | null, use_case_slug?: string | null, use_case_slugs?: Array<string> | null, filters?: Array<{ __typename: 'DynamicSearchFilterOutput', filter_key: string, values: Array<string | null> }> | null } }
     | null } | null };

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = { __typename: 'Query', getNotifications: { __typename: 'UserNotificationsResponse', unreadCount: number, notifications: Array<{ __typename: 'UserNotification', id: string, title: string, description?: string | null, quote?: string | null, isRead: boolean, timestamp: string, bodyImage?: string | null, avatar?: { __typename: 'UserNotificationAvatar', image?: string | null, icon?: string | null, emoji?: string | null, background?: string | null, badge?: { __typename: 'UserNotificationBadge', icon?: string | null, emoji?: string | null, background?: string | null } | null } | null, card?: { __typename: 'UserNotificationCard', coverImage: string, primaryCopy: string, secondaryCopy?: Array<string> | null, listingStatus?: string | null, primaryPriceCopy?: string | null, secondaryPriceCopy?: string | null, copyCentered?: boolean | null, upperBanner?: { __typename: 'UserNotificationBanner', copy: string, backgroundColor?: string | null, color?: string | null } | null, lowerBanner?: { __typename: 'UserNotificationBanner', copy: string, backgroundColor?: string | null, color?: string | null } | null, cta: { __typename: 'Cta', text: string, target: CtaTarget, icon?: string | null, full?: boolean | null, destination?:
            | { __typename: 'BookingDestination', id: string, isHost: boolean }
            | { __typename: 'ListingDestination', id: string, isHost: boolean }
            | { __typename: 'SearchDestination', search: { __typename: 'CtaSearchParams', favorite_collection_id?: number | null, first: number, page: number, adults: number, children?: number | null, infants?: number | null, pets?: number | null, space_type_slug?: string | null, use_case_slug?: string | null, use_case_slugs?: Array<string> | null, filters?: Array<{ __typename: 'DynamicSearchFilterOutput', filter_key: string, values: Array<string | null> }> | null } }
           | null } } | null, cta?: { __typename: 'Cta', text: string, target: CtaTarget, icon?: string | null, full?: boolean | null, destination?:
          | { __typename: 'BookingDestination', id: string, isHost: boolean }
          | { __typename: 'ListingDestination', id: string, isHost: boolean }
          | { __typename: 'SearchDestination', search: { __typename: 'CtaSearchParams', favorite_collection_id?: number | null, first: number, page: number, adults: number, children?: number | null, infants?: number | null, pets?: number | null, space_type_slug?: string | null, use_case_slug?: string | null, use_case_slugs?: Array<string> | null, filters?: Array<{ __typename: 'DynamicSearchFilterOutput', filter_key: string, values: Array<string | null> }> | null } }
         | null } | null }> } };

export type DeleteNotificationMutationVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type DeleteNotificationMutation = { __typename: 'Mutation', deleteNotification: { __typename: 'UserNotificationMutationResult', success: boolean, message?: string | null } };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsReadMutation = { __typename: 'Mutation', markAllNotificationsAsRead: { __typename: 'UserNotificationMutationResult', success: boolean, message?: string | null } };

export type DeleteAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllNotificationsMutation = { __typename: 'Mutation', deleteAllNotifications: { __typename: 'UserNotificationMutationResult', success: boolean, message?: string | null } };

export type ListingSelectorListingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListingSelectorListingsQuery = { __typename: 'Query', listings: Array<{ __typename: 'MyPool', id: string, title: string, status: number, stealth_mode: boolean, city?: string | null, state?: string | null, max_guests?: number | null, country_code?: string | null, onboardingPercentageComplete: number, totalPercentageComplete: number, customType?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', url: string, pool_id: number, cover: boolean }>, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null }> };

export type RemoveListingReviewHostResponseMutationVariables = Exact<{
  data: RemoveListingReviewHostResponseInput;
}>;


export type RemoveListingReviewHostResponseMutation = { __typename: 'Mutation', removeListingReviewHostResponse: { __typename: 'RemoveListingReviewHostResponseResult', message: string, succeeded: boolean } };

export type RespondToListingReviewMutationVariables = Exact<{
  data: RespondToListingReviewInput;
}>;


export type RespondToListingReviewMutation = { __typename: 'Mutation', respondToListingReview: { __typename: 'RespondToListingReviewResult', message: string, succeeded: boolean } };

export type ListingHostInfoQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ListingHostInfoQuery = { __typename: 'Query', listing?: { __typename: 'PoolPublic', stealth_mode: boolean, user?: { __typename: 'UserPublic', id: string, is_verified: boolean, bio?: string | null, firstName?: string | null, photoUrl?: string | null, isProHost: boolean, createdAt: any } | null } | null };

export type UserProfileQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type UserProfileQuery = { __typename: 'Query', userPublic?: { __typename: 'UserPublic', id: string, is_verified: boolean, bio?: string | null, firstName?: string | null, photoUrl?: string | null, isProHost: boolean, createdAt: any } | null };

export type UserReviewsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserReviewsQuery = { __typename: 'Query', userReviews: { __typename: 'HostReviewPaginator', reviews: Array<{ __typename: 'HostReview', id: string, rating: number, comment: string, createdAt: any, commenter: { __typename: 'UserPublic', id: string, photoUrl?: string | null, firstName?: string | null, formattedName?: string | null, isProHost: boolean } }>, paginatorInfo: { __typename: 'PaginatorInfo', currentPage: number, total: number, hasMorePages: boolean, totalPages: number } } };

export type CancelPremiumFeesAndCreditsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CancelPremiumFeesAndCreditsQuery = { __typename: 'Query', cancelPremiumFeesAndCredits:
    | { __typename: 'CancelPremiumFeesAndCredits', creditsLost: number, fees: number, totalCreditsEarned: number, totalFeesSaved: number, totalPremiumBookings: number }
    | { __typename: 'MutationResult', succeeded: boolean, message?: string | null }
   };

export type CancelSwimplyPremiumMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  reasonInputMessage?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelSwimplyPremiumMutation = { __typename: 'Mutation', cancelPremium: { __typename: 'CancelPremiumResult', premium: { __typename: 'Premium', endDatetimeUtc?: any | null, startDatetimeUtc: any, paymentSourceId?: string | null, status: PremiumStatus, id: string, autoRenewState?: AutoRenewState | null, pausedAt?: any | null, type: PremiumType, price: { __typename: 'Money', amount: number } } } };

export type PauseSwimplyPremiumMutationVariables = Exact<{ [key: string]: never; }>;


export type PauseSwimplyPremiumMutation = { __typename: 'Mutation', pausePremium:
    | { __typename: 'Premium', endDatetimeUtc?: any | null, startDatetimeUtc: any, paymentSourceId?: string | null, status: PremiumStatus, id: string, autoRenewState?: AutoRenewState | null, pausedAt?: any | null, type: PremiumType, price: { __typename: 'Money', amount: number } }
    | { __typename: 'PremiumNotFound', message: string }
   };

export type GetPassCostsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetPassCostsQuery = { __typename: 'Query', getPassCosts:
    | { __typename: 'MutationResult' }
    | { __typename: 'PassCostsResult', premium: { __typename: 'PassCost', discount: number, total: number, nonDiscounted: number }, igloo: { __typename: 'PassCost', discount: number, total: number, nonDiscounted: number } }
   };

export type GetPassesByIdQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetPassesByIdQuery = { __typename: 'Query', passByUserId:
    | { __typename: 'MutationResult' }
    | { __typename: 'Premium', endDatetimeUtc?: any | null, startDatetimeUtc: any, paymentSourceId?: string | null, status: PremiumStatus, id: string, autoRenewState?: AutoRenewState | null, pausedAt?: any | null, type: PremiumType, price: { __typename: 'Money', amount: number } }
  , premiumByUserId:
    | { __typename: 'MutationResult' }
    | { __typename: 'Premium', endDatetimeUtc?: any | null, startDatetimeUtc: any, paymentSourceId?: string | null, status: PremiumStatus, id: string, autoRenewState?: AutoRenewState | null, pausedAt?: any | null, type: PremiumType, price: { __typename: 'Money', amount: number } }
  , iglooByUserId:
    | { __typename: 'MutationResult' }
    | { __typename: 'Premium', endDatetimeUtc?: any | null, startDatetimeUtc: any, paymentSourceId?: string | null, status: PremiumStatus, id: string, autoRenewState?: AutoRenewState | null, pausedAt?: any | null, type: PremiumType, price: { __typename: 'Money', amount: number } }
   };

export type BillingHistoryItemFragment = { __typename: 'BillingHistoryEntry', invoiceId: number, createdAt: string, status: string, lineItems: Array<{ __typename: 'BillingHistoryLineItem', amount: number, currency: string, premiumType?: string | null, label: string }> };

export type BillingHistoryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type BillingHistoryQuery = { __typename: 'Query', billingHistory:
    | { __typename: 'BillingHistoryError', message: string }
    | { __typename: 'BillingHistoryResult', entries: Array<{ __typename: 'BillingHistoryEntry', invoiceId: number, createdAt: string, status: string, lineItems: Array<{ __typename: 'BillingHistoryLineItem', amount: number, currency: string, premiumType?: string | null, label: string }> }> }
   };

export type ChangePremiumPaymentMethodMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: ChangePremiumPaymentInput;
}>;


export type ChangePremiumPaymentMethodMutation = { __typename: 'Mutation', changePremiumPaymentMethod:
    | { __typename: 'MutationResult', succeeded: boolean, message?: string | null }
    | { __typename: 'Premium', endDatetimeUtc?: any | null, startDatetimeUtc: any, paymentSourceId?: string | null, status: PremiumStatus, id: string, autoRenewState?: AutoRenewState | null, pausedAt?: any | null, type: PremiumType, price: { __typename: 'Money', amount: number } }
   };

export type SwimplyPremiumFragment = { __typename: 'Premium', endDatetimeUtc?: any | null, startDatetimeUtc: any, paymentSourceId?: string | null, status: PremiumStatus, id: string, autoRenewState?: AutoRenewState | null, pausedAt?: any | null, type: PremiumType, price: { __typename: 'Money', amount: number } };

export type RenewSwimplyPremiumMutationVariables = Exact<{
  input: PremiumInput;
}>;


export type RenewSwimplyPremiumMutation = { __typename: 'Mutation', renewPremium:
    | { __typename: 'Premium', endDatetimeUtc?: any | null, startDatetimeUtc: any, paymentSourceId?: string | null, status: PremiumStatus, id: string, autoRenewState?: AutoRenewState | null, pausedAt?: any | null, type: PremiumType, price: { __typename: 'Money', amount: number } }
    | { __typename: 'PurchasePremiumError', message: string }
   };

export type StartSwimplyPremiumMutationVariables = Exact<{
  input: PremiumInput;
}>;


export type StartSwimplyPremiumMutation = { __typename: 'Mutation', startPremium:
    | { __typename: 'Premium', endDatetimeUtc?: any | null, startDatetimeUtc: any, paymentSourceId?: string | null, status: PremiumStatus, id: string, autoRenewState?: AutoRenewState | null, pausedAt?: any | null, type: PremiumType, price: { __typename: 'Money', amount: number } }
    | { __typename: 'PurchasePremiumError', message: string }
   };

export type SwitchToIglooMutationVariables = Exact<{ [key: string]: never; }>;


export type SwitchToIglooMutation = { __typename: 'Mutation', switchToIglooPass:
    | { __typename: 'Premium', endDatetimeUtc?: any | null, startDatetimeUtc: any, paymentSourceId?: string | null, status: PremiumStatus, id: string, autoRenewState?: AutoRenewState | null, pausedAt?: any | null, type: PremiumType, price: { __typename: 'Money', amount: number } }
    | { __typename: 'PremiumNotFound', message: string }
   };

export type UpgradeToPremiumMutationVariables = Exact<{
  input: PremiumInput;
}>;


export type UpgradeToPremiumMutation = { __typename: 'Mutation', upgradeToPremium:
    | { __typename: 'Premium', endDatetimeUtc?: any | null, startDatetimeUtc: any, paymentSourceId?: string | null, status: PremiumStatus, id: string, autoRenewState?: AutoRenewState | null, pausedAt?: any | null, type: PremiumType, price: { __typename: 'Money', amount: number } }
    | { __typename: 'PremiumNotFound', message: string }
    | { __typename: 'PurchasePremiumError', message: string }
   };

export type PremiumInfoQueryVariables = Exact<{
  input?: InputMaybe<PremiumInfoInput>;
}>;


export type PremiumInfoQuery = { __typename: 'Query', premiumInfo: { __typename: 'PremiumInfoResponse', summerPass?: { __typename: 'SummerPassOption', currentPrice: number, fullPrice: number, buyCopy: string, disclaimerCopy: string, title: string, benefitsTitle: string, perks: Array<string>, saleEndDate?: any | null, earlyBirdSpecial?: { __typename: 'EarlyBirdSpecial', saleEndDate: any, headerCopy?: string | null, copy?: string | null } | null, selection: { __typename: 'PassOptionSelection', headerCopy: string, salesCopy?: string | null } } | null, monthlyPass?: { __typename: 'PassOption', currentPrice: number, fullPrice: number, buyCopy: string, disclaimerCopy: string, title: string, benefitsTitle: string, perks: Array<string>, selection: { __typename: 'PassOptionSelection', headerCopy: string, salesCopy?: string | null } } | null, bookingUpsell?: { __typename: 'BookingUpsell', upsellHeaderCopy: string, upsellCopy: string, earnableCredits: number, serviceFeesSaved: number } | null, profileEntryPoint: { __typename: 'ProfileEntryPoint', headerCopy: string, copy: string }, homePageBanner?: { __typename: 'HomePageBanner', label: string, sublabel: string, cta: string } | null } };

export type ServerSearchSpaceTypeFragment = { __typename: 'SearchSpaceType', listingCount: number, spaceType: { __typename: 'SpaceType', id: number, name: string, description?: string | null, slug: string, icon?: SearchFilterIcon | null, color?: string | null, waitlistListingType?: WaitlistListingType | null, listingType?: ListingType | null } };

export type ServerSearchUseCaseFragment = { __typename: 'SearchUseCase', listingCount: number, useCase: { __typename: 'UseCase', id: number, name: string, description?: string | null, slug: string, icon?: SearchFilterIcon | null, waitlistable: boolean } };

export type SearchSpaceTypeFragment = { __typename: 'SearchSpaceType', listingCount: number, spaceType: { __typename: 'SpaceType', id: number, name: string, description?: string | null, slug: string, icon?: SearchFilterIcon | null, color?: string | null, waitlistListingType?: WaitlistListingType | null, listingType?: ListingType | null } };

export type SearchUseCaseFragment = { __typename: 'SearchUseCase', listingCount: number, useCase: { __typename: 'UseCase', id: number, name: string, description?: string | null, slug: string, icon?: SearchFilterIcon | null, waitlistable: boolean } };

export type ListingAvailabilityFragment = { __typename: 'PoolPublic', id: string, status: number, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, advance_notice?: number | null, default_instant_booking: boolean, instant_group_size?: number | null, time_zone?: string | null, pause_start?: any | null, pause_end?: any | null };

export type ListingPriceFragment = { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null };

export type PublicListingFragment = { __typename: 'PoolPublic', id: string, title: string, description?: string | null, city?: string | null, state?: string | null, country_code?: string | null, zip_code?: string | null, hourly_price?: number | null, rating?: number | null, additional_rules?: string | null, is_security_cameras?: boolean | null, host_interaction_setting?: HostInteractionSettings | null, pets_rule?: PetsRules | null, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, guests_pets_allowed?: boolean | null, cancellation_policy_id?: number | null, latitude_round?: number | null, longitude_round?: number | null, status: number, status_name: string, time_zone?: string | null, default_instant_booking: boolean, instant_group_size?: number | null, availability_window?: number | null, advance_notice?: number | null, available_from?: string | null, available_to?: string | null, reviewsCount: number, custom_listing_type?: string | null, min_booking_length?: number | null, discount_first_bookings?: boolean | null, pause_start?: any | null, pause_end?: any | null, is_quality: boolean, tour_360_url?: string | null, stealth_mode: boolean, space_types: Array<string>, securityDepositMinGuests?: number | null, securityDepositMinor?: number | null, cancellation_policy?: { __typename: 'CancellationPolicy', id: string, title: string, color: string, description: string, hours: string, discount: string } | null, images: Array<{ __typename: 'PoolImage', id?: string | null, url: string, cover: boolean }>, rules?: Array<{ __typename: 'Rule', id: string, name: string, active: boolean } | null> | null, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, pool_id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, enable?: boolean | null, square_footage?: number | null, amenity?: { __typename: 'Amenity', id: string, name: string, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, featured_promo_code?: { __typename: 'FeaturedPromoCode', id: number, promo_code: string, percent_off: number, max_redemptions: number, redeem_by: any, times_redeemed: number, feature_text?: string | null, can_redeem: boolean } | null, user?: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, created_at: any } | null, response_time: { __typename: 'PoolResponseTime', response_time_text?: string | null }, instagram_images: Array<{ __typename: 'InstagramImage', id: string, url: string } | null> };

export type MyPoolFragment = { __typename: 'MyPool', id: string, title: string, description?: string | null, custom_listing_type?: string | null, city?: string | null, state?: string | null, time_zone?: string | null, country_code?: string | null, discount_first_bookings?: boolean | null, is_security_cameras?: boolean | null, additional_rules?: string | null, host_interaction_setting?: HostInteractionSettings | null, pets_rule?: PetsRules | null, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, guests_pets_allowed?: boolean | null, default_instant_booking: boolean, instant_group_size?: number | null, special_access_instruction?: string | null, availability_window?: number | null, advance_notice?: number | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, pause_start?: any | null, pause_end?: any | null, min_buffer_time?: number | null, available_days: Array<string | null>, are_post_onboarding_steps_completed: boolean, is_third_party_address_opted_in: boolean, is_covered_by_insurance: boolean, can_update_insurance: boolean, cancellation_policy_id?: number | null, status: number, status_name: string, reviewsCount: number, rating?: number | null, is_quality: boolean, is_in_rehab: boolean, tour_360_url?: string | null, guest_leads: number, one_time_guests: number, repeat_guests: number, abandoned_carts: number, total_fans?: number | null, has_instagram_connection: boolean, instagram_username?: string | null, can_upload_video: boolean, stealth_mode: boolean, securityDepositMinGuests?: number | null, securityDepositMinor?: number | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, rule_settings: Array<{ __typename: 'RuleSetting', id: number, slug: string, name: string, icon: RuleIcon, active: boolean, description?: string | null, is_allowed?: boolean | null } | null>, access_photos: Array<{ __typename: 'PoolAccessPhoto', id: number, image_url: string } | null>, cancellation_policy?: { __typename: 'CancellationPolicy', id: string, title: string, color: string, description: string, hours: string, discount: string } | null, images: Array<{ __typename: 'PoolImage', id?: string | null, pool_id: number, url: string, cover: boolean, index?: number | null }>, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, pool_id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, enable?: boolean | null, square_footage?: number | null, amenity?: { __typename: 'Amenity', id: string, name: string, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, featured_promo_code?: { __typename: 'FeaturedPromoCode', id: number, promo_code: string, percent_off: number, max_redemptions: number, redeem_by: any, times_redeemed: number, feature_text?: string | null, can_redeem: boolean } | null };

export type ListingPricingFragment = { __typename: 'PoolPublic', id: string, country_code?: string | null, user?: { __typename: 'UserPublic', id: string, firstname?: string | null } | null, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, featuredPromo?: { __typename: 'FeaturedPromoCode', id: number, promo_code: string, percent_off: number, max_redemptions: number, redeem_by: any, times_redeemed: number, can_redeem: boolean } | null };

export type ServerSearchListingFragment = { __typename: 'SearchPool', id: string, title: string, description?: string | null, distance?: number | null, state: string, city: string, zip_code: string, rating?: number | null, image_urls?: Array<string | null> | null, cover_image_url?: string | null, video_thumbnail_url?: string | null, country_code?: string | null, listing_type: ListingType, max_guests?: number | null, instant_booking: boolean, default_instant_booking?: boolean | null, is_new: boolean, is_quality: boolean, stealth_mode: boolean, badges?: Array<string | null> | null, reviewsCount: number, latitude_round?: number | null, longitude_round?: number | null, nextAvailableDay?: any | null, pricing: { __typename: 'SearchPoolPricing', pricing_scheme: PricingScheme, price: number, discounted_price: number, featured_promo_code_percent: number, grand_opening_discount_percent: number } };

export type SearchListingFragment = { __typename: 'SearchPool', id: string, title: string, description?: string | null, distance?: number | null, state: string, city: string, zip_code: string, rating?: number | null, image_urls?: Array<string | null> | null, cover_image_url?: string | null, video_thumbnail_url?: string | null, country_code?: string | null, listing_type: ListingType, max_guests?: number | null, instant_booking: boolean, default_instant_booking?: boolean | null, is_new: boolean, is_quality: boolean, stealth_mode: boolean, badges?: Array<string | null> | null, reviewsCount: number, latitude_round?: number | null, longitude_round?: number | null, nextAvailableDay?: any | null, pricing: { __typename: 'SearchPoolPricing', pricing_scheme: PricingScheme, price: number, discounted_price: number, featured_promo_code_percent: number, grand_opening_discount_percent: number }, experiences?: { __typename: 'SearchPoolExperiences', duration?: number | null, per_guest_pricing?: number | null, guest_restrictions?: string | null } | null };

export type ServerGuestReviewFragment = { __typename: 'HostReview', id: string, rating: number, comment: string, createdAt: any, commenter: { __typename: 'UserPublic', id: string, photoUrl?: string | null, firstName?: string | null, formattedName?: string | null, isProHost: boolean } };

export type ServerListingReviewFragment = { __typename: 'Review', id: string, booking_id?: string | null, rating: number, comment: string, createdAt?: any | null, isRepeatedGuest: boolean, isBetaGuest: boolean, hostRespondedAt?: any | null, hostResponse?: string | null, commenter: { __typename: 'UserPublic', id: string, photoUrl?: string | null, firstName?: string | null, formattedName?: string | null, isProHost: boolean }, bookingReasonChoice?: { __typename: 'BookingReasonChoice', label: string, id: string, icon: string } | null };

export type GuestReviewFragment = { __typename: 'HostReview', id: string, rating: number, comment: string, createdAt: any, commenter: { __typename: 'UserPublic', id: string, photoUrl?: string | null, firstName?: string | null, formattedName?: string | null, isProHost: boolean } };

export type ListingReviewFragment = { __typename: 'Review', id: string, booking_id?: string | null, rating: number, comment: string, createdAt?: any | null, isRepeatedGuest: boolean, isBetaGuest: boolean, hostRespondedAt?: any | null, hostResponse?: string | null, commenter: { __typename: 'UserPublic', id: string, photoUrl?: string | null, firstName?: string | null, formattedName?: string | null, isProHost: boolean }, bookingReasonChoice?: { __typename: 'BookingReasonChoice', label: string, id: string, icon: string } | null };

export type AccurateCountryMutationVariables = Exact<{
  data: AccurateInput;
}>;


export type AccurateCountryMutation = { __typename: 'Mutation', accurateCountry: { __typename: 'accurateResult', status?: string | null } };

export type AddPaymentMethodMutationVariables = Exact<{
  data: AddPaymentSourceInput;
}>;


export type AddPaymentMethodMutation = { __typename: 'Mutation', addPaymentSource: { __typename: 'AddPaymentSourceResult', status: string, message: string, paymentSources: Array<{ __typename: 'PaymentSource', id: number, brand?: string | null, last4?: string | null, type?: string | null, postal_code?: string | null, isDefault: boolean, expirationDate?: any | null }> } };

export type ApproveEditReservationMutationVariables = Exact<{
  data: ApproveEditReservationInput;
}>;


export type ApproveEditReservationMutation = { __typename: 'Mutation', approveEditReservation: { __typename: 'ApproveEditReservationResult', status: string, message: string, booking_id?: number | null, clientSecret?: string | null } };

export type ApproveReservationMutationVariables = Exact<{
  data: ReservationInput;
}>;


export type ApproveReservationMutation = { __typename: 'Mutation', approveReservation?: { __typename: 'ReservationResult', status: string, message: string } | null };

export type BookPoolMutationVariables = Exact<{
  data: BookPoolInput;
}>;


export type BookPoolMutation = { __typename: 'Mutation', bookPool?: { __typename: 'BookPoolResult', booking_id?: number | null, status: string, message: string, clientSecret?: string | null } | null };

export type CancelEditReservationRequestMutationVariables = Exact<{
  data: CancelEditReservationRequestInput;
}>;


export type CancelEditReservationRequestMutation = { __typename: 'Mutation', cancelEditReservationRequest: { __typename: 'CancelEditReservationRequestResult', message?: string | null, status?: string | null } };

export type CancelReservationMutationVariables = Exact<{
  data: ReservationInput;
}>;


export type CancelReservationMutation = { __typename: 'Mutation', cancelReservation?: { __typename: 'CancelReservationResult', message: string, status: string, charged?: boolean | null } | null };

export type CreateProfileMutationVariables = Exact<{
  data: CreateProfileInput;
}>;


export type CreateProfileMutation = { __typename: 'Mutation', createProfile?: { __typename: 'CreateProfileResult', status: boolean, message: string, image_url?: string | null } | null };

export type DeclineEditReservationMutationVariables = Exact<{
  data: DeclineEditReservationTypeInput;
}>;


export type DeclineEditReservationMutation = { __typename: 'Mutation', declineEditReservation: { __typename: 'DeclineEditReservationResult', status: string, message: string } };

export type DeclineReservationMutationVariables = Exact<{
  data: ReservationInput;
}>;


export type DeclineReservationMutation = { __typename: 'Mutation', declineReservation?: { __typename: 'ReservationResult', status: string, message: string } | null };

export type DeleteUserAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserAccountMutation = { __typename: 'Mutation', deleteUserAccount?: { __typename: 'DeleteAccountResult', status: string, message: string } | null };

export type EditBookingMutationVariables = Exact<{
  data: EditBookingInput;
}>;


export type EditBookingMutation = { __typename: 'Mutation', editBooking: { __typename: 'EditBookingResult', message: string, status: string, clientSecret?: string | null, booking?: { __typename: 'Booking', id: string } | null } };

export type ForgotPasswordMutationVariables = Exact<{
  data: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename: 'Mutation', forgotPassword: { __typename: 'ForgotPasswordResponse', status: string, message?: string | null } };

export type EmailLoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  verificationCode?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmailLoginMutation = { __typename: 'Mutation', emailLogin: { __typename: 'LoginResponse', access_token?: string | null, token_type?: string | null, lastname?: string | null, firstname?: string | null, country_code?: string | null, country_code_swimmer?: string | null, roles?: Array<{ __typename: 'Role', name: string } | null> | null } };

export type ResendEmailCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
  verificationCode?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResendEmailCodeMutation = { __typename: 'Mutation', emailLogin: { __typename: 'LoginResponse', access_token?: string | null, token_type?: string | null, lastname?: string | null, firstname?: string | null, country_code?: string | null, country_code_swimmer?: string | null, roles?: Array<{ __typename: 'Role', name: string } | null> | null } };

export type MobileLoginMutationVariables = Exact<{
  phoneCountryCode: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
  mobileNumber: Scalars['String']['input'];
}>;


export type MobileLoginMutation = { __typename: 'Mutation', mobileLogin: { __typename: 'LoginResponse', access_token?: string | null, token_type?: string | null, lastname?: string | null, firstname?: string | null, country_code?: string | null, country_code_swimmer?: string | null, roles?: Array<{ __typename: 'Role', name: string } | null> | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename: 'Mutation', logout: { __typename: 'LogoutResponse', status: string, message?: string | null } };

export type RecordActivityMutationVariables = Exact<{
  data: RecordActivityInput;
}>;


export type RecordActivityMutation = { __typename: 'Mutation', recordActivity?: boolean | null };

export type RemovePaymentMethodMutationVariables = Exact<{
  data: RemovePaymentSourceInput;
}>;


export type RemovePaymentMethodMutation = { __typename: 'Mutation', removePaymentSource: { __typename: 'RemovePaymentSourceResult', status: string, message: string } };

export type HostReviewStoreMutationVariables = Exact<{
  data: HostReviewInput;
}>;


export type HostReviewStoreMutation = { __typename: 'Mutation', hostReviewStore?: { __typename: 'HostReviewResult', status?: string | null, message?: string | null } | null };

export type ReviewPoolMutationVariables = Exact<{
  data: ReviewInput;
}>;


export type ReviewPoolMutation = { __typename: 'Mutation', reviewPool?: { __typename: 'ReviewResult', status?: string | null, message?: string | null } | null };

export type SaveListingPremiumAmenitiesMutationVariables = Exact<{
  data: Array<InputMaybe<PremiumAmenityInput>> | InputMaybe<PremiumAmenityInput>;
  pool_id: Scalars['Int']['input'];
}>;


export type SaveListingPremiumAmenitiesMutation = { __typename: 'Mutation', saveListingPremiumAmenities?: { __typename: 'PoolPremiumAmenityResponse', status?: string | null, pool_premium_amenity?: Array<{ __typename: 'PoolPremiumAmenity', id: number, pool_id: number, title: string, enable?: boolean | null, main_category?: string | null, description?: string | null, square_footage?: number | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null } | null };

export type SavePoolDiscountDaysMutationVariables = Exact<{
  data: PoolDiscountDaysInput;
}>;


export type SavePoolDiscountDaysMutation = { __typename: 'Mutation', savePoolDiscountDays?: { __typename: 'PoolSavingResult', status?: string | null } | null };

export type SavePoolInfoMutationVariables = Exact<{
  data: SavePoolInfoInput;
}>;


export type SavePoolInfoMutation = { __typename: 'Mutation', savePoolInfo?: { __typename: 'PoolSavingResult', status?: string | null, message?: string | null } | null };

export type SendVerificationCodeToMobileMutationVariables = Exact<{
  data: SendVerificationCodeToMobileInput;
  includeSMSBody: Scalars['Boolean']['input'];
}>;


export type SendVerificationCodeToMobileMutation = { __typename: 'Mutation', sendVerificationCodeToMobile?: { __typename: 'SendVerificationCodeToMobileResult', status: string, message: string, smsMessage?: string | null } | null };

export type SetDefaultPaymentSourceMutationVariables = Exact<{
  data: SetDefaultPaymentSourceInput;
}>;


export type SetDefaultPaymentSourceMutation = { __typename: 'Mutation', setDefaultPaymentSource: { __typename: 'SetDefaultPaymentSourceResult', status: string, message: string } };

export type SetPoolsDiscountFirstBookingMutationVariables = Exact<{
  data: DiscountFirstBookingSData;
}>;


export type SetPoolsDiscountFirstBookingMutation = { __typename: 'Mutation', setPoolsDiscountFirstBooking?: { __typename: 'PoolsDiscountFirstBooking', status: string, message?: string | null } | null };

export type SignUpMutationVariables = Exact<{
  data: SignUpInput;
}>;


export type SignUpMutation = { __typename: 'Mutation', signUp: { __typename: 'SignUpResult', status: string, access_token?: string | null, message: string, country_code?: string | null, country_code_swimmer?: string | null, id?: string | null, roles?: Array<{ __typename: 'Role', name: string } | null> | null } };

export type SkipBookingReviewMutationVariables = Exact<{
  data: SkipBookingReviewInput;
}>;


export type SkipBookingReviewMutation = { __typename: 'Mutation', skipBookingReview: { __typename: 'SkipBookingReviewResult', status: string, message: string } };

export type SsoAuthMutationVariables = Exact<{
  data?: InputMaybe<SsoAuthInput>;
}>;


export type SsoAuthMutation = { __typename: 'Mutation', SsoAuth?: { __typename: 'SsoAuthResponse', provider: string, access_token: string, status: string, message: string, firstname?: string | null, lastname?: string | null, country_code?: string | null, country_code_swimmer?: string | null, image_url?: string | null, email: string, mobile_number?: string | null, mobile_number_verified_at?: any | null, new_user?: boolean | null, id?: string | null, roles: Array<{ __typename: 'Role', name: string } | null> } | null };

export type StoreCalibrationDataMutationVariables = Exact<{
  interestedIn?: InputMaybe<Array<InputMaybe<InterestedInSpaceType>> | InputMaybe<InterestedInSpaceType>>;
  heardAboutUs?: InputMaybe<HeardAboutUsChannel>;
}>;


export type StoreCalibrationDataMutation = { __typename: 'Mutation', storeCalibrationData: boolean };

export type UpdatePasswordMutationVariables = Exact<{
  data: NewPasswordWithCodeInput;
}>;


export type UpdatePasswordMutation = { __typename: 'Mutation', updateForgottenPassword: { __typename: 'ForgotPasswordResponse', status: string, message?: string | null } };

export type UpdateProfileMutationVariables = Exact<{
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProfileMutation = { __typename: 'Mutation', updateProfile: { __typename: 'Me', id: string, firstname?: string | null, lastname?: string | null, zipcode?: string | null, email?: string | null, description?: string | null, phone_number?: string | null, mobile_number?: string | null, mobile_number_verified_at?: any | null, country_phone_code?: string | null, date_birthday?: string | null, referral_token: string, country?: string | null, img_url?: string | null, isAnyPool: boolean, unread_message: boolean, stripe_id?: string | null, country_code?: string | null, country_code_swimmer?: string | null, accept_chat_rules: boolean, credit_balance?: number | null, stripe_account_onboard?: boolean | null, stripe_identity_verified: boolean, blocked_user_ids: Array<number>, blocked_by_user_ids: Array<number>, facebook_id?: string | null, most_recent_booking_id?: string | null, listing_ids: Array<string>, used_app_recently: boolean, heard_about_us?: HeardAboutUsChannel | null, is_under_age: boolean, incomplete_post_onboarding_step_listing_ids: Array<string>, has_pending_bookings: boolean, premium_state: PremiumState, premium_type: UserPremiumType, opt_in_date?: any | null, opt_in_id?: number | null, is_pro_host: boolean, has_opt_in_banner: boolean, roles: Array<{ __typename: 'Role', name: string }>, verificationsPrivate?: Array<{ __typename: 'UserVerificationPrivate', successful_booking?: boolean | null, passport_drive_url?: boolean | null, pool_proof_url?: boolean | null, img_id_approved?: boolean | null, img_proof_approved?: boolean | null } | null> | null } };

export type VerifyEmailMutationVariables = Exact<{
  data: EmailVerificationInput;
}>;


export type VerifyEmailMutation = { __typename: 'Mutation', verifyUserEmail?: { __typename: 'EmailVerificationResult', status: string, accessToken: string, roles?: Array<{ __typename: 'Role', name: string } | null> | null } | null };

export type VerifyMobileNumberMutationVariables = Exact<{
  data: VerifyMobileNumberInput;
}>;


export type VerifyMobileNumberMutation = { __typename: 'Mutation', verifyMobileNumber?: { __typename: 'VerifyMobileNumberResult', status: string, mobileNumberVerified: boolean } | null };

export type VerifyUserMobileNumberMutationVariables = Exact<{
  data: VerifyMobileNumberInput;
}>;


export type VerifyUserMobileNumberMutation = { __typename: 'Mutation', verifyUserMobileNumber?: { __typename: 'VerifyMobileNumberResult', status: string, mobileNumberVerified: boolean } | null };

export type BadgesQueryVariables = Exact<{ [key: string]: never; }>;


export type BadgesQuery = { __typename: 'Query', badges: Array<{ __typename: 'Badge', badge_name: string, market_name: string, market_rank?: number | null, global_rank?: number | null, listing?: { __typename: 'PoolPublic', id: string, title: string, city?: string | null, state?: string | null, zip_code?: string | null, description?: string | null, min_hourly_price?: number | null, cover_photo?: { __typename: 'PoolImage', url: string } | null } | null }> };

export type CanRedeemPromocodeQueryVariables = Exact<{
  input: GetPromocodeInput;
}>;


export type CanRedeemPromocodeQuery = { __typename: 'Query', canRedeemPromocode:
    | { __typename: 'CanRedeemPromocodeResponse', canRedeem: boolean, reason?: string | null, promoCode?: { __typename: 'Promocode', id: string, discountType: string, discountPercent: number, discountValue: number, name: string } | null }
    | { __typename: 'PromocodeNotFoundError', message: string }
   };

export type FavCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FavCollectionsQuery = { __typename: 'Query', favCollections: Array<{ __typename: 'FavCollection', id: number, name: string, listingCount: number, coverImageUrl?: string | null, inviteUrl?: string | null, shareUrl: string, isOwner: boolean, ownerName?: string | null, ownerId?: number | null, ownerImageUrl?: string | null, listingIds: Array<number | null>, collaboratorUsers?: Array<{ __typename: 'FavCollectionCollaborators', id: number, firstname?: string | null, lastname?: string | null, email?: string | null, imgUrl?: string | null } | null> | null } | null> };

export type GetReferralInviterV2QueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetReferralInviterV2Query = { __typename: 'Query', getReferralInviterV2?: { __typename: 'ReferralClaimInviter', id: string, firstname?: string | null, img_url?: string | null, first_active_listing_id?: string | null, first_active_listing_stealth_mode?: boolean | null, roles: Array<{ __typename: 'ReferralClaimInviterRole', name: string }> } | null };

export type PoolCheckoutCardQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  listingId: Scalars['ID']['input'];
}>;


export type PoolCheckoutCardQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, title: string, description?: string | null, rating?: number | null, reviewsCount: number, custom_listing_type?: string | null, images: Array<{ __typename: 'PoolImage', id?: string | null, url: string, cover: boolean }>, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null } | null, listingDetails:
    | { __typename: 'GetListingDetailsResponse', listing:
        | { __typename: 'BasketballCourtListing' }
        | { __typename: 'HomeListing' }
        | { __typename: 'Listing' }
        | { __typename: 'PickleballCourtListing' }
        | { __typename: 'PoolListing', poolType?: string | null }
        | { __typename: 'TennisCourtListing' }
       }
    | { __typename: 'ListingNotFoundError' }
   };

export type GetSwimplyContactOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSwimplyContactOptionsQuery = { __typename: 'Query', swimplyContactOptions: { __typename: 'SwimplyContactOptionsResult', open_chat_directly: boolean, options: Array<{ __typename: 'SwimplyContactOption', type: SwimplyContactOptionType, icon: string, url?: string | null, title: { __typename: 'SwimplyContactOptionStyledText', text: string, color?: string | null }, subtitle?: { __typename: 'SwimplyContactOptionStyledText', text: string, color?: string | null } | null }> } };

export type BookingReviewFragment = { __typename: 'Booking', id: string, start_datetime_utc: any, end_datetime_utc: any, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, poolPrivate: { __typename: 'PoolPrivate', id: string, country_code?: string | null, city?: string | null, state?: string | null, zip_code?: string | null, status: number, status_name: string, time_zone?: string | null, default_instant_booking: boolean, reviewsCount: number, is_quality: boolean, title: string, rating?: number | null, latitude_round?: number | null, max_guests?: number | null, stealth_mode: boolean, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, user?: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, created_at: any } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean, id?: string | null }>, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null }, userPublic: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, rating?: number | null } };

export type LatestBookingPendingReviewQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestBookingPendingReviewQuery = { __typename: 'Query', latestBookingPendingReview?: { __typename: 'Booking', id: string, start_datetime_utc: any, end_datetime_utc: any, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, poolPrivate: { __typename: 'PoolPrivate', id: string, country_code?: string | null, city?: string | null, state?: string | null, zip_code?: string | null, status: number, status_name: string, time_zone?: string | null, default_instant_booking: boolean, reviewsCount: number, is_quality: boolean, title: string, rating?: number | null, latitude_round?: number | null, max_guests?: number | null, stealth_mode: boolean, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, user?: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, created_at: any } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean, id?: string | null }>, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null }, userPublic: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, rating?: number | null } } | null };

export type BookingReviewQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type BookingReviewQuery = { __typename: 'Query', reservationDetails?: { __typename: 'Booking', id: string, start_datetime_utc: any, end_datetime_utc: any, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, poolPrivate: { __typename: 'PoolPrivate', id: string, country_code?: string | null, city?: string | null, state?: string | null, zip_code?: string | null, status: number, status_name: string, time_zone?: string | null, default_instant_booking: boolean, reviewsCount: number, is_quality: boolean, title: string, rating?: number | null, latitude_round?: number | null, max_guests?: number | null, stealth_mode: boolean, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, user?: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, created_at: any } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean, id?: string | null }>, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null }, userPublic: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, rating?: number | null } } | null };

export type ServerListingReviewsQueryVariables = Exact<{
  listingId: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  apply_ordering?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ServerListingReviewsQuery = { __typename: 'Query', listingReviews: { __typename: 'ReviewPaginator', reviews: Array<{ __typename: 'Review', id: string, booking_id?: string | null, rating: number, comment: string, createdAt?: any | null, isRepeatedGuest: boolean, isBetaGuest: boolean, hostRespondedAt?: any | null, hostResponse?: string | null, commenter: { __typename: 'UserPublic', id: string, photoUrl?: string | null, firstName?: string | null, formattedName?: string | null, isProHost: boolean }, bookingReasonChoice?: { __typename: 'BookingReasonChoice', label: string, id: string, icon: string } | null }>, paginatorInfo: { __typename: 'PaginatorInfo', currentPage: number, total: number, hasMorePages: boolean, totalPages: number } } };

export type ListingReviewsQueryVariables = Exact<{
  listingId: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  apply_ordering?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListingReviewsQuery = { __typename: 'Query', listingReviews: { __typename: 'ReviewPaginator', reviews: Array<{ __typename: 'Review', id: string, booking_id?: string | null, rating: number, comment: string, createdAt?: any | null, isRepeatedGuest: boolean, isBetaGuest: boolean, hostRespondedAt?: any | null, hostResponse?: string | null, commenter: { __typename: 'UserPublic', id: string, photoUrl?: string | null, firstName?: string | null, formattedName?: string | null, isProHost: boolean }, bookingReasonChoice?: { __typename: 'BookingReasonChoice', label: string, id: string, icon: string } | null }>, paginatorInfo: { __typename: 'PaginatorInfo', currentPage: number, total: number, hasMorePages: boolean, totalPages: number } } };

export type ListingQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ListingQuery = { __typename: 'Query', listing: { __typename: 'MyPool', id: string, title: string, description?: string | null, custom_listing_type?: string | null, city?: string | null, state?: string | null, time_zone?: string | null, country_code?: string | null, discount_first_bookings?: boolean | null, is_security_cameras?: boolean | null, additional_rules?: string | null, host_interaction_setting?: HostInteractionSettings | null, pets_rule?: PetsRules | null, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, guests_pets_allowed?: boolean | null, default_instant_booking: boolean, instant_group_size?: number | null, special_access_instruction?: string | null, availability_window?: number | null, advance_notice?: number | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, pause_start?: any | null, pause_end?: any | null, min_buffer_time?: number | null, available_days: Array<string | null>, are_post_onboarding_steps_completed: boolean, is_third_party_address_opted_in: boolean, is_covered_by_insurance: boolean, can_update_insurance: boolean, cancellation_policy_id?: number | null, status: number, status_name: string, reviewsCount: number, rating?: number | null, is_quality: boolean, is_in_rehab: boolean, tour_360_url?: string | null, guest_leads: number, one_time_guests: number, repeat_guests: number, abandoned_carts: number, total_fans?: number | null, has_instagram_connection: boolean, instagram_username?: string | null, can_upload_video: boolean, stealth_mode: boolean, securityDepositMinGuests?: number | null, securityDepositMinor?: number | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, rule_settings: Array<{ __typename: 'RuleSetting', id: number, slug: string, name: string, icon: RuleIcon, active: boolean, description?: string | null, is_allowed?: boolean | null } | null>, access_photos: Array<{ __typename: 'PoolAccessPhoto', id: number, image_url: string } | null>, cancellation_policy?: { __typename: 'CancellationPolicy', id: string, title: string, color: string, description: string, hours: string, discount: string } | null, images: Array<{ __typename: 'PoolImage', id?: string | null, pool_id: number, url: string, cover: boolean, index?: number | null }>, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, pool_id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, enable?: boolean | null, square_footage?: number | null, amenity?: { __typename: 'Amenity', id: string, name: string, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, featured_promo_code?: { __typename: 'FeaturedPromoCode', id: number, promo_code: string, percent_off: number, max_redemptions: number, redeem_by: any, times_redeemed: number, feature_text?: string | null, can_redeem: boolean } | null } };

export type LookupEmailQueryVariables = Exact<{
  data: LookupEmailInput;
}>;


export type LookupEmailQuery = { __typename: 'Query', lookupEmail?: { __typename: 'LookupEmailResult', status: string, id?: number | null, email?: string | null, firstName?: string | null, photoUrl?: string | null, phoneNumberVerifiedAt?: string | null, phoneNumber?: string | null } | null };

export type LookupMobileNumberQueryVariables = Exact<{
  data: LookupMobileNumberInput;
}>;


export type LookupMobileNumberQuery = { __typename: 'Query', lookupMobileNumber?: { __typename: 'LookupMobileNumberResult', status: string, userId?: number | null } | null };

export type MyPoolsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPoolsQuery = { __typename: 'Query', myPoolsQuery: Array<{ __typename: 'MyPool', id: string, title: string, description?: string | null, custom_listing_type?: string | null, city?: string | null, state?: string | null, time_zone?: string | null, country_code?: string | null, discount_first_bookings?: boolean | null, is_security_cameras?: boolean | null, additional_rules?: string | null, host_interaction_setting?: HostInteractionSettings | null, pets_rule?: PetsRules | null, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, guests_pets_allowed?: boolean | null, default_instant_booking: boolean, instant_group_size?: number | null, special_access_instruction?: string | null, availability_window?: number | null, advance_notice?: number | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, pause_start?: any | null, pause_end?: any | null, min_buffer_time?: number | null, available_days: Array<string | null>, are_post_onboarding_steps_completed: boolean, is_third_party_address_opted_in: boolean, is_covered_by_insurance: boolean, can_update_insurance: boolean, cancellation_policy_id?: number | null, status: number, status_name: string, reviewsCount: number, rating?: number | null, is_quality: boolean, is_in_rehab: boolean, tour_360_url?: string | null, guest_leads: number, one_time_guests: number, repeat_guests: number, abandoned_carts: number, total_fans?: number | null, has_instagram_connection: boolean, instagram_username?: string | null, can_upload_video: boolean, stealth_mode: boolean, securityDepositMinGuests?: number | null, securityDepositMinor?: number | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, rule_settings: Array<{ __typename: 'RuleSetting', id: number, slug: string, name: string, icon: RuleIcon, active: boolean, description?: string | null, is_allowed?: boolean | null } | null>, access_photos: Array<{ __typename: 'PoolAccessPhoto', id: number, image_url: string } | null>, cancellation_policy?: { __typename: 'CancellationPolicy', id: string, title: string, color: string, description: string, hours: string, discount: string } | null, images: Array<{ __typename: 'PoolImage', id?: string | null, pool_id: number, url: string, cover: boolean, index?: number | null }>, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, pool_id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, enable?: boolean | null, square_footage?: number | null, amenity?: { __typename: 'Amenity', id: string, name: string, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, featured_promo_code?: { __typename: 'FeaturedPromoCode', id: number, promo_code: string, percent_off: number, max_redemptions: number, redeem_by: any, times_redeemed: number, feature_text?: string | null, can_redeem: boolean } | null }> };

export type PaymentMethodFragment = { __typename: 'PaymentSource', id: number, brand?: string | null, last4?: string | null, type?: string | null, postal_code?: string | null, isDefault: boolean, expirationDate?: any | null };

export type PaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsQuery = { __typename: 'Query', paymentSources: { __typename: 'PaymentSourcesResult', paymentSources: Array<{ __typename: 'PaymentSource', id: number, brand?: string | null, last4?: string | null, type?: string | null, postal_code?: string | null, isDefault: boolean, expirationDate?: any | null }> } };

export type MeFragment = { __typename: 'Me', id: string, firstname?: string | null, lastname?: string | null, zipcode?: string | null, email?: string | null, description?: string | null, phone_number?: string | null, mobile_number?: string | null, mobile_number_verified_at?: any | null, country_phone_code?: string | null, date_birthday?: string | null, referral_token: string, country?: string | null, img_url?: string | null, isAnyPool: boolean, unread_message: boolean, stripe_id?: string | null, country_code?: string | null, country_code_swimmer?: string | null, accept_chat_rules: boolean, credit_balance?: number | null, stripe_account_onboard?: boolean | null, stripe_identity_verified: boolean, blocked_user_ids: Array<number>, blocked_by_user_ids: Array<number>, facebook_id?: string | null, most_recent_booking_id?: string | null, listing_ids: Array<string>, used_app_recently: boolean, heard_about_us?: HeardAboutUsChannel | null, is_under_age: boolean, incomplete_post_onboarding_step_listing_ids: Array<string>, has_pending_bookings: boolean, premium_state: PremiumState, premium_type: UserPremiumType, opt_in_date?: any | null, opt_in_id?: number | null, is_pro_host: boolean, has_opt_in_banner: boolean, roles: Array<{ __typename: 'Role', name: string }>, verificationsPrivate?: Array<{ __typename: 'UserVerificationPrivate', successful_booking?: boolean | null, passport_drive_url?: boolean | null, pool_proof_url?: boolean | null, img_id_approved?: boolean | null, img_proof_approved?: boolean | null } | null> | null };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename: 'Query', meQuery: { __typename: 'Me', id: string, firstname?: string | null, lastname?: string | null, zipcode?: string | null, email?: string | null, description?: string | null, phone_number?: string | null, mobile_number?: string | null, mobile_number_verified_at?: any | null, country_phone_code?: string | null, date_birthday?: string | null, referral_token: string, country?: string | null, img_url?: string | null, isAnyPool: boolean, unread_message: boolean, stripe_id?: string | null, country_code?: string | null, country_code_swimmer?: string | null, accept_chat_rules: boolean, credit_balance?: number | null, stripe_account_onboard?: boolean | null, stripe_identity_verified: boolean, blocked_user_ids: Array<number>, blocked_by_user_ids: Array<number>, facebook_id?: string | null, most_recent_booking_id?: string | null, listing_ids: Array<string>, used_app_recently: boolean, heard_about_us?: HeardAboutUsChannel | null, is_under_age: boolean, incomplete_post_onboarding_step_listing_ids: Array<string>, has_pending_bookings: boolean, premium_state: PremiumState, premium_type: UserPremiumType, opt_in_date?: any | null, opt_in_id?: number | null, is_pro_host: boolean, has_opt_in_banner: boolean, roles: Array<{ __typename: 'Role', name: string }>, verificationsPrivate?: Array<{ __typename: 'UserVerificationPrivate', successful_booking?: boolean | null, passport_drive_url?: boolean | null, pool_proof_url?: boolean | null, img_id_approved?: boolean | null, img_proof_approved?: boolean | null } | null> | null } };

export type PublicListingDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  bookingStartTime?: InputMaybe<Scalars['DateTimeUtc']['input']>;
}>;


export type PublicListingDetailsQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, title: string, description?: string | null, city?: string | null, state?: string | null, country_code?: string | null, zip_code?: string | null, hourly_price?: number | null, rating?: number | null, additional_rules?: string | null, is_security_cameras?: boolean | null, host_interaction_setting?: HostInteractionSettings | null, pets_rule?: PetsRules | null, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, guests_pets_allowed?: boolean | null, cancellation_policy_id?: number | null, latitude_round?: number | null, longitude_round?: number | null, status: number, status_name: string, time_zone?: string | null, default_instant_booking: boolean, instant_group_size?: number | null, availability_window?: number | null, advance_notice?: number | null, available_from?: string | null, available_to?: string | null, reviewsCount: number, custom_listing_type?: string | null, min_booking_length?: number | null, discount_first_bookings?: boolean | null, pause_start?: any | null, pause_end?: any | null, is_quality: boolean, tour_360_url?: string | null, stealth_mode: boolean, space_types: Array<string>, securityDepositMinGuests?: number | null, securityDepositMinor?: number | null, cancellation_policy?: { __typename: 'CancellationPolicy', id: string, title: string, color: string, description: string, hours: string, discount: string } | null, images: Array<{ __typename: 'PoolImage', id?: string | null, url: string, cover: boolean }>, rules?: Array<{ __typename: 'Rule', id: string, name: string, active: boolean } | null> | null, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, pool_id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, enable?: boolean | null, square_footage?: number | null, amenity?: { __typename: 'Amenity', id: string, name: string, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, featured_promo_code?: { __typename: 'FeaturedPromoCode', id: number, promo_code: string, percent_off: number, max_redemptions: number, redeem_by: any, times_redeemed: number, feature_text?: string | null, can_redeem: boolean } | null, user?: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, created_at: any } | null, response_time: { __typename: 'PoolResponseTime', response_time_text?: string | null }, instagram_images: Array<{ __typename: 'InstagramImage', id: string, url: string } | null> } | null };

export type ReferralBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferralBalanceQuery = { __typename: 'Query', meQuery: { __typename: 'Me', id: string, credit_balance?: number | null } };

export type ReferralsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferralsQuery = { __typename: 'Query', getReferrals: Array<{ __typename: 'ReferralResult', booked_at?: any | null, current_milestone_value: number, referralUser: { __typename: 'ReferralResultUser', firstname?: string | null, lastname?: string | null, email?: string | null, img_url?: string | null, created_at: any }, transaction?: { __typename: 'ReferralTransaction', payout_amount: number } | null, milestone?: { __typename: 'Milestone', title: string, host_or_guest_milestone: ReferralInviteTypes, amount: number } | null }> };

export type ServiceFragment = { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null };

export type ReservationAmenityFragment = { __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null };

export type ReservationListingFragment = { __typename: 'PoolPrivate', additional_rules?: string | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, max_guests?: number | null, id: string, status: number, title: string, description?: string | null, street_number?: string | null, state?: string | null, city?: string | null, special_access_instruction?: string | null, zip_code?: string | null, country_code?: string | null, time_zone?: string | null, is_security_cameras?: boolean | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, default_instant_booking: boolean, instant_group_size?: number | null, rating?: number | null, status_name: string, reviewsCount: number, is_quality: boolean, stealth_mode: boolean, rule_settings: Array<{ __typename: 'RuleSetting', id: number, slug: string, name: string, icon: RuleIcon, active: boolean, description?: string | null, is_allowed?: boolean | null } | null>, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, access_photos: Array<{ __typename: 'PoolAccessPhoto', image_url: string } | null>, user?: { __typename: 'UserPublic', formatted_name?: string | null, firstname?: string | null, id: string, img_url?: string | null, created_at: any, description?: string | null, is_verified: boolean, is_pro_host: boolean } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean, id?: string | null }>, cancellation_policy?: { __typename: 'CancellationPolicy', id: string, hours: string, discount: string, title: string, color: string, description: string } | null, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null };

export type EditedFieldsFragment = { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> };

export type UseReservationMemoReservationFragment = { __typename: 'Booking', id: string, status: number, end_datetime_utc: any, start_datetime_utc: any, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, premium_id?: number | null, guest_pass_id?: number | null, upsold_pass_id?: number | null, guestPassName?: string | null, reservation_price_total: number, swimmer_review?: boolean | null, host_review?: boolean | null, cancelled_by?: number | null, guest_last_name: string, discount_offered_by_host?: number | null, guestPass?: { __typename: 'BookingGuestPass', id: string, passHoursPerMonth?: number | null, end: any, price?: number | null, hoursLeft: number, maxGuestCount?: number | null, priceNoFess?: number | null } | null, poolPrivate: { __typename: 'PoolPrivate', title: string, time_zone?: string | null, country_code?: string | null, default_instant_booking: boolean, instant_group_size?: number | null, max_guests?: number | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, user?: { __typename: 'UserPublic', formatted_name?: string | null, firstname?: string | null, id: string, img_url?: string | null, created_at: any, description?: string | null, is_verified: boolean, is_pro_host: boolean } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, cancellation_policy?: { __typename: 'CancellationPolicy', hours: string } | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null }, userPublic: { __typename: 'UserPublic', id: string, img_url?: string | null, rating?: number | null, formatted_name?: string | null, firstname?: string | null, created_at: any, description?: string | null, is_verified: boolean, reviewsCount: number }, last_change_request?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, edited_fields?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string } | null, booking_update_request?: { __typename: 'BookingUpdatedRequest', id?: number | null, discount_offered_by_host?: number | null, requester: { __typename: 'UserPublic', id: string } } | null, current_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, booking_host_cancellation?: { __typename: 'BookingHostCancellation', guest_compensation?: GuestCompensation | null } | null };

export type ListReservationFragment = { __typename: 'Booking', created_at: any, survey_response?: any | null, checked_in_at?: any | null, id: string, status: number, end_datetime_utc: any, start_datetime_utc: any, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, premium_id?: number | null, guest_pass_id?: number | null, upsold_pass_id?: number | null, guestPassName?: string | null, reservation_price_total: number, swimmer_review?: boolean | null, host_review?: boolean | null, cancelled_by?: number | null, guest_last_name: string, discount_offered_by_host?: number | null, poolPrivate: { __typename: 'PoolPrivate', stealth_mode: boolean, id: string, city?: string | null, state?: string | null, title: string, time_zone?: string | null, country_code?: string | null, default_instant_booking: boolean, instant_group_size?: number | null, max_guests?: number | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, images: Array<{ __typename: 'PoolImage', cover: boolean, url: string }>, user?: { __typename: 'UserPublic', formatted_name?: string | null, firstname?: string | null, id: string, img_url?: string | null, created_at: any, description?: string | null, is_verified: boolean, is_pro_host: boolean } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, cancellation_policy?: { __typename: 'CancellationPolicy', hours: string } | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null }, bookingReasonChoice?: { __typename: 'BookingReasonChoice', label: string } | null, booking_update_request?: { __typename: 'BookingUpdatedRequest', reschedule_reason_message?: string | null, id?: number | null, discount_offered_by_host?: number | null, requester: { __typename: 'UserPublic', id: string } } | null, paymentBreakdown: Array<{ __typename: 'PaymentBreakdownDisplayItem', displayLine: string, icon: string, paymentMethod: PaymentMethod, amount: number }>, monitor?: { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null } | null, lifeguard?: { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null } | null, guestPass?: { __typename: 'BookingGuestPass', id: string, passHoursPerMonth?: number | null, end: any, price?: number | null, hoursLeft: number, maxGuestCount?: number | null, priceNoFess?: number | null } | null, userPublic: { __typename: 'UserPublic', id: string, img_url?: string | null, rating?: number | null, formatted_name?: string | null, firstname?: string | null, created_at: any, description?: string | null, is_verified: boolean, reviewsCount: number }, last_change_request?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, edited_fields?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string } | null, current_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, booking_host_cancellation?: { __typename: 'BookingHostCancellation', guest_compensation?: GuestCompensation | null } | null };

export type ReservationFragment = { __typename: 'Booking', host_will_earn?: number | null, reservation_price: number, reservation_price_total: number, id: string, status: number, latitude: number, longitude: number, swimmer_review?: boolean | null, host_review?: boolean | null, available_address?: string | null, confirmed_at?: string | null, created_at: any, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, promocode_status?: string | null, checked_in_at?: any | null, start_datetime_utc: any, end_datetime_utc: any, expended_award_amount?: number | null, cancel_reason?: string | null, cancel_reason_message?: string | null, cancel_chat_message?: string | null, cancelled_by?: number | null, cancelled_at?: string | null, cancelled_at_utc?: any | null, discount_offered_by_host?: number | null, discount_first_bookings_used?: boolean | null, booking_invite_url: string, premium_id?: number | null, guest_pass_id?: number | null, upsold_pass_id?: number | null, guestPassName?: string | null, guest_last_name: string, is_in_refund_window: boolean, status_name: BookingStatusEnum, survey_response?: any | null, bookingInvitesExperiment: BookingInvitesExperiment, bookingInvitesExpCapAmount: number, bookingInvitesExpPerGuestAmount: number, hasExperiences?: boolean | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string } | null, bookingReasonChoice?: { __typename: 'BookingReasonChoice', label: string } | null, current_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, poolPrivate: { __typename: 'PoolPrivate', additional_rules?: string | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, max_guests?: number | null, id: string, status: number, title: string, description?: string | null, street_number?: string | null, state?: string | null, city?: string | null, special_access_instruction?: string | null, zip_code?: string | null, country_code?: string | null, time_zone?: string | null, is_security_cameras?: boolean | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, default_instant_booking: boolean, instant_group_size?: number | null, rating?: number | null, status_name: string, reviewsCount: number, is_quality: boolean, stealth_mode: boolean, rule_settings: Array<{ __typename: 'RuleSetting', id: number, slug: string, name: string, icon: RuleIcon, active: boolean, description?: string | null, is_allowed?: boolean | null } | null>, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, access_photos: Array<{ __typename: 'PoolAccessPhoto', image_url: string } | null>, user?: { __typename: 'UserPublic', formatted_name?: string | null, firstname?: string | null, id: string, img_url?: string | null, created_at: any, description?: string | null, is_verified: boolean, is_pro_host: boolean } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean, id?: string | null }>, cancellation_policy?: { __typename: 'CancellationPolicy', id: string, hours: string, discount: string, title: string, color: string, description: string } | null, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null }, userPublic: { __typename: 'UserPublic', id: string, img_url?: string | null, rating?: number | null, formatted_name?: string | null, firstname?: string | null, created_at: any, description?: string | null, is_verified: boolean, reviewsCount: number }, edited_fields?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, last_change_request?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, booking_update_request?: { __typename: 'BookingUpdatedRequest', id?: number | null, reschedule_reason_message?: string | null, discount_offered_by_host?: number | null, requester: { __typename: 'UserPublic', id: string } } | null, booking_invites?: Array<{ __typename: 'BookingInvite', id?: number | null, attendee: { __typename: 'AttendeeUser', email?: string | null, id: string, firstName?: string | null, imgUrl?: string | null } } | null> | null, booking_host_cancellation?: { __typename: 'BookingHostCancellation', id?: number | null, note?: string | null, created_at?: any | null, guest_compensation?: GuestCompensation | null } | null, guestPass?: { __typename: 'BookingGuestPass', id: string, passHoursPerMonth?: number | null, end: any, price?: number | null, hoursLeft: number, maxGuestCount?: number | null, priceNoFess?: number | null } | null, cancelRefund?: { __typename: 'CancelRefund', canceledAt: any, cashRefundAmount: number, creditsRefundAmount: number, cardRefundAmount: number, klarnaFees: number, klarnaRefundAmount: number, depositRefundAmount: number } | null, paymentBreakdown: Array<{ __typename: 'PaymentBreakdownDisplayItem', displayLine: string, icon: string, paymentMethod: PaymentMethod, amount: number }>, securityDeposit?: { __typename: 'SecurityDeposit', id: string, status?: SecurityDepositEnum | null, currency: string, amountMinor: number, claimAmountMinor?: number | null, refundedAmountMinor?: number | null } | null, monitor?: { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null } | null, lifeguard?: { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null } | null };

export type ReservationDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  bookingId: Scalars['ID']['input'];
}>;


export type ReservationDetailsQuery = { __typename: 'Query', reservationDetails?: { __typename: 'Booking', host_will_earn?: number | null, reservation_price: number, reservation_price_total: number, id: string, status: number, latitude: number, longitude: number, swimmer_review?: boolean | null, host_review?: boolean | null, available_address?: string | null, confirmed_at?: string | null, created_at: any, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, promocode_status?: string | null, checked_in_at?: any | null, start_datetime_utc: any, end_datetime_utc: any, expended_award_amount?: number | null, cancel_reason?: string | null, cancel_reason_message?: string | null, cancel_chat_message?: string | null, cancelled_by?: number | null, cancelled_at?: string | null, cancelled_at_utc?: any | null, discount_offered_by_host?: number | null, discount_first_bookings_used?: boolean | null, booking_invite_url: string, premium_id?: number | null, guest_pass_id?: number | null, upsold_pass_id?: number | null, guestPassName?: string | null, guest_last_name: string, is_in_refund_window: boolean, status_name: BookingStatusEnum, survey_response?: any | null, bookingInvitesExperiment: BookingInvitesExperiment, bookingInvitesExpCapAmount: number, bookingInvitesExpPerGuestAmount: number, hasExperiences?: boolean | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string } | null, bookingReasonChoice?: { __typename: 'BookingReasonChoice', label: string } | null, current_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, poolPrivate: { __typename: 'PoolPrivate', additional_rules?: string | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, max_guests?: number | null, id: string, status: number, title: string, description?: string | null, street_number?: string | null, state?: string | null, city?: string | null, special_access_instruction?: string | null, zip_code?: string | null, country_code?: string | null, time_zone?: string | null, is_security_cameras?: boolean | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, default_instant_booking: boolean, instant_group_size?: number | null, rating?: number | null, status_name: string, reviewsCount: number, is_quality: boolean, stealth_mode: boolean, rule_settings: Array<{ __typename: 'RuleSetting', id: number, slug: string, name: string, icon: RuleIcon, active: boolean, description?: string | null, is_allowed?: boolean | null } | null>, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, access_photos: Array<{ __typename: 'PoolAccessPhoto', image_url: string } | null>, user?: { __typename: 'UserPublic', formatted_name?: string | null, firstname?: string | null, id: string, img_url?: string | null, created_at: any, description?: string | null, is_verified: boolean, is_pro_host: boolean } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean, id?: string | null }>, cancellation_policy?: { __typename: 'CancellationPolicy', id: string, hours: string, discount: string, title: string, color: string, description: string } | null, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null }, userPublic: { __typename: 'UserPublic', id: string, img_url?: string | null, rating?: number | null, formatted_name?: string | null, firstname?: string | null, created_at: any, description?: string | null, is_verified: boolean, reviewsCount: number }, edited_fields?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, last_change_request?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, booking_update_request?: { __typename: 'BookingUpdatedRequest', id?: number | null, reschedule_reason_message?: string | null, discount_offered_by_host?: number | null, requester: { __typename: 'UserPublic', id: string } } | null, booking_invites?: Array<{ __typename: 'BookingInvite', id?: number | null, attendee: { __typename: 'AttendeeUser', email?: string | null, id: string, firstName?: string | null, imgUrl?: string | null } } | null> | null, booking_host_cancellation?: { __typename: 'BookingHostCancellation', id?: number | null, note?: string | null, created_at?: any | null, guest_compensation?: GuestCompensation | null } | null, guestPass?: { __typename: 'BookingGuestPass', id: string, passHoursPerMonth?: number | null, end: any, price?: number | null, hoursLeft: number, maxGuestCount?: number | null, priceNoFess?: number | null } | null, cancelRefund?: { __typename: 'CancelRefund', canceledAt: any, cashRefundAmount: number, creditsRefundAmount: number, cardRefundAmount: number, klarnaFees: number, klarnaRefundAmount: number, depositRefundAmount: number } | null, paymentBreakdown: Array<{ __typename: 'PaymentBreakdownDisplayItem', displayLine: string, icon: string, paymentMethod: PaymentMethod, amount: number }>, securityDeposit?: { __typename: 'SecurityDeposit', id: string, status?: SecurityDepositEnum | null, currency: string, amountMinor: number, claimAmountMinor?: number | null, refundedAmountMinor?: number | null } | null, monitor?: { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null } | null, lifeguard?: { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null } | null } | null, listingDetailsByBooking:
    | { __typename: 'BookingNotFoundError' }
    | { __typename: 'GetListingDetailsResponse', listing:
        | { __typename: 'BasketballCourtListing', restroomAccessType?: RestroomAccessType | null, parkingOptions?: Array<string> | null, parkingContext?: string | null, numberOfParkingSpaces?: number | null }
        | { __typename: 'HomeListing', restroomAccessType?: RestroomAccessType | null, parkingOptions?: Array<string> | null, parkingContext?: string | null, numberOfParkingSpaces?: number | null }
        | { __typename: 'Listing', restroomAccessType?: RestroomAccessType | null, parkingOptions?: Array<string> | null, parkingContext?: string | null, numberOfParkingSpaces?: number | null }
        | { __typename: 'PickleballCourtListing', restroomAccessType?: RestroomAccessType | null, parkingOptions?: Array<string> | null, parkingContext?: string | null, numberOfParkingSpaces?: number | null }
        | { __typename: 'PoolListing', waterSystem?: string | null, restroomAccessType?: RestroomAccessType | null, parkingOptions?: Array<string> | null, parkingContext?: string | null, numberOfParkingSpaces?: number | null }
        | { __typename: 'TennisCourtListing', restroomAccessType?: RestroomAccessType | null, parkingOptions?: Array<string> | null, parkingContext?: string | null, numberOfParkingSpaces?: number | null }
       }
    | { __typename: 'ListingNotFoundError' }
   };

export type StripeExpressDashboardQueryVariables = Exact<{
  data?: InputMaybe<StripeDashboardInput>;
}>;


export type StripeExpressDashboardQuery = { __typename: 'Query', getStripeExpressLink?: { __typename: 'StripeDashboard', object?: string | null, created?: number | null, url?: string | null } | null };

export type UserExperimentsQueryVariables = Exact<{
  input?: InputMaybe<GetUserExperimentsInput>;
}>;


export type UserExperimentsQuery = { __typename: 'Query', getUserExperiments: Array<{ __typename: 'UserExperiment', experiment: { __typename: 'Experiment', name: string }, group: { __typename: 'ExperimentGroup', name: string } }> };

export type FeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagsQuery = { __typename: 'Query', featureFlagsForUser: Array<{ __typename: 'FeatureFlag', id: string, default_value: boolean, value?: boolean | null, description?: string | null, name: string }> };

export type GeocodeQueryVariables = Exact<{
  input: GeoCodeInput;
}>;


export type GeocodeQuery = { __typename: 'Query', geocode?: { __typename: 'Address', isCached: boolean, city?: string | null, state?: string | null, country?: string | null, stateCode?: string | null, postalCode?: string | null, countryCode?: string | null, formattedAddress?: string | null, coordinates?: { __typename: 'Coordinates', lat?: number | null, lng?: number | null } | null } | null };

export type MilestoneFragment = { __typename: 'ReferralMilestone', id: string, title: string, action: ReferalMilestoneActionsTypes, amount: number, who_gets_paid: ReferalMilestoneWhoGetsPaidTypes, payout_amount: number, payout_type: ReferalMilestonePayoutTypes, is_active: boolean, apply_to: ReferalMilestoneApplyToTypes, apply_to_referrer: ReferalMilestoneApplyToTypes };

export type GetReferralMilestonesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReferralMilestonesQuery = { __typename: 'Query', referral_milestones: Array<{ __typename: 'ReferralMilestone', id: string, title: string, action: ReferalMilestoneActionsTypes, amount: number, who_gets_paid: ReferalMilestoneWhoGetsPaidTypes, payout_amount: number, payout_type: ReferalMilestonePayoutTypes, is_active: boolean, apply_to: ReferalMilestoneApplyToTypes, apply_to_referrer: ReferalMilestoneApplyToTypes }> };

export type ReferralMilestonesByReferralTokenQueryVariables = Exact<{
  data: ReferralMilestonesByReferralTokenInput;
}>;


export type ReferralMilestonesByReferralTokenQuery = { __typename: 'Query', referralMilestonesByReferralToken: Array<{ __typename: 'ReferralMilestone', id: string, title: string, action: ReferalMilestoneActionsTypes, amount: number, who_gets_paid: ReferalMilestoneWhoGetsPaidTypes, payout_amount: number, payout_type: ReferalMilestonePayoutTypes, is_active: boolean, apply_to: ReferalMilestoneApplyToTypes, apply_to_referrer: ReferalMilestoneApplyToTypes }> };

export type BookingAmenitiesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  bookingStartTime?: InputMaybe<Scalars['DateTimeUtc']['input']>;
}>;


export type BookingAmenitiesQuery = { __typename: 'Query', reservationDetails?: { __typename: 'Booking', poolPrivate: { __typename: 'PoolPrivate', enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null }, current_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null } | null };

export type BookingUserRoleFragment = { __typename: 'Booking', id: string, poolPrivate: { __typename: 'PoolPrivate', user?: { __typename: 'UserPublic', id: string } | null }, userPublic: { __typename: 'UserPublic', id: string } };

export type CheckLifeguardAvailabilityQueryVariables = Exact<{
  input: CheckServiceAvailabilityInput;
}>;


export type CheckLifeguardAvailabilityQuery = { __typename: 'Query', checkLifeguardAvailability: { __typename: 'CheckServiceAvailabilityResult', available?: boolean | null, service?: { __typename: 'ServiceTimeSlot', providerFirstName: string, price: number } | null } };

export type CheckMonitorAvailabilityQueryVariables = Exact<{
  input: CheckServiceAvailabilityInput;
}>;


export type CheckMonitorAvailabilityQuery = { __typename: 'Query', checkMonitorAvailability: { __typename: 'CheckServiceAvailabilityResult', available?: boolean | null, service?: { __typename: 'ServiceTimeSlot', providerFirstName: string, price: number } | null } };

export type ReservationsFragment = { __typename: 'ReservationsPaginatedResult', data?: Array<{ __typename: 'Booking', show_contact_option: boolean, created_at: any, survey_response?: any | null, checked_in_at?: any | null, id: string, status: number, end_datetime_utc: any, start_datetime_utc: any, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, premium_id?: number | null, guest_pass_id?: number | null, upsold_pass_id?: number | null, guestPassName?: string | null, reservation_price_total: number, swimmer_review?: boolean | null, host_review?: boolean | null, cancelled_by?: number | null, guest_last_name: string, discount_offered_by_host?: number | null, poolPrivate: { __typename: 'PoolPrivate', stealth_mode: boolean, id: string, city?: string | null, state?: string | null, title: string, time_zone?: string | null, country_code?: string | null, default_instant_booking: boolean, instant_group_size?: number | null, max_guests?: number | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, images: Array<{ __typename: 'PoolImage', cover: boolean, url: string }>, user?: { __typename: 'UserPublic', formatted_name?: string | null, firstname?: string | null, id: string, img_url?: string | null, created_at: any, description?: string | null, is_verified: boolean, is_pro_host: boolean } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, cancellation_policy?: { __typename: 'CancellationPolicy', hours: string } | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null }, bookingReasonChoice?: { __typename: 'BookingReasonChoice', label: string } | null, booking_update_request?: { __typename: 'BookingUpdatedRequest', reschedule_reason_message?: string | null, id?: number | null, discount_offered_by_host?: number | null, requester: { __typename: 'UserPublic', id: string } } | null, paymentBreakdown: Array<{ __typename: 'PaymentBreakdownDisplayItem', displayLine: string, icon: string, paymentMethod: PaymentMethod, amount: number }>, monitor?: { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null } | null, lifeguard?: { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null } | null, guestPass?: { __typename: 'BookingGuestPass', id: string, passHoursPerMonth?: number | null, end: any, price?: number | null, hoursLeft: number, maxGuestCount?: number | null, priceNoFess?: number | null } | null, userPublic: { __typename: 'UserPublic', id: string, img_url?: string | null, rating?: number | null, formatted_name?: string | null, firstname?: string | null, created_at: any, description?: string | null, is_verified: boolean, reviewsCount: number }, last_change_request?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, edited_fields?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string } | null, current_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, booking_host_cancellation?: { __typename: 'BookingHostCancellation', guest_compensation?: GuestCompensation | null } | null } | null> | null, paginatorInfo?: { __typename: 'MyPaginatorInfo', count?: number | null, firstItem?: number | null, lastItem?: number | null, total?: number | null, hasMorePages?: boolean | null } | null };

export type GuestBookingsQueryVariables = Exact<{
  input: GuestBookingsInput;
}>;


export type GuestBookingsQuery = { __typename: 'Query', guestBookings: { __typename: 'ReservationsPaginatedResult', data?: Array<{ __typename: 'Booking', show_contact_option: boolean, created_at: any, survey_response?: any | null, checked_in_at?: any | null, id: string, status: number, end_datetime_utc: any, start_datetime_utc: any, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, premium_id?: number | null, guest_pass_id?: number | null, upsold_pass_id?: number | null, guestPassName?: string | null, reservation_price_total: number, swimmer_review?: boolean | null, host_review?: boolean | null, cancelled_by?: number | null, guest_last_name: string, discount_offered_by_host?: number | null, poolPrivate: { __typename: 'PoolPrivate', stealth_mode: boolean, id: string, city?: string | null, state?: string | null, title: string, time_zone?: string | null, country_code?: string | null, default_instant_booking: boolean, instant_group_size?: number | null, max_guests?: number | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, images: Array<{ __typename: 'PoolImage', cover: boolean, url: string }>, user?: { __typename: 'UserPublic', formatted_name?: string | null, firstname?: string | null, id: string, img_url?: string | null, created_at: any, description?: string | null, is_verified: boolean, is_pro_host: boolean } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, cancellation_policy?: { __typename: 'CancellationPolicy', hours: string } | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null }, bookingReasonChoice?: { __typename: 'BookingReasonChoice', label: string } | null, booking_update_request?: { __typename: 'BookingUpdatedRequest', reschedule_reason_message?: string | null, id?: number | null, discount_offered_by_host?: number | null, requester: { __typename: 'UserPublic', id: string } } | null, paymentBreakdown: Array<{ __typename: 'PaymentBreakdownDisplayItem', displayLine: string, icon: string, paymentMethod: PaymentMethod, amount: number }>, monitor?: { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null } | null, lifeguard?: { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null } | null, guestPass?: { __typename: 'BookingGuestPass', id: string, passHoursPerMonth?: number | null, end: any, price?: number | null, hoursLeft: number, maxGuestCount?: number | null, priceNoFess?: number | null } | null, userPublic: { __typename: 'UserPublic', id: string, img_url?: string | null, rating?: number | null, formatted_name?: string | null, firstname?: string | null, created_at: any, description?: string | null, is_verified: boolean, reviewsCount: number }, last_change_request?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, edited_fields?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string } | null, current_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, booking_host_cancellation?: { __typename: 'BookingHostCancellation', guest_compensation?: GuestCompensation | null } | null } | null> | null, paginatorInfo?: { __typename: 'MyPaginatorInfo', count?: number | null, firstItem?: number | null, lastItem?: number | null, total?: number | null, hasMorePages?: boolean | null } | null } };

export type HostBookingsQueryVariables = Exact<{
  input: HostBookingsInput;
}>;


export type HostBookingsQuery = { __typename: 'Query', hostBookings: { __typename: 'ReservationsPaginatedResult', data?: Array<{ __typename: 'Booking', show_contact_option: boolean, created_at: any, survey_response?: any | null, checked_in_at?: any | null, id: string, status: number, end_datetime_utc: any, start_datetime_utc: any, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, premium_id?: number | null, guest_pass_id?: number | null, upsold_pass_id?: number | null, guestPassName?: string | null, reservation_price_total: number, swimmer_review?: boolean | null, host_review?: boolean | null, cancelled_by?: number | null, guest_last_name: string, discount_offered_by_host?: number | null, poolPrivate: { __typename: 'PoolPrivate', stealth_mode: boolean, id: string, city?: string | null, state?: string | null, title: string, time_zone?: string | null, country_code?: string | null, default_instant_booking: boolean, instant_group_size?: number | null, max_guests?: number | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, images: Array<{ __typename: 'PoolImage', cover: boolean, url: string }>, user?: { __typename: 'UserPublic', formatted_name?: string | null, firstname?: string | null, id: string, img_url?: string | null, created_at: any, description?: string | null, is_verified: boolean, is_pro_host: boolean } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, cancellation_policy?: { __typename: 'CancellationPolicy', hours: string } | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null }, bookingReasonChoice?: { __typename: 'BookingReasonChoice', label: string } | null, booking_update_request?: { __typename: 'BookingUpdatedRequest', reschedule_reason_message?: string | null, id?: number | null, discount_offered_by_host?: number | null, requester: { __typename: 'UserPublic', id: string } } | null, paymentBreakdown: Array<{ __typename: 'PaymentBreakdownDisplayItem', displayLine: string, icon: string, paymentMethod: PaymentMethod, amount: number }>, monitor?: { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null } | null, lifeguard?: { __typename: 'Service', id: string, price: number, status: string, type: string, providerName?: string | null } | null, guestPass?: { __typename: 'BookingGuestPass', id: string, passHoursPerMonth?: number | null, end: any, price?: number | null, hoursLeft: number, maxGuestCount?: number | null, priceNoFess?: number | null } | null, userPublic: { __typename: 'UserPublic', id: string, img_url?: string | null, rating?: number | null, formatted_name?: string | null, firstname?: string | null, created_at: any, description?: string | null, is_verified: boolean, reviewsCount: number }, last_change_request?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, edited_fields?: { __typename: 'EditedFieldsType', start_datetime?: any | null, end_datetime?: any | null, adult_guests?: number | null, children_guests?: number | null, infant_guests?: number | null, pet_guests?: number | null, edit_status?: string | null, reservation_price_total?: number | null, reservation_price?: number | null, host_can_earn?: number | null, created_at: any, premium_amenities: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null }> } | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string } | null, current_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, booking_host_cancellation?: { __typename: 'BookingHostCancellation', guest_compensation?: GuestCompensation | null } | null } | null> | null, paginatorInfo?: { __typename: 'MyPaginatorInfo', count?: number | null, firstItem?: number | null, lastItem?: number | null, total?: number | null, hasMorePages?: boolean | null } | null } };

export type ActivePartnershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivePartnershipsQuery = { __typename: 'Query', getActivePartnerships: Array<
    | { __typename: 'MutationResult' }
    | { __typename: 'Partnership', active: boolean, bannerToInsert?: string | null, mobileBannerToInsert?: string | null, sponsoredBy?: string | null, colorTheme?: string | null, hasExplicitAvailability: boolean, hasWaitListBooking: boolean, listingHeroIcon?: string | null, listingTypeId: number, listingTypeName?: string | null, name: string, icon?: string | null, survey?: any | null, showBanners: boolean, isPriced: boolean, submitCaption?: string | null, pdpHighlightMsgTitle?: string | null, pdpHighlightMsgBody?: string | null, guestRestrictions?: string | null }
  > };

export type DailyBookingAvailabilityDetailQueryVariables = Exact<{
  input: GetDailyBookingAvailabilityInput;
}>;


export type DailyBookingAvailabilityDetailQuery = { __typename: 'Query', dailyBookingAvailabilityDetail:
    | { __typename: 'GetDailyListingAvailabilityDetailResponse', timeSlots: Array<{ __typename: 'TimeSlot', start: string, end: string }> }
    | { __typename: 'ListingNotFoundError' }
   };

export type DailyListingAvailabilitySummaryQueryVariables = Exact<{
  input: GetDailyListingAvailabilitySummaryInput;
}>;


export type DailyListingAvailabilitySummaryQuery = { __typename: 'Query', dailyListingAvailabilitySummary:
    | { __typename: 'GetDailyListingAvailabilitySummaryResponse', nextAvailableDay?: any | null, summaries: Array<{ __typename: 'TimeSlotSummary', day: any, hasTimeSlots: boolean }> }
    | { __typename: 'ListingNotFoundError' }
   };

export type DailyListingAvailabilityDetailQueryVariables = Exact<{
  input: GetDailyListingAvailabilityInput;
}>;


export type DailyListingAvailabilityDetailQuery = { __typename: 'Query', dailyListingAvailabilityDetail:
    | { __typename: 'GetDailyListingAvailabilityDetailResponse', bookingStatus: ListingBookingRequestType, timeSlots: Array<{ __typename: 'TimeSlot', start: string, end: string }> }
    | { __typename: 'ListingNotFoundError' }
   };

export type GetPopupsQueryVariables = Exact<{
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetPopupsQuery = { __typename: 'Query', getPopups: Array<{ __typename: 'PopupData', id: string, name: string }> };

export type SetPopupValMutationVariables = Exact<{
  popupId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
}>;


export type SetPopupValMutation = { __typename: 'Mutation', setPopupVal: { __typename: 'SetPopupValResult', success: boolean } };

export type PricingSummaryFragment = { __typename: 'PricingSummary', subtotal: number, host_earnings: number, guest_price: number, display_full_price: boolean, klarnaEligible: boolean, klarnaCancellationFee: number, base_pricing: { __typename: 'BasePricing', amount: number, duration_hours: number, min_guests_for_price: number, max_guests_for_price: number, hourly_rate?: number | null }, base_price_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, amount?: number | null }>, additional_guest_pricing?: { __typename: 'AdditionalGuestPricing', amount: number, additional_guest_count: number, per_guest_rate: number, duration_hours: number } | null, amenity_pricing?: { __typename: 'AmenityPricing', amount: number, amenity_count: number } | null, reservation_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, discount_type: DiscountType, amount?: number | null }>, credit_pricing?: { __typename: 'CreditPricing', amount: number, remaining_balance?: number | null } | null, credit_earnings?: { __typename: 'CreditEarnings', amount: number, earned_credit_type: CreditEarningsType } | null, service_fee_pricing: { __typename: 'ServiceFeePricing', amount?: number | null, service_fee_percentage: number }, host_fee_pricing: { __typename: 'HostFeePricing', amount: number, host_fee_percentage: number }, display_sections?: Array<{ __typename: 'DisplaySection', lines: Array<{ __typename: 'DisplayLine', title: string, subtitle?: any | null, amount: string, is_discount: boolean, is_total: boolean, is_subtotal: boolean, is_premium?: boolean | null, is_membership?: boolean | null }> }> | null, securityDeposit?: { __typename: 'SecurityDepositPricing', amount: number, totalGuests: number } | null, premium_savings?: { __typename: 'PremiumSavings', premium_savings: number, premium_not_saving?: number | null } | null, upsell_discount?: { __typename: 'UpsellDiscount', discount: number, amount: number, hoursUsed: number, hoursLeft: number } | null, pass_discount?: { __typename: 'PassDiscount', discount: number, amount?: number | null, discount_type: DiscountType, can_redeem?: boolean | null, hoursUsed: number, hoursLeft: number } | null };

export type PricingSummaryPublicQueryVariables = Exact<{
  data: PricingSummaryPublicInput;
}>;


export type PricingSummaryPublicQuery = { __typename: 'Query', pricingSummaryPublic: { __typename: 'PricingSummary', subtotal: number, host_earnings: number, guest_price: number, display_full_price: boolean, klarnaEligible: boolean, klarnaCancellationFee: number, base_pricing: { __typename: 'BasePricing', amount: number, duration_hours: number, min_guests_for_price: number, max_guests_for_price: number, hourly_rate?: number | null }, base_price_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, amount?: number | null }>, additional_guest_pricing?: { __typename: 'AdditionalGuestPricing', amount: number, additional_guest_count: number, per_guest_rate: number, duration_hours: number } | null, amenity_pricing?: { __typename: 'AmenityPricing', amount: number, amenity_count: number } | null, reservation_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, discount_type: DiscountType, amount?: number | null }>, credit_pricing?: { __typename: 'CreditPricing', amount: number, remaining_balance?: number | null } | null, credit_earnings?: { __typename: 'CreditEarnings', amount: number, earned_credit_type: CreditEarningsType } | null, service_fee_pricing: { __typename: 'ServiceFeePricing', amount?: number | null, service_fee_percentage: number }, host_fee_pricing: { __typename: 'HostFeePricing', amount: number, host_fee_percentage: number }, display_sections?: Array<{ __typename: 'DisplaySection', lines: Array<{ __typename: 'DisplayLine', title: string, subtitle?: any | null, amount: string, is_discount: boolean, is_total: boolean, is_subtotal: boolean, is_premium?: boolean | null, is_membership?: boolean | null }> }> | null, securityDeposit?: { __typename: 'SecurityDepositPricing', amount: number, totalGuests: number } | null, premium_savings?: { __typename: 'PremiumSavings', premium_savings: number, premium_not_saving?: number | null } | null, upsell_discount?: { __typename: 'UpsellDiscount', discount: number, amount: number, hoursUsed: number, hoursLeft: number } | null, pass_discount?: { __typename: 'PassDiscount', discount: number, amount?: number | null, discount_type: DiscountType, can_redeem?: boolean | null, hoursUsed: number, hoursLeft: number } | null } };

export type PricingSummaryQueryVariables = Exact<{
  data: PricingSummaryInput;
}>;


export type PricingSummaryQuery = { __typename: 'Query', pricingSummary: { __typename: 'PricingSummary', subtotal: number, host_earnings: number, guest_price: number, display_full_price: boolean, klarnaEligible: boolean, klarnaCancellationFee: number, base_pricing: { __typename: 'BasePricing', amount: number, duration_hours: number, min_guests_for_price: number, max_guests_for_price: number, hourly_rate?: number | null }, base_price_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, amount?: number | null }>, additional_guest_pricing?: { __typename: 'AdditionalGuestPricing', amount: number, additional_guest_count: number, per_guest_rate: number, duration_hours: number } | null, amenity_pricing?: { __typename: 'AmenityPricing', amount: number, amenity_count: number } | null, reservation_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, discount_type: DiscountType, amount?: number | null }>, credit_pricing?: { __typename: 'CreditPricing', amount: number, remaining_balance?: number | null } | null, credit_earnings?: { __typename: 'CreditEarnings', amount: number, earned_credit_type: CreditEarningsType } | null, service_fee_pricing: { __typename: 'ServiceFeePricing', amount?: number | null, service_fee_percentage: number }, host_fee_pricing: { __typename: 'HostFeePricing', amount: number, host_fee_percentage: number }, display_sections?: Array<{ __typename: 'DisplaySection', lines: Array<{ __typename: 'DisplayLine', title: string, subtitle?: any | null, amount: string, is_discount: boolean, is_total: boolean, is_subtotal: boolean, is_premium?: boolean | null, is_membership?: boolean | null }> }> | null, securityDeposit?: { __typename: 'SecurityDepositPricing', amount: number, totalGuests: number } | null, premium_savings?: { __typename: 'PremiumSavings', premium_savings: number, premium_not_saving?: number | null } | null, upsell_discount?: { __typename: 'UpsellDiscount', discount: number, amount: number, hoursUsed: number, hoursLeft: number } | null, pass_discount?: { __typename: 'PassDiscount', discount: number, amount?: number | null, discount_type: DiscountType, can_redeem?: boolean | null, hoursUsed: number, hoursLeft: number } | null } };

export type GetHostListingTypeAmenitiesQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type GetHostListingTypeAmenitiesQuery = { __typename: 'Query', premiumAmenities?: Array<{ __typename: 'Amenity', id: string, name: string, icon: string, active: boolean, image?: string | null, category?: string | null, premium?: boolean | null } | null> | null };

export type AddHostSignupInterestMutationVariables = Exact<{
  data: HostSignupInterest;
}>;


export type AddHostSignupInterestMutation = { __typename: 'Mutation', addHostSignupInterest: boolean };

export type EstimateEarningsExtendedMutationVariables = Exact<{
  input: EstimateEarningsExtendedInput;
}>;


export type EstimateEarningsExtendedMutation = { __typename: 'Mutation', estimateEarningsExtended:
    | { __typename: 'EstimateEarningsExtendedResponse', poolId: string, state: LoadingState, latitude?: number | null, longitude?: number | null, thresholds?: Array<{ __typename: 'GuestThresholdEarnings', minGuests: number, maxGuests?: number | null, estimatedMonthlyEarnings: number }> | null }
    | { __typename: 'ListingNotFoundError', message: string }
   };

export type EstimateEarningsQueryVariables = Exact<{
  input: EstimateEarningsInput;
}>;


export type EstimateEarningsQuery = { __typename: 'Query', estimateEarnings: { __typename: 'EarningsEstimate', latitude: number, longitude: number, thresholds: Array<{ __typename: 'GuestThresholdEarnings', minGuests: number, maxGuests?: number | null, estimatedMonthlyEarnings: number }> } };

export type CreateFavCollectionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  listingIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  from: FavoriteFrom;
}>;


export type CreateFavCollectionMutation = { __typename: 'Mutation', createFavCollection: Array<{ __typename: 'FavCollection', id: number, name: string } | null> };

export type DeleteFavCollectionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFavCollectionMutation = { __typename: 'Mutation', deleteFavCollection: Array<{ __typename: 'FavCollection', id: number, name: string } | null> };

export type FavCollectionCollaboratorFragment = { __typename: 'FavCollectionCollaborators', id: number, firstname?: string | null, lastname?: string | null, email?: string | null, imgUrl?: string | null };

export type FavCollectionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  adults?: InputMaybe<Scalars['Int']['input']>;
  children?: InputMaybe<Scalars['Int']['input']>;
  infants?: InputMaybe<Scalars['Int']['input']>;
  pets?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FavCollectionQuery = { __typename: 'Query', favCollection?: { __typename: 'FavCollection', id: number, name: string, listingCount: number, coverImageUrl?: string | null, inviteUrl?: string | null, shareUrl: string, isOwner: boolean, ownerName?: string | null, ownerId?: number | null, ownerImageUrl?: string | null, listingIds: Array<number | null>, collaboratorUsers?: Array<{ __typename: 'FavCollectionCollaborators', id: number, firstname?: string | null, lastname?: string | null, email?: string | null, imgUrl?: string | null } | null> | null, listings: { __typename: 'FavCollectionListingsResponse', displayFullPriceToggle: boolean, data: Array<{ __typename: 'SearchPool', id: string, title: string, description?: string | null, distance?: number | null, state: string, city: string, zip_code: string, rating?: number | null, image_urls?: Array<string | null> | null, cover_image_url?: string | null, video_thumbnail_url?: string | null, country_code?: string | null, listing_type: ListingType, max_guests?: number | null, instant_booking: boolean, default_instant_booking?: boolean | null, is_new: boolean, is_quality: boolean, stealth_mode: boolean, badges?: Array<string | null> | null, reviewsCount: number, latitude_round?: number | null, longitude_round?: number | null, nextAvailableDay?: any | null, pricing: { __typename: 'SearchPoolPricing', pricing_scheme: PricingScheme, price: number, discounted_price: number, featured_promo_code_percent: number, grand_opening_discount_percent: number } } | null>, paginatorInfo: { __typename: 'PaginatorInfo', currentPage: number, hasMorePages: boolean } } } | null };

export type RemoveUsersFromFavCollectionMutationVariables = Exact<{
  collectionId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type RemoveUsersFromFavCollectionMutation = { __typename: 'Mutation', removeUsersFromFavCollection: { __typename: 'FavCollection', id: number, name: string, collaborators?: Array<{ __typename: 'FavCollectionCollaborators', id: number, firstname?: string | null, lastname?: string | null, email?: string | null, imgUrl?: string | null } | null> | null } };

export type SendFavCollectionInvitesMutationVariables = Exact<{
  collectionId: Scalars['Int']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  inviteType?: InputMaybe<FavCollectionInviteType>;
}>;


export type SendFavCollectionInvitesMutation = { __typename: 'Mutation', sendFavCollectionInvites: { __typename: 'FavCollection', id: number } };

export type UpdateFavCollectionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  listingIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type UpdateFavCollectionMutation = { __typename: 'Mutation', updateFavCollection: Array<{ __typename: 'FavCollection', id: number, name: string, listingCount: number } | null> };

export type AcceptFavCollectionInviteMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AcceptFavCollectionInviteMutation = { __typename: 'Mutation', acceptFavCollectionInvite: { __typename: 'FavCollection', id: number, name: string } };

export type BookingUserRoleQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type BookingUserRoleQuery = { __typename: 'Query', reservationDetails?: { __typename: 'Booking', id: string, poolPrivate: { __typename: 'PoolPrivate', country_code?: string | null, user?: { __typename: 'UserPublic', id: string } | null }, userPublic: { __typename: 'UserPublic', id: string } } | null };

export type BookLifeguardMutationVariables = Exact<{
  input: BookServiceInput;
}>;


export type BookLifeguardMutation = { __typename: 'Mutation', bookLifeguard: { __typename: 'BookServiceResult', id: string } };

export type EventFragment = { __typename: 'ScheduleEvent', from: string, to: string, bookingId?: string | null, unavailabilityEventId?: string | null, totalGuests?: number | null, isAllDay: boolean, isEditable: boolean, calendarName?: string | null, bookingGuest?: { __typename: 'BookingGuest', fullName: string, avatar?: any | null } | null };

export type ScheduleDetailFragment = { __typename: 'ListingScheduleDetail', listingId: string, date: any, events: Array<{ __typename: 'ScheduleEvent', from: string, to: string, bookingId?: string | null, unavailabilityEventId?: string | null, totalGuests?: number | null, isAllDay: boolean, isEditable: boolean, calendarName?: string | null, bookingGuest?: { __typename: 'BookingGuest', fullName: string, avatar?: any | null } | null }> };

export type AvailabilityFragment = { __typename: 'AvailabilityEvent', id: string, day: any, availableFrom?: string | null, availableTo?: string | null, priceModifier?: number | null, isInstantBook?: boolean | null };

export type CalendarListingQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CalendarListingQuery = { __typename: 'Query', myPool: { __typename: 'MyPool', id: string, title: string, description?: string | null, custom_listing_type?: string | null, city?: string | null, state?: string | null, time_zone?: string | null, country_code?: string | null, discount_first_bookings?: boolean | null, is_security_cameras?: boolean | null, additional_rules?: string | null, host_interaction_setting?: HostInteractionSettings | null, pets_rule?: PetsRules | null, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, guests_pets_allowed?: boolean | null, default_instant_booking: boolean, instant_group_size?: number | null, special_access_instruction?: string | null, availability_window?: number | null, advance_notice?: number | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, pause_start?: any | null, pause_end?: any | null, min_buffer_time?: number | null, available_days: Array<string | null>, are_post_onboarding_steps_completed: boolean, is_third_party_address_opted_in: boolean, is_covered_by_insurance: boolean, can_update_insurance: boolean, cancellation_policy_id?: number | null, status: number, status_name: string, reviewsCount: number, rating?: number | null, is_quality: boolean, is_in_rehab: boolean, tour_360_url?: string | null, guest_leads: number, one_time_guests: number, repeat_guests: number, abandoned_carts: number, total_fans?: number | null, has_instagram_connection: boolean, instagram_username?: string | null, can_upload_video: boolean, stealth_mode: boolean, securityDepositMinGuests?: number | null, securityDepositMinor?: number | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, rule_settings: Array<{ __typename: 'RuleSetting', id: number, slug: string, name: string, icon: RuleIcon, active: boolean, description?: string | null, is_allowed?: boolean | null } | null>, access_photos: Array<{ __typename: 'PoolAccessPhoto', id: number, image_url: string } | null>, cancellation_policy?: { __typename: 'CancellationPolicy', id: string, title: string, color: string, description: string, hours: string, discount: string } | null, images: Array<{ __typename: 'PoolImage', id?: string | null, pool_id: number, url: string, cover: boolean, index?: number | null }>, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, pool_id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, enable?: boolean | null, square_footage?: number | null, amenity?: { __typename: 'Amenity', id: string, name: string, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, featured_promo_code?: { __typename: 'FeaturedPromoCode', id: number, promo_code: string, percent_off: number, max_redemptions: number, redeem_by: any, times_redeemed: number, feature_text?: string | null, can_redeem: boolean } | null } };

export type CalendarSummaryQueryVariables = Exact<{
  input: GetListingScheduleInput;
}>;


export type CalendarSummaryQuery = { __typename: 'Query', summaryScheduleForListing:
    | { __typename: 'GetSummaryScheduleForListingResponse', summaries: Array<{ __typename: 'ListingScheduleSummary', listingId: string, day: any, status: ListingAvailabilityStatus, hasBookings: boolean, priceModifier?: number | null, unavailabilitySource?: UnavailabilitySource | null }> }
    | { __typename: 'InvalidDateRangeError' }
    | { __typename: 'ListingNotFoundError' }
   };

export type CalendarDetailQueryVariables = Exact<{
  input: GetListingScheduleInput;
}>;


export type CalendarDetailQuery = { __typename: 'Query', detailedScheduleForListing:
    | { __typename: 'GetDetailScheduleForListingResponse', availabilityStatus: ListingAvailabilityStatus, bookingStatus: ListingBookingRequestType, schedules: Array<{ __typename: 'ListingScheduleDetail', listingId: string, date: any, events: Array<{ __typename: 'ScheduleEvent', from: string, to: string, bookingId?: string | null, unavailabilityEventId?: string | null, totalGuests?: number | null, isAllDay: boolean, isEditable: boolean, calendarName?: string | null, bookingGuest?: { __typename: 'BookingGuest', fullName: string, avatar?: any | null } | null }> }>, availabilityEvents: Array<{ __typename: 'AvailabilityEvent', id: string, day: any, availableFrom?: string | null, availableTo?: string | null, priceModifier?: number | null, isInstantBook?: boolean | null }> }
    | { __typename: 'InvalidDateRangeError' }
    | { __typename: 'ListingNotFoundError' }
   };

export type DeleteUnavailabilityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUnavailabilityMutation = { __typename: 'Mutation', deleteUnavailabilityEvent:
    | { __typename: 'ListingNotFoundError', message: string }
    | { __typename: 'ListingOwnershipError', message: string }
    | { __typename: 'MutationResult', succeeded: boolean }
    | { __typename: 'UnavailabilityEventNotFoundError', message: string }
   };

export type SaveListingAvailabilityOverrideMutationVariables = Exact<{
  input: SaveListingAvailabilityOverrideInput;
}>;


export type SaveListingAvailabilityOverrideMutation = { __typename: 'Mutation', saveListingAvailabilityOverride:
    | { __typename: 'InvalidDailyAvailabilityError', message: string }
    | { __typename: 'InvalidDateRangeError', message: string }
    | { __typename: 'InvalidUnavailabilityEventError', message: string }
    | { __typename: 'ListingNotFoundError', message: string }
    | { __typename: 'ListingOwnershipError', message: string }
    | { __typename: 'OverlappingBookingError', message: string, bookings: Array<{ __typename: 'ListingBooking', id: string, from: any, to: any }>, unavailabilityEvent: { __typename: 'UnavailabilityEvent', id: string, from: any, to: any } }
    | { __typename: 'SaveListingAvailabilityOverrideResponse', succeeded: boolean, availabilityStatus: ListingAvailabilityStatus, bookingStatus: ListingBookingRequestType, schedules: Array<{ __typename: 'ListingScheduleDetail', listingId: string, date: any, events: Array<{ __typename: 'ScheduleEvent', from: string, to: string, bookingId?: string | null, unavailabilityEventId?: string | null, totalGuests?: number | null, isAllDay: boolean, isEditable: boolean, calendarName?: string | null, bookingGuest?: { __typename: 'BookingGuest', fullName: string, avatar?: any | null } | null }> }>, availabilityEvents: Array<{ __typename: 'AvailabilityEvent', id: string, day: any, availableFrom?: string | null, availableTo?: string | null, priceModifier?: number | null, isInstantBook?: boolean | null }> }
   };

export type GetCalendarLinkQueryVariables = Exact<{
  input: GetCalendarLinkInput;
}>;


export type GetCalendarLinkQuery = { __typename: 'Query', listingCalendarLink: string };

export type ToggleCalendarSyncBufferMutationVariables = Exact<{
  listingId: Scalars['ID']['input'];
  provider: CalendarSyncBufferProvider;
  shouldIncludeBuffer: Scalars['Boolean']['input'];
}>;


export type ToggleCalendarSyncBufferMutation = { __typename: 'Mutation', toggleCalendarSyncBuffer: { __typename: 'MutationResult', message?: string | null, succeeded: boolean } };

export type CalendarSyncBufferStatusQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
  provider: CalendarSyncBufferProvider;
}>;


export type CalendarSyncBufferStatusQuery = { __typename: 'Query', calendarSyncBufferStatus: boolean };

export type ListingCalendarFragment = { __typename: 'SyncedListingCalendar', id: string, isSynced: boolean, name: string, provider: CalendarProvider };

export type AuthorizeCronofyProviderMutationVariables = Exact<{
  code: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
}>;


export type AuthorizeCronofyProviderMutation = { __typename: 'Mutation', authorizeCronofyProvider:
    | { __typename: 'CronofyAuthorizationError', message: string }
    | { __typename: 'SyncedCalendars', calendars?: Array<{ __typename: 'SyncedListingCalendar', id: string, isSynced: boolean, name: string, provider: CalendarProvider }> | null }
   };

export type DeactivateCronofyMutationVariables = Exact<{ [key: string]: never; }>;


export type DeactivateCronofyMutation = { __typename: 'Mutation', deactivateCronofy: { __typename: 'SyncedCalendars', calendars?: Array<{ __typename: 'SyncedListingCalendar', id: string, isSynced: boolean, name: string, provider: CalendarProvider }> | null } };

export type AuthorizeiCalCalendarMutationVariables = Exact<{
  name: Scalars['String']['input'];
  iCalUrl: Scalars['URL']['input'];
  listingId: Scalars['ID']['input'];
}>;


export type AuthorizeiCalCalendarMutation = { __typename: 'Mutation', authorizeiCalCalendar: { __typename: 'SyncedCalendars', calendars?: Array<{ __typename: 'SyncedListingCalendar', id: string, isSynced: boolean, name: string, provider: CalendarProvider }> | null } };

export type SynciCalCalendarMutationVariables = Exact<{
  calendarId: Scalars['ID']['input'];
  listingId: Scalars['ID']['input'];
}>;


export type SynciCalCalendarMutation = { __typename: 'Mutation', synciCalCalendar: { __typename: 'SyncedCalendars', calendars?: Array<{ __typename: 'SyncedListingCalendar', id: string, isSynced: boolean, name: string, provider: CalendarProvider }> | null } };

export type RefreshiCalCalendarMutationVariables = Exact<{
  calendarId: Scalars['ID']['input'];
}>;


export type RefreshiCalCalendarMutation = { __typename: 'Mutation', refreshiCalCalendar: { __typename: 'MutationResult', message?: string | null, succeeded: boolean } };

export type DeactivateiCalCalendarMutationVariables = Exact<{
  calendarId: Scalars['ID']['input'];
}>;


export type DeactivateiCalCalendarMutation = { __typename: 'Mutation', deactivateiCalCalendar: { __typename: 'SyncedCalendars', calendars?: Array<{ __typename: 'SyncedListingCalendar', id: string, isSynced: boolean, name: string, provider: CalendarProvider }> | null } };

export type SyncCronofyCalendarMutationVariables = Exact<{
  calendarId: Scalars['ID']['input'];
  listingId: Scalars['ID']['input'];
}>;


export type SyncCronofyCalendarMutation = { __typename: 'Mutation', syncCronofyCalendar:
    | { __typename: 'CronofyAuthorizationError', message: string }
    | { __typename: 'SyncedCalendars', calendars?: Array<{ __typename: 'SyncedListingCalendar', id: string, isSynced: boolean, name: string, provider: CalendarProvider }> | null }
   };

export type UnsyncExternalCalendarMutationVariables = Exact<{
  calendarId: Scalars['ID']['input'];
  listingId: Scalars['ID']['input'];
}>;


export type UnsyncExternalCalendarMutation = { __typename: 'Mutation', unsyncExternalCalendar: { __typename: 'SyncedCalendars', calendars?: Array<{ __typename: 'SyncedListingCalendar', id: string, isSynced: boolean, name: string, provider: CalendarProvider }> | null } };

export type ListingCalendarsQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type ListingCalendarsQuery = { __typename: 'Query', listingCalendars: { __typename: 'SyncedCalendars', calendars?: Array<{ __typename: 'SyncedListingCalendar', id: string, isSynced: boolean, name: string, provider: CalendarProvider }> | null } };

export type AcceptChatRulesMutationVariables = Exact<{
  accept: Scalars['Boolean']['input'];
}>;


export type AcceptChatRulesMutation = { __typename: 'Mutation', acceptChatRules: { __typename: 'acceptChatRulesResult', status: boolean, message?: string | null } };

export type CompletedTransactionFragment = { __typename: 'CompletedTransactionV2', id: number, date?: any | null, amount: number, bookingId?: number | null, guestName: string, guestImage?: string | null, payOutDate?: any | null, paidOutDate?: any | null, guestPassId?: number | null, passName?: string | null };

export type UpcomingTransactionFragment = { __typename: 'UpcomingTransaction', id: number, date?: any | null, amount: number, bookingId: number, guestName: string, guestImage?: string | null, payOutDate?: any | null, paidOutDate?: any | null };

export type CompletedTransactionsQueryVariables = Exact<{
  data?: InputMaybe<TransactionsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
}>;


export type CompletedTransactionsQuery = { __typename: 'Query', completedTransactionsV2: { __typename: 'CompletedTransactionV2Paginator', paginatorInfo: { __typename: 'PaginatorInfo', hasMorePages: boolean, currentPage: number, total: number }, transactions: Array<{ __typename: 'CompletedTransactionV2', id: number, date?: any | null, amount: number, bookingId?: number | null, guestName: string, guestImage?: string | null, payOutDate?: any | null, paidOutDate?: any | null, guestPassId?: number | null, passName?: string | null }> } };

export type UpcomingTransactionsQueryVariables = Exact<{
  data?: InputMaybe<TransactionsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
}>;


export type UpcomingTransactionsQuery = { __typename: 'Query', upcomingTransactions: { __typename: 'UpcomingTransactionPaginator', paginatorInfo: { __typename: 'PaginatorInfo', hasMorePages: boolean, currentPage: number, total: number }, transactions: Array<{ __typename: 'UpcomingTransaction', id: number, date?: any | null, amount: number, bookingId: number, guestName: string, guestImage?: string | null, payOutDate?: any | null, paidOutDate?: any | null }> } };

export type EarningsInsightsQueryVariables = Exact<{
  data: EarningsInsightsInput;
}>;


export type EarningsInsightsQuery = { __typename: 'Query', earningsInsights?: { __typename: 'EarningsInsights', summaryValue: number, dataPoints: Array<{ __typename: 'EarningsInsightsDataPoint', value: number, date: any }> } | null };

export type EarningsSummaryQueryVariables = Exact<{
  data: EarningsSummaryInput;
}>;


export type EarningsSummaryQuery = { __typename: 'Query', earningsSummary?: { __typename: 'EarningsSummary', earningsPerBooking: number, completedBookings: number, earningsPerHour: number, averageBookingDurationHours: number, earningsPerGuest: number, averageGuestCount: number } | null };

export type GuestMembershipsQueryVariables = Exact<{
  activeOrExpired: ActiveOrExpired;
}>;


export type GuestMembershipsQuery = { __typename: 'Query', guestPassesV2: Array<{ __typename: 'GuestPass', id: string, paymentSourceId?: string | null, hoursLeft?: number | null, price?: number | null, end: any, state: GuestPassState, autoRenewState: GuestPassAutoRenewState, monthlyPriceWithFees?: number | null, renewAvailable?: boolean | null, maxGuestCount?: number | null, pass?: { __typename: 'Pass', discount?: number | null, id: string, state: PassState, listingId: number, hoursPerMonth?: number | null, type: PassType, name: string, enabledForWeekends?: boolean | null, enabledForHolidays?: boolean | null, maxGuestCount?: number | null, availableTimes?: Array<{ __typename: 'AvailableTime', from: string, to: string }> | null, listing?: { __typename: 'Listing', ownerId: number, title: string, stealthMode?: boolean | null, availableFrom: string, availableTo: string } | null } | null }> };

export type PurchaseFullPassMutationVariables = Exact<{
  input: PurchasePassInput;
}>;


export type PurchaseFullPassMutation = { __typename: 'Mutation', purchaseFullPass:
    | { __typename: 'GuestPass' }
    | { __typename: 'PurchasePassError', message: string }
   };

export type UpdatePaymentMethodMutationVariables = Exact<{
  input: UpdateGuestPassV2PaymentInput;
}>;


export type UpdatePaymentMethodMutation = { __typename: 'Mutation', guestPassV2UpdatePayment:
    | { __typename: 'GuestPass' }
    | { __typename: 'UpdateGuestPassV2PaymentError', message: string }
   };

export type GuestPassPurchaseHistoryQueryVariables = Exact<{
  input: GetGuestPassPurchaseHistoryInput;
}>;


export type GuestPassPurchaseHistoryQuery = { __typename: 'Query', guestPassPurchaseHistoryV2: { __typename: 'GuestPassPurchaseHistory', purchases: Array<{ __typename: 'GuestPassPurchase', guestPass: { __typename: 'GuestPass', id: string }, upsoldCharge?: { __typename: 'UpsoldCharge', amount: number, date: any, bookingId: string } | null, activationCharge?: { __typename: 'ActivationCharge', amount: number, date: any } | null }> } };

export type PopularEscapesQueryVariables = Exact<{
  data: DynamicSearchInput;
}>;


export type PopularEscapesQuery = { __typename: 'Query', dynamicSearch: { __typename: 'DynamicSearchResponse', data: Array<{ __typename: 'SearchPool', id: string, title: string, description?: string | null, distance?: number | null, state: string, city: string, zip_code: string, rating?: number | null, image_urls?: Array<string | null> | null, cover_image_url?: string | null, video_thumbnail_url?: string | null, country_code?: string | null, listing_type: ListingType, max_guests?: number | null, instant_booking: boolean, default_instant_booking?: boolean | null, is_new: boolean, is_quality: boolean, stealth_mode: boolean, badges?: Array<string | null> | null, reviewsCount: number, latitude_round?: number | null, longitude_round?: number | null, nextAvailableDay?: any | null, pricing: { __typename: 'SearchPoolPricing', pricing_scheme: PricingScheme, price: number, discounted_price: number, featured_promo_code_percent: number, grand_opening_discount_percent: number }, experiences?: { __typename: 'SearchPoolExperiences', duration?: number | null, per_guest_pricing?: number | null, guest_restrictions?: string | null } | null } | null> } };

export type HostBusinessKitQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type HostBusinessKitQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, title: string, city?: string | null, state?: string | null } | null };

export type ListingTipFragment = { __typename: 'ListingTip', title: string, description: string, button: string, slug: string, images: { __typename: 'TipsImages', small?: string | null, medium?: string | null, large?: string | null } };

export type PerformanceTipsQueryVariables = Exact<{
  data: PerformanceTipsInput;
}>;


export type PerformanceTipsQuery = { __typename: 'Query', performanceTips: Array<{ __typename: 'ListingTip', title: string, description: string, button: string, slug: string, images: { __typename: 'TipsImages', small?: string | null, medium?: string | null, large?: string | null } } | null> };

export type MarketingTipsQueryVariables = Exact<{
  data: MarketingTipsInput;
}>;


export type MarketingTipsQuery = { __typename: 'Query', marketingTips: Array<{ __typename: 'ListingTip', title: string, description: string, button: string, slug: string, images: { __typename: 'TipsImages', small?: string | null, medium?: string | null, large?: string | null } } | null> };

export type HostListingPassesQueryVariables = Exact<{
  input: GetListingPassesV2Input;
}>;


export type HostListingPassesQuery = { __typename: 'Query', listingPassesV2: Array<{ __typename: 'ListingPass', id: number, hoursPerMonth: number, discount: number, monthlyPriceNoFees: number, hourlyPrice: number, active: boolean, enabledForWeekends: boolean, enabledForHolidays: boolean }> };

export type SaveMembershipMutationVariables = Exact<{
  input: PassInput;
}>;


export type SaveMembershipMutation = { __typename: 'Mutation', savePassV2:
    | { __typename: 'InvalidPassError', message: string }
    | { __typename: 'Pass' }
    | { __typename: 'PassArray', numberOfAffectedGuests: number }
   };

export type PerformanceOverviewQueryVariables = Exact<{
  data: PerformanceOverviewInput;
}>;


export type PerformanceOverviewQuery = { __typename: 'Query', performanceOverview: { __typename: 'PerformanceOverview', views?: number | null, bookings: number, earnings: number, overall_score_rating?: PerformanceRating | null, uniqueGuests: number, repeatGuests: number } };

export type PerformanceScoresQueryVariables = Exact<{
  data: PerformanceScoresInput;
}>;


export type PerformanceScoresQuery = { __typename: 'Query', performanceScores?: { __typename: 'PerformanceScores', overall_score: number, overall_score_rating?: PerformanceRating | null, median_response_time_hours?: number | null, median_response_time_rating?: PerformanceRating | null, cancellation_rate_percentage?: number | null, cancellation_rate_rating?: PerformanceRating | null, success_rate_percentage?: number | null, success_rate_rating?: PerformanceRating | null, availability_score: number, availability_score_rating?: PerformanceRating | null, photo_score?: number | null, photo_score_rating?: PerformanceRating | null, average_price?: number | null, average_price_rating?: PerformanceRating | null } | null };

export type UpdateListingWakeupChecklistMutationVariables = Exact<{
  input: UpdateListingWakeupChecklistInput;
}>;


export type UpdateListingWakeupChecklistMutation = { __typename: 'Mutation', updateListingWakeupChecklist:
    | { __typename: 'ListingNotFoundError' }
    | { __typename: 'PostOnboardingCompletedError', message: string, listingId: string }
    | { __typename: 'WakeupChecklist', listingId: string, hasStickers: boolean, items: Array<{ __typename: 'WakeupChecklistItem', name: WakeupChecklistItemName, title: string, isCompleted: boolean, description: string, order: number, icon: WakeupChecklistItemIcon }> }
   };

export type ListingWakeupChecklistQueryVariables = Exact<{
  input: ListingWakeupChecklistInput;
}>;


export type ListingWakeupChecklistQuery = { __typename: 'Query', listingWakeupChecklist: { __typename: 'WakeupChecklistResults', checklist: Array<
      | { __typename: 'ListingNotFoundError' }
      | { __typename: 'PostOnboardingCompletedError', message: string, listingId: string }
      | { __typename: 'WakeupChecklist', listingId: string, hasStickers: boolean, items: Array<{ __typename: 'WakeupChecklistItem', name: WakeupChecklistItemName, title: string, isCompleted: boolean, description: string, order: number, icon: WakeupChecklistItemIcon }> }
    > } };

export type ListingPostOnboardingStepsQueryVariables = Exact<{
  input: GetListingPostOnboardingStepsInput;
}>;


export type ListingPostOnboardingStepsQuery = { __typename: 'Query', listingPostOnboardingSteps:
    | { __typename: 'GetListingPostOnboardingStepsResponse', listingPostOnboardingSteps: Array<{ __typename: 'ListingPostOnboardingStep', id: string, postOnboardingStepId: string, isCompleted: boolean, postOnboardingStep: { __typename: 'PostOnboardingStep', id: string, name: PostOnboardingStepName, icon: PostOnboardingStepIcon, title: string, description: string, isDisplayed: boolean, order: number } }> }
    | { __typename: 'ListingNotFoundError', message: string }
   };

export type CompletePostOnboardingStepMutationVariables = Exact<{
  input: CompleteListingPostOnboardingStepInput;
}>;


export type CompletePostOnboardingStepMutation = { __typename: 'Mutation', completeListingPostOnboardingStep:
    | { __typename: 'CompleteListingPostOnboardingStepResponse', result: { __typename: 'MutationResult', succeeded: boolean }, listingPostOnboardingSteps: Array<{ __typename: 'ListingPostOnboardingStep', id: string, postOnboardingStepId: string, isCompleted: boolean, postOnboardingStep: { __typename: 'PostOnboardingStep', id: string, name: PostOnboardingStepName, icon: PostOnboardingStepIcon, title: string, description: string, isDisplayed: boolean, order: number } }> }
    | { __typename: 'ListingNotFoundError', message: string }
    | { __typename: 'ListingOwnershipError', message: string }
    | { __typename: 'ListingPostOnboardingStepNotFoundError', message: string }
   };

export type GetAbandonCartFansQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetAbandonCartFansQuery = { __typename: 'Query', myPool: { __typename: 'MyPool', id: string, abandoned_carts: number } };

export type AbandonCartSettingsFragment = { __typename: 'ListingAbandonedCartSettings', listingId: string, promoCodeAmountOff: number, promoCodeAmountOffType: ListingAbandonedCartSettingsPromoCodeAmountOffType, promoCodeDaysExpiresIn: number, message: string, isActive: boolean };

export type ListingAbandonedCartSettingsQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type ListingAbandonedCartSettingsQuery = { __typename: 'Query', listingAbandonedCartSettings: { __typename: 'GetListingAbandonedCartSettingsResponse', settings?: { __typename: 'ListingAbandonedCartSettings', listingId: string, promoCodeAmountOff: number, promoCodeAmountOffType: ListingAbandonedCartSettingsPromoCodeAmountOffType, promoCodeDaysExpiresIn: number, message: string, isActive: boolean } | null } };

export type UpdateAbandonCartSettingsMutationVariables = Exact<{
  input: UpdateListingAbandonedCartSettingsInput;
}>;


export type UpdateAbandonCartSettingsMutation = { __typename: 'Mutation', updateListingAbandonedCartSettings: { __typename: 'UpdateListingAbandonedCartSettingsResponse', settings: { __typename: 'ListingAbandonedCartSettings', listingId: string, promoCodeAmountOff: number, promoCodeAmountOffType: ListingAbandonedCartSettingsPromoCodeAmountOffType, promoCodeDaysExpiresIn: number, message: string, isActive: boolean } } };

export type CancellationPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type CancellationPoliciesQuery = { __typename: 'Query', cancellationPolicies?: Array<{ __typename: 'CancellationPolicy', id: string, title: string, description: string, hours: string, active: boolean, color: string, discount: string } | null> | null };

export type SaveListingCancellationPolicyMutationVariables = Exact<{
  data: PoolCancellationPolicyInput;
}>;


export type SaveListingCancellationPolicyMutation = { __typename: 'Mutation', saveListingCancellationPolicy?: { __typename: 'PoolSavingResult', status?: string | null, message?: string | null } | null };

export type SendFansMessageMutationVariables = Exact<{
  data: SendGroupMessageInput;
}>;


export type SendFansMessageMutation = { __typename: 'Mutation', sendGroupMessage?: { __typename: 'SendGroupMessageResult', status?: string | null, message?: string | null } | null };

export type SaveListingAccessInstructionMutationVariables = Exact<{
  data: SpecialAccessInput;
}>;


export type SaveListingAccessInstructionMutation = { __typename: 'Mutation', saveListingAccessInstruction: { __typename: 'SaveListingDataResult', status: string, message: string } };

export type SaveListingMaxGuestsMutationVariables = Exact<{
  data: GuestsInput;
}>;


export type SaveListingMaxGuestsMutation = { __typename: 'Mutation', saveListingMaxGuests: { __typename: 'SaveListingDataResult', status: string, message: string } };

export type DeleteInstagramConnectionMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
}>;


export type DeleteInstagramConnectionMutation = { __typename: 'Mutation', deleteInstagramConnection: { __typename: 'DeleteInstagramConnectionResult', confirmation_code: string, deleted_at: any } };

export type DefaultPricesFragment = { __typename: 'DefaultPriceTiersResult', id: number, title: string, minGuests: number, maxGuests: number, defaultPrice: number };

export type DefaultDailyPricesFragment = { __typename: 'DefaultDailyPriceTier', id: number, minGuests: number, maxGuests: number, defaultPrice: number };

export type DefaultDailyPriceTiersQueryVariables = Exact<{
  listingId: Scalars['Int']['input'];
}>;


export type DefaultDailyPriceTiersQuery = { __typename: 'Query', defaultDailyPriceTiers: Array<{ __typename: 'DefaultDailyPriceTier', id: number, minGuests: number, maxGuests: number, defaultPrice: number } | null> };

export type SaveTieredPricingMutationVariables = Exact<{
  data: TieredPricingInput;
}>;


export type SaveTieredPricingMutation = { __typename: 'Mutation', saveTieredPricing: { __typename: 'MyPool', id: string, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null } };

export type SavePerGuestPricingMutationVariables = Exact<{
  data: PerGuestPricingInput;
}>;


export type SavePerGuestPricingMutation = { __typename: 'Mutation', savePerGuestPricing: { __typename: 'MyPool', id: string, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null } };

export type SaveDailyPricingMutationVariables = Exact<{
  data: DailyPricingInput;
}>;


export type SaveDailyPricingMutation = { __typename: 'Mutation', saveDailyPricing: { __typename: 'MyPool', id: string, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null } };

export type SaveDailyTieredPricingMutationVariables = Exact<{
  data: DailyTieredPricingInput;
}>;


export type SaveDailyTieredPricingMutation = { __typename: 'Mutation', saveDailyTieredPricing: { __typename: 'MyPool', id: string, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null } };

export type OnboardingPricingQueryVariables = Exact<{
  listingId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OnboardingPricingQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, max_guests?: number | null, country_code?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, user?: { __typename: 'UserPublic', id: string } | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null } | null, defaultAvailablePriceTiers: Array<{ __typename: 'DefaultPriceTiersResult', id: number, title: string, minGuests: number, maxGuests: number, defaultPrice: number }>, listingPriceTiers: Array<{ __typename: 'ListingPriceTiers', id: number, title: string, minGuests: number, maxGuests: number, defaultPrice: number, listingPrice?: { __typename: 'ListingPrice', price: number } | null }> };

export type SetBasePriceMutationVariables = Exact<{
  input: SetBasePriceInput;
}>;


export type SetBasePriceMutation = { __typename: 'Mutation', setBasePrice:
    | { __typename: 'ListingNotFoundError', errorMessage: string }
    | { __typename: 'ListingOwnershipError', errorMessage: string }
    | { __typename: 'SetBasePriceResponse', succeeded: boolean }
   };

export type ListingPromocodeFragment = { __typename: 'Promocode', id: string, name: string, discountPercent: number, expirationDate: any, maxRedemptions: number, redemptionCount: number, isValid: boolean, isExpired: boolean, maxRedemptionsReached: boolean, isFeaturedPromo: boolean, redemptionRuleLimit?: number | null };

export type ListingPromocodesQueryVariables = Exact<{
  input: GetListingPromocodesInput;
}>;


export type ListingPromocodesQuery = { __typename: 'Query', hostListingPromocodes:
    | { __typename: 'GetListingPromocodesResponse', promocodes: Array<{ __typename: 'Promocode', id: string, name: string, discountPercent: number, expirationDate: any, maxRedemptions: number, redemptionCount: number, isValid: boolean, isExpired: boolean, maxRedemptionsReached: boolean, isFeaturedPromo: boolean, redemptionRuleLimit?: number | null }> }
    | { __typename: 'ListingNotFoundError' }
    | { __typename: 'ListingOwnershipError' }
   };

export type CreateListingPromocodeMutationVariables = Exact<{
  input: CreateListingPromocodeInput;
}>;


export type CreateListingPromocodeMutation = { __typename: 'Mutation', createListingPromocode:
    | { __typename: 'CreateListingPromocodeResponse', result: { __typename: 'Promocode', id: string, name: string, discountPercent: number, expirationDate: any, maxRedemptions: number, redemptionCount: number, isValid: boolean, isExpired: boolean, maxRedemptionsReached: boolean, isFeaturedPromo: boolean, redemptionRuleLimit?: number | null } }
    | { __typename: 'CreatePromocodeError', message: string }
    | { __typename: 'ListingNotFoundError', message: string }
    | { __typename: 'ListingOwnershipError', message: string }
   };

export type ActivateFeaturedPromoCodeMutationVariables = Exact<{
  input: ActivateFeaturedPromoCodeInput;
}>;


export type ActivateFeaturedPromoCodeMutation = { __typename: 'Mutation', activateFeaturedPromoCode:
    | { __typename: 'ActivateFeaturedPromoCodeResponse' }
    | { __typename: 'InvalidFeaturedPromoCodeError', message: string }
    | { __typename: 'ListingNotFoundError', message: string }
    | { __typename: 'ListingOwnershipError', message: string }
    | { __typename: 'PromocodeNotFoundError', message: string }
   };

export type DeactivateFeaturedPromoCodeMutationVariables = Exact<{
  input: DeactivateFeaturedPromoCodeInput;
}>;


export type DeactivateFeaturedPromoCodeMutation = { __typename: 'Mutation', deactivateFeaturedPromoCode:
    | { __typename: 'DeactivateFeaturedPromoCodeResponse' }
    | { __typename: 'InvalidFeaturedPromoCodeError', message: string }
    | { __typename: 'ListingNotFoundError', message: string }
    | { __typename: 'ListingOwnershipError', message: string }
    | { __typename: 'PromocodeNotFoundError', message: string }
   };

export type RuleSettingsFragment = { __typename: 'RuleSetting', id: number, slug: string, name: string, icon: RuleIcon, active: boolean, description?: string | null, is_allowed?: boolean | null };

export type UpdateListingRulesMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
  rules: Array<InputMaybe<RuleInput>> | InputMaybe<RuleInput>;
  additionalRulesText?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateListingRulesMutation = { __typename: 'Mutation', updateListingRules: { __typename: 'RulesResponse', additional_rules_text?: string | null, rules: Array<{ __typename: 'RuleSetting', id: number, slug: string, name: string, icon: RuleIcon, active: boolean, description?: string | null, is_allowed?: boolean | null } | null> } };

export type SavePoolSecurityDepositMutationVariables = Exact<{
  data: PoolSecurityDepositInput;
}>;


export type SavePoolSecurityDepositMutation = { __typename: 'Mutation', savePoolSecurityDeposit: { __typename: 'SavePoolSecurityDepositResult', succeeded: boolean } };

export type GetSecurityDepositConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSecurityDepositConfigurationQuery = { __typename: 'Query', getSecurityDepositConfiguration: { __typename: 'SecurityDepositConfiguration', minGuests: number, amountsMinor: Array<number> } };

export type GetListingVideoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetListingVideoQuery = { __typename: 'Query', listingVideo?: { __typename: 'ListingVideo', id: string, playbackUrl?: string | null, thumbnailUrl?: string | null, isReady: boolean } | null };

export type RemoveListingVideoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveListingVideoMutation = { __typename: 'Mutation', removeListingVideo: { __typename: 'MutationResult', succeeded: boolean } };

export type IsListingOptedInQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type IsListingOptedInQuery = { __typename: 'Query', myPool: { __typename: 'MyPool', id: string, is_third_party_address_opted_in: boolean } };

export type SetThirdPartyAddressOptInMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
  isOptedIn: Scalars['Boolean']['input'];
}>;


export type SetThirdPartyAddressOptInMutation = { __typename: 'Mutation', setThirdPartyAddressOptIn: boolean };

export type ReadPropertiesFragment = { __typename: 'ListingTypeReadProperty', fieldName: string, label: string, sublabel: string, category?: ListingTypePropertiesCategory | null, icon?: ListingTypePropertyIcon | null, linked_field?: string | null, value: string };

export type ListingTypeCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListingTypeCategoriesQuery = { __typename: 'Query', listingTypeCategories: { __typename: 'ListingTypeCategoriesResponse', title: string, categories: Array<{ __typename: 'ListingTypeCategory', slug: string, isListingType: boolean, card: { __typename: 'ListingTypeCategoryCard', icon: ListingTypeCategoryIcon, title: string, description: string }, listingTypeCategoryDetails?: { __typename: 'ListingTypeCategoryDetails', title: string, listingTypes: Array<{ __typename: 'ListingTypeCategoryType', slug: string, handleWithOnboardingV1: boolean, card: { __typename: 'ListingTypeCategoryTypeCard', icon: ListingTypeCategoryListingTypeIcon, title: string, description: string } }> } | null }> } };

export type DefaultMaxGuestCountTiersQueryVariables = Exact<{
  input: GetDefaultMaxGuestCountTiersInput;
}>;


export type DefaultMaxGuestCountTiersQuery = { __typename: 'Query', defaultMaxGuestCountTiers:
    | { __typename: 'GetDefaultMaxGuestCountTiersResponse', minRecommendedMaxGuestCount: number, defaultMaxGuestCount: number, listingType: ListingTypeNameEnum, tiers: Array<{ __typename: 'DefaultMaxGuestCountTier', id: string, listingTypeId: string, minGuestCount: number, maxGuestCount: number, isMostListings: boolean, isTopTenPerc: boolean, earningsText: string, earningsPerc: number }> }
    | { __typename: 'ListingNotFoundError' }
   };

export type OnboardingScreenFragment = { __typename: 'ListingOnboardingScreen', id: string, isCompleted: boolean, onboardingScreen: { __typename: 'OnboardingScreen', id: string, name: OnboardingScreenName, title: string, order: number } };

export type OnboardingScreensQueryVariables = Exact<{
  input: GetListingOnboardingScreensInput;
}>;


export type OnboardingScreensQuery = { __typename: 'Query', listingOnboardingScreens: { __typename: 'GetListingOnboardingScreensResponse', listingOnboardingScreens: Array<{ __typename: 'ListingOnboardingScreen', id: string, isCompleted: boolean, onboardingScreen: { __typename: 'OnboardingScreen', id: string, name: OnboardingScreenName, title: string, order: number } }> } };

export type CompleteOnboardingScreenMutationVariables = Exact<{
  input: CompleteOnboardingScreenInput;
}>;


export type CompleteOnboardingScreenMutation = { __typename: 'Mutation', completeOnboardingScreen:
    | { __typename: 'CompleteOnboardingScreenResponse', listingOnboardingScreens: Array<{ __typename: 'ListingOnboardingScreen', id: string, isCompleted: boolean, onboardingScreen: { __typename: 'OnboardingScreen', id: string, name: OnboardingScreenName, title: string, order: number } }> }
    | { __typename: 'ListingNotFoundError', message: string }
    | { __typename: 'ListingOnboardingScreenNotFoundError' }
    | { __typename: 'ListingOwnershipError', message: string }
    | { __typename: 'OnboardingScreenNotFoundError', message: string }
   };

export type SaveListingLocationMutationVariables = Exact<{
  data: PoolLocationInput;
}>;


export type SaveListingLocationMutation = { __typename: 'Mutation', savePoolLocation?: { __typename: 'PoolIdResult', pool_id: string, status?: string | null, message?: string | null } | null };

export type ListingPropertiesReadOnlyQueryVariables = Exact<{
  data: GetListingTypePropertiesInput;
}>;


export type ListingPropertiesReadOnlyQuery = { __typename: 'Query', listingProperties:
    | { __typename: 'GetListingTypePropertiesResponse', readProperties: Array<{ __typename: 'ListingTypeReadProperty', fieldName: string, label: string, sublabel: string, category?: ListingTypePropertiesCategory | null, icon?: ListingTypePropertyIcon | null, linked_field?: string | null, value: string }> }
    | { __typename: 'ListingNotFoundError', message: string }
   };

export type ListingOnboardingScreenQueryVariables = Exact<{
  data: GetListingOnboardingScreenInput;
}>;


export type ListingOnboardingScreenQuery = { __typename: 'Query', listingOnboardingScreen:
    | { __typename: 'GetListingOnboardingScreenResponse', listingOnboardingScreen: { __typename: 'ListingOnboardingScreen', id: string, onboardingScreen: { __typename: 'OnboardingScreen', id: string, readProperties?: Array<{ __typename: 'ListingTypeReadProperty', fieldName: string, label: string, sublabel: string, category?: ListingTypePropertiesCategory | null, icon?: ListingTypePropertyIcon | null, linked_field?: string | null, value: string }> | null } } }
    | { __typename: 'OnboardingScreenNotFoundError', message: string }
   };

export type OnboardingFullPriceListDataQueryVariables = Exact<{
  listingId: Scalars['Int']['input'];
  listingIdString: Scalars['ID']['input'];
}>;


export type OnboardingFullPriceListDataQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, max_guests?: number | null, country_code?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, hourly_price?: number | null, daily_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, pricing_scheme: PricingScheme } | null } | null, defaultAvailablePriceTiers: Array<{ __typename: 'DefaultPriceTiersResult', id: number, title: string, minGuests: number, maxGuests: number, defaultPrice: number }>, listingPriceTiers: Array<{ __typename: 'ListingPriceTiers', id: number, title: string, minGuests: number, maxGuests: number, defaultPrice: number, listingPrice?: { __typename: 'ListingPrice', price: number } | null }> };

export type SendOnboardingDeeplinkSmsMutationVariables = Exact<{ [key: string]: never; }>;


export type SendOnboardingDeeplinkSmsMutation = { __typename: 'Mutation', sendOnboardingDeeplinkSms: { __typename: 'SendOnboardingDeeplinkSmsResult', status: string, message: string } };

export type EnqueueListingForPhotoReviewMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
}>;


export type EnqueueListingForPhotoReviewMutation = { __typename: 'Mutation', enqueueListingForPhotoReview: { __typename: 'EnqueuePhotoReviewResponse', success: boolean, message?: string | null } };

export type GetInstantBookingSettingsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  input: GetListingOnboardingScreenInput;
}>;


export type GetInstantBookingSettingsQuery = { __typename: 'Query', myPool: { __typename: 'MyPool', id: string, default_instant_booking: boolean, instant_group_size?: number | null, max_guests?: number | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, instant_booking_params?: { __typename: 'PoolInstantBookingParams', min_hours_in_advance?: number | null, require_verified: boolean } | null }, listingOnboardingScreen:
    | { __typename: 'GetListingOnboardingScreenResponse', listingOnboardingScreen: { __typename: 'ListingOnboardingScreen', id: string, onboardingScreen: { __typename: 'OnboardingScreen', id: string, readProperties?: Array<{ __typename: 'ListingTypeReadProperty', fieldName: string, label: string, sublabel: string, category?: ListingTypePropertiesCategory | null, icon?: ListingTypePropertyIcon | null, linked_field?: string | null, value: string }> | null } } }
    | { __typename: 'OnboardingScreenNotFoundError', message: string }
   };

export type GetGuestAccessSettingsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetGuestAccessSettingsQuery = { __typename: 'Query', myPool: { __typename: 'MyPool', id: string, host_interaction_setting?: HostInteractionSettings | null, special_access_instruction?: string | null, entry_method?: EntryMethod | null, share_access_timing?: ShareAccessTiming | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, access_photos: Array<{ __typename: 'PoolAccessPhoto', id: number, image_url: string } | null> } };

export type GetGuestCheckInSettingsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetGuestCheckInSettingsQuery = { __typename: 'Query', myPool: { __typename: 'MyPool', id: string, host_interaction_setting?: HostInteractionSettings | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null } };

export type GetListingGuestCountQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  input: GetDefaultMaxGuestCountTiersInput;
}>;


export type GetListingGuestCountQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, guests_pets_allowed?: boolean | null, pets_rule?: PetsRules | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null } | null, defaultMaxGuestCountTiers:
    | { __typename: 'GetDefaultMaxGuestCountTiersResponse', minRecommendedMaxGuestCount: number, defaultMaxGuestCount: number, listingType: ListingTypeNameEnum, tiers: Array<{ __typename: 'DefaultMaxGuestCountTier', id: string, listingTypeId: string, minGuestCount: number, maxGuestCount: number, isMostListings: boolean, isTopTenPerc: boolean, earningsText: string, earningsPerc: number }> }
    | { __typename: 'ListingNotFoundError' }
   };

export type GetListingSavedTitleAndDescriptionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  input: GetListingBrandingInput;
}>;


export type GetListingSavedTitleAndDescriptionQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, title: string, description?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', cover: boolean, url: string }> } | null, listingBranding:
    | { __typename: 'GetListingBrandingResponse', state: LoadingState, descriptions?: Array<{ __typename: 'BrandingItem', value: string }> | null, titles?: Array<{ __typename: 'BrandingItem', value: string }> | null }
    | { __typename: 'ListingNotFoundError', message: string }
   };

export type GetListingPromotionsQueryVariables = Exact<{
  input: GetListingPromotionsInput;
  listingId: Scalars['Int']['input'];
}>;


export type GetListingPromotionsQuery = { __typename: 'Query', listingPromotions:
    | { __typename: 'ListingNotFoundError', message: string }
    | { __typename: 'ListingOwnershipError', message: string }
    | { __typename: 'ListingPromotionsResponse', promotions: Array<{ __typename: 'ListingPromotion', promotionType: PromotionType, isEnabled: boolean, discountPercentage: number, title: string, icon: string, description: string }> }
  , poolPublic?: { __typename: 'PoolPublic', id: string, country_code?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null } | null };

export type GetListingBrandingQueryVariables = Exact<{
  input: GetListingBrandingInput;
}>;


export type GetListingBrandingQuery = { __typename: 'Query', listingBranding:
    | { __typename: 'GetListingBrandingResponse', state: LoadingState, titles?: Array<{ __typename: 'BrandingItem', value: string }> | null, descriptions?: Array<{ __typename: 'BrandingItem', value: string }> | null }
    | { __typename: 'ListingNotFoundError', message: string }
   };

export type GetListingLocationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetListingLocationQuery = { __typename: 'Query', myPool: { __typename: 'MyPool', id: string, latitude?: number | null, longitude?: number | null, full_address?: string | null, zip_code?: string | null, state?: string | null, street_number?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null } };

export type CreateListingMutationVariables = Exact<{
  data: CreateListingInput;
}>;


export type CreateListingMutation = { __typename: 'Mutation', createListing: { __typename: 'PoolIdResult', pool_id: string, status?: string | null, message?: string | null } };

export type ServerNextOnboardingScreensQueryVariables = Exact<{
  input: GetListingOnboardingScreensInput;
}>;


export type ServerNextOnboardingScreensQuery = { __typename: 'Query', listingOnboardingScreens: { __typename: 'GetListingOnboardingScreensResponse', listingOnboardingScreens: Array<{ __typename: 'ListingOnboardingScreen', id: string, isCompleted: boolean, onboardingScreen: { __typename: 'OnboardingScreen', id: string, name: OnboardingScreenName, title: string, order: number } }> } };

export type ServerListingCoverImageQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ServerListingCoverImageQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, title: string, description?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', cover: boolean, url: string }> } | null };

export type ServerListingDescriptionDataQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  input: GetListingBrandingInput;
}>;


export type ServerListingDescriptionDataQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, title: string, description?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null } | null, listingBranding:
    | { __typename: 'GetListingBrandingResponse', state: LoadingState, descriptions?: Array<{ __typename: 'BrandingItem', value: string }> | null }
    | { __typename: 'ListingNotFoundError', message: string }
   };

export type ServerDynamicFormListingQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ServerDynamicFormListingQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null } | null };

export type ServerBrandPreviewListingQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  listingId: Scalars['ID']['input'];
  input: ListingCompletenessInput;
  data: GetListingOnboardingScreenInput;
}>;


export type ServerBrandPreviewListingQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, city?: string | null, state?: string | null, title: string, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', cover: boolean, url: string }> } | null, listingDetails:
    | { __typename: 'GetListingDetailsResponse', listing:
        | { __typename: 'BasketballCourtListing' }
        | { __typename: 'HomeListing' }
        | { __typename: 'Listing' }
        | { __typename: 'PickleballCourtListing' }
        | { __typename: 'PoolListing', poolType?: string | null }
        | { __typename: 'TennisCourtListing' }
       }
    | { __typename: 'ListingNotFoundError' }
  , listingCompleteness: { __typename: 'ListingCompleteness', onboardingPercentageComplete: number }, listingOnboardingScreen:
    | { __typename: 'GetListingOnboardingScreenResponse', listingOnboardingScreen: { __typename: 'ListingOnboardingScreen', id: string, onboardingScreen: { __typename: 'OnboardingScreen', id: string, readProperties?: Array<{ __typename: 'ListingTypeReadProperty', fieldName: string, label: string, sublabel: string, category?: ListingTypePropertiesCategory | null, icon?: ListingTypePropertyIcon | null, linked_field?: string | null, value: string }> | null } } }
    | { __typename: 'OnboardingScreenNotFoundError', message: string }
   };

export type ServerOnboardingPricingTiersQueryVariables = Exact<{
  listingId: Scalars['Int']['input'];
  listingIdString: Scalars['ID']['input'];
}>;


export type ServerOnboardingPricingTiersQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, latitude_round?: number | null, longitude_round?: number | null, country_code?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, currentPoolPrice?: { __typename: 'PoolPrice', hourly_price?: number | null } | null } | null, defaultAvailablePriceTiers: Array<{ __typename: 'DefaultPriceTiersResult', id: number, title: string, minGuests: number, maxGuests: number, defaultPrice: number }> };

export type ServerOnboardingBasePriceQueryVariables = Exact<{
  basePriceInput: GetBasePriceInput;
}>;


export type ServerOnboardingBasePriceQuery = { __typename: 'Query', basePrice:
    | { __typename: 'GetBasePriceResponse', recommendedMin: number, recommendedMax: number, targetPriceMajor: number, minimumPrice: number, incrementMajor: number }
    | { __typename: 'ListingNotFoundError', message: string }
   };

export type ServerReadyToContinueScreensQueryVariables = Exact<{
  input: GetListingOnboardingScreensInput;
  id: Scalars['Int']['input'];
  listingId: Scalars['ID']['input'];
  completenessInput: ListingCompletenessInput;
}>;


export type ServerReadyToContinueScreensQuery = { __typename: 'Query', listingOnboardingScreens: { __typename: 'GetListingOnboardingScreensResponse', listingOnboardingScreens: Array<{ __typename: 'ListingOnboardingScreen', id: string, isCompleted: boolean, onboardingScreen: { __typename: 'OnboardingScreen', id: string, name: OnboardingScreenName, title: string, order: number } }> }, listingCompleteness: { __typename: 'ListingCompleteness', onboardingPercentageComplete: number }, poolPublic?: { __typename: 'PoolPublic', id: string, city?: string | null, state?: string | null, country_code?: string | null, title: string, max_guests?: number | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', cover: boolean, url: string }>, currentPoolPrice?: { __typename: 'PoolPrice', price_tiers?: Array<{ __typename: 'PoolPriceTier', max_guests: number, hourly_price: number } | null> | null } | null } | null, listingDetails:
    | { __typename: 'GetListingDetailsResponse', listing:
        | { __typename: 'BasketballCourtListing' }
        | { __typename: 'HomeListing' }
        | { __typename: 'Listing' }
        | { __typename: 'PickleballCourtListing' }
        | { __typename: 'PoolListing', poolType?: string | null }
        | { __typename: 'TennisCourtListing' }
       }
    | { __typename: 'ListingNotFoundError' }
   };

export type ServerPhaseFourPreviewQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  listingId: Scalars['ID']['input'];
  data: GetListingOnboardingScreenInput;
}>;


export type ServerPhaseFourPreviewQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, city?: string | null, state?: string | null, zip_code?: string | null, country_code?: string | null, title: string, max_guests?: number | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', cover: boolean, url: string }>, currentPoolPrice?: { __typename: 'PoolPrice', price_tiers?: Array<{ __typename: 'PoolPriceTier', max_guests: number, hourly_price: number } | null> | null } | null } | null, listingDetails:
    | { __typename: 'GetListingDetailsResponse', listing:
        | { __typename: 'BasketballCourtListing' }
        | { __typename: 'HomeListing' }
        | { __typename: 'Listing' }
        | { __typename: 'PickleballCourtListing' }
        | { __typename: 'PoolListing', poolType?: string | null }
        | { __typename: 'TennisCourtListing' }
       }
    | { __typename: 'ListingNotFoundError' }
  , listingOnboardingScreen:
    | { __typename: 'GetListingOnboardingScreenResponse', listingOnboardingScreen: { __typename: 'ListingOnboardingScreen', id: string, onboardingScreen: { __typename: 'OnboardingScreen', id: string, readProperties?: Array<{ __typename: 'ListingTypeReadProperty', fieldName: string, label: string, sublabel: string, category?: ListingTypePropertiesCategory | null, icon?: ListingTypePropertyIcon | null, linked_field?: string | null, value: string }> | null } } }
    | { __typename: 'OnboardingScreenNotFoundError', message: string }
   };

export type NearMeSearchQueryVariables = Exact<{
  data: DynamicSearchInput;
}>;


export type NearMeSearchQuery = { __typename: 'Query', dynamicSearch: { __typename: 'DynamicSearchResponse', data: Array<{ __typename: 'SearchPool', id: string, country_code?: string | null, image_urls?: Array<string | null> | null, cover_image_url?: string | null, video_thumbnail_url?: string | null, is_quality: boolean, badges?: Array<string | null> | null, city: string, listing_type: ListingType, rating?: number | null, nextAvailableDay?: any | null, reviewsCount: number, latitude_round?: number | null, longitude_round?: number | null, pricing: { __typename: 'SearchPoolPricing', pricing_scheme: PricingScheme, price: number, discounted_price: number, featured_promo_code_percent: number, grand_opening_discount_percent: number } } | null> } };

export type ScreenPropertiesQueryVariables = Exact<{
  input: GetScreenPropertiesInput;
}>;


export type ScreenPropertiesQuery = { __typename: 'Query', screenProperties: { __typename: 'GetScreenPropertiesResponse', copy: Array<{ __typename: 'KeyValueEntry', key: string, value: string }>, properties: Array<{ __typename: 'KeyValueEntry', key: string, value: string }> } };

export type ListingPreviewQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  listingId: Scalars['ID']['input'];
}>;


export type ListingPreviewQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, title: string, city?: string | null, state?: string | null, pause_end?: any | null, max_guests?: number | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, images: Array<{ __typename: 'PoolImage', id?: string | null, url: string, cover: boolean }> } | null, listingDetails:
    | { __typename: 'GetListingDetailsResponse', listing:
        | { __typename: 'BasketballCourtListing', id: string, restroomAccessType?: RestroomAccessType | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, courtCount?: string | null, courtSurface?: string | null, courtSize?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, basketballCourtSpaceFeatures: Array<{ __typename: 'BasketballCourtSpaceFeature', value: string, icon: string }> }
        | { __typename: 'HomeListing', id: string, homeType?: string | null, availableRestrooms?: number | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, spaceArea?: number | null, restroomAccessType?: RestroomAccessType | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, homeFeatures: Array<{ __typename: 'HomeFeature', value: string, icon: string }>, homeSpaceFeatures: Array<{ __typename: 'HomeSpaceFeature', value: string, icon: string }> }
        | { __typename: 'Listing', id: string, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, restroomAccessType?: RestroomAccessType | null, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null }
        | { __typename: 'PickleballCourtListing', id: string, restroomAccessType?: RestroomAccessType | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, netType?: string | null, courtCount?: string | null, courtSize?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, pickleballCourtSpaceFeatures: Array<{ __typename: 'PickleballCourtSpaceFeature', value: string, icon: string }> }
        | { __typename: 'PoolListing', id: string, restroomAccessType?: RestroomAccessType | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, spaceUseType?: string | null, poolLength?: number | null, poolWidth?: number | null, poolDeepEndSize?: number | null, poolShallowEndSize?: number | null, poolType?: string | null, waterSystem?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, poolFeatures: Array<{ __typename: 'PoolFeature', value: string, icon: string }>, poolSpaceFeatures: Array<{ __typename: 'PoolSpaceFeature', value: string, icon: string }> }
        | { __typename: 'TennisCourtListing', id: string, restroomAccessType?: RestroomAccessType | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, courtCount?: string | null, courtSurface?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, tennisCourtSpaceFeatures: Array<{ __typename: 'TennisCourtSpaceFeature', value: string, icon: string }> }
       }
    | { __typename: 'ListingNotFoundError', message: string }
  , defaultMaxGuestCountTiers:
    | { __typename: 'GetDefaultMaxGuestCountTiersResponse', minRecommendedMaxGuestCount: number, defaultMaxGuestCount: number, listingType: ListingTypeNameEnum }
    | { __typename: 'ListingNotFoundError' }
   };

export type GetOnboardingListingPhotosQueryV2QueryVariables = Exact<{
  id: Scalars['Int']['input'];
  data: GetListingOnboardingScreenInput;
}>;


export type GetOnboardingListingPhotosQueryV2Query = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', title: string, enable?: boolean | null } | null> | null } | null, listingOnboardingScreen:
    | { __typename: 'GetListingOnboardingScreenResponse', listingOnboardingScreen: { __typename: 'ListingOnboardingScreen', id: string, onboardingScreen: { __typename: 'OnboardingScreen', id: string, readProperties?: Array<{ __typename: 'ListingTypeReadProperty', fieldName: string, label: string, sublabel: string, category?: ListingTypePropertiesCategory | null, icon?: ListingTypePropertyIcon | null, linked_field?: string | null, value: string }> | null } } }
    | { __typename: 'OnboardingScreenNotFoundError', message: string }
   };

export type ExemplaryHostsForOnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type ExemplaryHostsForOnboardingQuery = { __typename: 'Query', exemplaryHostsForOnboarding: { __typename: 'GetExemplaryHostsForOnboardingResponse', listings: Array<{ __typename: 'ExemplaryHostListing', title: string, hostName: string, coverPhoto: string, accentShots: Array<string>, loungeAreas: Array<string>, additionalSpaces: Array<string>, amenities: Array<string> }> } };

export type SaveListingTypeMutationVariables = Exact<{
  data: ListingTypeInput;
}>;


export type SaveListingTypeMutation = { __typename: 'Mutation', saveListingType: { __typename: 'SaveListingDataResult', status: string, message: string } };

export type SetListingPromotionsMutationVariables = Exact<{
  input: SetListingPromotionsInput;
}>;


export type SetListingPromotionsMutation = { __typename: 'Mutation', setListingPromotions:
    | { __typename: 'InvalidPromotionDataError', message: string }
    | { __typename: 'ListingNotFoundError', message: string }
    | { __typename: 'ListingOwnershipError', message: string }
    | { __typename: 'ListingPromotionsResponse', promotions: Array<{ __typename: 'ListingPromotion', promotionType: PromotionType, isEnabled: boolean, discountPercentage: number }> }
   };

export type SetStartDateMutationVariables = Exact<{
  input: SetStartDateInput;
}>;


export type SetStartDateMutation = { __typename: 'Mutation', setStartDate:
    | { __typename: 'ListingNotFoundError', message: string }
    | { __typename: 'ListingOwnershipError', message: string }
    | { __typename: 'SetStartDateResponse', result: { __typename: 'MutationResult', succeeded: boolean } }
   };

export type ReportListingMutationVariables = Exact<{
  reason: Scalars['String']['input'];
  listingId: Scalars['ID']['input'];
}>;


export type ReportListingMutation = { __typename: 'Mutation', reportListing: { __typename: 'ReportListingResult', succeeded: boolean } };

export type AdditionalDetailsResponseFragment = { __typename: 'GetListingDetailsResponse', listing:
    | { __typename: 'BasketballCourtListing', id: string, restroomAccessType?: RestroomAccessType | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, courtCount?: string | null, courtSurface?: string | null, courtSize?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, basketballCourtSpaceFeatures: Array<{ __typename: 'BasketballCourtSpaceFeature', value: string, icon: string }> }
    | { __typename: 'HomeListing', id: string, homeType?: string | null, availableRestrooms?: number | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, spaceArea?: number | null, restroomAccessType?: RestroomAccessType | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, homeFeatures: Array<{ __typename: 'HomeFeature', value: string, icon: string }>, homeSpaceFeatures: Array<{ __typename: 'HomeSpaceFeature', value: string, icon: string }> }
    | { __typename: 'Listing', id: string, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, restroomAccessType?: RestroomAccessType | null, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null }
    | { __typename: 'PickleballCourtListing', id: string, restroomAccessType?: RestroomAccessType | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, netType?: string | null, courtCount?: string | null, courtSize?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, pickleballCourtSpaceFeatures: Array<{ __typename: 'PickleballCourtSpaceFeature', value: string, icon: string }> }
    | { __typename: 'PoolListing', id: string, restroomAccessType?: RestroomAccessType | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, spaceUseType?: string | null, poolLength?: number | null, poolWidth?: number | null, poolDeepEndSize?: number | null, poolShallowEndSize?: number | null, poolType?: string | null, waterSystem?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, poolFeatures: Array<{ __typename: 'PoolFeature', value: string, icon: string }>, poolSpaceFeatures: Array<{ __typename: 'PoolSpaceFeature', value: string, icon: string }> }
    | { __typename: 'TennisCourtListing', id: string, restroomAccessType?: RestroomAccessType | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, courtCount?: string | null, courtSurface?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, tennisCourtSpaceFeatures: Array<{ __typename: 'TennisCourtSpaceFeature', value: string, icon: string }> }
   };

export type AdditionalListingDetailsQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type AdditionalListingDetailsQuery = { __typename: 'Query', listingDetails:
    | { __typename: 'GetListingDetailsResponse', listing:
        | { __typename: 'BasketballCourtListing', id: string, restroomAccessType?: RestroomAccessType | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, courtCount?: string | null, courtSurface?: string | null, courtSize?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, basketballCourtSpaceFeatures: Array<{ __typename: 'BasketballCourtSpaceFeature', value: string, icon: string }> }
        | { __typename: 'HomeListing', id: string, homeType?: string | null, availableRestrooms?: number | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, spaceArea?: number | null, restroomAccessType?: RestroomAccessType | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, homeFeatures: Array<{ __typename: 'HomeFeature', value: string, icon: string }>, homeSpaceFeatures: Array<{ __typename: 'HomeSpaceFeature', value: string, icon: string }> }
        | { __typename: 'Listing', id: string, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, restroomAccessType?: RestroomAccessType | null, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null }
        | { __typename: 'PickleballCourtListing', id: string, restroomAccessType?: RestroomAccessType | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, netType?: string | null, courtCount?: string | null, courtSize?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, pickleballCourtSpaceFeatures: Array<{ __typename: 'PickleballCourtSpaceFeature', value: string, icon: string }> }
        | { __typename: 'PoolListing', id: string, restroomAccessType?: RestroomAccessType | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, spaceUseType?: string | null, poolLength?: number | null, poolWidth?: number | null, poolDeepEndSize?: number | null, poolShallowEndSize?: number | null, poolType?: string | null, waterSystem?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, poolFeatures: Array<{ __typename: 'PoolFeature', value: string, icon: string }>, poolSpaceFeatures: Array<{ __typename: 'PoolSpaceFeature', value: string, icon: string }> }
        | { __typename: 'TennisCourtListing', id: string, restroomAccessType?: RestroomAccessType | null, isInstantBook: boolean, isTopListing: boolean, isFanFavorite: boolean, numberOfParkingSpaces?: number | null, parkingContext?: string | null, parkingOptions?: Array<string> | null, stickers: Array<string>, spaceUseType?: string | null, isAdaFriendly?: boolean | null, accessibilityInfo?: string | null, courtCount?: string | null, courtSurface?: string | null, listingType: { __typename: 'ListingTypeEntity', id: string, name: ListingTypeNameEnum, label: string }, privacy?: { __typename: 'Privacy', value: string, description: string } | null, tennisCourtSpaceFeatures: Array<{ __typename: 'TennisCourtSpaceFeature', value: string, icon: string }> }
       }
    | { __typename: 'ListingNotFoundError', message: string }
   };

export type ListingAvailabilityServerFragment = { __typename: 'PoolPublic', id: string, status: number, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, advance_notice?: number | null, default_instant_booking: boolean, instant_group_size?: number | null, time_zone?: string | null, pause_start?: any | null, pause_end?: any | null };

export type ListingPricingServerFragment = { __typename: 'PoolPublic', id: string, country_code?: string | null, user?: { __typename: 'UserPublic', id: string, firstname?: string | null } | null, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, featuredPromo?: { __typename: 'FeaturedPromoCode', id: number, promo_code: string, percent_off: number, max_redemptions: number, redeem_by: any, times_redeemed: number, can_redeem: boolean } | null };

export type ServerListingDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ServerListingDetailsQuery = { __typename: 'Query', listing?: { __typename: 'PoolPublic', id: string, custom_listing_type?: string | null, title: string, city?: string | null, state?: string | null, latitude_round?: number | null, longitude_round?: number | null, rating?: number | null, reviewsCount: number, description?: string | null, host_interaction_setting?: HostInteractionSettings | null, tour_360_url?: string | null, is_security_cameras?: boolean | null, additional_rules?: string | null, country_code?: string | null, video_thumbnail_url?: string | null, video_playback_url?: string | null, should_show_guest_banner: boolean, should_show_photo_banner: boolean, stealth_mode: boolean, badges?: Array<string> | null, per_guest_pricing?: number | null, status: number, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, advance_notice?: number | null, default_instant_booking: boolean, instant_group_size?: number | null, time_zone?: string | null, pause_start?: any | null, pause_end?: any | null, securityDepositMinGuests?: number | null, securityDepositMinor?: number | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, cancellation_policy?: { __typename: 'CancellationPolicy', id: string, hours: string } | null, rule_settings: Array<{ __typename: 'RuleSetting', id: number, slug: string, name: string, icon: RuleIcon, active: boolean, description?: string | null, is_allowed?: boolean | null } | null>, user?: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, description?: string | null, created_at: any, is_pro_host: boolean, is_verified: boolean } | null, images: Array<{ __typename: 'PoolImage', id?: string | null, cover: boolean, url: string }>, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, enable?: boolean | null, pool_id: number, amenity?: { __typename: 'Amenity', name: string, id: string, active: boolean } | null } | null> | null, response_time: { __typename: 'PoolResponseTime', response_time_text?: string | null }, instagram_images: Array<{ __typename: 'InstagramImage', id: string, url: string } | null>, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, featuredPromo?: { __typename: 'FeaturedPromoCode', id: number, promo_code: string, percent_off: number, max_redemptions: number, redeem_by: any, times_redeemed: number, can_redeem: boolean } | null } | null };

export type MessageFragment = { __typename: 'MessageEntity', id: string, senderId: string, receiverId: string, bookingId?: string | null, message: string, roomId: string, readAt?: any | null, createdAt: any, updatedAt?: any | null, type: TypeMessage, typeSystemMessage?: TypeSystemMessage | null, automated: boolean, metadata?:
    | { __typename: 'BookingMessageMetadata', bookingId: string, listingId: string, hostId: string }
    | { __typename: 'FansMessageMetadata', promoCodeId: string, listingId: string, listingTitle: string, listingPhoto: string, listingStealthMode?: boolean | null, promoCode: string, promoCodeExpireAt: any, promoCodeOffType: string, promoCodeOffAmount: number }
    | { __typename: 'SpecialOfferMessageMetadata', specialOfferId: string, listingId: string, hostId: string }
   | null };

export type ConversationQueryVariables = Exact<{
  input: ConversationInput;
}>;


export type ConversationQuery = { __typename: 'Query', conversation:
    | { __typename: 'ConversationResponse', roomId: string, messages: Array<{ __typename: 'MessageEntity', id: string, senderId: string, receiverId: string, bookingId?: string | null, message: string, roomId: string, readAt?: any | null, createdAt: any, updatedAt?: any | null, type: TypeMessage, typeSystemMessage?: TypeSystemMessage | null, automated: boolean, metadata?:
          | { __typename: 'BookingMessageMetadata', bookingId: string, listingId: string, hostId: string }
          | { __typename: 'FansMessageMetadata', promoCodeId: string, listingId: string, listingTitle: string, listingPhoto: string, listingStealthMode?: boolean | null, promoCode: string, promoCodeExpireAt: any, promoCodeOffType: string, promoCodeOffAmount: number }
          | { __typename: 'SpecialOfferMessageMetadata', specialOfferId: string, listingId: string, hostId: string }
         | null }>, participant: { __typename: 'UserEntity', id: string, firstName: string, lastName: string, imageUrl: string } }
    | { __typename: 'ConversationUserNotFoundError' }
   };

export type ConversationListQueryVariables = Exact<{
  input: ConversationListInput;
}>;


export type ConversationListQuery = { __typename: 'Query', conversationList: { __typename: 'ConversationListResponse', conversationListItems: Array<{ __typename: 'ConversationListItem', message: { __typename: 'MessageEntity', id: string, senderId: string, receiverId: string, bookingId?: string | null, message: string, roomId: string, readAt?: any | null, createdAt: any, updatedAt?: any | null, type: TypeMessage, typeSystemMessage?: TypeSystemMessage | null, automated: boolean, metadata?:
          | { __typename: 'BookingMessageMetadata', bookingId: string, listingId: string, hostId: string }
          | { __typename: 'FansMessageMetadata', promoCodeId: string, listingId: string, listingTitle: string, listingPhoto: string, listingStealthMode?: boolean | null, promoCode: string, promoCodeExpireAt: any, promoCodeOffType: string, promoCodeOffAmount: number }
          | { __typename: 'SpecialOfferMessageMetadata', specialOfferId: string, listingId: string, hostId: string }
         | null }, participant: { __typename: 'UserEntity', id: string, firstName: string, lastName: string, imageUrl: string }, bookingForChat?: { __typename: 'ConversationListItemBooking', bookingId: string, guestId: string, hostId: string, status: ConversationListItemBookingStatus, startDateUtc: any, listingTimeZone: string, canGuestReview: boolean, canHostReview: boolean, listingId: string, listingStealthMode?: boolean | null } | null }> } };

export type ReadMessagesMutationVariables = Exact<{
  input: ReadMessagesInput;
}>;


export type ReadMessagesMutation = { __typename: 'Mutation', readMessages: { __typename: 'ReadMessagesResponse', succeeded: boolean } };

export type SendMessageMutationVariables = Exact<{
  input: SendMessageInput;
}>;


export type SendMessageMutation = { __typename: 'Mutation', sendMessage:
    | { __typename: 'ConversationBlockedError' }
    | { __typename: 'SendMessageResponse', succeeded: boolean, message: { __typename: 'MessageEntity', id: string, senderId: string, receiverId: string, bookingId?: string | null, message: string, roomId: string, readAt?: any | null, createdAt: any, updatedAt?: any | null, type: TypeMessage, typeSystemMessage?: TypeSystemMessage | null, automated: boolean, metadata?:
          | { __typename: 'BookingMessageMetadata', bookingId: string, listingId: string, hostId: string }
          | { __typename: 'FansMessageMetadata', promoCodeId: string, listingId: string, listingTitle: string, listingPhoto: string, listingStealthMode?: boolean | null, promoCode: string, promoCodeExpireAt: any, promoCodeOffType: string, promoCodeOffAmount: number }
          | { __typename: 'SpecialOfferMessageMetadata', specialOfferId: string, listingId: string, hostId: string }
         | null } }
   };

export type MarkUnreadMutationVariables = Exact<{
  input: MarkUnreadInput;
}>;


export type MarkUnreadMutation = { __typename: 'Mutation', markUnread: { __typename: 'MarkUnreadResponse', succeeded: boolean } };

export type ChatBookingFragment = { __typename: 'Booking', id: string, status: number, status_name: BookingStatusEnum, start_datetime_utc: any, end_datetime_utc: any, swimmer_review?: boolean | null, host_review?: boolean | null, adultGuests?: number | null, childrenGuests?: number | null, infantGuests?: number | null, petGuests?: number | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string, booking_id: string, status: BookingSpecialOfferStatus, start_datetime_utc: any, end_datetime_utc: any, special_offer_price: number, note: string, created_at: any, expiration_datetime_utc?: any | null, adultGuests: number, childrenGuests: number, infantGuests: number, petGuests: number, premiumAmenities: Array<{ __typename: 'BookingSpecialOfferPremiumAmenity', poolPremiumAmenity: { __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } }> } | null, listing: { __typename: 'PoolPrivate', stealth_mode: boolean, id: string, title: string, time_zone?: string | null, city?: string | null, status: number, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, available_from?: string | null, available_to?: string | null, default_instant_booking: boolean, min_booking_length?: number | null, timeZone?: string | null, countryCode?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean, pool_id: number, id?: string | null }>, createdBy?: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, isProHost: boolean, createdAt: any } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null }, booking_update_request?: { __typename: 'BookingUpdatedRequest', id?: number | null } | null, amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, userPublic: { __typename: 'UserPublic', id: string, firstname?: string | null, rating?: number | null, img_url?: string | null, created_at: any, reviewsCount: number } };

export type ListingMessageTemplatesForChatQueryVariables = Exact<{
  input: GetListingMessageTemplatesForChatInput;
}>;


export type ListingMessageTemplatesForChatQuery = { __typename: 'Query', listingMessageTemplatesForChat: Array<{ __typename: 'ListingMessageTemplate', id?: string | null, listingId: number, eventName?: AutomatedMessageEventType | null, messageTitle?: string | null, messageContent?: string | null, isConfigured: boolean, enabled: boolean, title: string, eventDescription: string, icon: string }> };

export type ChatBookingQueryVariables = Exact<{
  data: BookingForChatInput;
}>;


export type ChatBookingQuery = { __typename: 'Query', getBookingForChat: { __typename: 'GetBookingForChatResponse', canCreateSpecialOffer: boolean, booking?: { __typename: 'Booking', id: string, status: number, status_name: BookingStatusEnum, start_datetime_utc: any, end_datetime_utc: any, swimmer_review?: boolean | null, host_review?: boolean | null, adultGuests?: number | null, childrenGuests?: number | null, infantGuests?: number | null, petGuests?: number | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string, booking_id: string, status: BookingSpecialOfferStatus, start_datetime_utc: any, end_datetime_utc: any, special_offer_price: number, note: string, created_at: any, expiration_datetime_utc?: any | null, adultGuests: number, childrenGuests: number, infantGuests: number, petGuests: number, premiumAmenities: Array<{ __typename: 'BookingSpecialOfferPremiumAmenity', poolPremiumAmenity: { __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } }> } | null, listing: { __typename: 'PoolPrivate', stealth_mode: boolean, id: string, title: string, time_zone?: string | null, city?: string | null, status: number, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, available_from?: string | null, available_to?: string | null, default_instant_booking: boolean, min_booking_length?: number | null, timeZone?: string | null, countryCode?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean, pool_id: number, id?: string | null }>, createdBy?: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, isProHost: boolean, createdAt: any } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null }, booking_update_request?: { __typename: 'BookingUpdatedRequest', id?: number | null } | null, amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, userPublic: { __typename: 'UserPublic', id: string, firstname?: string | null, rating?: number | null, img_url?: string | null, created_at: any, reviewsCount: number } } | null } };

export type InquiryPricingSummaryQueryVariables = Exact<{
  data: PricingSummaryInput;
}>;


export type InquiryPricingSummaryQuery = { __typename: 'Query', pricingSummary: { __typename: 'PricingSummary', subtotal: number, host_earnings: number, guest_price: number, base_pricing: { __typename: 'BasePricing', amount: number } } };

export type BlockUserMutationVariables = Exact<{
  data: BlockUserInput;
}>;


export type BlockUserMutation = { __typename: 'Mutation', blockUser: { __typename: 'BlockUserResult', meUser: { __typename: 'Me', blocked_user_ids: Array<number>, blocked_by_user_ids: Array<number> } } };

export type BookingRefundInfoQueryVariables = Exact<{
  bookingId: Scalars['Int']['input'];
}>;


export type BookingRefundInfoQuery = { __typename: 'Query', booking?: { __typename: 'Booking', id: string, reservation_price_total: number, listing: { __typename: 'PoolPrivate', countryCode?: string | null }, paymentBreakdown: Array<{ __typename: 'PaymentBreakdownDisplayItem', displayLine: string, icon: string, paymentMethod: PaymentMethod, amount: number }>, hostCancellation?: { __typename: 'BookingHostCancellation', id?: number | null, note?: string | null, createdAt?: any | null, guestCompensation?: GuestCompensation | null } | null } | null };

export type SelectRefundOptionMutationVariables = Exact<{
  data: SelectHostCancellationCompensationInput;
}>;


export type SelectRefundOptionMutation = { __typename: 'Mutation', selectRefundOption?: { __typename: 'SelectHostCancellationCompensationResult', status: string, message: string } | null };

export type ReservationRefundFragment = { __typename: 'ReservationRefundDetails', alreadyRefunded?: { __typename: 'AlreadyRefunded', chargesRefundAmount: number, creditsRefundAmount: number, totalRefundAmount: number } | null, availableRefund?: { __typename: 'AvailableRefund', chargesToRefund: number, creditsToRefund: number, fullRefund: boolean, klarnaFees: number, serviceFeesInCredits: number, totalRefundAmount: number } | null };

export type ReservationRefundDetailsCashQueryVariables = Exact<{
  bookingId: Scalars['Int']['input'];
  refundType?: InputMaybe<RefundType>;
}>;


export type ReservationRefundDetailsCashQuery = { __typename: 'Query', reservationRefundDetails: { __typename: 'ReservationRefundDetails', alreadyRefunded?: { __typename: 'AlreadyRefunded', chargesRefundAmount: number, creditsRefundAmount: number, totalRefundAmount: number } | null, availableRefund?: { __typename: 'AvailableRefund', chargesToRefund: number, creditsToRefund: number, fullRefund: boolean, klarnaFees: number, serviceFeesInCredits: number, totalRefundAmount: number } | null } };

export type ReservationRefundDetailsCreditsQueryVariables = Exact<{
  bookingId: Scalars['Int']['input'];
  refundType?: InputMaybe<RefundType>;
}>;


export type ReservationRefundDetailsCreditsQuery = { __typename: 'Query', reservationRefundDetails: { __typename: 'ReservationRefundDetails', alreadyRefunded?: { __typename: 'AlreadyRefunded', chargesRefundAmount: number, creditsRefundAmount: number, totalRefundAmount: number } | null, availableRefund?: { __typename: 'AvailableRefund', chargesToRefund: number, creditsToRefund: number, fullRefund: boolean, klarnaFees: number, serviceFeesInCredits: number, totalRefundAmount: number } | null } };

export type NotificationSettingFragment = { __typename: 'NotificationSetting', channel: NotificationChannel, isOptedIn: boolean, subscriptionGroupId?: string | null };

export type NotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationSettingsQuery = { __typename: 'Query', notificationSettings: Array<{ __typename: 'NotificationSetting', channel: NotificationChannel, isOptedIn: boolean, subscriptionGroupId?: string | null } | null> };

export type UpdateNotificationSettingsMutationVariables = Exact<{
  data: UpdateNotificationSettingsInput;
}>;


export type UpdateNotificationSettingsMutation = { __typename: 'Mutation', updateNotificationSettings: Array<{ __typename: 'NotificationSetting', channel: NotificationChannel, isOptedIn: boolean, subscriptionGroupId?: string | null } | null> };

export type UpdateListingPropertiesMutationVariables = Exact<{
  data: UpdateListingPropertiesInput;
}>;


export type UpdateListingPropertiesMutation = { __typename: 'Mutation', updateListingProperties:
    | { __typename: 'ListingNotFoundError', message: string }
    | { __typename: 'UpdateListingPropertiesResponse', properties: Array<{ __typename: 'ListingTypeProperty', id: string, value: string, fieldName: string }> }
   };

export type ListingSeasonalAvailabilityQueryVariables = Exact<{
  data: ListingSeasonalAvailabilityInput;
}>;


export type ListingSeasonalAvailabilityQuery = { __typename: 'Query', listingSeasonalAvailability: { __typename: 'ListingSeasonalAvailability', open_from: string, open_to: string, peak_demand_message: string } };

export type ListingMessageTemplatesQueryVariables = Exact<{
  input: GetListingMessageTemplatesInput;
}>;


export type ListingMessageTemplatesQuery = { __typename: 'Query', listingMessageTemplates: Array<{ __typename: 'ListingMessageTemplate', id?: string | null, listingId: number, eventName?: AutomatedMessageEventType | null, messageTitle?: string | null, messageContent?: string | null, isConfigured: boolean, enabled: boolean, title: string, eventDescription: string, icon: string }>, automatedMessageVariables: Array<{ __typename: 'AutomatedMessageVariable', key: string, displayName: string }> };

export type SaveListingMessageTemplateMutationVariables = Exact<{
  input: SaveListingMessageTemplateInput;
}>;


export type SaveListingMessageTemplateMutation = { __typename: 'Mutation', saveListingMessageTemplate: { __typename: 'ListingMessageTemplate', id?: string | null, listingId: number, eventName?: AutomatedMessageEventType | null, messageTitle?: string | null, messageContent?: string | null, isConfigured: boolean, enabled: boolean, title: string, eventDescription: string, icon: string } };

export type GetAutomatedMessageEventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAutomatedMessageEventTypesQuery = { __typename: 'Query', automatedMessageEventTypes: Array<{ __typename: 'AutomatedMessageEventTypeInfo', eventType: AutomatedMessageEventType, eventName: string, eventDescription: string }> };

export type ListingBookabilityScoreQueryVariables = Exact<{
  input: ListingBookabilityScoreInput;
}>;


export type ListingBookabilityScoreQuery = { __typename: 'Query', listingBookabilityScore: { __typename: 'ListingBookabilityScore', listingId: string, date: any, bookabilityScore: number, bookabilityScoreStatus: BookabilityScoreStatus, bookabilityScoreLabel: string, categories: Array<{ __typename: 'BookabilityCategoryScore', category: BookabilityCategory, categoryLabel: string, categoryScoreDescription: string, highestImpactOnSearch: boolean, score: number, icon: ManageItemIcon, statusCode: BookabilityScoreStatus, statusLabel: string, emptyTodosTabCopy: string, todos: Array<{ __typename: 'BookabilityTodoItem', icon: ManageItemIcon, title: string, content: string, potentialPoints?: number | null, highImpact: boolean, cta?: { __typename: 'BookabilityTodoCta', label: string, targetScreen: TargetScreen, customUrl?: string | null } | null }> }>, momentum: { __typename: 'BookabilityMomentum', message: string } } };

export type InsightsQueryVariables = Exact<{
  data: PerformanceOverviewInput;
}>;


export type InsightsQuery = { __typename: 'Query', performanceOverview: { __typename: 'PerformanceOverview', views?: number | null, bookings: number, earnings: number } };

export type GetHostServicesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetHostServicesQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', country_code?: string | null, enabled_host_services?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, advance_notice?: number | null, is_service_enabled?: boolean | null, is_service?: boolean | null, amenity?: { __typename: 'Amenity', id: string, icon: string, name: string } | null } | null> | null } | null };

export type SaveHostServicesMutationVariables = Exact<{
  poolId: Scalars['Int']['input'];
  data: Array<InputMaybe<HostServiceInput>> | InputMaybe<HostServiceInput>;
}>;


export type SaveHostServicesMutation = { __typename: 'Mutation', saveListingHostServices?: { __typename: 'PoolPremiumAmenityResponse', status?: string | null, message?: string | null, pool_premium_amenity?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, is_service_enabled?: boolean | null, price_type?: PriceTypeEnum | null, price_amount?: number | null } | null> | null } | null };

export type PassFormFragment = { __typename: 'PassFormV3', state: PassState, dayTypes: Array<DayType>, discount: number, hoursPerMonth: number, monthlyPricing: number, name: string, timeType: TimeType, type: PassType, maxGuests: number, passHolderCount: number, hourlyPrice: number, expirationType: PassExpirationType, defaultPassExpiration: string, timeRanges: Array<{ __typename: 'TimeTypeRange', timeRange: string, timeType: TimeType }> };

export type ReadPassFormQueryVariables = Exact<{
  input: ReadPassFormV3Input;
}>;


export type ReadPassFormQuery = { __typename: 'Query', readPassFormV3: Array<{ __typename: 'PassFormV3', state: PassState, dayTypes: Array<DayType>, discount: number, hoursPerMonth: number, monthlyPricing: number, name: string, timeType: TimeType, type: PassType, maxGuests: number, passHolderCount: number, hourlyPrice: number, expirationType: PassExpirationType, defaultPassExpiration: string, timeRanges: Array<{ __typename: 'TimeTypeRange', timeRange: string, timeType: TimeType }> }> };

export type SavePassFormMutationVariables = Exact<{
  input: SavePassV3Input;
}>;


export type SavePassFormMutation = { __typename: 'Mutation', savePassV3:
    | { __typename: 'InvalidPassError', message: string, userMessages?: Array<string> | null }
    | { __typename: 'PassFormV3', state: PassState, dayTypes: Array<DayType>, discount: number, hoursPerMonth: number, monthlyPricing: number, name: string, timeType: TimeType, type: PassType, maxGuests: number, passHolderCount: number, hourlyPrice: number, expirationType: PassExpirationType, defaultPassExpiration: string, timeRanges: Array<{ __typename: 'TimeTypeRange', timeRange: string, timeType: TimeType }> }
   };

export type ProToolCardFragment = { __typename: 'ProToolCard', unlockCondition?: string | null, isNew: boolean, isLocked: boolean, isElevated: boolean, isMobileButton: boolean, cta?: string | null, target: ProToolTarget, customUrl?: string | null, title: string, description: string };

export type ProQueryVariables = Exact<{
  input: ProInput;
}>;


export type ProQuery = { __typename: 'Query', pro: { __typename: 'Pro', default: ProDefaultTab, fans: { __typename: 'ProFansPage', name: string, fansInfo: { __typename: 'ProFans', title: string, profileImages: Array<string>, cards: Array<{ __typename: 'ProFanCard', icon: string, title: string }> }, reviews: { __typename: 'ProReviews', title: string, icon: string, hasReviews: boolean }, tools: { __typename: 'ProTools', title: string, icon: string, cards: Array<{ __typename: 'ProToolCard', unlockCondition?: string | null, isNew: boolean, isLocked: boolean, isElevated: boolean, isMobileButton: boolean, cta?: string | null, target: ProToolTarget, customUrl?: string | null, title: string, description: string }> }, tips: { __typename: 'ProMarketingTips', icon: string, title: string, cards: Array<{ __typename: 'ProMarketingTipCard', thumbnail: string, title: string, description: string, externalUrl: string }> }, shopPrompt: { __typename: 'ProShopPrompt', title: string, description: string, cta: string }, shop: { __typename: 'ProShop', title: string, cta: string, url: string, cards: Array<{ __typename: 'ProShopCard', title: string, description: string, media: string, url: string }> } }, marketing: { __typename: 'ProMarketingPage', name: string, title: string, description: string, share: { __typename: 'ProMarketingShare', title: string, link: string, subtitle: string, directBookings: string, cards: Array<{ __typename: 'ProMarketingShareCard', isMobile: boolean, isDesktop: boolean, isFull: boolean, title: string, icon: string, target: ProMarketingShareTarget, subject?: string | null, subjectPreview?: string | null, body?: string | null }> }, tools: { __typename: 'ProTools', title: string, icon: string, cards: Array<{ __typename: 'ProToolCard', unlockCondition?: string | null, isNew: boolean, isLocked: boolean, isElevated: boolean, isMobileButton: boolean, cta?: string | null, target: ProToolTarget, customUrl?: string | null, title: string, description: string }> }, marketContent: { __typename: 'ProMarketContent', icon: string, title: string, description: string, cards: Array<{ __typename: 'ProMarketContentCard', thumbnail: string, media: string }> }, tips: { __typename: 'ProMarketingTips', icon: string, title: string, cards: Array<{ __typename: 'ProMarketingTipCard', thumbnail: string, title: string, description: string, externalUrl: string }> } } } };

export type GetManageGuestsQueryVariables = Exact<{
  input: ManageGuestsInput;
}>;


export type GetManageGuestsQuery = { __typename: 'Query', manageGuests: { __typename: 'ManageGuestsPaginatedResult', data: Array<{ __typename: 'ManageGuestCard', bookingCount: string, isFavorite: boolean, lastVisit?: string | null, totalSpent: string, passType?: PassesType | null, passHolderLabel?: string | null, user: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null } }>, paginatorInfo: { __typename: 'MyPaginatorInfo', count?: number | null, offset?: number | null, hasMoreItems?: boolean | null, total?: number | null } } };

export type GetManageGuestQueryVariables = Exact<{
  input: GuestInput;
}>;


export type GetManageGuestQuery = { __typename: 'Query', guestDetails: { __typename: 'GuestDetail', isFavorite: boolean, note?: string | null, recentReviews: Array<{ __typename: 'HostReviewSummary', id: string, comment?: string | null, rating: number, name?: string | null, profileImage?: string | null, reason?: string | null, reasonIcon?: string | null, relativeTime?: string | null }>, stats: Array<{ __typename: 'GuestStatRow', label: string, value: string }>, user: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, description?: string | null } } };

export type AddGuestAsFavoriteMutationVariables = Exact<{
  input: AddGuestAsFavoriteInput;
}>;


export type AddGuestAsFavoriteMutation = { __typename: 'Mutation', addGuestAsFavorite: { __typename: 'GuestFavoriteResult', success: boolean } };

export type RemoveGuestFromFavoritesMutationVariables = Exact<{
  input: RemoveGuestFromFavoritesInput;
}>;


export type RemoveGuestFromFavoritesMutation = { __typename: 'Mutation', removeGuestFromFavorites: { __typename: 'GuestFavoriteResult', success: boolean } };

export type SaveGuestNoteMutationVariables = Exact<{
  input: SaveGuestNoteInput;
}>;


export type SaveGuestNoteMutation = { __typename: 'Mutation', saveGuestNote: { __typename: 'SaveGuestNoteResult', success: boolean } };

export type GetListingSavedTitleQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetListingSavedTitleQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, title: string, description?: string | null } | null };

export type HostSettingsListingPropertiesQueryVariables = Exact<{
  data: GetListingTypePropertiesInput;
  listingId: Scalars['Int']['input'];
  __skipPoolPublic: Scalars['Boolean']['input'];
}>;


export type HostSettingsListingPropertiesQuery = { __typename: 'Query', poolPublic?: { __typename: 'PoolPublic', id: string, custom_listing_type?: string | null, pets_rule?: PetsRules | null } | null, listingProperties:
    | { __typename: 'GetListingTypePropertiesResponse', listingTypeName: ListingTypeNameEnum, properties: Array<{ __typename: 'ListingTypeProperty', id: string, icon?: ListingTypePropertyIcon | null, listingTypeId: string, category: ListingTypePropertiesCategory, fieldName: string, label: string, sublabel: string, isRequired: boolean, dataType: ListingTypePropertiesDataType, displayType: ListingTypePropertiesDisplayType, value: string, defaultValue: string, displayOrder: number, options?: Array<
          | { __typename: 'CardSelectorOptions', value: string, iconWrapperColor: string, title: string, requiredDescription: string, requiredIcon: ListingTypePropertyIcon }
          | { __typename: 'DropdownOptions', label?: string | null, unitType?: string | null, selectOptions?: Array<{ __typename: 'SelectOption', value: string, description?: string | null }> | null }
          | { __typename: 'DropdownRelationshipOptions', minStart: number, maxStart: number, minEnd: number, maxEnd: number, labelStart: string, labelEnd: string, unitTypeStart: string, unitTypeEnd: string, titleStart?: string | null, titleEnd?: string | null, coupled?: boolean | null }
          | { __typename: 'GridSelectorOptions', label?: string | null, value: string, icon?: ListingTypePropertyIcon | null }
          | { __typename: 'HorizontalRadioSelectorOptions', label?: string | null, value: string, icon?: ListingTypePropertyIcon | null }
          | { __typename: 'MultiRadioSelectorOptions', label?: string | null, value: string, icon?: ListingTypePropertyIcon | null }
          | { __typename: 'PopupTextareaOptions', icon?: ListingTypePropertyIcon | null, popupTitle: string, placeholder: string, submit: string, trigger: string, triggerIcon?: string | null }
          | { __typename: 'RadioSelectorOptions', value: string, label?: string | null, description?: string | null, icon?: ListingTypePropertyIcon | null }
          | { __typename: 'RestroomSelectorOptions', value: string, label?: string | null, description?: string | null, image: string }
          | { __typename: 'StringOptions', value: string, label?: string | null, icon?: ListingTypePropertyIcon | null, count?: number | null, countable?: boolean | null, isHostService?: boolean | null }
          | { __typename: 'ToggleDropdownOptions' }
        > | null, displayTypeRules?:
          | { __typename: 'CardSelectorRules', webItemsPerRow: number, appItemsPerRow: number }
          | { __typename: 'DropdownRelationshipRules' }
          | { __typename: 'DropdownRules' }
          | { __typename: 'GridSelectorRules', rounded: boolean, webItemsPerRow: number, appItemsPerRow: number }
          | { __typename: 'HorizontalRadioSelectorRules', rounded: boolean }
          | { __typename: 'NumericInputRules', minValue?: number | null, maxValue?: number | null, measurement?: Measurement | null, icon?: ListingTypePropertyIcon | null, prefix?: string | null, suffix?: string | null }
          | { __typename: 'NumericSliderRules', minValue?: number | null, maxValue?: number | null, measurement?: Measurement | null, increments: number }
          | { __typename: 'PopupTextAreaRules' }
          | { __typename: 'QuantitySelectorRules', minValue?: number | null, maxValue?: number | null, suffix?: string | null }
          | { __typename: 'RadioSelectorRules', displayOnlyDescription?: boolean | null }
          | { __typename: 'TagSelectorRules', minValue?: number | null, maxValue?: number | null, inputPrompt: string }
          | { __typename: 'TextAreaInputRules', characterLimit: number, placeholder: string }
          | { __typename: 'ToggleDropdownRules' }
          | { __typename: 'ToggleSelectorRules' }
         | null }> }
    | { __typename: 'ListingNotFoundError', message: string }
   };

export type UseBoostMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
}>;


export type UseBoostMutation = { __typename: 'Mutation', useSearchBoost: { __typename: 'UseSearchBoostResult', status: string, success: boolean } };

export type SelectListingMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
}>;


export type SelectListingMutation = { __typename: 'Mutation', selectListing: { __typename: 'SelectListingResult', success: boolean } };

export type ManageListingItemFragment = { __typename: 'ManageItem', id: string, category?: ManageCategory | null, title: string, description: string, icon: ManageItemIcon, isComplete: boolean, isNew: boolean, isBeta: boolean, searchTerms?: string | null, targetScreen: TargetScreen, idempotencyKey?: string | null, customUrl?: string | null };

export type SetIdempotencyKeyMutationVariables = Exact<{
  key: Scalars['String']['input'];
  listingId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetIdempotencyKeyMutation = { __typename: 'Mutation', setIdempotencyKey: { __typename: 'SetIdempotencyKeyResult', success: boolean } };

export type ExitRehabMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
}>;


export type ExitRehabMutation = { __typename: 'Mutation', exitRehab: { __typename: 'ExitRehabResult', succeeded: boolean } };

export type ManageListingQueryVariables = Exact<{
  input: ManageListingInput;
  bookabilityScoreInput: ListingBookabilityScoreInput;
}>;


export type ManageListingQuery = { __typename: 'Query', manageListing: { __typename: 'ManageListing', emptyTodosTabCopy: string, percentageCompletion: number, manageList: Array<{ __typename: 'ManageItem', id: string, category?: ManageCategory | null, title: string, description: string, icon: ManageItemIcon, isComplete: boolean, isNew: boolean, isBeta: boolean, searchTerms?: string | null, targetScreen: TargetScreen, idempotencyKey?: string | null, customUrl?: string | null }>, todos: Array<{ __typename: 'ManageItem', id: string, category?: ManageCategory | null, title: string, description: string, icon: ManageItemIcon, isComplete: boolean, isNew: boolean, isBeta: boolean, searchTerms?: string | null, targetScreen: TargetScreen, idempotencyKey?: string | null, customUrl?: string | null }>, copy: Array<{ __typename: 'CopyEntry', key: string, value: string }>, categories: Array<{ __typename: 'ManageCategoryInfo', title: string, category: ManageCategory, isComplete: boolean }>, notifications: Array<{ __typename: 'NotificationItem', id: string, auto: boolean, autoIdempotencyKey?: string | null, description: string, title: string, target?: TargetScreen | null, visual: NotificationVisual }> }, listingBookabilityScore: { __typename: 'ListingBookabilityScore', bookabilityScore: number } };

export type SearchBoostQueryVariables = Exact<{
  listingId: Scalars['Int']['input'];
}>;


export type SearchBoostQuery = { __typename: 'Query', searchBoost?: { __typename: 'SearchBoostStatus', status: string, usedAt?: any | null, preReqs?: { __typename: 'SearchBoostPreReqs', userFacingDescription: string, items: Array<{ __typename: 'SearchBoostPreReqItem', name: string, description: string, completed: boolean }> } | null } | null };

export type AcceptBookingInviteMutationVariables = Exact<{
  data: AcceptBookingInviteInput;
}>;


export type AcceptBookingInviteMutation = { __typename: 'Mutation', acceptBookingInvite?: { __typename: 'AcceptBookingInviteResult', status: string, message: string } | null };

export type AcceptGenericBookingInviteMutationVariables = Exact<{
  data: AcceptGenericBookingInviteInput;
}>;


export type AcceptGenericBookingInviteMutation = { __typename: 'Mutation', acceptGenericBookingInvite: { __typename: 'AcceptGenericBookingInviteResult', booking: { __typename: 'Booking', id: string } } };

export type SendReferralInviteMutationVariables = Exact<{
  data: ReferralInviteInput;
}>;


export type SendReferralInviteMutation = { __typename: 'Mutation', sendReferralInvite?: { __typename: 'ReferralInviteResult', status: string, message: string } | null };

export type CheckInMutationVariables = Exact<{
  data: CheckInBookingInput;
}>;


export type CheckInMutation = { __typename: 'Mutation', checkInBooking: { __typename: 'CheckInBookingResult', status: string, message: string } };

export type CurrentCheckInPricingQueryVariables = Exact<{
  data: PricingSummaryInput;
}>;


export type CurrentCheckInPricingQuery = { __typename: 'Query', pricingSummary: { __typename: 'PricingSummary', subtotal: number, host_earnings: number, guest_price: number, display_full_price: boolean, klarnaEligible: boolean, klarnaCancellationFee: number, base_pricing: { __typename: 'BasePricing', amount: number, duration_hours: number, min_guests_for_price: number, max_guests_for_price: number, hourly_rate?: number | null }, base_price_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, amount?: number | null }>, additional_guest_pricing?: { __typename: 'AdditionalGuestPricing', amount: number, additional_guest_count: number, per_guest_rate: number, duration_hours: number } | null, amenity_pricing?: { __typename: 'AmenityPricing', amount: number, amenity_count: number } | null, reservation_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, discount_type: DiscountType, amount?: number | null }>, credit_pricing?: { __typename: 'CreditPricing', amount: number, remaining_balance?: number | null } | null, credit_earnings?: { __typename: 'CreditEarnings', amount: number, earned_credit_type: CreditEarningsType } | null, service_fee_pricing: { __typename: 'ServiceFeePricing', amount?: number | null, service_fee_percentage: number }, host_fee_pricing: { __typename: 'HostFeePricing', amount: number, host_fee_percentage: number }, display_sections?: Array<{ __typename: 'DisplaySection', lines: Array<{ __typename: 'DisplayLine', title: string, subtitle?: any | null, amount: string, is_discount: boolean, is_total: boolean, is_subtotal: boolean, is_premium?: boolean | null, is_membership?: boolean | null }> }> | null, securityDeposit?: { __typename: 'SecurityDepositPricing', amount: number, totalGuests: number } | null, premium_savings?: { __typename: 'PremiumSavings', premium_savings: number, premium_not_saving?: number | null } | null, upsell_discount?: { __typename: 'UpsellDiscount', discount: number, amount: number, hoursUsed: number, hoursLeft: number } | null, pass_discount?: { __typename: 'PassDiscount', discount: number, amount?: number | null, discount_type: DiscountType, can_redeem?: boolean | null, hoursUsed: number, hoursLeft: number } | null } };

export type PendingCheckInSummaryQueryVariables = Exact<{
  data: PricingSummaryInput;
}>;


export type PendingCheckInSummaryQuery = { __typename: 'Query', pricingSummary: { __typename: 'PricingSummary', subtotal: number, host_earnings: number, guest_price: number, display_full_price: boolean, klarnaEligible: boolean, klarnaCancellationFee: number, base_pricing: { __typename: 'BasePricing', amount: number, duration_hours: number, min_guests_for_price: number, max_guests_for_price: number, hourly_rate?: number | null }, base_price_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, amount?: number | null }>, additional_guest_pricing?: { __typename: 'AdditionalGuestPricing', amount: number, additional_guest_count: number, per_guest_rate: number, duration_hours: number } | null, amenity_pricing?: { __typename: 'AmenityPricing', amount: number, amenity_count: number } | null, reservation_discounts: Array<{ __typename: 'PricingDiscount', title: string, subtitle?: any | null, discount: number, discount_type: DiscountType, amount?: number | null }>, credit_pricing?: { __typename: 'CreditPricing', amount: number, remaining_balance?: number | null } | null, credit_earnings?: { __typename: 'CreditEarnings', amount: number, earned_credit_type: CreditEarningsType } | null, service_fee_pricing: { __typename: 'ServiceFeePricing', amount?: number | null, service_fee_percentage: number }, host_fee_pricing: { __typename: 'HostFeePricing', amount: number, host_fee_percentage: number }, display_sections?: Array<{ __typename: 'DisplaySection', lines: Array<{ __typename: 'DisplayLine', title: string, subtitle?: any | null, amount: string, is_discount: boolean, is_total: boolean, is_subtotal: boolean, is_premium?: boolean | null, is_membership?: boolean | null }> }> | null, securityDeposit?: { __typename: 'SecurityDepositPricing', amount: number, totalGuests: number } | null, premium_savings?: { __typename: 'PremiumSavings', premium_savings: number, premium_not_saving?: number | null } | null, upsell_discount?: { __typename: 'UpsellDiscount', discount: number, amount: number, hoursUsed: number, hoursLeft: number } | null, pass_discount?: { __typename: 'PassDiscount', discount: number, amount?: number | null, discount_type: DiscountType, can_redeem?: boolean | null, hoursUsed: number, hoursLeft: number } | null } };

export type SendBookingInvitesMutationVariables = Exact<{
  data: SendBookingInvitesInput;
}>;


export type SendBookingInvitesMutation = { __typename: 'Mutation', sendBookingInvites: { __typename: 'SendBookingInvitesResult', booking: { __typename: 'Booking', id: string } } };

export type ReservationDetailsChatBookingQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ReservationDetailsChatBookingQuery = { __typename: 'Query', reservationDetails?: { __typename: 'Booking', id: string, status: number, status_name: BookingStatusEnum, start_datetime_utc: any, end_datetime_utc: any, swimmer_review?: boolean | null, host_review?: boolean | null, adultGuests?: number | null, childrenGuests?: number | null, infantGuests?: number | null, petGuests?: number | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string, booking_id: string, status: BookingSpecialOfferStatus, start_datetime_utc: any, end_datetime_utc: any, special_offer_price: number, note: string, created_at: any, expiration_datetime_utc?: any | null, adultGuests: number, childrenGuests: number, infantGuests: number, petGuests: number, premiumAmenities: Array<{ __typename: 'BookingSpecialOfferPremiumAmenity', poolPremiumAmenity: { __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } }> } | null, listing: { __typename: 'PoolPrivate', stealth_mode: boolean, id: string, title: string, time_zone?: string | null, city?: string | null, status: number, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, available_from?: string | null, available_to?: string | null, default_instant_booking: boolean, min_booking_length?: number | null, timeZone?: string | null, countryCode?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean, pool_id: number, id?: string | null }>, createdBy?: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, isProHost: boolean, createdAt: any } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null }, booking_update_request?: { __typename: 'BookingUpdatedRequest', id?: number | null } | null, amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, userPublic: { __typename: 'UserPublic', id: string, firstname?: string | null, rating?: number | null, img_url?: string | null, created_at: any, reviewsCount: number } } | null };

export type BookMonitorMutationVariables = Exact<{
  input: BookServiceInput;
}>;


export type BookMonitorMutation = { __typename: 'Mutation', bookMonitor: { __typename: 'BookServiceResult', id: string } };

export type SubmitHostClaimMutationVariables = Exact<{
  data: HostClaimInput;
}>;


export type SubmitHostClaimMutation = { __typename: 'Mutation', submitHostClaim: { __typename: 'HostClaimResult', succeeded: boolean, message?: string | null } };

export type RequestRefundMutationVariables = Exact<{
  data: RequestRefundInput;
}>;


export type RequestRefundMutation = { __typename: 'Mutation', requestRefund: { __typename: 'RequestRefundResult', succeeded: boolean } };

export type FullRefundMutationVariables = Exact<{
  data: FullRefundInput;
}>;


export type FullRefundMutation = { __typename: 'Mutation', fullRefund: { __typename: 'FullRefundResult', succeeded: boolean, refund_amount: number } };

export type BookWithConciergeMutationVariables = Exact<{
  data: BookWithConciergeInput;
}>;


export type BookWithConciergeMutation = { __typename: 'Mutation', bookWithConcierge: { __typename: 'BookWithConciergeResult', succeeded: boolean } };

export type AddWaitlistSubscriptionMutationVariables = Exact<{
  data: AddWaitlistSubscriptionInput;
}>;


export type AddWaitlistSubscriptionMutation = { __typename: 'Mutation', addWaitlistSubscription:
    | { __typename: 'InvalidDataError' }
    | { __typename: 'MutationResult', succeeded: boolean }
   };

export type SearchFiltersQueryVariables = Exact<{
  spaceType?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchFiltersQuery = { __typename: 'Query', searchFilters: Array<{ __typename: 'SearchFilter', id: number, label: string, description?: string | null, icon?: SearchFilterIcon | null, type: SearchFilterType, unit?: string | null, filterKey: string, minValue?: number | null, maxValue?: number | null, displayTemplate?: string | null, displayTemplatePlaceholder?: string | null, displayScrollBanner: boolean, defaultValue?: string | null, displayOrder: number, displaySelectAll: boolean, choices?: Array<{ __typename: 'SearchFilterChoice', key: string, label: string, description?: string | null, icon?: SearchFilterIcon | null } | null> | null }> };

export type SpaceTypeSearchFiltersQueryVariables = Exact<{
  country?: InputMaybe<Scalars['String']['input']>;
  optInSearchV2?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SpaceTypeSearchFiltersQuery = { __typename: 'Query', spaceTypeSearchFilters: Array<{ __typename: 'SpaceTypeSearchFilters', spaceTypeSlug?: string | null, dynamicSearchFilters: Array<{ __typename: 'SearchFilter', id: number, label: string, description?: string | null, icon?: SearchFilterIcon | null, type: SearchFilterType, unit?: string | null, filterKey: string, minValue?: number | null, maxValue?: number | null, displayTemplate?: string | null, displayTemplatePlaceholder?: string | null, displayScrollBanner: boolean, displaySelectAll: boolean, defaultValue?: string | null, displayOrder: number, choices?: Array<{ __typename: 'SearchFilterChoice', key: string, label: string, description?: string | null, icon?: SearchFilterIcon | null } | null> | null } | null> }> };

export type DynamicSearchServerQueryVariables = Exact<{
  data: DynamicSearchInput;
}>;


export type DynamicSearchServerQuery = { __typename: 'Query', dynamicSearch: { __typename: 'DynamicSearchResponse', total: number, display_full_price_toggle: boolean, all_in_pricing: boolean, currentPage: number, lastPage: number, perPage: number, data: Array<{ __typename: 'SearchPool', id: string, title: string, description?: string | null, distance?: number | null, state: string, city: string, zip_code: string, rating?: number | null, image_urls?: Array<string | null> | null, cover_image_url?: string | null, video_thumbnail_url?: string | null, country_code?: string | null, listing_type: ListingType, max_guests?: number | null, instant_booking: boolean, default_instant_booking?: boolean | null, is_new: boolean, is_quality: boolean, stealth_mode: boolean, badges?: Array<string | null> | null, reviewsCount: number, latitude_round?: number | null, longitude_round?: number | null, nextAvailableDay?: any | null, pricing: { __typename: 'SearchPoolPricing', pricing_scheme: PricingScheme, price: number, discounted_price: number, featured_promo_code_percent: number, grand_opening_discount_percent: number } } | null>, spaceTypes: Array<{ __typename: 'SearchSpaceType', listingCount: number, spaceType: { __typename: 'SpaceType', id: number, name: string, description?: string | null, slug: string, icon?: SearchFilterIcon | null, color?: string | null, waitlistListingType?: WaitlistListingType | null, listingType?: ListingType | null } } | null>, useCases: Array<{ __typename: 'SearchUseCase', listingCount: number, useCase: { __typename: 'UseCase', id: number, name: string, description?: string | null, slug: string, icon?: SearchFilterIcon | null, waitlistable: boolean } } | null>, histogram_data?: { __typename: 'HistogramData', initial_x_max_selection: number, initial_x_min_selection: number, x_max: number, x_min: number, y_max: number, data_points: Array<{ __typename: 'HistogramDataPoint', x_min: number, x_max: number, y: number }> } | null, experiments: Array<{ __typename: 'SearchExperimentAssignment', experiment: string, group: string }> } };

export type DiscoveryQueryVariables = Exact<{
  input: DiscoveryInput;
}>;


export type DiscoveryQuery = { __typename: 'Query', discovery: { __typename: 'DiscoveryResponse', collections_label: string, trending_collections: Array<{ __typename: 'SearchCollection', title: string, description: string, hero_image_url?: string | null, is_new: boolean, search_input: { __typename: 'DynamicSearchParams', first: number, page: number, latitude: number, longitude: number, adults: number, space_type_slug?: string | null, use_case_slug?: string | null, use_case_slugs?: Array<string> | null, children?: number | null, infants?: number | null, pets?: number | null, filters?: Array<{ __typename: 'DynamicSearchFilterOutput', filter_key: string, values: Array<string | null> }> | null } }> } };

export type SearchCarouselFragment = { __typename: 'SearchCarousel', title: string, subtitle?: string | null, is_new: boolean, searchable: boolean, show_all_cta?: string | null, search_input: { __typename: 'DynamicSearchParams', first: number, page: number, latitude: number, longitude: number, adults: number, space_type_slug?: string | null, use_case_slug?: string | null, use_case_slugs?: Array<string> | null, children?: number | null, infants?: number | null, pets?: number | null, filters?: Array<{ __typename: 'DynamicSearchFilterOutput', filter_key: string, values: Array<string | null> }> | null }, pools: Array<{ __typename: 'SearchPool', id: string, title: string, description?: string | null, distance?: number | null, state: string, city: string, zip_code: string, rating?: number | null, image_urls?: Array<string | null> | null, cover_image_url?: string | null, video_thumbnail_url?: string | null, country_code?: string | null, listing_type: ListingType, max_guests?: number | null, instant_booking: boolean, default_instant_booking?: boolean | null, is_new: boolean, is_quality: boolean, stealth_mode: boolean, badges?: Array<string | null> | null, reviewsCount: number, latitude_round?: number | null, longitude_round?: number | null, nextAvailableDay?: any | null, pricing: { __typename: 'SearchPoolPricing', pricing_scheme: PricingScheme, price: number, discounted_price: number, featured_promo_code_percent: number, grand_opening_discount_percent: number }, experiences?: { __typename: 'SearchPoolExperiences', duration?: number | null, per_guest_pricing?: number | null, guest_restrictions?: string | null } | null }> };

export type DynamicSearchQueryVariables = Exact<{
  data: DynamicSearchInput;
}>;


export type DynamicSearchQuery = { __typename: 'Query', dynamicSearch: { __typename: 'DynamicSearchResponse', total: number, display_full_price_toggle: boolean, all_in_pricing: boolean, currentPage: number, lastPage: number, perPage: number, data: Array<{ __typename: 'SearchPool', id: string, title: string, description?: string | null, distance?: number | null, state: string, city: string, zip_code: string, rating?: number | null, image_urls?: Array<string | null> | null, cover_image_url?: string | null, video_thumbnail_url?: string | null, country_code?: string | null, listing_type: ListingType, max_guests?: number | null, instant_booking: boolean, default_instant_booking?: boolean | null, is_new: boolean, is_quality: boolean, stealth_mode: boolean, badges?: Array<string | null> | null, reviewsCount: number, latitude_round?: number | null, longitude_round?: number | null, nextAvailableDay?: any | null, pricing: { __typename: 'SearchPoolPricing', pricing_scheme: PricingScheme, price: number, discounted_price: number, featured_promo_code_percent: number, grand_opening_discount_percent: number }, experiences?: { __typename: 'SearchPoolExperiences', duration?: number | null, per_guest_pricing?: number | null, guest_restrictions?: string | null } | null } | null>, spaceTypes: Array<{ __typename: 'SearchSpaceType', listingCount: number, spaceType: { __typename: 'SpaceType', id: number, name: string, description?: string | null, slug: string, icon?: SearchFilterIcon | null, color?: string | null, waitlistListingType?: WaitlistListingType | null, listingType?: ListingType | null } } | null>, useCases: Array<{ __typename: 'SearchUseCase', listingCount: number, useCase: { __typename: 'UseCase', id: number, name: string, description?: string | null, slug: string, icon?: SearchFilterIcon | null, waitlistable: boolean } } | null>, ads?: { __typename: 'SearchAdsSection', position: number, content: { __typename: 'SearchCarousel', title: string, subtitle?: string | null, is_new: boolean, searchable: boolean, show_all_cta?: string | null, search_input: { __typename: 'DynamicSearchParams', first: number, page: number, latitude: number, longitude: number, adults: number, space_type_slug?: string | null, use_case_slug?: string | null, use_case_slugs?: Array<string> | null, children?: number | null, infants?: number | null, pets?: number | null, filters?: Array<{ __typename: 'DynamicSearchFilterOutput', filter_key: string, values: Array<string | null> }> | null }, pools: Array<{ __typename: 'SearchPool', id: string, title: string, description?: string | null, distance?: number | null, state: string, city: string, zip_code: string, rating?: number | null, image_urls?: Array<string | null> | null, cover_image_url?: string | null, video_thumbnail_url?: string | null, country_code?: string | null, listing_type: ListingType, max_guests?: number | null, instant_booking: boolean, default_instant_booking?: boolean | null, is_new: boolean, is_quality: boolean, stealth_mode: boolean, badges?: Array<string | null> | null, reviewsCount: number, latitude_round?: number | null, longitude_round?: number | null, nextAvailableDay?: any | null, pricing: { __typename: 'SearchPoolPricing', pricing_scheme: PricingScheme, price: number, discounted_price: number, featured_promo_code_percent: number, grand_opening_discount_percent: number }, experiences?: { __typename: 'SearchPoolExperiences', duration?: number | null, per_guest_pricing?: number | null, guest_restrictions?: string | null } | null }> } } | null, histogram_data?: { __typename: 'HistogramData', initial_x_max_selection: number, initial_x_min_selection: number, x_max: number, x_min: number, y_max: number, data_points: Array<{ __typename: 'HistogramDataPoint', x_min: number, x_max: number, y: number }> } | null, experiments: Array<{ __typename: 'SearchExperimentAssignment', experiment: string, group: string }> } };

export type BookingInquiryMutationVariables = Exact<{
  data: BookingInquiryInput;
}>;


export type BookingInquiryMutation = { __typename: 'Mutation', bookingInquiry: { __typename: 'BookingInquiryResult', booking: { __typename: 'Booking', id: string }, message: { __typename: 'Message', id: string } } };

export type InquiryListingQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  listingId: Scalars['ID']['input'];
}>;


export type InquiryListingQuery = { __typename: 'Query', listing?: { __typename: 'PoolPublic', id: string, title: string, country_code?: string | null, rating?: number | null, reviewsCount: number, city?: string | null, state?: string | null, status: number, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, available_from?: string | null, available_to?: string | null, min_booking_length?: number | null, advance_notice?: number | null, default_instant_booking: boolean, instant_group_size?: number | null, time_zone?: string | null, pause_start?: any | null, pause_end?: any | null, tour360Url?: string | null, securityDepositMinGuests?: number | null, securityDepositMinor?: number | null, images: Array<{ __typename: 'PoolImage', cover: boolean, url: string }>, user?: { __typename: 'UserPublic', id: string, firstname?: string | null } | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, discount_days?: Array<{ __typename: 'DiscountDaysType', day_number?: number | null, discount_percentage?: number | null } | null> | null, currentPoolPrice?: { __typename: 'PoolPrice', id: number, pool_id: number, pricing_scheme: PricingScheme, start_datetime_utc: any, end_datetime_utc: any, is_current: boolean, hourly_price?: number | null, full_hourly_price?: number | null, price_per_guest?: number | null, price_per_guest_threshold?: number | null, full_price_per_guest?: number | null, daily_price?: number | null, full_daily_price?: number | null, price_tiers?: Array<{ __typename: 'PoolPriceTier', price_tier_id: number, title: string, min_guests: number, max_guests: number, default_price: number, hourly_price: number } | null> | null, daily_price_tiers?: Array<{ __typename: 'DailyPriceTier', daily_price_tier_id: number, daily_price: number, full_daily_price?: number | null, min_guests: number, max_guests: number, default_price: number } | null> | null } | null, featuredPromo?: { __typename: 'FeaturedPromoCode', id: number, promo_code: string, percent_off: number, max_redemptions: number, redeem_by: any, times_redeemed: number, can_redeem: boolean } | null } | null, listingDetails:
    | { __typename: 'GetListingDetailsResponse', listing:
        | { __typename: 'BasketballCourtListing' }
        | { __typename: 'HomeListing' }
        | { __typename: 'Listing' }
        | { __typename: 'PickleballCourtListing' }
        | { __typename: 'PoolListing', poolType?: string | null }
        | { __typename: 'TennisCourtListing' }
       }
    | { __typename: 'ListingNotFoundError' }
   };

export type InquiryPricingDetailsQueryVariables = Exact<{
  data: PricingDetailsInput;
}>;


export type InquiryPricingDetailsQuery = { __typename: 'Query', pricingDetails: { __typename: 'PricingDetails', pricing_scheme: PricingScheme, pricing: Array<{ __typename: 'Pricing', modifiedPrice: number, minGuests: number, maxGuests: number, fullHourlyPrice?: number | null, fullModifiedPrice?: number | null }> } };

export type SeoLinkFragment = { __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null };

export type SeoPrivateListingFragment = { __typename: 'SearchPool', id: string, cover_image_url?: string | null, title: string, description?: string | null, rating?: number | null, country_code?: string | null, listing_type: ListingType, city: string, state: string, distance?: number | null, is_quality: boolean, max_guests?: number | null, stealth_mode: boolean, reviewsCount: number, pricing: { __typename: 'SearchPoolPricing', price: number, pricing_scheme: PricingScheme, featured_promo_code_percent: number, grand_opening_discount_percent: number } };

export type CityFragment = { __typename: 'City', name: string, state: string, stateAbbreviation: string };

export type PublicPoolFragment = { __typename: 'PublicPool', id: string, address: string, city: string, description: string, imageUrl: string, rating: number, reviewsCount: number, stateAbbreviation: string, title: string, url: string };

export type PublicPoolsQueryVariables = Exact<{
  input: GetPublicPoolsInput;
  searchInput: DynamicSearchInput;
}>;


export type PublicPoolsQuery = { __typename: 'Query', publicPools: { __typename: 'GetPublicPoolsResponse', cities: Array<{ __typename: 'City', name: string, state: string, stateAbbreviation: string }>, publicPools: Array<{ __typename: 'PublicPool', id: string, address: string, city: string, description: string, imageUrl: string, rating: number, reviewsCount: number, stateAbbreviation: string, title: string, url: string }> }, dynamicSearch: { __typename: 'DynamicSearchResponse', data: Array<{ __typename: 'SearchPool', id: string, cover_image_url?: string | null, title: string, description?: string | null, rating?: number | null, country_code?: string | null, listing_type: ListingType, city: string, state: string, distance?: number | null, is_quality: boolean, max_guests?: number | null, stealth_mode: boolean, reviewsCount: number, pricing: { __typename: 'SearchPoolPricing', price: number, pricing_scheme: PricingScheme, featured_promo_code_percent: number, grand_opening_discount_percent: number } } | null> } };

export type StatePublicPoolsQueryVariables = Exact<{
  input: GetPublicPoolsInput;
}>;


export type StatePublicPoolsQuery = { __typename: 'Query', publicPools: { __typename: 'GetPublicPoolsResponse', cities: Array<{ __typename: 'City', name: string, state: string, stateAbbreviation: string }>, publicPools: Array<{ __typename: 'PublicPool', id: string, address: string, city: string, description: string, imageUrl: string, rating: number, reviewsCount: number, stateAbbreviation: string, title: string, url: string }> } };

export type CityPublicPoolsQueryVariables = Exact<{
  input: GetPublicPoolsInput;
  citySlug: Scalars['String']['input'];
  seoEntitySlug: Scalars['String']['input'];
}>;


export type CityPublicPoolsQuery = { __typename: 'Query', publicPools: { __typename: 'GetPublicPoolsResponse', content?: string | null, cities: Array<{ __typename: 'City', name: string, state: string, stateAbbreviation: string }>, publicPools: Array<{ __typename: 'PublicPool', id: string, address: string, city: string, description: string, imageUrl: string, rating: number, reviewsCount: number, stateAbbreviation: string, title: string, url: string }> }, seoPage?: { __typename: 'SeoPageResult', listings: Array<{ __typename: 'SearchPool', id: string, cover_image_url?: string | null, title: string, description?: string | null, rating?: number | null, country_code?: string | null, listing_type: ListingType, city: string, state: string, distance?: number | null, is_quality: boolean, max_guests?: number | null, stealth_mode: boolean, reviewsCount: number, pricing: { __typename: 'SearchPoolPricing', price: number, pricing_scheme: PricingScheme, featured_promo_code_percent: number, grand_opening_discount_percent: number } }>, additionalLocationLinks: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null>, additionalSpaceTypeLinks: Array<{ __typename: 'SeoLinkSection', title: string, links: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null> } | null>, additionalUseCaseLinks: Array<{ __typename: 'SeoLink', label: string, citySlug: string, seoEntitySlug: string, seoEntityName: string, categoryName?: string | null } | null> } | null };

export type SpecialOfferFragment = { __typename: 'BookingSpecialOffer', id: string, booking_id: string, status: BookingSpecialOfferStatus, start_datetime_utc: any, end_datetime_utc: any, special_offer_price: number, note: string, created_at: any, expiration_datetime_utc?: any | null, adultGuests: number, childrenGuests: number, infantGuests: number, petGuests: number, premiumAmenities: Array<{ __typename: 'BookingSpecialOfferPremiumAmenity', poolPremiumAmenity: { __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } }> };

export type SpecialOfferBookingFragment = { __typename: 'Booking', id: string, status: number, status_name: BookingStatusEnum, start_datetime_utc: any, end_datetime_utc: any, swimmer_review?: boolean | null, host_review?: boolean | null, adultGuests?: number | null, childrenGuests?: number | null, infantGuests?: number | null, petGuests?: number | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string, booking_id: string, status: BookingSpecialOfferStatus, start_datetime_utc: any, end_datetime_utc: any, special_offer_price: number, note: string, created_at: any, expiration_datetime_utc?: any | null, adultGuests: number, childrenGuests: number, infantGuests: number, petGuests: number, premiumAmenities: Array<{ __typename: 'BookingSpecialOfferPremiumAmenity', poolPremiumAmenity: { __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } }> } | null, listing: { __typename: 'PoolPrivate', stealth_mode: boolean, id: string, title: string, time_zone?: string | null, city?: string | null, status: number, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, available_from?: string | null, available_to?: string | null, default_instant_booking: boolean, min_booking_length?: number | null, timeZone?: string | null, countryCode?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean, pool_id: number, id?: string | null }>, createdBy?: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, isProHost: boolean, createdAt: any } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null }, booking_update_request?: { __typename: 'BookingUpdatedRequest', id?: number | null } | null, amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, userPublic: { __typename: 'UserPublic', id: string, firstname?: string | null, rating?: number | null, img_url?: string | null, created_at: any, reviewsCount: number } };

export type GetBookingForChatQueryVariables = Exact<{
  data: BookingForChatInput;
}>;


export type GetBookingForChatQuery = { __typename: 'Query', getBookingForChat: { __typename: 'GetBookingForChatResponse', canCreateSpecialOffer: boolean, booking?: { __typename: 'Booking', id: string, status: number, status_name: BookingStatusEnum, start_datetime_utc: any, end_datetime_utc: any, swimmer_review?: boolean | null, host_review?: boolean | null, adultGuests?: number | null, childrenGuests?: number | null, infantGuests?: number | null, petGuests?: number | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string, booking_id: string, status: BookingSpecialOfferStatus, start_datetime_utc: any, end_datetime_utc: any, special_offer_price: number, note: string, created_at: any, expiration_datetime_utc?: any | null, adultGuests: number, childrenGuests: number, infantGuests: number, petGuests: number, premiumAmenities: Array<{ __typename: 'BookingSpecialOfferPremiumAmenity', poolPremiumAmenity: { __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } }> } | null, listing: { __typename: 'PoolPrivate', stealth_mode: boolean, id: string, title: string, time_zone?: string | null, city?: string | null, status: number, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, available_from?: string | null, available_to?: string | null, default_instant_booking: boolean, min_booking_length?: number | null, timeZone?: string | null, countryCode?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean, pool_id: number, id?: string | null }>, createdBy?: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, isProHost: boolean, createdAt: any } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null }, booking_update_request?: { __typename: 'BookingUpdatedRequest', id?: number | null } | null, amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, userPublic: { __typename: 'UserPublic', id: string, firstname?: string | null, rating?: number | null, img_url?: string | null, created_at: any, reviewsCount: number } } | null } };

export type DeclineBookingSpecialOfferMutationVariables = Exact<{
  data: DeclineBookingSpecialOfferInput;
}>;


export type DeclineBookingSpecialOfferMutation = { __typename: 'Mutation', declineBookingSpecialOffer?: boolean | null };

export type CancelBookingSpecialOfferMutationVariables = Exact<{
  data: CancelBookingSpecialOfferInput;
}>;


export type CancelBookingSpecialOfferMutation = { __typename: 'Mutation', cancelBookingSpecialOffer?: boolean | null };

export type SpecialOfferBookingDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SpecialOfferBookingDetailsQuery = { __typename: 'Query', reservationDetails?: { __typename: 'Booking', id: string, status: number, status_name: BookingStatusEnum, start_datetime_utc: any, end_datetime_utc: any, swimmer_review?: boolean | null, host_review?: boolean | null, adultGuests?: number | null, childrenGuests?: number | null, infantGuests?: number | null, petGuests?: number | null, booking_special_offer?: { __typename: 'BookingSpecialOffer', id: string, booking_id: string, status: BookingSpecialOfferStatus, start_datetime_utc: any, end_datetime_utc: any, special_offer_price: number, note: string, created_at: any, expiration_datetime_utc?: any | null, adultGuests: number, childrenGuests: number, infantGuests: number, petGuests: number, premiumAmenities: Array<{ __typename: 'BookingSpecialOfferPremiumAmenity', poolPremiumAmenity: { __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } }> } | null, listing: { __typename: 'PoolPrivate', stealth_mode: boolean, id: string, title: string, time_zone?: string | null, city?: string | null, status: number, max_guests?: number | null, guests_children_allowed?: boolean | null, guests_infants_allowed?: boolean | null, pets_rule?: PetsRules | null, available_from?: string | null, available_to?: string | null, default_instant_booking: boolean, min_booking_length?: number | null, timeZone?: string | null, countryCode?: string | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null, images: Array<{ __typename: 'PoolImage', url: string, cover: boolean, pool_id: number, id?: string | null }>, createdBy?: { __typename: 'UserPublic', id: string, firstname?: string | null, img_url?: string | null, isProHost: boolean, createdAt: any } | null, enabled_premium_amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null }, booking_update_request?: { __typename: 'BookingUpdatedRequest', id?: number | null } | null, amenities?: Array<{ __typename: 'PoolPremiumAmenity', id: number, title: string, description?: string | null, price_type?: PriceTypeEnum | null, price_amount?: number | null, pool_id: number, enabled?: boolean | null, amenity?: { __typename: 'Amenity', id: string, name: string, icon: string, image?: string | null, active: boolean, category?: string | null, premium?: boolean | null } | null } | null> | null, userPublic: { __typename: 'UserPublic', id: string, firstname?: string | null, rating?: number | null, img_url?: string | null, created_at: any, reviewsCount: number } } | null };

export type CreateBookingSpecialOfferMutationVariables = Exact<{
  data: CreateBookingSpecialOfferInput;
}>;


export type CreateBookingSpecialOfferMutation = { __typename: 'Mutation', createBookingSpecialOffer: { __typename: 'BookingSpecialOffer' } };

export type PreApproveReservationMutationVariables = Exact<{
  data: ReservationInput;
}>;


export type PreApproveReservationMutation = { __typename: 'Mutation', preApproveReservation?: { __typename: 'ReservationResult', status: string, message: string } | null };

export type ViewInquiryPricingSummaryQueryVariables = Exact<{
  data: PricingSummaryInput;
}>;


export type ViewInquiryPricingSummaryQuery = { __typename: 'Query', pricingSummary: { __typename: 'PricingSummary', subtotal: number, host_earnings: number, guest_price: number, securityDeposit?: { __typename: 'SecurityDepositPricing', amount: number, totalGuests: number } | null } };

export type GetLatestBookingInquiryQueryVariables = Exact<{
  data: LatestInquiryInput;
}>;


export type GetLatestBookingInquiryQuery = { __typename: 'Query', getLatestBookingInquiry?: { __typename: 'Booking', id: string, status: number, start_datetime_utc: any, end_datetime_utc: any, adults?: number | null, children?: number | null, infants?: number | null, pets?: number | null, listing: { __typename: 'PoolPrivate', id: string, title: string, rating?: number | null, reviewsCount: number, time_zone?: string | null, countryCode?: string | null, images: Array<{ __typename: 'PoolImage', cover: boolean, url: string }>, user?: { __typename: 'UserPublic', id: string, firstname?: string | null, is_pro_host: boolean, imgUrl?: string | null } | null, listingType?: { __typename: 'ListingTypeModel', name: ListingType } | null }, userPublic: { __typename: 'UserPublic', id: string, firstname?: string | null, rating?: number | null, reviewsCount: number, imgUrl?: string | null } } | null };

export type ServerGetAllUserExperimentsQueryVariables = Exact<{
  input?: InputMaybe<GetUserExperimentsInput>;
}>;


export type ServerGetAllUserExperimentsQuery = { __typename: 'Query', getUserExperiments: Array<{ __typename: 'UserExperiment', experiment: { __typename: 'Experiment', name: string }, group: { __typename: 'ExperimentGroup', name: string } }> };

export type ServerFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type ServerFeatureFlagsQuery = { __typename: 'Query', featureFlagsForUser: Array<{ __typename: 'FeatureFlag', id: string, default_value: boolean, value?: boolean | null, description?: string | null, name: string }> };

export type SelectedListingQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectedListingQuery = { __typename: 'Query', selectedListingQuery?: { __typename: 'MyPool', id: string } | null };

export type ServerProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ServerProfileQuery = { __typename: 'Query', meQuery: { __typename: 'Me', id: string, email?: string | null, country_code?: string | null, listing_ids: Array<string>, premium_state: PremiumState, premium_type: UserPremiumType, roles: Array<{ __typename: 'Role', name: string }> } };

export type ListingOnboardingStatusQueryVariables = Exact<{
  completenessInput: ListingCompletenessInput;
}>;


export type ListingOnboardingStatusQuery = { __typename: 'Query', listingCompleteness: { __typename: 'ListingCompleteness', onboardingPercentageComplete: number } };

export type Operations = {
      GetOnboardingListingTypeQuery: { data: GetOnboardingListingTypeQuery, variables: GetOnboardingListingTypeQueryVariables };
GetPoolMaxGuestsQuery: { data: GetPoolMaxGuestsQuery, variables: GetPoolMaxGuestsQueryVariables };
GetOnboardingHowSwimplyWorksQuery: { data: GetOnboardingHowSwimplyWorksQuery, variables: GetOnboardingHowSwimplyWorksQueryVariables };
GetOnboardingListingPhotosQuery: { data: GetOnboardingListingPhotosQuery, variables: GetOnboardingListingPhotosQueryVariables };
GetListingTypeQuery: { data: GetListingTypeQuery, variables: GetListingTypeQueryVariables };
GetOnboardingListingStartDateQuery: { data: GetOnboardingListingStartDateQuery, variables: GetOnboardingListingStartDateQueryVariables };
GetOnboardingListingTitleQuery: { data: GetOnboardingListingTitleQuery, variables: GetOnboardingListingTitleQueryVariables };
GetListingTypeForBasicsPreviewQuery: { data: GetListingTypeForBasicsPreviewQuery, variables: GetListingTypeForBasicsPreviewQueryVariables };
BookingPublicFragment: { data: BookingPublicFragment};
BookingInviteReservationQuery: { data: BookingInviteReservationQuery, variables: BookingInviteReservationQueryVariables };
GetBookingInviteQuery: { data: GetBookingInviteQuery, variables: GetBookingInviteQueryVariables };
BookingInvitationOgQuery: { data: BookingInvitationOgQuery, variables: BookingInvitationOgQueryVariables };
ReferralMilestonesByReferralTokenServerQuery: { data: ReferralMilestonesByReferralTokenServerQuery, variables: ReferralMilestonesByReferralTokenServerQueryVariables };
SeoUseCaseFragment: { data: SeoUseCaseFragment};
SeoSpaceTypeFragment: { data: SeoSpaceTypeFragment};
SeoEntityFilterFragment: { data: SeoEntityFilterFragment};
SeoPageQuery: { data: SeoPageQuery, variables: SeoPageQueryVariables };
BackyardsPageQuery: { data: BackyardsPageQuery, variables: BackyardsPageQueryVariables };
BirthdayPartyPageQuery: { data: BirthdayPartyPageQuery, variables: BirthdayPartyPageQueryVariables };
PoolPassesPageQuery: { data: PoolPassesPageQuery, variables: PoolPassesPageQueryVariables };
KidsBirthdayPartyPageQuery: { data: KidsBirthdayPartyPageQuery, variables: KidsBirthdayPartyPageQueryVariables };
SeoLinksQuery: { data: SeoLinksQuery, variables: SeoLinksQueryVariables };
ConnectInstagramAccountMutation: { data: ConnectInstagramAccountMutation, variables: ConnectInstagramAccountMutationVariables };
GetInstagramAccountDeletionQuery: { data: GetInstagramAccountDeletionQuery, variables: GetInstagramAccountDeletionQueryVariables };
MembershipsOverviewSearchQuery: { data: MembershipsOverviewSearchQuery, variables: MembershipsOverviewSearchQueryVariables };
ExperiencesPopupDataQuery: { data: ExperiencesPopupDataQuery, variables: ExperiencesPopupDataQueryVariables };
PreBookingChecksQuery: { data: PreBookingChecksQuery, variables: PreBookingChecksQueryVariables };
SelectedDayDetailQuery: { data: SelectedDayDetailQuery, variables: SelectedDayDetailQueryVariables };
BookingChoicesFragment: { data: BookingChoicesFragment};
BookingChoicesQuery: { data: BookingChoicesQuery, variables: BookingChoicesQueryVariables };
StartCartMutation: { data: StartCartMutation, variables: StartCartMutationVariables };
ListingAmenitiesQuery: { data: ListingAmenitiesQuery, variables: ListingAmenitiesQueryVariables };
MembershipSelectionPricingSummaryQuery: { data: MembershipSelectionPricingSummaryQuery, variables: MembershipSelectionPricingSummaryQueryVariables };
NonMembershipSelectionPricingSummaryQuery: { data: NonMembershipSelectionPricingSummaryQuery, variables: NonMembershipSelectionPricingSummaryQueryVariables };
CheckoutSetupBookingQuery: { data: CheckoutSetupBookingQuery, variables: CheckoutSetupBookingQueryVariables };
GoPuffInfoQuery: { data: GoPuffInfoQuery, variables: GoPuffInfoQueryVariables };
CancelMembershipMutation: { data: CancelMembershipMutation, variables: CancelMembershipMutationVariables };
PassholderFragment: { data: PassholderFragment};
GetActiveMembersQuery: { data: GetActiveMembersQuery, variables: GetActiveMembersQueryVariables };
GetExpiredMembersQuery: { data: GetExpiredMembersQuery, variables: GetExpiredMembersQueryVariables };
GuestPassCancelInfoQuery: { data: GuestPassCancelInfoQuery, variables: GuestPassCancelInfoQueryVariables };
PendingMembershipSelectionPricingSummaryQuery: { data: PendingMembershipSelectionPricingSummaryQuery, variables: PendingMembershipSelectionPricingSummaryQueryVariables };
ListingPassesForGuestQuery: { data: ListingPassesForGuestQuery, variables: ListingPassesForGuestQueryVariables };
HostGuideQuery: { data: HostGuideQuery, variables: HostGuideQueryVariables };
PhotoScoreFragment: { data: PhotoScoreFragment};
GetHostListingPhotosQuery: { data: GetHostListingPhotosQuery, variables: GetHostListingPhotosQueryVariables };
GetHostListingPhotoScoresQuery: { data: GetHostListingPhotoScoresQuery, variables: GetHostListingPhotoScoresQueryVariables };
SetImageOrderMutation: { data: SetImageOrderMutation, variables: SetImageOrderMutationVariables };
FailReservationPaymentMutation: { data: FailReservationPaymentMutation, variables: FailReservationPaymentMutationVariables };
BookingSuccessQuery: { data: BookingSuccessQuery, variables: BookingSuccessQueryVariables };
VerifyGuestMutation: { data: VerifyGuestMutation, variables: VerifyGuestMutationVariables };
GetVerificationStatusQuery: { data: GetVerificationStatusQuery, variables: GetVerificationStatusQueryVariables };
ReviewPendingRequestBookingQuery: { data: ReviewPendingRequestBookingQuery, variables: ReviewPendingRequestBookingQueryVariables };
CurrentPricingSummaryQuery: { data: CurrentPricingSummaryQuery, variables: CurrentPricingSummaryQueryVariables };
PendingPricingSummaryQuery: { data: PendingPricingSummaryQuery, variables: PendingPricingSummaryQueryVariables };
BookingForCancellingQuery: { data: BookingForCancellingQuery, variables: BookingForCancellingQueryVariables };
CancelPricingSummaryQuery: { data: CancelPricingSummaryQuery, variables: CancelPricingSummaryQueryVariables };
EditBookingRequiresApprovalQuery: { data: EditBookingRequiresApprovalQuery, variables: EditBookingRequiresApprovalQueryVariables };
AddListingToFavCollectionsMutation: { data: AddListingToFavCollectionsMutation, variables: AddListingToFavCollectionsMutationVariables };
RemoveListingFromFavCollectionsMutation: { data: RemoveListingFromFavCollectionsMutation, variables: RemoveListingFromFavCollectionsMutationVariables };
SetListingAvailabilityMutation: { data: SetListingAvailabilityMutation, variables: SetListingAvailabilityMutationVariables };
SetStealthModeMutation: { data: SetStealthModeMutation, variables: SetStealthModeMutationVariables };
PricingDetailsQuery: { data: PricingDetailsQuery, variables: PricingDetailsQueryVariables };
CreateConnectAccountMutation: { data: CreateConnectAccountMutation, variables: CreateConnectAccountMutationVariables };
RemoveGuestsMutation: { data: RemoveGuestsMutation, variables: RemoveGuestsMutationVariables };
NotificationCtaFragment: { data: NotificationCtaFragment};
UserNotificationFieldsFragment: { data: UserNotificationFieldsFragment};
GetNotificationsQuery: { data: GetNotificationsQuery, variables: GetNotificationsQueryVariables };
DeleteNotificationMutation: { data: DeleteNotificationMutation, variables: DeleteNotificationMutationVariables };
MarkAllNotificationsAsReadMutation: { data: MarkAllNotificationsAsReadMutation, variables: MarkAllNotificationsAsReadMutationVariables };
DeleteAllNotificationsMutation: { data: DeleteAllNotificationsMutation, variables: DeleteAllNotificationsMutationVariables };
ListingSelectorListingsQuery: { data: ListingSelectorListingsQuery, variables: ListingSelectorListingsQueryVariables };
RemoveListingReviewHostResponseMutation: { data: RemoveListingReviewHostResponseMutation, variables: RemoveListingReviewHostResponseMutationVariables };
RespondToListingReviewMutation: { data: RespondToListingReviewMutation, variables: RespondToListingReviewMutationVariables };
ListingHostInfoQuery: { data: ListingHostInfoQuery, variables: ListingHostInfoQueryVariables };
UserProfileQuery: { data: UserProfileQuery, variables: UserProfileQueryVariables };
UserReviewsQuery: { data: UserReviewsQuery, variables: UserReviewsQueryVariables };
CancelPremiumFeesAndCreditsQuery: { data: CancelPremiumFeesAndCreditsQuery, variables: CancelPremiumFeesAndCreditsQueryVariables };
CancelSwimplyPremiumMutation: { data: CancelSwimplyPremiumMutation, variables: CancelSwimplyPremiumMutationVariables };
PauseSwimplyPremiumMutation: { data: PauseSwimplyPremiumMutation, variables: PauseSwimplyPremiumMutationVariables };
GetPassCostsQuery: { data: GetPassCostsQuery, variables: GetPassCostsQueryVariables };
GetPassesByIdQuery: { data: GetPassesByIdQuery, variables: GetPassesByIdQueryVariables };
BillingHistoryItemFragment: { data: BillingHistoryItemFragment};
BillingHistoryQuery: { data: BillingHistoryQuery, variables: BillingHistoryQueryVariables };
ChangePremiumPaymentMethodMutation: { data: ChangePremiumPaymentMethodMutation, variables: ChangePremiumPaymentMethodMutationVariables };
SwimplyPremiumFragment: { data: SwimplyPremiumFragment};
RenewSwimplyPremiumMutation: { data: RenewSwimplyPremiumMutation, variables: RenewSwimplyPremiumMutationVariables };
StartSwimplyPremiumMutation: { data: StartSwimplyPremiumMutation, variables: StartSwimplyPremiumMutationVariables };
SwitchToIglooMutation: { data: SwitchToIglooMutation, variables: SwitchToIglooMutationVariables };
UpgradeToPremiumMutation: { data: UpgradeToPremiumMutation, variables: UpgradeToPremiumMutationVariables };
PremiumInfoQuery: { data: PremiumInfoQuery, variables: PremiumInfoQueryVariables };
ServerSearchSpaceTypeFragment: { data: ServerSearchSpaceTypeFragment};
ServerSearchUseCaseFragment: { data: ServerSearchUseCaseFragment};
SearchSpaceTypeFragment: { data: SearchSpaceTypeFragment};
SearchUseCaseFragment: { data: SearchUseCaseFragment};
ListingAvailabilityFragment: { data: ListingAvailabilityFragment};
ListingPriceFragment: { data: ListingPriceFragment};
PublicListingFragment: { data: PublicListingFragment};
MyPoolFragment: { data: MyPoolFragment};
ListingPricingFragment: { data: ListingPricingFragment};
ServerSearchListingFragment: { data: ServerSearchListingFragment};
SearchListingFragment: { data: SearchListingFragment};
ServerGuestReviewFragment: { data: ServerGuestReviewFragment};
ServerListingReviewFragment: { data: ServerListingReviewFragment};
GuestReviewFragment: { data: GuestReviewFragment};
ListingReviewFragment: { data: ListingReviewFragment};
AccurateCountryMutation: { data: AccurateCountryMutation, variables: AccurateCountryMutationVariables };
AddPaymentMethodMutation: { data: AddPaymentMethodMutation, variables: AddPaymentMethodMutationVariables };
ApproveEditReservationMutation: { data: ApproveEditReservationMutation, variables: ApproveEditReservationMutationVariables };
ApproveReservationMutation: { data: ApproveReservationMutation, variables: ApproveReservationMutationVariables };
BookPoolMutation: { data: BookPoolMutation, variables: BookPoolMutationVariables };
CancelEditReservationRequestMutation: { data: CancelEditReservationRequestMutation, variables: CancelEditReservationRequestMutationVariables };
CancelReservationMutation: { data: CancelReservationMutation, variables: CancelReservationMutationVariables };
CreateProfileMutation: { data: CreateProfileMutation, variables: CreateProfileMutationVariables };
DeclineEditReservationMutation: { data: DeclineEditReservationMutation, variables: DeclineEditReservationMutationVariables };
DeclineReservationMutation: { data: DeclineReservationMutation, variables: DeclineReservationMutationVariables };
DeleteUserAccountMutation: { data: DeleteUserAccountMutation, variables: DeleteUserAccountMutationVariables };
EditBookingMutation: { data: EditBookingMutation, variables: EditBookingMutationVariables };
ForgotPasswordMutation: { data: ForgotPasswordMutation, variables: ForgotPasswordMutationVariables };
EmailLoginMutation: { data: EmailLoginMutation, variables: EmailLoginMutationVariables };
ResendEmailCodeMutation: { data: ResendEmailCodeMutation, variables: ResendEmailCodeMutationVariables };
MobileLoginMutation: { data: MobileLoginMutation, variables: MobileLoginMutationVariables };
LogoutMutation: { data: LogoutMutation, variables: LogoutMutationVariables };
RecordActivityMutation: { data: RecordActivityMutation, variables: RecordActivityMutationVariables };
RemovePaymentMethodMutation: { data: RemovePaymentMethodMutation, variables: RemovePaymentMethodMutationVariables };
HostReviewStoreMutation: { data: HostReviewStoreMutation, variables: HostReviewStoreMutationVariables };
ReviewPoolMutation: { data: ReviewPoolMutation, variables: ReviewPoolMutationVariables };
SaveListingPremiumAmenitiesMutation: { data: SaveListingPremiumAmenitiesMutation, variables: SaveListingPremiumAmenitiesMutationVariables };
SavePoolDiscountDaysMutation: { data: SavePoolDiscountDaysMutation, variables: SavePoolDiscountDaysMutationVariables };
SavePoolInfoMutation: { data: SavePoolInfoMutation, variables: SavePoolInfoMutationVariables };
SendVerificationCodeToMobileMutation: { data: SendVerificationCodeToMobileMutation, variables: SendVerificationCodeToMobileMutationVariables };
SetDefaultPaymentSourceMutation: { data: SetDefaultPaymentSourceMutation, variables: SetDefaultPaymentSourceMutationVariables };
SetPoolsDiscountFirstBookingMutation: { data: SetPoolsDiscountFirstBookingMutation, variables: SetPoolsDiscountFirstBookingMutationVariables };
SignUpMutation: { data: SignUpMutation, variables: SignUpMutationVariables };
SkipBookingReviewMutation: { data: SkipBookingReviewMutation, variables: SkipBookingReviewMutationVariables };
SsoAuthMutation: { data: SsoAuthMutation, variables: SsoAuthMutationVariables };
StoreCalibrationDataMutation: { data: StoreCalibrationDataMutation, variables: StoreCalibrationDataMutationVariables };
UpdatePasswordMutation: { data: UpdatePasswordMutation, variables: UpdatePasswordMutationVariables };
UpdateProfileMutation: { data: UpdateProfileMutation, variables: UpdateProfileMutationVariables };
VerifyEmailMutation: { data: VerifyEmailMutation, variables: VerifyEmailMutationVariables };
VerifyMobileNumberMutation: { data: VerifyMobileNumberMutation, variables: VerifyMobileNumberMutationVariables };
VerifyUserMobileNumberMutation: { data: VerifyUserMobileNumberMutation, variables: VerifyUserMobileNumberMutationVariables };
BadgesQuery: { data: BadgesQuery, variables: BadgesQueryVariables };
CanRedeemPromocodeQuery: { data: CanRedeemPromocodeQuery, variables: CanRedeemPromocodeQueryVariables };
FavCollectionsQuery: { data: FavCollectionsQuery, variables: FavCollectionsQueryVariables };
GetReferralInviterV2Query: { data: GetReferralInviterV2Query, variables: GetReferralInviterV2QueryVariables };
PoolCheckoutCardQuery: { data: PoolCheckoutCardQuery, variables: PoolCheckoutCardQueryVariables };
GetSwimplyContactOptionsQuery: { data: GetSwimplyContactOptionsQuery, variables: GetSwimplyContactOptionsQueryVariables };
BookingReviewFragment: { data: BookingReviewFragment};
LatestBookingPendingReviewQuery: { data: LatestBookingPendingReviewQuery, variables: LatestBookingPendingReviewQueryVariables };
BookingReviewQuery: { data: BookingReviewQuery, variables: BookingReviewQueryVariables };
ServerListingReviewsQuery: { data: ServerListingReviewsQuery, variables: ServerListingReviewsQueryVariables };
ListingReviewsQuery: { data: ListingReviewsQuery, variables: ListingReviewsQueryVariables };
ListingQuery: { data: ListingQuery, variables: ListingQueryVariables };
LookupEmailQuery: { data: LookupEmailQuery, variables: LookupEmailQueryVariables };
LookupMobileNumberQuery: { data: LookupMobileNumberQuery, variables: LookupMobileNumberQueryVariables };
MyPoolsQuery: { data: MyPoolsQuery, variables: MyPoolsQueryVariables };
PaymentMethodFragment: { data: PaymentMethodFragment};
PaymentMethodsQuery: { data: PaymentMethodsQuery, variables: PaymentMethodsQueryVariables };
MeFragment: { data: MeFragment};
ProfileQuery: { data: ProfileQuery, variables: ProfileQueryVariables };
PublicListingDetailsQuery: { data: PublicListingDetailsQuery, variables: PublicListingDetailsQueryVariables };
ReferralBalanceQuery: { data: ReferralBalanceQuery, variables: ReferralBalanceQueryVariables };
ReferralsQuery: { data: ReferralsQuery, variables: ReferralsQueryVariables };
ServiceFragment: { data: ServiceFragment};
ReservationAmenityFragment: { data: ReservationAmenityFragment};
ReservationListingFragment: { data: ReservationListingFragment};
EditedFieldsFragment: { data: EditedFieldsFragment};
UseReservationMemoReservationFragment: { data: UseReservationMemoReservationFragment};
ListReservationFragment: { data: ListReservationFragment};
ReservationFragment: { data: ReservationFragment};
ReservationDetailsQuery: { data: ReservationDetailsQuery, variables: ReservationDetailsQueryVariables };
StripeExpressDashboardQuery: { data: StripeExpressDashboardQuery, variables: StripeExpressDashboardQueryVariables };
UserExperimentsQuery: { data: UserExperimentsQuery, variables: UserExperimentsQueryVariables };
FeatureFlagsQuery: { data: FeatureFlagsQuery, variables: FeatureFlagsQueryVariables };
GeocodeQuery: { data: GeocodeQuery, variables: GeocodeQueryVariables };
MilestoneFragment: { data: MilestoneFragment};
GetReferralMilestonesQuery: { data: GetReferralMilestonesQuery, variables: GetReferralMilestonesQueryVariables };
ReferralMilestonesByReferralTokenQuery: { data: ReferralMilestonesByReferralTokenQuery, variables: ReferralMilestonesByReferralTokenQueryVariables };
BookingAmenitiesQuery: { data: BookingAmenitiesQuery, variables: BookingAmenitiesQueryVariables };
BookingUserRoleFragment: { data: BookingUserRoleFragment};
CheckLifeguardAvailabilityQuery: { data: CheckLifeguardAvailabilityQuery, variables: CheckLifeguardAvailabilityQueryVariables };
CheckMonitorAvailabilityQuery: { data: CheckMonitorAvailabilityQuery, variables: CheckMonitorAvailabilityQueryVariables };
ReservationsFragment: { data: ReservationsFragment};
GuestBookingsQuery: { data: GuestBookingsQuery, variables: GuestBookingsQueryVariables };
HostBookingsQuery: { data: HostBookingsQuery, variables: HostBookingsQueryVariables };
ActivePartnershipsQuery: { data: ActivePartnershipsQuery, variables: ActivePartnershipsQueryVariables };
DailyBookingAvailabilityDetailQuery: { data: DailyBookingAvailabilityDetailQuery, variables: DailyBookingAvailabilityDetailQueryVariables };
DailyListingAvailabilitySummaryQuery: { data: DailyListingAvailabilitySummaryQuery, variables: DailyListingAvailabilitySummaryQueryVariables };
DailyListingAvailabilityDetailQuery: { data: DailyListingAvailabilityDetailQuery, variables: DailyListingAvailabilityDetailQueryVariables };
GetPopupsQuery: { data: GetPopupsQuery, variables: GetPopupsQueryVariables };
SetPopupValMutation: { data: SetPopupValMutation, variables: SetPopupValMutationVariables };
PricingSummaryFragment: { data: PricingSummaryFragment};
PricingSummaryPublicQuery: { data: PricingSummaryPublicQuery, variables: PricingSummaryPublicQueryVariables };
PricingSummaryQuery: { data: PricingSummaryQuery, variables: PricingSummaryQueryVariables };
GetHostListingTypeAmenitiesQuery: { data: GetHostListingTypeAmenitiesQuery, variables: GetHostListingTypeAmenitiesQueryVariables };
AddHostSignupInterestMutation: { data: AddHostSignupInterestMutation, variables: AddHostSignupInterestMutationVariables };
EstimateEarningsExtendedMutation: { data: EstimateEarningsExtendedMutation, variables: EstimateEarningsExtendedMutationVariables };
EstimateEarningsQuery: { data: EstimateEarningsQuery, variables: EstimateEarningsQueryVariables };
CreateFavCollectionMutation: { data: CreateFavCollectionMutation, variables: CreateFavCollectionMutationVariables };
DeleteFavCollectionMutation: { data: DeleteFavCollectionMutation, variables: DeleteFavCollectionMutationVariables };
FavCollectionCollaboratorFragment: { data: FavCollectionCollaboratorFragment};
FavCollectionQuery: { data: FavCollectionQuery, variables: FavCollectionQueryVariables };
RemoveUsersFromFavCollectionMutation: { data: RemoveUsersFromFavCollectionMutation, variables: RemoveUsersFromFavCollectionMutationVariables };
SendFavCollectionInvitesMutation: { data: SendFavCollectionInvitesMutation, variables: SendFavCollectionInvitesMutationVariables };
UpdateFavCollectionMutation: { data: UpdateFavCollectionMutation, variables: UpdateFavCollectionMutationVariables };
AcceptFavCollectionInviteMutation: { data: AcceptFavCollectionInviteMutation, variables: AcceptFavCollectionInviteMutationVariables };
BookingUserRoleQuery: { data: BookingUserRoleQuery, variables: BookingUserRoleQueryVariables };
BookLifeguardMutation: { data: BookLifeguardMutation, variables: BookLifeguardMutationVariables };
EventFragment: { data: EventFragment};
ScheduleDetailFragment: { data: ScheduleDetailFragment};
AvailabilityFragment: { data: AvailabilityFragment};
CalendarListingQuery: { data: CalendarListingQuery, variables: CalendarListingQueryVariables };
CalendarSummaryQuery: { data: CalendarSummaryQuery, variables: CalendarSummaryQueryVariables };
CalendarDetailQuery: { data: CalendarDetailQuery, variables: CalendarDetailQueryVariables };
DeleteUnavailabilityMutation: { data: DeleteUnavailabilityMutation, variables: DeleteUnavailabilityMutationVariables };
SaveListingAvailabilityOverrideMutation: { data: SaveListingAvailabilityOverrideMutation, variables: SaveListingAvailabilityOverrideMutationVariables };
GetCalendarLinkQuery: { data: GetCalendarLinkQuery, variables: GetCalendarLinkQueryVariables };
ToggleCalendarSyncBufferMutation: { data: ToggleCalendarSyncBufferMutation, variables: ToggleCalendarSyncBufferMutationVariables };
CalendarSyncBufferStatusQuery: { data: CalendarSyncBufferStatusQuery, variables: CalendarSyncBufferStatusQueryVariables };
ListingCalendarFragment: { data: ListingCalendarFragment};
AuthorizeCronofyProviderMutation: { data: AuthorizeCronofyProviderMutation, variables: AuthorizeCronofyProviderMutationVariables };
DeactivateCronofyMutation: { data: DeactivateCronofyMutation, variables: DeactivateCronofyMutationVariables };
AuthorizeiCalCalendarMutation: { data: AuthorizeiCalCalendarMutation, variables: AuthorizeiCalCalendarMutationVariables };
SynciCalCalendarMutation: { data: SynciCalCalendarMutation, variables: SynciCalCalendarMutationVariables };
RefreshiCalCalendarMutation: { data: RefreshiCalCalendarMutation, variables: RefreshiCalCalendarMutationVariables };
DeactivateiCalCalendarMutation: { data: DeactivateiCalCalendarMutation, variables: DeactivateiCalCalendarMutationVariables };
SyncCronofyCalendarMutation: { data: SyncCronofyCalendarMutation, variables: SyncCronofyCalendarMutationVariables };
UnsyncExternalCalendarMutation: { data: UnsyncExternalCalendarMutation, variables: UnsyncExternalCalendarMutationVariables };
ListingCalendarsQuery: { data: ListingCalendarsQuery, variables: ListingCalendarsQueryVariables };
AcceptChatRulesMutation: { data: AcceptChatRulesMutation, variables: AcceptChatRulesMutationVariables };
CompletedTransactionFragment: { data: CompletedTransactionFragment};
UpcomingTransactionFragment: { data: UpcomingTransactionFragment};
CompletedTransactionsQuery: { data: CompletedTransactionsQuery, variables: CompletedTransactionsQueryVariables };
UpcomingTransactionsQuery: { data: UpcomingTransactionsQuery, variables: UpcomingTransactionsQueryVariables };
EarningsInsightsQuery: { data: EarningsInsightsQuery, variables: EarningsInsightsQueryVariables };
EarningsSummaryQuery: { data: EarningsSummaryQuery, variables: EarningsSummaryQueryVariables };
GuestMembershipsQuery: { data: GuestMembershipsQuery, variables: GuestMembershipsQueryVariables };
PurchaseFullPassMutation: { data: PurchaseFullPassMutation, variables: PurchaseFullPassMutationVariables };
UpdatePaymentMethodMutation: { data: UpdatePaymentMethodMutation, variables: UpdatePaymentMethodMutationVariables };
GuestPassPurchaseHistoryQuery: { data: GuestPassPurchaseHistoryQuery, variables: GuestPassPurchaseHistoryQueryVariables };
PopularEscapesQuery: { data: PopularEscapesQuery, variables: PopularEscapesQueryVariables };
HostBusinessKitQuery: { data: HostBusinessKitQuery, variables: HostBusinessKitQueryVariables };
ListingTipFragment: { data: ListingTipFragment};
PerformanceTipsQuery: { data: PerformanceTipsQuery, variables: PerformanceTipsQueryVariables };
MarketingTipsQuery: { data: MarketingTipsQuery, variables: MarketingTipsQueryVariables };
HostListingPassesQuery: { data: HostListingPassesQuery, variables: HostListingPassesQueryVariables };
SaveMembershipMutation: { data: SaveMembershipMutation, variables: SaveMembershipMutationVariables };
PerformanceOverviewQuery: { data: PerformanceOverviewQuery, variables: PerformanceOverviewQueryVariables };
PerformanceScoresQuery: { data: PerformanceScoresQuery, variables: PerformanceScoresQueryVariables };
UpdateListingWakeupChecklistMutation: { data: UpdateListingWakeupChecklistMutation, variables: UpdateListingWakeupChecklistMutationVariables };
ListingWakeupChecklistQuery: { data: ListingWakeupChecklistQuery, variables: ListingWakeupChecklistQueryVariables };
ListingPostOnboardingStepsQuery: { data: ListingPostOnboardingStepsQuery, variables: ListingPostOnboardingStepsQueryVariables };
CompletePostOnboardingStepMutation: { data: CompletePostOnboardingStepMutation, variables: CompletePostOnboardingStepMutationVariables };
GetAbandonCartFansQuery: { data: GetAbandonCartFansQuery, variables: GetAbandonCartFansQueryVariables };
AbandonCartSettingsFragment: { data: AbandonCartSettingsFragment};
ListingAbandonedCartSettingsQuery: { data: ListingAbandonedCartSettingsQuery, variables: ListingAbandonedCartSettingsQueryVariables };
UpdateAbandonCartSettingsMutation: { data: UpdateAbandonCartSettingsMutation, variables: UpdateAbandonCartSettingsMutationVariables };
CancellationPoliciesQuery: { data: CancellationPoliciesQuery, variables: CancellationPoliciesQueryVariables };
SaveListingCancellationPolicyMutation: { data: SaveListingCancellationPolicyMutation, variables: SaveListingCancellationPolicyMutationVariables };
SendFansMessageMutation: { data: SendFansMessageMutation, variables: SendFansMessageMutationVariables };
SaveListingAccessInstructionMutation: { data: SaveListingAccessInstructionMutation, variables: SaveListingAccessInstructionMutationVariables };
SaveListingMaxGuestsMutation: { data: SaveListingMaxGuestsMutation, variables: SaveListingMaxGuestsMutationVariables };
DeleteInstagramConnectionMutation: { data: DeleteInstagramConnectionMutation, variables: DeleteInstagramConnectionMutationVariables };
DefaultPricesFragment: { data: DefaultPricesFragment};
DefaultDailyPricesFragment: { data: DefaultDailyPricesFragment};
DefaultDailyPriceTiersQuery: { data: DefaultDailyPriceTiersQuery, variables: DefaultDailyPriceTiersQueryVariables };
SaveTieredPricingMutation: { data: SaveTieredPricingMutation, variables: SaveTieredPricingMutationVariables };
SavePerGuestPricingMutation: { data: SavePerGuestPricingMutation, variables: SavePerGuestPricingMutationVariables };
SaveDailyPricingMutation: { data: SaveDailyPricingMutation, variables: SaveDailyPricingMutationVariables };
SaveDailyTieredPricingMutation: { data: SaveDailyTieredPricingMutation, variables: SaveDailyTieredPricingMutationVariables };
OnboardingPricingQuery: { data: OnboardingPricingQuery, variables: OnboardingPricingQueryVariables };
SetBasePriceMutation: { data: SetBasePriceMutation, variables: SetBasePriceMutationVariables };
ListingPromocodeFragment: { data: ListingPromocodeFragment};
ListingPromocodesQuery: { data: ListingPromocodesQuery, variables: ListingPromocodesQueryVariables };
CreateListingPromocodeMutation: { data: CreateListingPromocodeMutation, variables: CreateListingPromocodeMutationVariables };
ActivateFeaturedPromoCodeMutation: { data: ActivateFeaturedPromoCodeMutation, variables: ActivateFeaturedPromoCodeMutationVariables };
DeactivateFeaturedPromoCodeMutation: { data: DeactivateFeaturedPromoCodeMutation, variables: DeactivateFeaturedPromoCodeMutationVariables };
RuleSettingsFragment: { data: RuleSettingsFragment};
UpdateListingRulesMutation: { data: UpdateListingRulesMutation, variables: UpdateListingRulesMutationVariables };
SavePoolSecurityDepositMutation: { data: SavePoolSecurityDepositMutation, variables: SavePoolSecurityDepositMutationVariables };
GetSecurityDepositConfigurationQuery: { data: GetSecurityDepositConfigurationQuery, variables: GetSecurityDepositConfigurationQueryVariables };
GetListingVideoQuery: { data: GetListingVideoQuery, variables: GetListingVideoQueryVariables };
RemoveListingVideoMutation: { data: RemoveListingVideoMutation, variables: RemoveListingVideoMutationVariables };
IsListingOptedInQuery: { data: IsListingOptedInQuery, variables: IsListingOptedInQueryVariables };
SetThirdPartyAddressOptInMutation: { data: SetThirdPartyAddressOptInMutation, variables: SetThirdPartyAddressOptInMutationVariables };
ReadPropertiesFragment: { data: ReadPropertiesFragment};
ListingTypeCategoriesQuery: { data: ListingTypeCategoriesQuery, variables: ListingTypeCategoriesQueryVariables };
DefaultMaxGuestCountTiersQuery: { data: DefaultMaxGuestCountTiersQuery, variables: DefaultMaxGuestCountTiersQueryVariables };
OnboardingScreenFragment: { data: OnboardingScreenFragment};
OnboardingScreensQuery: { data: OnboardingScreensQuery, variables: OnboardingScreensQueryVariables };
CompleteOnboardingScreenMutation: { data: CompleteOnboardingScreenMutation, variables: CompleteOnboardingScreenMutationVariables };
SaveListingLocationMutation: { data: SaveListingLocationMutation, variables: SaveListingLocationMutationVariables };
ListingPropertiesReadOnlyQuery: { data: ListingPropertiesReadOnlyQuery, variables: ListingPropertiesReadOnlyQueryVariables };
ListingOnboardingScreenQuery: { data: ListingOnboardingScreenQuery, variables: ListingOnboardingScreenQueryVariables };
OnboardingFullPriceListDataQuery: { data: OnboardingFullPriceListDataQuery, variables: OnboardingFullPriceListDataQueryVariables };
SendOnboardingDeeplinkSmsMutation: { data: SendOnboardingDeeplinkSmsMutation, variables: SendOnboardingDeeplinkSmsMutationVariables };
EnqueueListingForPhotoReviewMutation: { data: EnqueueListingForPhotoReviewMutation, variables: EnqueueListingForPhotoReviewMutationVariables };
GetInstantBookingSettingsQuery: { data: GetInstantBookingSettingsQuery, variables: GetInstantBookingSettingsQueryVariables };
GetGuestAccessSettingsQuery: { data: GetGuestAccessSettingsQuery, variables: GetGuestAccessSettingsQueryVariables };
GetGuestCheckInSettingsQuery: { data: GetGuestCheckInSettingsQuery, variables: GetGuestCheckInSettingsQueryVariables };
GetListingGuestCountQuery: { data: GetListingGuestCountQuery, variables: GetListingGuestCountQueryVariables };
GetListingSavedTitleAndDescriptionQuery: { data: GetListingSavedTitleAndDescriptionQuery, variables: GetListingSavedTitleAndDescriptionQueryVariables };
GetListingPromotionsQuery: { data: GetListingPromotionsQuery, variables: GetListingPromotionsQueryVariables };
GetListingBrandingQuery: { data: GetListingBrandingQuery, variables: GetListingBrandingQueryVariables };
GetListingLocationQuery: { data: GetListingLocationQuery, variables: GetListingLocationQueryVariables };
CreateListingMutation: { data: CreateListingMutation, variables: CreateListingMutationVariables };
ServerNextOnboardingScreensQuery: { data: ServerNextOnboardingScreensQuery, variables: ServerNextOnboardingScreensQueryVariables };
ServerListingCoverImageQuery: { data: ServerListingCoverImageQuery, variables: ServerListingCoverImageQueryVariables };
ServerListingDescriptionDataQuery: { data: ServerListingDescriptionDataQuery, variables: ServerListingDescriptionDataQueryVariables };
ServerDynamicFormListingQuery: { data: ServerDynamicFormListingQuery, variables: ServerDynamicFormListingQueryVariables };
ServerBrandPreviewListingQuery: { data: ServerBrandPreviewListingQuery, variables: ServerBrandPreviewListingQueryVariables };
ServerOnboardingPricingTiersQuery: { data: ServerOnboardingPricingTiersQuery, variables: ServerOnboardingPricingTiersQueryVariables };
ServerOnboardingBasePriceQuery: { data: ServerOnboardingBasePriceQuery, variables: ServerOnboardingBasePriceQueryVariables };
ServerReadyToContinueScreensQuery: { data: ServerReadyToContinueScreensQuery, variables: ServerReadyToContinueScreensQueryVariables };
ServerPhaseFourPreviewQuery: { data: ServerPhaseFourPreviewQuery, variables: ServerPhaseFourPreviewQueryVariables };
NearMeSearchQuery: { data: NearMeSearchQuery, variables: NearMeSearchQueryVariables };
ScreenPropertiesQuery: { data: ScreenPropertiesQuery, variables: ScreenPropertiesQueryVariables };
ListingPreviewQuery: { data: ListingPreviewQuery, variables: ListingPreviewQueryVariables };
GetOnboardingListingPhotosQueryV2Query: { data: GetOnboardingListingPhotosQueryV2Query, variables: GetOnboardingListingPhotosQueryV2QueryVariables };
ExemplaryHostsForOnboardingQuery: { data: ExemplaryHostsForOnboardingQuery, variables: ExemplaryHostsForOnboardingQueryVariables };
SaveListingTypeMutation: { data: SaveListingTypeMutation, variables: SaveListingTypeMutationVariables };
SetListingPromotionsMutation: { data: SetListingPromotionsMutation, variables: SetListingPromotionsMutationVariables };
SetStartDateMutation: { data: SetStartDateMutation, variables: SetStartDateMutationVariables };
ReportListingMutation: { data: ReportListingMutation, variables: ReportListingMutationVariables };
AdditionalDetailsResponseFragment: { data: AdditionalDetailsResponseFragment};
AdditionalListingDetailsQuery: { data: AdditionalListingDetailsQuery, variables: AdditionalListingDetailsQueryVariables };
ListingAvailabilityServerFragment: { data: ListingAvailabilityServerFragment};
ListingPricingServerFragment: { data: ListingPricingServerFragment};
ServerListingDetailsQuery: { data: ServerListingDetailsQuery, variables: ServerListingDetailsQueryVariables };
MessageFragment: { data: MessageFragment};
ConversationQuery: { data: ConversationQuery, variables: ConversationQueryVariables };
ConversationListQuery: { data: ConversationListQuery, variables: ConversationListQueryVariables };
ReadMessagesMutation: { data: ReadMessagesMutation, variables: ReadMessagesMutationVariables };
SendMessageMutation: { data: SendMessageMutation, variables: SendMessageMutationVariables };
MarkUnreadMutation: { data: MarkUnreadMutation, variables: MarkUnreadMutationVariables };
ChatBookingFragment: { data: ChatBookingFragment};
ListingMessageTemplatesForChatQuery: { data: ListingMessageTemplatesForChatQuery, variables: ListingMessageTemplatesForChatQueryVariables };
ChatBookingQuery: { data: ChatBookingQuery, variables: ChatBookingQueryVariables };
InquiryPricingSummaryQuery: { data: InquiryPricingSummaryQuery, variables: InquiryPricingSummaryQueryVariables };
BlockUserMutation: { data: BlockUserMutation, variables: BlockUserMutationVariables };
BookingRefundInfoQuery: { data: BookingRefundInfoQuery, variables: BookingRefundInfoQueryVariables };
SelectRefundOptionMutation: { data: SelectRefundOptionMutation, variables: SelectRefundOptionMutationVariables };
ReservationRefundFragment: { data: ReservationRefundFragment};
ReservationRefundDetailsCashQuery: { data: ReservationRefundDetailsCashQuery, variables: ReservationRefundDetailsCashQueryVariables };
ReservationRefundDetailsCreditsQuery: { data: ReservationRefundDetailsCreditsQuery, variables: ReservationRefundDetailsCreditsQueryVariables };
NotificationSettingFragment: { data: NotificationSettingFragment};
NotificationSettingsQuery: { data: NotificationSettingsQuery, variables: NotificationSettingsQueryVariables };
UpdateNotificationSettingsMutation: { data: UpdateNotificationSettingsMutation, variables: UpdateNotificationSettingsMutationVariables };
UpdateListingPropertiesMutation: { data: UpdateListingPropertiesMutation, variables: UpdateListingPropertiesMutationVariables };
ListingSeasonalAvailabilityQuery: { data: ListingSeasonalAvailabilityQuery, variables: ListingSeasonalAvailabilityQueryVariables };
ListingMessageTemplatesQuery: { data: ListingMessageTemplatesQuery, variables: ListingMessageTemplatesQueryVariables };
SaveListingMessageTemplateMutation: { data: SaveListingMessageTemplateMutation, variables: SaveListingMessageTemplateMutationVariables };
GetAutomatedMessageEventTypesQuery: { data: GetAutomatedMessageEventTypesQuery, variables: GetAutomatedMessageEventTypesQueryVariables };
ListingBookabilityScoreQuery: { data: ListingBookabilityScoreQuery, variables: ListingBookabilityScoreQueryVariables };
InsightsQuery: { data: InsightsQuery, variables: InsightsQueryVariables };
GetHostServicesQuery: { data: GetHostServicesQuery, variables: GetHostServicesQueryVariables };
SaveHostServicesMutation: { data: SaveHostServicesMutation, variables: SaveHostServicesMutationVariables };
PassFormFragment: { data: PassFormFragment};
ReadPassFormQuery: { data: ReadPassFormQuery, variables: ReadPassFormQueryVariables };
SavePassFormMutation: { data: SavePassFormMutation, variables: SavePassFormMutationVariables };
ProToolCardFragment: { data: ProToolCardFragment};
ProQuery: { data: ProQuery, variables: ProQueryVariables };
GetManageGuestsQuery: { data: GetManageGuestsQuery, variables: GetManageGuestsQueryVariables };
GetManageGuestQuery: { data: GetManageGuestQuery, variables: GetManageGuestQueryVariables };
AddGuestAsFavoriteMutation: { data: AddGuestAsFavoriteMutation, variables: AddGuestAsFavoriteMutationVariables };
RemoveGuestFromFavoritesMutation: { data: RemoveGuestFromFavoritesMutation, variables: RemoveGuestFromFavoritesMutationVariables };
SaveGuestNoteMutation: { data: SaveGuestNoteMutation, variables: SaveGuestNoteMutationVariables };
GetListingSavedTitleQuery: { data: GetListingSavedTitleQuery, variables: GetListingSavedTitleQueryVariables };
HostSettingsListingPropertiesQuery: { data: HostSettingsListingPropertiesQuery, variables: HostSettingsListingPropertiesQueryVariables };
UseBoostMutation: { data: UseBoostMutation, variables: UseBoostMutationVariables };
SelectListingMutation: { data: SelectListingMutation, variables: SelectListingMutationVariables };
ManageListingItemFragment: { data: ManageListingItemFragment};
SetIdempotencyKeyMutation: { data: SetIdempotencyKeyMutation, variables: SetIdempotencyKeyMutationVariables };
ExitRehabMutation: { data: ExitRehabMutation, variables: ExitRehabMutationVariables };
ManageListingQuery: { data: ManageListingQuery, variables: ManageListingQueryVariables };
SearchBoostQuery: { data: SearchBoostQuery, variables: SearchBoostQueryVariables };
AcceptBookingInviteMutation: { data: AcceptBookingInviteMutation, variables: AcceptBookingInviteMutationVariables };
AcceptGenericBookingInviteMutation: { data: AcceptGenericBookingInviteMutation, variables: AcceptGenericBookingInviteMutationVariables };
SendReferralInviteMutation: { data: SendReferralInviteMutation, variables: SendReferralInviteMutationVariables };
CheckInMutation: { data: CheckInMutation, variables: CheckInMutationVariables };
CurrentCheckInPricingQuery: { data: CurrentCheckInPricingQuery, variables: CurrentCheckInPricingQueryVariables };
PendingCheckInSummaryQuery: { data: PendingCheckInSummaryQuery, variables: PendingCheckInSummaryQueryVariables };
SendBookingInvitesMutation: { data: SendBookingInvitesMutation, variables: SendBookingInvitesMutationVariables };
ReservationDetailsChatBookingQuery: { data: ReservationDetailsChatBookingQuery, variables: ReservationDetailsChatBookingQueryVariables };
BookMonitorMutation: { data: BookMonitorMutation, variables: BookMonitorMutationVariables };
SubmitHostClaimMutation: { data: SubmitHostClaimMutation, variables: SubmitHostClaimMutationVariables };
RequestRefundMutation: { data: RequestRefundMutation, variables: RequestRefundMutationVariables };
FullRefundMutation: { data: FullRefundMutation, variables: FullRefundMutationVariables };
BookWithConciergeMutation: { data: BookWithConciergeMutation, variables: BookWithConciergeMutationVariables };
AddWaitlistSubscriptionMutation: { data: AddWaitlistSubscriptionMutation, variables: AddWaitlistSubscriptionMutationVariables };
SearchFiltersQuery: { data: SearchFiltersQuery, variables: SearchFiltersQueryVariables };
SpaceTypeSearchFiltersQuery: { data: SpaceTypeSearchFiltersQuery, variables: SpaceTypeSearchFiltersQueryVariables };
DynamicSearchServerQuery: { data: DynamicSearchServerQuery, variables: DynamicSearchServerQueryVariables };
DiscoveryQuery: { data: DiscoveryQuery, variables: DiscoveryQueryVariables };
SearchCarouselFragment: { data: SearchCarouselFragment};
DynamicSearchQuery: { data: DynamicSearchQuery, variables: DynamicSearchQueryVariables };
BookingInquiryMutation: { data: BookingInquiryMutation, variables: BookingInquiryMutationVariables };
InquiryListingQuery: { data: InquiryListingQuery, variables: InquiryListingQueryVariables };
InquiryPricingDetailsQuery: { data: InquiryPricingDetailsQuery, variables: InquiryPricingDetailsQueryVariables };
SeoLinkFragment: { data: SeoLinkFragment};
SeoPrivateListingFragment: { data: SeoPrivateListingFragment};
CityFragment: { data: CityFragment};
PublicPoolFragment: { data: PublicPoolFragment};
PublicPoolsQuery: { data: PublicPoolsQuery, variables: PublicPoolsQueryVariables };
StatePublicPoolsQuery: { data: StatePublicPoolsQuery, variables: StatePublicPoolsQueryVariables };
CityPublicPoolsQuery: { data: CityPublicPoolsQuery, variables: CityPublicPoolsQueryVariables };
SpecialOfferFragment: { data: SpecialOfferFragment};
SpecialOfferBookingFragment: { data: SpecialOfferBookingFragment};
GetBookingForChatQuery: { data: GetBookingForChatQuery, variables: GetBookingForChatQueryVariables };
DeclineBookingSpecialOfferMutation: { data: DeclineBookingSpecialOfferMutation, variables: DeclineBookingSpecialOfferMutationVariables };
CancelBookingSpecialOfferMutation: { data: CancelBookingSpecialOfferMutation, variables: CancelBookingSpecialOfferMutationVariables };
SpecialOfferBookingDetailsQuery: { data: SpecialOfferBookingDetailsQuery, variables: SpecialOfferBookingDetailsQueryVariables };
CreateBookingSpecialOfferMutation: { data: CreateBookingSpecialOfferMutation, variables: CreateBookingSpecialOfferMutationVariables };
PreApproveReservationMutation: { data: PreApproveReservationMutation, variables: PreApproveReservationMutationVariables };
ViewInquiryPricingSummaryQuery: { data: ViewInquiryPricingSummaryQuery, variables: ViewInquiryPricingSummaryQueryVariables };
GetLatestBookingInquiryQuery: { data: GetLatestBookingInquiryQuery, variables: GetLatestBookingInquiryQueryVariables };
ServerGetAllUserExperimentsQuery: { data: ServerGetAllUserExperimentsQuery, variables: ServerGetAllUserExperimentsQueryVariables };
ServerFeatureFlagsQuery: { data: ServerFeatureFlagsQuery, variables: ServerFeatureFlagsQueryVariables };
SelectedListingQuery: { data: SelectedListingQuery, variables: SelectedListingQueryVariables };
ServerProfileQuery: { data: ServerProfileQuery, variables: ServerProfileQueryVariables };
ListingOnboardingStatusQuery: { data: ListingOnboardingStatusQuery, variables: ListingOnboardingStatusQueryVariables };
    }